// ── GOOGLE ANALYTICS INTEGRATION ─────────────────────────────────────────────
// The react-ga4 package was chosen as it's the modern standard for React GA4.
// The tracking ID is injected via Bun.build's define mechanism using process.env.PUBLIC_GA_ID.
const ReactGA = require('react-ga4').default || require('react-ga4');
const { Helmet, HelmetProvider } = require('react-helmet-async');

if (process.env.PUBLIC_GA_ID) {
  ReactGA.initialize(process.env.PUBLIC_GA_ID);
}

/**
 * Reusable utility to track custom GA events.
 * Attach this to buttons or important interactions.
 * Example: window.trackCustomEvent('conversion', 'sign_up_clicked', 'Header Button');
 */
window.trackCustomEvent = (category, action, label) => {
  if (process.env.PUBLIC_GA_ID) {
    ReactGA.event({
      category: category,
      action: action,
      label: label
    });
  }
};
// ─────────────────────────────────────────────────────────────────────────────

// Shared components: Logo, Nav, Footer
// Exports to window for use across pages

const DICT_EN = {
  "k_0": "Keychain",
  "k_1": "Keychain — go to home",
  "k_2": "Login",
  "k_3": "Solutions",
  "k_4": "Chatbot",
  "k_5": "KeyChain AI Assistant",
  "k_6": "AI Rental Agent. Payment Institution by UK FCA",
  "k_7": "Contact",
  "k_8": "🇬🇧 UK Office",
  "k_9": "3rd Floor 86-90 Paul Street, London, EC2A 4NE, UK",
  "k_10": "🇭🇰 HK Office",
  "k_11": "Unit 1901, 19/F, No. 3 Lockhart Road, Wanchai, Hong Kong",
  "k_12": "© 2026 KeyChain FinTech Ltd. All rights reserved.",
  "k_13": "Live Collection Rate",
  "k_14": "AI-monitored · Real-time",
  "k_15": "middle",
  "k_16": "Space Grotesk, sans-serif",
  "k_17": "ON TIME",
  "k_18": "14 days",
  "k_19": "avg. advance",
  "k_20": "38 hrs",
  "k_21": "saved / month",
  "k_22": "Recent collections",
  "k_23": "rgba(229,117,0,0.4)",
  "k_24": "AI Rental Agent",
  "k_25": "rgba(255,255,255,0.25)",
  "k_26": "FCA Licensed",
  "k_27": "Rent paid on time.",
  "k_28": "Every time.",
  "k_29": "Autonomous.",
  "k_30": "Keychain AI secures rent before due dates, automates property management with responses and actions, and turns payments into rewards",
  "k_31": "I rent",
  "k_32": "I lease",
  "k_33": "I invest",
  "k_34": "How it works",
  "k_35": "Two seamless paths. One goal.",
  "k_36": "Whether you're collecting rent or paying it, Keychain handles the complexity.",
  "k_37": "For",
  "k_38": "white",
  "k_39": "Why Keychain",
  "k_40": "Three outcomes that matter.",
  "k_41": "Our Product",
  "k_42": "Meet our market-fit App, Platform and Agent",
  "k_43": "Built for landlords who need certainty and tenants who expect delight.",
  "k_44": "Trusted by",
  "k_45": "Insightful clients & Premium partners.",
  "k_46": "Property Developers",
  "k_47": "Sino Group",
  "k_48": "Swire Properties",
  "k_49": "Hang Lung Properties",
  "k_50": "Sun Hing Group",
  "k_51": "Banks & Partners",
  "k_52": "Mastercard Start Path",
  "k_53": "HSBC Visa Signature",
  "k_54": "HSBC Premier Mastercard",
  "k_55": "Google for Startups",
  "k_56": "Security & Compliance",
  "k_57": "Banking-grade protection.",
  "k_58": "Your data and your money are secured to the highest standards.",
  "k_59": "FAQ",
  "k_60": "Common questions.",
  "k_61": "rgba(255,165,103,0.2)",
  "k_62": "Get started today",
  "k_63": "Ready to end rental arrears?",
  "k_64": "Join landlords and tenants across Hong Kong and the UK.",
  "k_65": "Collection Rate",
  "k_66": "↑ vs 87% industry avg",
  "k_67": "Properties",
  "k_68": "+12 this quarter",
  "k_69": "VISA",
  "k_70": "AMEX",
  "k_71": "Card holder",
  "k_72": "This month",
  "k_73": "Cashback / month",
  "k_74": "HKD",
  "k_75": "YTD: HKD",
  "k_76": "Miles / month",
  "k_77": "YTD:",
  "k_78": "miles",
  "k_79": "rgba(45,212,191,0.1)",
  "k_80": "For Landlords, Developers & Managers",
  "k_81": "Stop chasing rent.",
  "k_82": "Power your portfolio with AI.",
  "k_83": "Collect rent in advance with AI-driven smart contracts. From individual units to global portfolios, boost your cash flow with zero risk.",
  "k_84": "Login →",
  "k_85": "Request Demo",
  "k_86": "rgba(13,148,136,0.1)",
  "k_87": "Our Portfolio",
  "k_88": "trusted by premium properties",
  "k_89": "The old way",
  "k_90": "Chasing rent is a burden.",
  "k_91": "The Keychain way",
  "k_92": "Set it once. Done.",
  "k_93": "Platform capabilities",
  "k_94": "Scale your portfolio without the overhead.",
  "k_95": "Built for individuals and property companies managing hundreds or thousands of units.",
  "k_96": "Case study",
  "k_97": "From manual chasing to zero arrears.",
  "k_98": "A major Hong Kong property developer managing over 300 premium residential units deployed Keychain. Within the first quarter, rental arrears dropped to zero.",
  "k_99": "\"The platform paid for itself in the first month. We no longer provision for bad debt.\"",
  "k_100": "Senior Director, Portfolio Management",
  "k_101": "Pricing",
  "k_102": "Simple, transparent fees.",
  "k_103": "No hidden charges. You choose who pays transaction fees.",
  "k_104": "^ Landlord / property manager can decide whether the transaction fee is to be paid by the tenant or the landlord.",
  "k_105": "Ready to guarantee your rent?",
  "k_106": "Join leading landlords and property managers across Hong Kong and the UK.",
  "k_107": "Login to get started →",
  "k_108": "this month",
  "k_109": "% · HKD",
  "k_110": "Monthly Rent",
  "k_111": "Split Payment",
  "k_112": "Card",
  "k_113": "✓ Transaction fee waived",
  "k_114": "Transaction fee: HKD",
  "k_115": "Charged: HKD",
  "k_116": "Transaction Fee",
  "k_117": "Total Charged",
  "k_118": "Payment Split",
  "k_119": "Monthly Reward Estimate",
  "k_120": "Monthly",
  "k_121": "/ yr",
  "k_122": "mi",
  "k_123": "mi / yr",
  "k_124": "pts",
  "k_125": "pts / yr",
  "k_126": "Please refer to card issuer for reward details.",
  "k_127": "*Results are for reference only. Rewards are calculated on total charged (rent + transaction fee) as an online merchant transaction. Excludes welcome offers. Refer to card issuer for final amounts. Terms apply.",
  "k_128": "rgba(229,117,0,0.1)",
  "k_129": "Rewards Calculator",
  "k_130": "See how much you could earn on HKD",
  "k_131": "/ month",
  "k_132": "rgba(230,160,137,0.25)",
  "k_133": "For Tenants",
  "k_134": "Split your rent.",
  "k_135": "You are rewarded",
  "k_136": "as a good tenant.",
  "k_137": "Use your favourite card or wallet. Split payments across up to 3 cards. Let AI handle the schedule — you just collect the rewards.",
  "k_138": "Download the app",
  "k_139": "See rewards",
  "k_140": "Getting started",
  "k_141": "Up and running in under 5 minutes.",
  "k_142": "No forms. No waiting. Just tap, authorise, and relax.",
  "k_143": "rgba(230,160,137,0.15)",
  "k_144": "Rewards",
  "k_145": "Your rent is your",
  "k_146": "biggest spend.",
  "k_147": "Start earning on it.",
  "k_148": "Earn miles, cashback, and points through our card partner programme. Every rent payment counts — just like any other purchase on your card.",
  "k_149": "SPLIT Payments",
  "k_150": "Spread rent across",
  "k_151": "up to 3 cards.",
  "k_152": "Maximise rewards by allocating different amounts to different cards. Risk-based 2FA keeps every card secure.",
  "k_153": "Estimate your rewards",
  "k_154": "Ask Kate - our AI assistant to guide you how to earn the most from paying your rent with us",
  "k_155": "Chat with Kate →",
  "k_156": "linear-gradient(135deg, #1F3540 0%, #494D4C 100%)",
  "k_157": "Your security",
  "k_158": "Your card details are never stored.",
  "k_159": "Bank-grade security you can actually understand.",
  "k_160": "Tenant FAQ",
  "k_161": "Your questions, answered.",
  "k_162": "More questions?",
  "k_163": "Start earning on your rent.",
  "k_164": "Download Keychain and set up in under 5 minutes.",
  "k_165": "Download for iOS",
  "k_166": "Download for Android",
  "k_167": "The AI Rental Agent:",
  "k_168": "Recurring income meets",
  "k_169": "AI credit reference.",
  "k_170": "Keychain is building the autonomous FinTech PropTech for the global rental economy—capital-efficient, data-driven, and backed by global AI, payment leaders",
  "k_171": "rgba(255,165,103,0.12)",
  "k_172": "Backed by",
  "k_173": "ASIA",
  "k_174": "PAY",
  "k_175": "CAPITAL",
  "k_176": "rgba(255,95,0,0.1)",
  "k_177": "rgba(255,255,255,0.08)",
  "k_178": "G",
  "k_179": "o",
  "k_180": "g",
  "k_181": "l",
  "k_182": "e",
  "k_183": "for Startups",
  "k_184": "rgba(20,184,166,0.1)",
  "k_185": "The Problem",
  "k_186": "A global market operating on legacy rails.",
  "k_187": "The residential rental market represents one of the largest asset classes globally, yet remains fundamentally inefficient. Fragmented payment methods, weak credit visibility, and lack of structured data create a massive \"infrastructure gap\" for both property owners and financial institutions.",
  "k_188": "Investment Thesis",
  "k_189": "\"We believe the convergence of",
  "k_190": "AI automation",
  "k_191": "and",
  "k_192": "embedded credit rails",
  "k_193": "will redefine how rental income is secured, managed, and capitalised.\"",
  "k_194": "50×",
  "k_195": "LTV / CAC",
  "k_196": "High",
  "k_197": "LTV vs Industry",
  "k_198": "The Solution",
  "k_199": "AI-powered rental financial infrastructure.",
  "k_200": "Keychain integrates the entire rental lifecycle into a single autonomous layer, from credit scoring to automated cash flow.",
  "k_201": "Why Now?",
  "k_202": "The perfect storm for rental infrastructure.",
  "k_203": "The convergence of these four major macro trends creates a unique window for a dominant player to emerge. Keychain's infrastructure is built for this moment—leveraging AI to solve legacy operational problems while creating a high-value financial dataset.",
  "k_204": "rgba(20,184,166,0.15)",
  "k_205": "The Core Story",
  "k_206": "The AI Rental Agent is not a chatbot.",
  "k_207": "It is an",
  "k_208": "autonomous financial and property operations layer",
  "k_209": ". It handles tenant interactions, payment reminders, and complex workflow automation, allowing portfolios to scale without increasing headcount.",
  "k_210": "Business Model",
  "k_211": "Predictable, scalable recurring revenue.",
  "k_212": "Our hybrid model combines high-margin recurring software fees with transaction-based volume and high-intent credit referencing. This creates multiple revenue streams while deepining our relationship with the user.",
  "k_213": "Strategic Embedded Finance",
  "k_214": "Traction",
  "k_215": "Validation from the best.",
  "k_216": "Our growth is driven by recurring usage behavior and expansion across key global financial hubs.",
  "k_217": "Why We Win",
  "k_218": "Request an Investor Teaser",
  "k_219": "Frequently Asked Questions",
  "k_220": "Everything you need to know about Keychain.",
  "k_221": "Tweaks",
  "k_222": "Accent Color",
  "k_223": "Navigate to page",
  "k_224": "登入",
  "k_225": "解決方案",
  "k_226": "聊天機器人",
  "k_227": "KeyChain 智能助理",
  "k_228": "聯絡我們",
  "k_229": "智能租務助理",
  "k_230": "租戶",
  "k_231": "業主",
  "k_232": "投資者",
  "k_233": "常見問題",
  "k_234": "致租戶",
  "k_235": "下載應用程式",
  "k_236": "查看預計獎賞",
  "k_237": "獎賞",
  "k_238": "估算您的獎賞",
  "k_239": "向我們的人工智能助理 Kate 查詢如何透過信用卡交租賺取最多獎賞",
  "k_240": "與 Kate 對話 →",
  "k_241": "contain",
  "k_242": "Landlord Property Developer / Manager",
  "k_243": "Enterprise rent rails for portfolios",
  "k_244": "Tenants",
  "k_245": "Pay rent, earn rewards",
  "k_246": "Investors & Partners",
  "k_247": "Traction, thesis, partnerships",
  "k_248": "blur(12px)",
  "k_249": "all 0.3s ease",
  "k_250": "0 auto",
  "k_251": "pointer",
  "k_252": "6px 12px",
  "k_253": "background 0.2s",
  "k_254": "繁",
  "k_255": "Eng",
  "k_256": "9px 18px",
  "k_257": "Close menu",
  "k_258": "Open menu",
  "k_259": "4px 8px",
  "k_260": "16px 24px 32px",
  "k_261": "calc(100vh - 68px)",
  "k_262": "uppercase",
  "k_263": "left",
  "k_264": "16px 0",
  "k_265": "16px 24px",
  "k_266": "0 8px 24px rgba(229,117,0,0.25)",
  "k_267": "8px 14px",
  "k_268": "color 0.2s, background 0.2s",
  "k_269": "Landlords & Developers",
  "k_270": "Company",
  "k_271": "Contact Us",
  "k_272": "mailto:enquiry@keychainpay.com",
  "k_273": "Legal",
  "k_274": "Terms of Services",
  "k_275": "Privacy Policy",
  "k_276": "User Terms",
  "k_277": "Cookie Policy",
  "k_278": "FCA Register",
  "k_279": "LinkedIn",
  "k_280": "Facebook",
  "k_281": "Instagram",
  "k_282": "Email",
  "k_283": "column",
  "k_284": "0 20px 40px rgba(0,0,0,0.5)",
  "k_285": "space-between",
  "k_286": "grid",
  "k_287": "repeat(auto-fit, minmax(160px, 1fr))",
  "k_288": "_self",
  "k_289": "_blank",
  "k_290": "all 0.2s",
  "k_291": "default",
  "k_292": "color 0.15s",
  "k_293": "12px 16px",
  "k_294": "0 10px 30px rgba(0,0,0,0.2)",
  "k_295": "wrap",
  "k_296": "🇬🇧 UK",
  "k_297": "🇭🇰 HK",
  "k_298": "4px 10px",
  "k_299": "IntersectionObserver",
  "k_300": "0px 0px -40px 0px",
  "k_301": "up",
  "k_302": "opacity, transform",
  "k_303": "is-visible",
  "k_304": "reverse",
  "k_305": "normal",
  "k_306": "all 0.3s",
  "k_307": "inline-block",
  "k_308": "transform 0.2s",
  "k_309": "scale(1.05)",
  "k_310": "inline-flex",
  "k_311": "4px 12px",
  "k_312": "primary",
  "k_313": "13px 26px",
  "k_314": "0 8px 24px rgba(0,0,0,0.15)",
  "k_315": "96px 24px",
  "k_316": "'Space Grotesk', sans-serif",
  "k_317": "clamp(28px, 4vw, 44px)",
  "k_318": "16px 0 16px",
  "k_319": "-0.02em",
  "k_320": "Rent collected",
  "k_321": "Pacific Place Apts · HKD 28,400",
  "k_322": "14 days early",
  "k_323": "AI-optimised charge date",
  "k_324": "+312 miles earned",
  "k_325": "Cathay Pacific · this month",
  "k_326": "Payment secured",
  "k_327": "PCI DSS · tokenised",
  "k_328": "Pacific Place Apts",
  "k_329": "Unit 12A",
  "k_330": "HKD 28,400",
  "k_331": "Collected",
  "k_332": "Hang Lung",
  "k_333": "Unit 8B",
  "k_334": "HKD 19,800",
  "k_335": "Sino Plaza",
  "k_336": "Unit 34F",
  "k_337": "HKD 22,000",
  "k_338": "Scheduled",
  "k_339": "Swire House",
  "k_340": "Unit 7C",
  "k_341": "GBP 3,200",
  "k_342": "blur(20px)",
  "k_343": "20px 20px 16px",
  "k_344": "pulse 2s infinite",
  "k_345": "stroke-dashoffset 0.05s linear",
  "k_346": "Space Grotesk,sans-serif",
  "k_347": "7px 0",
  "k_348": "opacity 0.4s ease, transform 0.4s ease",
  "k_349": "right",
  "k_350": "blur(16px)",
  "k_351": "2d",
  "k_352": "resize",
  "k_353": "visibilitychange",
  "k_354": "gradient-roll 10s ease infinite",
  "k_355": "140px 24px 96px",
  "k_356": "1fr 1fr",
  "k_357": "clamp(40px, 6.5vw, 80px)",
  "k_358": "-0.03em",
  "k_359": "clamp(17px, 2vw, 21px)",
  "k_360": "HSBC Card Partner",
  "k_361": "Landlords",
  "k_362": "Upload tenancy / stamp duty",
  "k_363": "Submit via our App or web portal. No paperwork required.",
  "k_364": "Tenant authorises",
  "k_365": "One-time 2FA setup. Smart contract created on their card.",
  "k_366": "AI schedules charges",
  "k_367": "Our model picks the optimal charge date before the lease date.",
  "k_368": "Rent lands on time",
  "k_369": "Funds arrive on or before each monthly leasing effective date. Receipt & statement auto-generated.",
  "k_370": "One-time 2FA setup. Smart contract created. Card tokenised.",
  "k_371": "AI schedules & charges",
  "k_372": "AI determines optimal charge date before the lease date.",
  "k_373": "0 4px 24px rgba(0,0,0,0.05)",
  "k_374": "'Space Grotesk',sans-serif",
  "k_375": "repeat(auto-fit, minmax(300px, 1fr))",
  "k_376": "No more rental arrears",
  "k_377": "on-time collection",
  "k_378": "AI charges ahead of the lease date. Rest-assured rent to arrive on or before each monthly leasing effective date.",
  "k_379": "Zero chargebacks",
  "k_380": "chargebacks recorded",
  "k_381": "AI performs KYC and ensures all payments require minimal authorisation while eliminating card fraud, abuse, and chargebacks.",
  "k_382": "Earn rewards & cashback",
  "k_383": "up to 5%",
  "k_384": "cashback on rent",
  "k_385": "Split rent across up to 3 cards and earn irresistible rewards, air miles, or cashback on every payment.",
  "k_386": "6px 0 16px",
  "k_387": "repeat(auto-fit, minmax(280px, 1fr))",
  "k_388": "Landlord Dashboard",
  "k_389": "Portfolio overview, arrears tracking, cash flow",
  "k_390": "uploads/landlord_dash.png",
  "k_391": "Tenant App",
  "k_392": "Rewards, split payments, payment history",
  "k_393": "uploads/tenant_app_v6.png",
  "k_394": "GenAI Property Manager",
  "k_395": "24/7 chat for maintenance, questions, renewals",
  "k_396": "uploads/genai_pm.png",
  "k_397": "cover",
  "k_398": "20px 24px",
  "k_399": "0 4px 16px rgba(0,0,0,0.12)",
  "k_400": "repeat(auto-fit, minmax(220px, 1fr))",
  "k_401": "Payment Institution (SPI) in the United Kingdom.",
  "k_402": "Certified compliant. No card data ever stored on our servers.",
  "k_403": "Tokenisation",
  "k_404": "All card details replaced with secure tokens before any transmission.",
  "k_405": "TLS + EV SSL",
  "k_406": "All traffic encrypted in transit. Extended Validation certificate.",
  "k_407": "0 auto 16px",
  "k_408": "What fees does Keychain charge?",
  "k_409": "Is paying rent online safe? Do you store my credit or debit card information?",
  "k_410": "Yes. Keychain mobile APP and Web Portal are PCI-DSS certified (Payment Card Industry Data Security Standards), and data is subject to bank-level security measures.\u003cbr\u003e\u003cbr\u003eKeychain doesn’t store the original credit or debit card numbers that you use with us. And when you use credit or debit cards, your transaction involves (i) the authorised token in the case of Apple Pay or Google Pay, or (ii) the last 4 digits of your credit or debit card number.",
  "k_411": "What I need to set up a Smart Contract?",
  "k_412": "Setting up is easy and can be done in as quick as 5 minutes:<br>⋅ Basic tenancy information<br>⋅ Landlord's contact number and bank account<br>⋅ Tenancy Agreement and stamp proof (or CR109)<br>⋅ Credit or debit card",
  "k_413": "When will my landlord receive the rent? Can I set when to deposit into my landlord's bank account?",
  "k_414": "In general, your landlord will receive your rent on or before the leasing effective day of each month.<br><br>Our AI ensures your rent will be arrived on time. We do not allow any manual set up on both of the dates.<br><br>You may log in to our Mobile App or Web App to check the estimated or the latest deposit date.",
  "k_415": "80px 24px",
  "k_416": "clamp(30px,4vw,50px)",
  "k_417": "20px 0 16px",
  "k_418": "20px 0",
  "k_419": "Oct",
  "k_420": "Nov",
  "k_421": "Dec",
  "k_422": "Jan",
  "k_423": "Feb",
  "k_424": "Mar",
  "k_425": "Apr",
  "k_426": "24px 24px 20px",
  "k_427": "flex-start",
  "k_428": "visible",
  "k_429": "1fr 1fr 1fr",
  "k_430": "Arrears",
  "k_431": "Avg advance",
  "k_432": "7 days",
  "k_433": "Admin saved",
  "k_434": "10px 8px",
  "k_435": "VIC I P LEE",
  "k_436": "multiply",
  "k_437": "italic",
  "k_438": "-1px",
  "k_439": "Arial,sans-serif",
  "k_440": "0 1px 2px rgba(0,0,0,0.15)",
  "k_441": "16px 20px",
  "k_442": "0 20px 60px rgba(0,0,0,0.5)",
  "k_443": "border-box",
  "k_444": "rotateY(90deg) scale(0.92)",
  "k_445": "rotateY(0deg) scale(1)",
  "k_446": "monospace",
  "k_447": "flex-end",
  "k_448": "12px 14px",
  "k_449": "width 0.05s",
  "k_450": "uploads/swire_logo_v2.png",
  "k_451": "uploads/sino_logo_v2.png",
  "k_452": "uploads/shg_logo_v2.png",
  "k_453": "uploads/hang_lung_logo_v2.png",
  "k_454": "City Park",
  "k_455": "uploads/citypark_logo_v2.png",
  "k_456": "Finford",
  "k_457": "uploads/finford_logo_v2.png",
  "k_458": "Star Studios",
  "k_459": "uploads/excz4l_star_studios_logo.png",
  "k_460": "Ham Tin Villas",
  "k_461": "uploads/mpaa3m_hamtin_logo.png",
  "k_462": "Pacific Palisades",
  "k_463": "uploads/k0pmz1_pacific_palisades_logo.png",
  "k_464": "Gold Coast Residences",
  "k_465": "uploads/j522u4_Gold_Coast_logo.png",
  "k_466": "The Camphora",
  "k_467": "uploads/x2zrqy_camphora_logo.png",
  "k_468": "The Johnston",
  "k_469": "uploads/hyxhw2_johnston_logo.png",
  "k_470": "The Gage",
  "k_471": "uploads/992d2p_gage_logo.png",
  "k_472": "The Staunton",
  "k_473": "uploads/9vwz6v_staunton_logo.png",
  "k_474": "The Hillside",
  "k_475": "uploads/ep9dvj_hillside_logo.png",
  "k_476": "The Ventris",
  "k_477": "uploads/0ebckk_ventris_logo.png",
  "k_478": "The Humphreys",
  "k_479": "uploads/u3z1fy_humphreys_logo.png",
  "k_480": "clamp(36px,5vw,60px)",
  "k_481": "20px 0 24px",
  "k_482": "16px 0 20px",
  "k_483": "Chasing tenants for rent every month",
  "k_484": "Manual bank reconciliation and spreadsheets",
  "k_485": "Late payments disrupting your cash flow",
  "k_486": "Hours spent generating statements",
  "k_487": "No early warning when a payment is at risk",
  "k_488": "AI charges tenants ahead of the due date",
  "k_489": "Automatic reconciliation and statements",
  "k_490": "Rent arrives on or before leasing effective date",
  "k_491": "One dashboard for your entire portfolio",
  "k_492": "Instant notifications on any payment issue",
  "k_493": "repeat(auto-fit, minmax(260px, 1fr))",
  "k_494": "Scalable rent collection",
  "k_495": "Guarantee rental collections with just a few clicks. AI-driven charging at any scale. Collect from 10 or 10,000 units with the same zero-touch process.",
  "k_496": "One-off collection",
  "k_497": "Recurring collection",
  "k_498": "Collection by phase",
  "k_499": "Operational analytics",
  "k_500": "Property status, yield, income and expense analytics — all in one dashboard your whole team can access.",
  "k_501": "Portfolio-level reporting",
  "k_502": "Expense and yield tracking",
  "k_503": "Utility disbursements",
  "k_504": "Systems integration",
  "k_505": "Secure file exchange with your accounting and property management software. Optional API integration.",
  "k_506": "Accounting system sync",
  "k_507": "Secure file exchange",
  "k_508": "REST API available",
  "k_509": "Banking-standard security",
  "k_510": "FCA-supervised, PCI DSS certified, tokenised card processing.",
  "k_511": "FCA SPI licensed",
  "k_512": "PCI DSS certified",
  "k_513": "Card tokenisation",
  "k_514": "32px 28px",
  "k_515": "20px 0 20px",
  "k_516": "Bad debt provisions",
  "k_517": "Down from prior avg",
  "k_518": "Units managed",
  "k_519": "Premium residential",
  "k_520": "On time",
  "k_521": "Avg collection",
  "k_522": "On leasing effective date",
  "k_523": "↓ 40%",
  "k_524": "Admin headcount",
  "k_525": "Redeployed to residents",
  "k_526": "Individual Landlord",
  "k_527": "From 0^",
  "k_528": "per transaction",
  "k_529": "Up to 5 properties",
  "k_530": "AI charge scheduling",
  "k_531": "Automated receipts",
  "k_532": "Dashboard access",
  "k_533": "Get started",
  "k_534": "Property Developer / Manager",
  "k_535": "Unlimited properties",
  "k_536": "Portfolio analytics",
  "k_537": "Accounting integrations",
  "k_538": "Priority support",
  "k_539": "Custom branding",
  "k_540": "Request enterprise access",
  "k_541": "scale(1.02)",
  "k_542": "clamp(28px,4vw,46px)",
  "k_543": "hsbc_premier_mc",
  "k_544": "HSBC",
  "k_545": "rc",
  "k_546": "RewardCash",
  "k_547": "2.40% RewardCash",
  "k_548": "uploads/hsbc_3d_mastercard_premier.png",
  "k_549": "hsbc_visa_sig",
  "k_550": "3.60% RewardCash",
  "k_551": "uploads/hsbc_3d_visa_signature.png",
  "k_552": "hsbc_everymile",
  "k_553": "HSBC EveryMile Credit Card",
  "k_554": "Miles",
  "k_555": "0.08 miles/HKD",
  "k_556": "hsbc_easy",
  "k_557": "HSBC easy Credit Card",
  "k_558": "cashback",
  "k_559": "Cashback",
  "k_560": "hsbc_red",
  "k_561": "HSBC Red Credit Card",
  "k_562": "0.40% RewardCash",
  "k_563": "uploads/hsbc_3d_red.png",
  "k_564": "hsbc_pulse_up",
  "k_565": "HSBC Pulse UnionPay Diamond",
  "k_566": "uploads/hsbc_pulse_unionpay.png",
  "k_567": "hs_mmpower",
  "k_568": "Hang Seng",
  "k_569": "Hang Seng MMPOWER Card",
  "k_570": "points",
  "k_571": "MoneyBack pts",
  "k_572": "5% +FUN Dollars",
  "k_573": "uploads/hangseng_3d_mpower.png",
  "k_574": "bea_titanium",
  "k_575": "BEA",
  "k_576": "BEA i-Titanium Card",
  "k_577": "4.0% i-Dollar",
  "k_578": "bea_goal",
  "k_579": "BEA GOAL Card",
  "k_580": "4.40% i-Dollar",
  "k_581": "uploads/bea_3d_mastercard_goal.png",
  "k_582": "bea_flyer",
  "k_583": "BEA Flyer World Mastercard",
  "k_584": "Asia Miles",
  "k_585": "10% Asia Miles",
  "k_586": "amex_plat",
  "k_587": "Amex Platinum / Explorer",
  "k_588": "3 points/HKD",
  "k_589": "uploads/amex_3d.png",
  "k_590": "sc_cathay",
  "k_591": "Standard Chartered",
  "k_592": "SC Cathay Mastercard",
  "k_593": "0.16 Asia Miles/HKD",
  "k_594": "uploads/sc_3d_cathay.png",
  "k_595": "sc_simplycash",
  "k_596": "SC Simply Cash Visa",
  "k_597": "1.50% 現金回贈",
  "k_598": "mox",
  "k_599": "Mox",
  "k_600": "Mox Credit",
  "k_601": "1% cashback",
  "k_602": "dbs_black",
  "k_603": "DBS",
  "k_604": "DBS Black World Mastercard",
  "k_605": "0.16 Asia Miles, Avios, KrisFlyer, PhoenixMiles/HKD",
  "k_606": "dahsing_ana",
  "k_607": "Dah Sing",
  "k_608": "Dah Sing ANA World Mastercard",
  "k_609": "ANA Miles",
  "k_610": "0.125 ANA Mileage/HKD",
  "k_611": "dahsing_ba",
  "k_612": "Dah Sing British Airways Platinum",
  "k_613": "Avios",
  "k_614": "0.16 Avios/HKD",
  "k_615": "fubon_in",
  "k_616": "Fubon",
  "k_617": "Fubon iN VISA Platinum",
  "k_618": "8% cashback",
  "k_619": "bochk_chill",
  "k_620": "BOCHK",
  "k_621": "BOCHK Chill Card",
  "k_622": "0.4% cashback",
  "k_623": "bochk_hkairlines",
  "k_624": "BOCHK HK Airlines Visa Signature",
  "k_625": "0.3 FWC Point/HKD",
  "k_626": "bochk_sogo",
  "k_627": "BOCHK SOGO Visa Signature",
  "k_628": "Pts",
  "k_629": "5% cash rebate",
  "k_630": "cncbi_motion",
  "k_631": "CNCBI",
  "k_632": "CNCBI Motion Credit Card",
  "k_633": "6% cash rebate",
  "k_634": "aeon_waku",
  "k_635": "AEON",
  "k_636": "AEON WAKUWAKU",
  "k_637": "6% cashback",
  "k_638": "aeon_jal",
  "k_639": "AEON JAL Mastercard",
  "k_640": "JAL Miles",
  "k_641": "0.125 mile/HKD",
  "k_642": "prime_wewa",
  "k_643": "PrimeCredit",
  "k_644": "PrimeCredit WeWa Visa Signature",
  "k_645": "4% cashback",
  "k_646": "prime_earnmore",
  "k_647": "PrimeCredit EarnMORE UnionPay",
  "k_648": "2% cashback",
  "k_649": "sim",
  "k_650": "sim Credit Card",
  "k_651": "others",
  "k_652": "Other",
  "k_653": "Other Card",
  "k_654": "refer",
  "k_655": "Refer to issuer",
  "k_656": "滙豐",
  "k_657": "滙豐 easy信用卡",
  "k_658": "獎賞錢",
  "k_659": "bea_it",
  "k_660": "東亞",
  "k_661": "東亞 i-Titanium卡",
  "k_662": "i-Dollar",
  "k_663": "hsbc_pulse",
  "k_664": "滙豐 Pulse銀聯雙幣鑽石信用卡",
  "k_665": "ae",
  "k_666": "美國運通",
  "k_667": "美國運通 白金信用卡 / Explorer 信用卡",
  "k_668": "美國運通積分",
  "k_669": "dsb_ana",
  "k_670": "大新",
  "k_671": "大新 ANA World Mastercard",
  "k_672": "ANA 里數",
  "k_673": "dsb_ba",
  "k_674": "大新 英國航空白金卡",
  "k_675": "boc_chill",
  "k_676": "中銀",
  "k_677": "中銀 Chill Card",
  "k_678": "現金回贈",
  "k_679": "boc_hka",
  "k_680": "中銀 香港航空 Visa Signature 卡",
  "k_681": "FWC Points",
  "k_682": "aeon_wakuwaku",
  "k_683": "AEON Card",
  "k_684": "AEON Card WAKUWAKU",
  "k_685": "AEON Card JAL Mastercard",
  "k_686": "日航里數",
  "k_687": "12.50% 日航里數",
  "k_688": "cncbi",
  "k_689": "信銀",
  "k_690": "信銀 國際Motion信用卡",
  "k_691": "fubon",
  "k_692": "FUBON",
  "k_693": "FUBON 富邦iN VISA白金卡",
  "k_694": "boc_sogovs",
  "k_695": "中銀 崇光VisaSignature卡",
  "k_696": "pc_wewa",
  "k_697": "安信",
  "k_698": "安信 WeWa Visa Signature卡",
  "k_699": "pc_earnmore",
  "k_700": "安信EarnMORE",
  "k_701": "安信EarnMORE 銀聯鑽石卡",
  "k_702": "其他信用卡",
  "k_703": "-0.5px",
  "k_704": "0 1px 3px rgba(0,0,0,0.4)",
  "k_705": "2px 5px",
  "k_706": "2px 6px 6px 2px",
  "k_707": "6px 2px 2px 6px",
  "k_708": "undefined",
  "k_709": "Refer issuer",
  "k_710": "transform 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s ease",
  "k_711": "scale(1)",
  "k_712": "drop-shadow(0 20px 40px rgba(0,0,0,0.3))",
  "k_713": "drop-shadow(0 10px 20px rgba(0,0,0,0.15))",
  "k_714": "blur(10px)",
  "k_715": "blur(8px)",
  "k_716": "nowrap",
  "k_717": "0 4px 12px rgba(0,0,0,0.2)",
  "k_718": "0 25px 50px -12px rgba(0,0,0,0.25)",
  "k_719": "0 10px 15px -3px rgba(0,0,0,0.1)",
  "k_720": "inset 0 1px 2px rgba(0,0,0,0.1)",
  "k_721": "0 4px 12px rgba(0,0,0,0.1)",
  "k_722": "start",
  "k_723": "13px 14px 13px 56px",
  "k_724": "border 0.2s",
  "k_725": "3px 11px",
  "k_726": "all 0.15s",
  "k_727": "1 Card",
  "k_728": "2 Cards",
  "k_729": "min HKD 10,000",
  "k_730": "3 Cards",
  "k_731": "min HKD 20,000",
  "k_732": "9px 6px",
  "k_733": "not-allowed",
  "k_734": "14px 16px",
  "k_735": "0 2px 10px rgba(0,0,0,0.04)",
  "k_736": "9px 10px",
  "k_737": "Inter,sans-serif",
  "k_738": "1fr auto 1fr auto 1fr",
  "k_739": "min(320px,100%)",
  "k_740": "min(240px,62%)",
  "k_741": "all 0.35s ease",
  "k_742": "width 0.35s ease",
  "k_743": "18px 20px",
  "k_744": "10px 12px",
  "k_745": "10px 0",
  "k_746": "26px 0",
  "k_747": "all 0.25s",
  "k_748": "M2 8L6 4L10 8",
  "k_749": "M2 4L6 8L10 4",
  "k_750": "140px 24px 100px",
  "k_751": "clamp(38px,5.5vw,66px)",
  "k_752": "smooth",
  "k_753": "uploads/mastercard_v5.svg",
  "k_754": "uploads/visa_v4.png",
  "k_755": "uploads/amex_v4.png",
  "k_756": "uploads/unionpay_v4.svg",
  "k_757": "Apple Pay",
  "k_758": "uploads/apple_pay_v4.svg",
  "k_759": "Google Pay",
  "k_760": "uploads/google_pay_v4.svg",
  "k_761": "AI determines the optimal charge date before your lease date.",
  "k_762": "28px 20px",
  "k_763": "0 4px 20px rgba(0,0,0,0.04)",
  "k_764": "0 auto 20px",
  "k_765": "clamp(26px,3.5vw,40px)",
  "k_766": "40px auto 80px",
  "k_767": "14px 28px",
  "k_768": "Tokenised",
  "k_769": "Your card number is immediately replaced with a secure token. We never store real card data.",
  "k_770": "Certified compliant to the highest card payment security standard globally.",
  "k_771": "You control it",
  "k_772": "View or cancel your smart contract any time from the app — 24/7.",
  "k_773": "2FA always",
  "k_774": "Every authorisation uses risk-based two-factor authentication for maximum security.",
  "k_775": "How to pay rent for Public Housing?",
  "k_776": "Yes. Please manage your payment methods in our Mobile App or Web App with your bill number.",
  "k_777": "Does my landlord need to register too if I use Keychain to pay rent?",
  "k_778": "No. However, you may give your landlord a heads up that you will be paying via Keychain. Your landlord will see a transfer record from KeyChain Fintech Ltd. We will also put tenant name into the remark field but it is not guaranteed to be shown as banks may handle the remark field differently.",
  "k_779": "When do you charge on my credit or debit card? Can I set the charge date?",
  "k_780": "Our AI decides the charge date for you. The AI predicts the most appropriate charge date so to ensure rent is arrived on time. The charge date is about 1-10 business days ahead of your monthly leasing effective date. We do not allow any manual set up on the charge date.",
  "k_781": "When shall I submit the application?",
  "k_782": "Please submit your application 7-10 days before the leasing effective date to ensure sufficient time to process transactions and deposits.",
  "k_783": "pre-wrap",
  "k_784": "120px 24px 80px",
  "k_785": "160px 24px 110px",
  "k_786": "clamp(40px, 5.5vw, 72px)",
  "k_787": "clamp(18px, 2vw, 22px)",
  "k_788": "1fr",
  "k_789": "1fr 1.2fr",
  "k_790": "clamp(32px, 4vw, 44px)",
  "k_791": "24px 0 28px",
  "k_792": "Fragmented Payments",
  "k_793": "Manual bank transfers and cheques lack the automation required for modern portfolio management.",
  "k_794": "Credit Blind Spots",
  "k_795": "Banks lack structured rental payment data to accurately underwrite the next generation of tenants.",
  "k_796": "Operational Overhead",
  "k_797": "Property managers are burdened by manual reconciliation and arrears management.",
  "k_798": "48px 40px",
  "k_799": "AI Credit Engine",
  "k_800": "Proprietary models for credit scoring, KYC/AML, and transaction monitoring. Credit built on Blockchain ready for bank reference.",
  "k_801": "Automated Collection",
  "k_802": "Smart contract-based recurring rent collection ensures payments are secured before the due date.",
  "k_803": "Payment Orchestration",
  "k_804": "Sophisticated rails for split payments, cross-border settlements, and institutional reporting.",
  "k_805": "The generative automation layer that handles operations, communications, and workflow without human intervention.",
  "k_806": "1.2fr 1fr",
  "k_807": "Digital Payments",
  "k_808": "Growth",
  "k_809": "Accelerating shift from manual to automated rails.",
  "k_810": "AI Adoption",
  "k_811": "Massive",
  "k_812": "Workflow automation moving from \"nice-to-have\" to core infrastructure.",
  "k_813": "Alt Credit",
  "k_814": "Rise",
  "k_815": "Increasing demand for alternative data-driven underwriting.",
  "k_816": "Proptech-Fintech",
  "k_817": "Convergence",
  "k_818": "Real estate operations and financial services are merging.",
  "k_819": "24px 0 24px",
  "k_820": "clamp(32px, 5vw, 52px)",
  "k_821": "28px 0 32px",
  "k_822": "Reduces Cost",
  "k_823": "Automates manual admin tasks by 80%+",
  "k_824": "Increases Retention",
  "k_825": "Faster responses and smoother payment UX",
  "k_826": "Scales Instantly",
  "k_827": "Manage 10k units as easily as 10",
  "k_828": "LTV",
  "k_829": "Industry-Outlier High",
  "k_830": "CAC",
  "k_831": "Low",
  "k_832": "Payback",
  "k_833": "Extremely Short",
  "k_834": "Churn",
  "k_835": "ltv-pulse-card",
  "k_836": "transform 0.3s, box-shadow 0.3s",
  "k_837": "0 10px 25px rgba(0,0,0,0.05)",
  "k_838": "Credit Reference hybrid monetization",
  "k_839": "Insurance / Guarantee cross-sell",
  "k_840": "Security deposit alternative financing",
  "k_841": "Proptech workflow automation licensing",
  "k_842": "Growing Adoption",
  "k_843": "Strong month-over-month growth in landlord portfolios and resident sign-ups.",
  "k_844": "Recurring Behavior",
  "k_845": "99%+ payment retention rate driven by automated smart-contract rails.",
  "k_846": "Global Expansion",
  "k_847": "Operational footprint expanding from Hong Kong into the UK and beyond.",
  "k_848": "64px 48px",
  "k_849": "repeat(auto-fit, minmax(200px, 1fr))",
  "k_850": "Superior Unit Economics",
  "k_851": "50× LTV/CAC at scale",
  "k_852": "Scalable Acquisition",
  "k_853": "High organic / referral mix",
  "k_854": "Defensible Data Loop",
  "k_855": "Proprietary AI/Credit feedback",
  "k_856": "Ecosystem Validation",
  "k_857": "Mastercard & Google supported",
  "k_858": "dark",
  "k_859": "<div style=\"margin-bottom: 20px\"> We only charge a transaction fee! </div> <style>#fee-rate-table-remark { display: none; font-size: 13px; color: #6B7280; margin-bottom: 8px; } @media (max-width: 570px) { #fee-rate-table-remark { display: block; } }</style><div id=\"fee-rate-table-remark\">(scroll right to see more)</div> <div class=\"fee-rate-table\"> <table> <tbody><tr> <td></td> <th scope=\"col\">Residential &amp; Carpark</th> <th scope=\"col\">Commercial</th> </tr> <tr> <th scope=\"col\"> Domestic Individual HSBC Mastercard or Visa cards </th> <td>1.8%</td> <td>1.98%</td> </tr> <tr> <th scope=\"col\"> Domestic Individual HSBC UnionPay cards* </th> <td>0.8%</td> <td>0.98%</td> </tr> <tr> <th scope=\"col\"> Domestic Individual Mastercard or Visa cards(non-HSBC) </th> <td>1.98%</td> <td>2.5%</td> </tr> <tr> <th scope=\"col\"> Domestic Individual UnionPay cards(non-HSBC)* </th> <td>0.98%</td> <td>1.98%</td> </tr> <tr> <th scope=\"col\"> Mainland China UnionPay cards* / International cards / Corporate cards / Apple Pay^ / Google Pay^ </th> <td colspan=\"3\">2.98%</td> </tr> <tr> <th scope=\"col\">American Express</th> <td colspan=\"3\">3.5%</td> </tr> </tbody></table> <br> <p> *UnionPay card is only applicable for rent above or equal to HK$10,000 (excludes transaction fee). </p> <p> ^Apple Pay / Google Pay is only applicable for rent below HK$10,000 (excludes transaction fee). </p> </div>",
  "k_860": "Yes. Keychain mobile APP and Web Portal are PCI-DSS certified (Payment Card Industry Data Security Standards), and data is subject to bank-level security measures. <a href=\"/en/home/#security\" target=\"_blank\" style=\"color: #0d333f\">Learn More</a>. <br><br> Keychain doesn’t store the original credit or debit card numbers that you use with us. And when you use credit or debit cards, your transaction involves (i) the authorised token in the case of Apple Pay or Google Pay, or (ii) the last 4 digits of your credit or debit card number.",
  "k_861": "How do I set up a Smart Contract?",
  "k_862": "Setting up is easy and can be done in as quick as 5 minutes:<br> ⋅ Basic tenancy information<br> ⋅ Landlord's contact number and bank account<br> ⋅ Tenancy Agreement and stamp proof (or CR109) <br> ⋅ Credit or debit card",
  "k_863": "Why do you need Tenancy Agreement?",
  "k_864": "Understanding who we serve for and the purpose of using Keychain is vital to detecting and deterring fraudulent use and abuse of cards as well as money laundering. Please upload the Tenancy Agreement and stamp proof.",
  "k_865": "Can I change, add, or remove payment methods?",
  "k_866": "Yes. Please manage your payment methods in our Mobile App or Web App.",
  "k_867": "Can I adjust the rent amount?",
  "k_868": "Yes. Please adjust the rent amount in our Mobile App or Web App.",
  "k_869": "Can I extend or terminate my Smart Contract?",
  "k_870": "Yes. Please extend or terminate your Smart Contract in our Mobile App or Web App.",
  "k_871": "No. But, you may give your landlord a heads up that you will be paying via KeyChain.<br>KeyChain doesn’t store the original credit or debit card numbers that you use with us. And when you use credit or debit cards, your transaction involves (i) the authorised token in the case of Apple Pay or Google Pay, or (ii) the last 4 digits of your credit or debit card number.",
  "k_872": "In general, your landlord will receive your rent on the leasing effective day of each month. <br><br> Our AI ensures your rent will be arrived on time. We do not allow any manual set up on both of the dates. <br><br> You may log in to our Mobile App or Web App to check the estimated or the latest deposit date.",
  "k_873": "Can you let my landlord know when the rent is transferred?",
  "k_874": "Yes. If the landlord's email address is provided in your application, we will send an email notification to the landlord when the rent is transferred to his/her bank account. You may log in to our Mobile App or Web App to check the estimated or the latest deposit date.",
  "k_875": "What if my credit card does not have enough limits?",
  "k_876": "When paying with us for the first time, we put a withholding of your rent with our transaction fee in your card.To make sure you have enough credits available, please settle any outstanding balance or contact your card issuer to increase your card limits before application.",
  "k_877": "Which card I can earn most on?",
  "k_878": "You can refer to our Rewards Calculator <a href=\"/en/tenants/#rewards-calculator\" target=\"_blank\">HERE</a>. <br> *The results are dependent on an online merchant simulation and displayed for reference only. You should contact your card issuer for confirmation.",
  "k_879": "How do I confirm how much I earn on my credit or debit card?",
  "k_880": "You can check through your bank statement or mobile banking app, or contact the card issuer for your rewards entitlement.",
  "k_881": "How to start using SPLIT?",
  "k_882": "Just three easy steps: <br> <div class=\"flexbox\"> <div class=\"flex-item\"> <div class=\"item\"> Step 1: Select \"Payment Method\". </div> <br> <div class=\"img\"> <img src=\"./images/src/setup/split_payment_step_1.png\" layout=\"responsive\" width=\"370\" height=\"680\"> </div> </div> <br> <div class=\"flex-item\"> <div class=\"item\"> Step 2: Select 2 or 3 cards for SPLIT. </div> <br> <div class=\"img\"> <img src=\"./images/src/setup/split_payment_step_2.png\" layout=\"responsive\" width=\"370\" height=\"680\"> </div> </div> <br> <div class=\"flex-item\"> <div class=\"item\"> Step 3: Set split ratios for each card. </div> <br> <div class=\"img\"> <img src=\"./images/src/setup/split_payment_step_3.png\" layout=\"responsive\" width=\"370\" height=\"680\"> </div> </div> </div>",
  "k_883": "How many payment cards I can use to pay?",
  "k_884": "You can use up to three cards each time - feel free to split with any of your credit or debit cards to pay. <br><br> We do not support Apply Pay and Google Pay for SPLIT at the moment.",
  "k_885": "Can I earn rewards on all payment cards?",
  "k_886": "Your rewards are subject to your card issuer's terms and conditions. Please contact your card issuer for rewards entitlement.",
  "k_887": "Is there any limit on rent amount for SPLIT?",
  "k_888": "The minimum rent amount on SPLIT for 2 cards is set at HK$10,000 or above on Smart Contract, while SPLIT for 3 cards requires a minimum of HK$20,000 or above.",
  "k_889": "I have a running Smart Contract. Can I still use SPLIT to pay my rent?",
  "k_890": "Yes. You can add another payment card on your existing Smart Contract before the next charge date.",
  "k_891": "How to calculate transaction fee for SPLIT?",
  "k_892": "Our rates remain unchanged! We charge on a pro-rata basis, for example, <br><br> Rent: HK$20,000, <br> Payment cards: 3 Mastercards, Transaction fee: 1.98%, SPLIT ratio: 5:3:2, <br> So the transaction fee is only at a total of HK$396. <br><br> ● Mastercard 1: (20,000 x 50%) x 1.98% = $198 <br> ● Mastercard 2: (20,000 x 30%) x 1.98% = $118.8 <br> ● Mastercard 3: (20,000 x 20%) x 1.98% = $79.2",
  "k_893": "When and how will the rebate be deducted?",
  "k_894": "Rebates are not deducted from the credit card authorization amount and are only deducted when the card is formally charged. <br><br> The rebate will be used to deduct the transaction fee when the transaction fee is higher or equal to the total amount of the rebate. The rebate will be used to deduct the transaction fee in your next payment with us.",
  "k_895": "For public housing, when will the Housing Authority receive my rent?",
  "k_896": "Generally, your rent will be paid to the Housing Authority about one week after your application has been submitted and approved, or on or before the last business day of each month.",
  "k_897": "If the tenancy agreement is about to expire, but I am ready to renew the lease, can I extend the Smart Contract directly in the App to continue the rental payment?",
  "k_898": "If you wish to extend your Smart Contract, please click on the Smart Contract details after logging in to the App, and click the \"Extend Contract\" button at the top of the page. <br><br> You are not required to re-upload the full lease document if the original lease is still valid when you extend the Smart Contract. <br><br> However, if the originally uploaded lease lapses when you extend the Smart Contract, you need to re-upload the complete lease document. Please submit your application 7-10 days before the leasing effective date to ensure sufficient time to process transactions and deposits.",
  "k_899": "Can I pay in advance? Can I pay more than one month's rent at a time?",
  "k_900": "You may apply for a one-off payment for a certain period, as long as it is stated in your Tenancy Agreement or with other valid proofs. Please enable the one-off payment option and input the total rent amount.",
  "k_901": "The lease lasts for several years. Is it possible to pay for a few months only? For example, my lease lasts for two years but I would like to pay for one month only.",
  "k_902": "Yes, just submit the dates you need to pay this time and we will review your application.",
  "k_903": "Can I stop rent payment for only one month?",
  "k_904": "We are sorry that we are unable to stop the rental payment for one month only. You may only terminate the Smart Contract. If you would like to continue using our services, please set up a new Smart Contract. <br><br> Please terminate your Smart Contract with the following steps:<br> Step 1: Select \"Contract List”<br> Step 2: Choose the corresponding Smart Contract<br> Step 3: Click the address to enter the detail page of the Smart Contract<br> Step 4: On the top of the page, press the \"Termination\" button<br>",
  "k_905": "Can I use my partner's credit card to pay the rent?",
  "k_906": "Generally, we recommend using the tenant's own credit card(s), but you can still submit the application with a different card combination. The outcome of the Smart Contract application is subject to the sole decision by AI and our company.",
  "k_907": "How can I view the detailed debit date for the payment schedule?",
  "k_908": "Please open the menu, press \"Contract List\", select the corresponding Smart Contract, and then click \"Payment Schedule\" to view the subsequent debit dates.",
  "k_909": "How to change the payment card?",
  "k_910": "Please open the menu, press \"Contract List\", select the corresponding Smart Contract. Then, please press \"Payment\" and press “Change Card &amp; Distribution”. Next, select or add the payment card(s) you would like to pay with.",
  "k_911": "160px 24px 80px",
  "k_912": "clamp(40px,5vw,64px)",
  "k_913": "object",
  "k_914": "0 20px 60px rgba(0,0,0,0.15)",
  "k_915": "border 0.15s",
  "k_916": "7px 12px",
  "k_917": "capitalize",
  "k_918": "404",
  "k_919": "Page not found",
  "k_920": "The page you're looking for doesn't exist or may have moved.",
  "k_921": "Go to Home",
  "k_922": "https://www.swireproperties.com/en/",
  "k_923": "https://www.sunhinggroup.com/zh/%e4%b8%bb%e9%a0%81/",
  "k_924": "https://www.redhotoffers.hsbc.com.hk/en/rewards/red-hot-rewards-of-your-choice/popup-home/",
  "k_925": '<div style="margin-bottom: 20px">We only charge a transaction fee!</div><div style="overflow-x: auto; width: 100%;"><table style="width: 100%; border-collapse: collapse; min-width: 500px; text-align: left; font-size: 14px;"><thead><tr><th style="padding: 12px; background: #042F2E; color: white; border: 1px solid #E5E7EB; border-top-left-radius: 8px;"></th><th style="padding: 12px; background: #042F2E; color: white; border: 1px solid #E5E7EB;">Residential & Carpark</th><th style="padding: 12px; background: #042F2E; color: white; border: 1px solid #E5E7EB; border-top-right-radius: 8px;">Commercial</th></tr></thead><tbody><tr><td style="padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB; font-weight: 600;">Domestic Individual HSBC Mastercard or Visa cards</td><td style="padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB;">1.80%</td><td style="padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB;">1.98%</td></tr><tr><td style="padding: 12px; border: 1px solid #E5E7EB; font-weight: 600;">Domestic Individual HSBC UnionPay cards*</td><td style="padding: 12px; border: 1px solid #E5E7EB;">0.80%</td><td style="padding: 12px; border: 1px solid #E5E7EB;">0.98%</td></tr><tr><td style="padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB; font-weight: 600;">Domestic Individual Mastercard or Visa cards(non-HSBC)</td><td style="padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB;">1.98%</td><td style="padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB;">2.50%</td></tr><tr><td style="padding: 12px; border: 1px solid #E5E7EB; font-weight: 600;">Domestic Individual UnionPay cards(non-HSBC)*</td><td style="padding: 12px; border: 1px solid #E5E7EB;">0.98%</td><td style="padding: 12px; border: 1px solid #E5E7EB;">1.98%</td></tr><tr><td style="padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB; font-weight: 600;">Mainland China UnionPay cards* / International cards / Corporate cards / Apple Pay^ / Google Pay^</td><td colspan="2" style="padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB; text-align: center;">2.98%</td></tr><tr><td style="padding: 12px; border: 1px solid #E5E7EB; font-weight: 600; border-bottom-left-radius: 8px;">American Express</td><td colspan="2" style="padding: 12px; border: 1px solid #E5E7EB; text-align: center; border-bottom-right-radius: 8px;">3.5%</td></tr></tbody></table></div><p style="font-size: 12px; color: #6B7280; margin-top: 12px;">*UnionPay card is only applicable for rent above or equal to HK$10,000 (excludes transaction fee).</p><p style="font-size: 12px; color: #6B7280; margin-top: 4px;">^Apple Pay / Google Pay is only applicable for rent below HK$10,000 (excludes transaction fee).</p>',
  "k_926": "https://www.sino.com/en/",
  "k_927": "https://www.hanglung.com/en-us/home",
  "k_928": "https://www.starstudios.com.hk/",
  "k_929": "https://www.hamtinvillas.hk/",
  "k_930": "https://www.pacificpalisades.com.hk/",
  "k_931": "https://www.goldcoastresidences.com.hk/en/",
  "k_932": "https://www.sinosuites.com.hk/en/",
  "k_933": "118 TLWR",
  "k_934": "uploads/t7k2m9_118tlwr_logo.png",
  "k_935": "Pacific Place Apartments",
  "k_936": "uploads/p3n8r1_pacific_place_apartments_logo.png",
  "k_937": "https://www.118tunglowan.com/",
  "k_938": "https://www.upperhouse.com/en/hongkong/pacific-place-apartments/",
  "k_939": "RewardCash",
  "k_940": "Miles",
  "k_941": "Asia Miles",
  "k_942": "Rebate",
  "k_943": "CashBack",
  "k_944": "Cash Rebate",
  "k_945": "Cash equiv.",
  "k_946": "JMB miles",
  "k_947": "Points",
  "k_948": "i-Dollar",
  "k_949": "+FUN Dollars",
  "k_950": "FWC Points",
  "k_951": "Avios Conversion",
  "k_952": "DBS$",
  "k_953": "Base 0.4% only — 4% online bonus tier excludes rent payments per HSBC Red T&C.",
  "k_954": "5.0% +FUN Dollars",
  "k_955": "4.0% i-Dollar",
  "k_956": "4.4% i-Dollar",
  "k_957": "HK$1 = 3 points",
  "k_958": "1.0% Rebate",
  "k_959": "1.0% Points Rebate",
  "k_960": "HK$100,000/yr RYC cap",
  "k_961": "RewardCash Equivalent: ",
  "k_962": "Cap reached",
  "k_963": "RYC 2.4% subject to HK$100,000 annual spending cap.",
  "k_964": "RYC 2.4% applies to first HK$100,000 spent per year; remaining earns base rate only.",
  "k_965": "*The results are dependent on an online-merchant simulation and displayed for reference only. They do not include any welcome offer or other promotions and offers. KeyChain FinTech Ltd. does not guarantee the accuracy, timeliness, validity or completeness of such information, and no responsibility or liability is accepted in relation to any loss or cost you may incur. Customer should refer to the actual Mileages / RewardCash / Cash Rebates stated in your monthly statement for the final amount entitled or reach out to card issuer for any questions.",
  "k_966": "简",
  "k_967": "(UnionPay) requires rent ≥ HK$10,000.",
  "k_968": "per month",
  "k_969": "Adjust inputs to see your reward estimate.",
  "k_970": "HSBC CREDIT CARDS × KEYCHAIN",
  "k_971": "Earn RewardCash on your rent",
  "k_972": "Pay rent with your HSBC credit card via Keychain — transaction fee as low as 0.8%, and earn up to 3.6% RewardCash.",
  "k_974": "See HSBC offers",
  "k_975": "uploads/hsbc-promo-hero.webp",
  "k_976": "View HSBC Year-round Offers",
  "k_977": "https://www.redhotoffers.hsbc.com.hk/en/yro/?cardType=Others&spendingCat=Travel+%26+Lifestyle&subCat=Others",
  "k_978": "Offers & Rewards",
  "k_979": "Promotions",
};
const DICT_TC = {
  "k_0": "Keychain",
  "k_1": "Keychain — go to home",
  "k_2": "登入",
  "k_3": "解決方案",
  "k_4": "聊天機器人",
  "k_5": "KeyChain 智能助理",
  "k_6": "智能租務代理。受英國金融行為監管局(FCA)監管之支付機構",
  "k_7": "聯絡我們",
  "k_8": "🇬🇧 UK Office",
  "k_9": "3rd Floor 86-90 Paul Street, London, EC2A 4NE, UK",
  "k_10": "🇭🇰 HK Office",
  "k_11": "Unit 1901, 19/F, No. 3 Lockhart Road, Wanchai, Hong Kong",
  "k_12": "© 2026 KeyChain FinTech Ltd. All rights reserved.",
  "k_13": "實時收租率",
  "k_14": "AI 監控 · 實時",
  "k_15": "middle",
  "k_16": "Space Grotesk, sans-serif",
  "k_17": "準時",
  "k_18": "14 日",
  "k_19": "平均提早",
  "k_20": "38 小時",
  "k_21": "每月節省",
  "k_22": "最近收款",
  "k_23": "rgba(229,117,0,0.4)",
  "k_24": "智能租務代理",
  "k_25": "rgba(255,255,255,0.25)",
  "k_26": "FCA支付機構牌照",
  "k_27": "用信用卡交租，",
  "k_28": "準時過數、",
  "k_29": "賺盡積分",
  "k_30": "Keychain AI 會在到期日前鎖定租金，實現物業管理自動化，並將每筆租金變成獎賞。",
  "k_31": "租戶",
  "k_32": "業主",
  "k_33": "投資者",
  "k_34": "如何運作",
  "k_35": "兩種無縫方式。同一個目標。",
  "k_36": "無論您是收租還是交租，Keychain 都為您處理所有繁複的程序。",
  "k_37": "致",
  "k_38": "white",
  "k_39": "為甚麼選擇 Keychain",
  "k_40": "三大關鍵成果。",
  "k_41": "我們的產品",
  "k_42": "為您而設的應用程式、平台及智能助理。",
  "k_43": "專為需要穩定收入的業主及尋求優質體驗的租戶而設。",
  "k_44": "深受信任",
  "k_45": "具遠見的客戶及頂級合作夥伴。",
  "k_46": "發展商",
  "k_47": "信和集團",
  "k_48": "太古地產",
  "k_49": "恒隆地產",
  "k_50": "新興集團",
  "k_51": "銀行及合作夥伴",
  "k_52": "Mastercard Start Path",
  "k_53": "滙豐 Visa Signature 卡",
  "k_54": "滙豐卓越理財信用卡",
  "k_55": "Google for Startups",
  "k_56": "安全與合規",
  "k_57": "銀行級別保障。",
  "k_58": "您的資料及資金均受最高標準的保障。",
  "k_59": "常見問題",
  "k_60": "常見問題。",
  "k_61": "rgba(255,165,103,0.2)",
  "k_62": "立即開始",
  "k_63": "準備好告別欠租問題嗎？",
  "k_64": "加入香港及英國的業主及租戶行列。",
  "k_65": "收租準時比率",
  "k_66": "↑ 相比行業平均 87%",
  "k_67": "物業",
  "k_68": "+12 本季度",
  "k_69": "VISA",
  "k_70": "AMEX",
  "k_71": "持卡人",
  "k_72": "本月",
  "k_73": "現金回贈 / 月",
  "k_74": "HKD",
  "k_75": "YTD: HKD",
  "k_76": "里數 / 月",
  "k_77": "YTD:",
  "k_78": "miles",
  "k_79": "rgba(45,212,191,0.1)",
  "k_80": "致業主、發展商及物業經理",
  "k_81": "告別追租。",
  "k_82": "以 AI 升級您的物業組合。",
  "k_83": "透過 AI 驅動的智能合約提前收取租金。從個別單位到全球物業組合，零風險提升您的現金流。",
  "k_84": "登入 →",
  "k_85": "預約示範",
  "k_86": "rgba(13,148,136,0.1)",
  "k_87": "我們的客戶",
  "k_88": "深受頂級物業信賴",
  "k_89": "傳統模式",
  "k_90": "追收租金費時失事。",
  "k_91": "Keychain 方案",
  "k_92": "一次設定，輕鬆搞定。",
  "k_93": "平台功能",
  "k_94": "零行政負擔，輕鬆擴展物業組合。",
  "k_95": "專為管理數百至數千個單位的個人業主及地產公司而設。",
  "k_96": "案例分析",
  "k_97": "告別手動追租，實現零欠租。",
  "k_98": "一間管理超過 300 個尊貴住宅單位的香港大型地產發展商已採用 Keychain。在首個季度內，租金拖欠金額即降至零。",
  "k_99": "「有關拖欠租金單位已轉用Keychain，我們無需再為壞帳作任何撥備。」",
  "k_100": "物業組合管理高級總監",
  "k_101": "收費標準",
  "k_102": "收費簡單透明。",
  "k_103": "絕無隱藏收費。您可自行決定由誰支付交易費。",
  "k_104": "^ 業主／物業經理可決定交易費由租戶或業主支付。",
  "k_105": "準備好開啟安心無憂的租務體驗了嗎？",
  "k_106": "加入香港及英國頂尖業主與物業管理公司的行列。",
  "k_107": "立即登入 →",
  "k_108": "本月",
  "k_109": "% · HKD",
  "k_110": "每月租金",
  "k_111": "分卡付款",
  "k_112": "Card",
  "k_113": "✓ 豁免交易費",
  "k_114": "交易費: HKD",
  "k_115": "支出: HKD",
  "k_116": "交易費",
  "k_117": "總支出",
  "k_118": "分卡付款",
  "k_119": "預計每月獎賞",
  "k_120": "每月",
  "k_121": "/ 年",
  "k_122": "mi",
  "k_123": "里 / 年",
  "k_124": "pts",
  "k_125": "分 / 年",
  "k_126": "回贈詳情請參閱發卡機構之條款。",
  "k_127": "*結果僅供參考。獎賞以總支出（租金+交易費）作為網上商戶交易計算。不包括迎新優惠。最終金額請向發卡機構查詢。受條款及細則約束。",
  "k_128": "rgba(229,117,0,0.1)",
  "k_129": "信用卡/扣賬卡獎賞計算機",
  "k_130": "了解每月 HK$",
  "k_131": " 的租金可賺取多少獎賞。",
  "k_132": "rgba(230,160,137,0.25)",
  "k_133": "致租戶",
  "k_134": "SPLIT分卡付款。",
  "k_135": "識用信用卡交租",
  "k_136": "您值得獎賞。",
  "k_137": "使用您喜歡的信用卡或電子錢包。最多可分拆至 3 張卡付款。付款時間交由 AI 安排 — 您只需輕鬆賺取獎賞。",
  "k_138": "下載應用程式",
  "k_139": "查看預計獎賞",
  "k_140": "立即開始",
  "k_141": "5 分鐘內即可啟用。",
  "k_142": "毋須填表，毋須等待。只需輕按授權，即可輕鬆解決繁瑣租務。",
  "k_143": "rgba(230,160,137,0.15)",
  "k_144": "獎賞",
  "k_145": "租金是您",
  "k_146": "最大的開支。",
  "k_147": "立即從中賺取現金回贈/飛行里數/信用卡積分。",
  "k_148": "在網上交租，透過我們的信用卡合作夥伴計劃，賺取飛行里數、現金回贈及積分。每筆租金付款，皆可如一般信用卡消費般賺取獎賞。",
  "k_149": "分卡付款",
  "k_150": "將租金分攤至",
  "k_151": "最多 3 張信用卡。",
  "k_152": "將不同金額分配到不同信用卡以賺取最多獎賞。基於風險的雙重認證（2FA）確保每張卡的安全。",
  "k_153": "估算您的獎賞",
  "k_154": "向我們的人工智能助理 Kate 查詢如何透過信用卡交租賺取最多獎賞",
  "k_155": "與 Kate 對話 →",
  "k_156": "linear-gradient(135deg, #1F3540 0%, #494D4C 100%)",
  "k_157": "您的安全",
  "k_158": "您的銀行卡資料絕不會被儲存。",
  "k_159": "達到銀行級別的安全標準。",
  "k_160": "租戶常見問題",
  "k_161": "為您解答疑問。",
  "k_162": "還有其他問題？",
  "k_163": "開始從租金賺取回報。",
  "k_164": "下載 Keychain 並在 5 分鐘內完成設定。",
  "k_165": "下載 iOS 版本",
  "k_166": "下載 Android 版本",
  "k_167": "AI 租務代理：",
  "k_168": "當持續性收入，",
  "k_169": "遇上 AI 信貸評估。",
  "k_170": "Keychain 正在打造面向全球租賃經濟的自主化 FinTech × PropTech 生態——以資本效率為核心、以數據智能為驅動，並獲全球 AI 與支付領域領導者支持。",
  "k_171": "rgba(255,165,103,0.12)",
  "k_172": "",
  "k_173": "ASIA",
  "k_174": "PAY",
  "k_175": "資本",
  "k_176": "rgba(255,95,0,0.1)",
  "k_177": "rgba(255,255,255,0.08)",
  "k_178": "G",
  "k_179": "o",
  "k_180": "g",
  "k_181": "l",
  "k_182": "e",
  "k_183": "for Startups",
  "k_184": "rgba(20,184,166,0.1)",
  "k_185": "市場痛點",
  "k_186": "全球市場仍依賴過時的系統運作。",
  "k_187": "住宅租務市場作為全球規模最大的資產類別之一，至今仍存在根本性的低效問題。支付方式零散、信用紀錄透明度不足，以及缺乏結構化數據，正為業主與金融機構之間形成龐大的「基礎設施缺口」，蘊藏巨大的數位化與金融升級機遇。",
  "k_188": "投資理念",
  "k_189": "我們相信，",
  "k_190": "AI 代理化",
  "k_191": "與",
  "k_192": "嵌入式信貸基礎設施",
  "k_193": "的融合，將重新定義租金收入的保障方式、管理模式，以及資本化效率。",
  "k_194": "50×",
  "k_195": "客戶終身價值 / 客戶獲取成本",
  "k_196": "冠絕同儕",
  "k_197": "客戶終身價值與行業對比",
  "k_198": "解決方案",
  "k_199": "以 AI 驅動的租務金融基礎設施。",
  "k_200": "Keychain 將整個租務生命週期整合至單一的自動化平台，從信貸評分到自動化現金流。",
  "k_201": "為何是現在？",
  "k_202": "租務基建的最佳時機。",
  "k_203": "這四大宏觀趨勢的匯聚創造了獨特的機遇。Keychain 的基建正為此而設 — 運用 AI 解決傳統營運問題，同時創造極具價值的金融數據集。",
  "k_204": "rgba(20,184,166,0.15)",
  "k_205": "核心理念",
  "k_206": "智能租務代理不只是一個聊天機器人。",
  "k_207": "它是一個",
  "k_208": "自動化財務及物業營運平台",
  "k_209": "。它能處理租戶互動、付款提醒及複雜的工作流程自動化，讓物業組合在不增加人手的情況下擴展。",
  "k_210": "商業模式",
  "k_211": "可預測、可擴展的經常性收入。",
  "k_212": "我們的混合模式結合了高利潤的經常性軟件費用、基於交易量的收費，以及高意向的信貸參考。這創造了多元化的收入來源，同時加深了我們與用戶的關係。",
  "k_213": "戰略性嵌入式金融",
  "k_214": "業務發展",
  "k_215": "獲得頂級客戶認可。",
  "k_216": "我們的增長由用戶的持續使用及擴展至全球主要金融中心所帶動。",
  "k_217": "為何我們能脫穎而出",
  "k_218": "索取投資者簡介",
  "k_219": "常見問題",
  "k_220": "所有您需要了解關於 Keychain 的資訊。",
  "k_221": "微調",
  "k_222": "主題顏色",
  "k_223": "前往頁面",
  "k_224": "登入",
  "k_225": "解決方案",
  "k_226": "聊天機械人",
  "k_227": "KeyChain 智能助理",
  "k_228": "聯絡我們",
  "k_229": "智能租務代理",
  "k_230": "租戶",
  "k_231": "業主",
  "k_232": "投資者",
  "k_233": "常見問題",
  "k_234": "致租戶",
  "k_235": "下載應用程式",
  "k_236": "查看預計獎賞",
  "k_237": "獎賞",
  "k_238": "估算您的獎賞",
  "k_239": "向我們的人工智能助理 Kate 查詢如何透過信用卡交租賺取最多獎賞",
  "k_240": "與 Kate 對話 →",
  "k_241": "contain",
  "k_242": "業主、發展商及物業管理",
  "k_243": "專為物業組合而設的企業級收租平台",
  "k_244": "租戶",
  "k_245": "交租同時賺獎賞",
  "k_246": "投資者及合作夥伴",
  "k_247": "業務發展、投資理念及合作夥伴",
  "k_248": "blur(12px)",
  "k_249": "all 0.3s ease",
  "k_250": "0 auto",
  "k_251": "pointer",
  "k_252": "6px 12px",
  "k_253": "background 0.2s",
  "k_254": "繁",
  "k_255": "Eng",
  "k_256": "9px 18px",
  "k_257": "關閉選單",
  "k_258": "打開選單",
  "k_259": "4px 8px",
  "k_260": "16px 24px 32px",
  "k_261": "calc(100vh - 68px)",
  "k_262": "uppercase",
  "k_263": "left",
  "k_264": "16px 0",
  "k_265": "16px 24px",
  "k_266": "0 8px 24px rgba(229,117,0,0.25)",
  "k_267": "8px 14px",
  "k_268": "color 0.2s, background 0.2s",
  "k_269": "業主及發展商",
  "k_270": "公司資訊",
  "k_271": "聯絡我們",
  "k_272": "mailto:enquiry@keychainpay.com",
  "k_273": "法律及條款",
  "k_274": "服務條款",
  "k_275": "私隱政策",
  "k_276": "用戶條款",
  "k_277": "Cookie 政策",
  "k_278": "英國 FCA 註冊",
  "k_279": "LinkedIn",
  "k_280": "Facebook",
  "k_281": "Instagram",
  "k_282": "電郵",
  "k_283": "column",
  "k_284": "0 20px 40px rgba(0,0,0,0.5)",
  "k_285": "space-between",
  "k_286": "grid",
  "k_287": "repeat(auto-fit, minmax(160px, 1fr))",
  "k_288": "_self",
  "k_289": "_blank",
  "k_290": "all 0.2s",
  "k_291": "default",
  "k_292": "color 0.15s",
  "k_293": "12px 16px",
  "k_294": "0 10px 30px rgba(0,0,0,0.2)",
  "k_295": "wrap",
  "k_296": "🇬🇧 英國",
  "k_297": "🇭🇰 香港",
  "k_298": "4px 10px",
  "k_299": "IntersectionObserver",
  "k_300": "0px 0px -40px 0px",
  "k_301": "up",
  "k_302": "opacity, transform",
  "k_303": "is-visible",
  "k_304": "reverse",
  "k_305": "normal",
  "k_306": "all 0.3s",
  "k_307": "inline-block",
  "k_308": "transform 0.2s",
  "k_309": "scale(1.05)",
  "k_310": "inline-flex",
  "k_311": "4px 12px",
  "k_312": "primary",
  "k_313": "13px 26px",
  "k_314": "0 8px 24px rgba(0,0,0,0.15)",
  "k_315": "96px 24px",
  "k_316": "'Space Grotesk', sans-serif",
  "k_317": "clamp(28px, 4vw, 44px)",
  "k_318": "16px 0 16px",
  "k_319": "-0.02em",
  "k_320": "已收租金",
  "k_321": "太古廣場柏舍 · HKD 28,400",
  "k_322": "提早 14 日",
  "k_323": "AI 優化扣帳日",
  "k_324": "賺取 +312 里數",
  "k_325": "國泰航空 · 本月",
  "k_326": "付款受安全保障",
  "k_327": "PCI DSS · 憑證化技術",
  "k_328": "太古廣場柏舍",
  "k_329": "12A 室",
  "k_330": "HKD 28,400",
  "k_331": "已收取",
  "k_332": "恒隆",
  "k_333": "8B 室",
  "k_334": "HKD 19,800",
  "k_335": "信和廣場",
  "k_336": "34F 室",
  "k_337": "HKD 22,000",
  "k_338": "已排程",
  "k_339": "太古大廈",
  "k_340": "7C 室",
  "k_341": "GBP 3,200",
  "k_342": "blur(20px)",
  "k_343": "20px 20px 16px",
  "k_344": "pulse 2s infinite",
  "k_345": "stroke-dashoffset 0.05s linear",
  "k_346": "Space Grotesk,sans-serif",
  "k_347": "7px 0",
  "k_348": "opacity 0.4s ease, transform 0.4s ease",
  "k_349": "right",
  "k_350": "blur(16px)",
  "k_351": "2d",
  "k_352": "resize",
  "k_353": "visibilitychange",
  "k_354": "gradient-roll 10s ease infinite",
  "k_355": "140px 24px 96px",
  "k_356": "1fr 1fr",
  "k_357": "clamp(40px, 6.5vw, 80px)",
  "k_358": "-0.03em",
  "k_359": "clamp(17px, 2vw, 21px)",
  "k_360": "滙豐信用卡合作夥伴",
  "k_361": "業主",
  "k_362": "上傳租約 / 印花稅",
  "k_363": "透過我們的 App 或網頁版提交，毋須處理繁複文件。",
  "k_364": "租戶授權",
  "k_365": "一次性雙重認證 (2FA) 設定。於其信用卡上建立智能合約。",
  "k_366": "AI 安排扣賬",
  "k_367": "我們的模型會在租約生效日前，釐定最佳的扣賬日期。",
  "k_368": "租金準時入帳",
  "k_369": "資金於每月租約生效日或之前存入。系統會自動生成收據及結單。",
  "k_370": "一次性雙重認證 (2FA) 設定。建立智能合約，信用卡資訊憑證化。",
  "k_371": "AI 排程及扣賬",
  "k_372": "AI 將在租約生效日前，釐定最佳的扣賬日期。",
  "k_373": "0 4px 24px rgba(0,0,0,0.05)",
  "k_374": "'Space Grotesk',sans-serif",
  "k_375": "repeat(auto-fit, minmax(300px, 1fr))",
  "k_376": "告別欠租",
  "k_377": "準時收租",
  "k_378": "AI 會在租約生效日前預先扣賬，確保租金在每月生效日或之前準時入帳，讓您安枕無憂。",
  "k_379": "零退款爭議",
  "k_380": "退款爭議記錄",
  "k_381": "AI 負責 KYC 認證，確保所有付款只需最少授權，同時杜絕信用卡欺詐、濫用及退款爭議。",
  "k_382": "賺取獎賞及現金回贈",
  "k_383": "高達 5%",
  "k_384": "交租現金回贈",
  "k_385": "支援最多 3 張銀行卡分卡付款，每筆簽賬均可賺取豐富獎賞、飛行里數或現金回贈。",
  "k_386": "6px 0 16px",
  "k_387": "repeat(auto-fit, minmax(280px, 1fr))",
  "k_388": "業主管理平台",
  "k_389": "物業組合概覽、欠租追蹤、現金流分析",
  "k_390": "uploads/landlord_dash.png",
  "k_391": "租客流動應用程式",
  "k_392": "豐富獎賞、分卡付款、交租紀錄",
  "k_393": "uploads/tenant_app_v6.png",
  "k_394": "GenAI 智能物業總管",
  "k_395": "24/7 全天候對話，解答維修、租務疑問及續租事宜",
  "k_396": "uploads/genai_pm.png",
  "k_397": "cover",
  "k_398": "20px 24px",
  "k_399": "0 4px 16px rgba(0,0,0,0.12)",
  "k_400": "repeat(auto-fit, minmax(220px, 1fr))",
  "k_401": "英國註冊支付機構 (SPI)。",
  "k_402": "符合國際安全認證。我們的伺服器絕不儲存任何信用卡資料。",
  "k_403": "代碼化技術",
  "k_404": "在傳輸前，所有信用卡資料均會被轉換為安全的代碼 (Token)。",
  "k_405": "TLS + EV SSL 加密",
  "k_406": "所有傳輸數據均經過加密，並具備延伸驗證 (EV) 證書。",
  "k_407": "0 auto 16px",
  "k_408": "Keychain 收取什麼費用？",
  "k_409": "網上交租安全嗎？你們會儲存我的信用卡或扣賬卡資料嗎？",
  "k_410": "絕對安全。Keychain 流動應用程式 及網頁版均獲 PCI-DSS (支付卡產業資料安全標準) 認證，數據受銀行級別的安全措施保護。\u003cbr\u003e\u003cbr\u003eKeychain 絕不儲存您使用的信用卡或扣賬卡完整號碼。當您使用信用卡或扣賬卡時，交易只會涉及 (i) Apple Pay 或 Google Pay 的授權代碼，或 (ii) 您的信用卡或扣賬卡最後 4 位數字。",
  "k_411": "設立智能合約需要準備甚麼？",
  "k_412": "設立過程非常簡單，最快 5 分鐘即可完成：<br>⋅ 基本租務資料<br>⋅ 業主的聯絡電話及銀行戶口<br>⋅ 租約及打厘印證明（或 CR109 表格）<br>⋅ 信用卡或扣帳卡",
  "k_413": "業主何時會收到租金？我可以自訂過數給業主的日期嗎？",
  "k_414": "一般情況下，您的業主會在每月租約生效日或之前收到租金。<br><br>我們的 AI 會確保您的租金準時到賬。我們不提供手動設定扣賬或過數日期的功能。<br><br>您可以登入我們的手機 App 或網頁版，查看最新的到賬日期。",
  "k_415": "80px 24px",
  "k_416": "clamp(30px,4vw,50px)",
  "k_417": "20px 0 16px",
  "k_418": "20px 0",
  "k_419": "10月",
  "k_420": "11月",
  "k_421": "12月",
  "k_422": "1月",
  "k_423": "2月",
  "k_424": "3月",
  "k_425": "4月",
  "k_426": "24px 24px 20px",
  "k_427": "flex-start",
  "k_428": "visible",
  "k_429": "1fr 1fr 1fr",
  "k_430": "欠租",
  "k_431": "平均提早",
  "k_432": "7 天",
  "k_433": "節省行政時間",
  "k_434": "10px 8px",
  "k_435": "VIC I P LEE",
  "k_436": "multiply",
  "k_437": "italic",
  "k_438": "-1px",
  "k_439": "Arial,sans-serif",
  "k_440": "0 1px 2px rgba(0,0,0,0.15)",
  "k_441": "16px 20px",
  "k_442": "0 20px 60px rgba(0,0,0,0.5)",
  "k_443": "border-box",
  "k_444": "rotateY(90deg) scale(0.92)",
  "k_445": "rotateY(0deg) scale(1)",
  "k_446": "monospace",
  "k_447": "flex-end",
  "k_448": "12px 14px",
  "k_449": "width 0.05s",
  "k_450": "uploads/swire_logo_v2.png",
  "k_451": "uploads/sino_logo_v2.png",
  "k_452": "uploads/shg_logo_v2.png",
  "k_453": "uploads/hang_lung_logo_v2.png",
  "k_454": "City Park",
  "k_455": "uploads/citypark_logo_v2.png",
  "k_456": "Finford",
  "k_457": "uploads/finford_logo_v2.png",
  "k_458": "星街小區",
  "k_459": "uploads/excz4l_star_studios_logo.png",
  "k_460": "咸田別墅",
  "k_461": "uploads/mpaa3m_hamtin_logo.png",
  "k_462": "寶馬山花園",
  "k_463": "uploads/k0pmz1_pacific_palisades_logo.png",
  "k_464": "黃金海岸住宅",
  "k_465": "uploads/j522u4_Gold_Coast_logo.png",
  "k_466": "The Camphora",
  "k_467": "uploads/x2zrqy_camphora_logo.png",
  "k_468": "The Johnston",
  "k_469": "uploads/hyxhw2_johnston_logo.png",
  "k_470": "The Gage",
  "k_471": "uploads/992d2p_gage_logo.png",
  "k_472": "The Staunton",
  "k_473": "uploads/9vwz6v_staunton_logo.png",
  "k_474": "The Hillside",
  "k_475": "uploads/ep9dvj_hillside_logo.png",
  "k_476": "The Ventris",
  "k_477": "uploads/0ebckk_ventris_logo.png",
  "k_478": "The Humphreys",
  "k_479": "uploads/u3z1fy_humphreys_logo.png",
  "k_480": "clamp(36px,5vw,60px)",
  "k_481": "20px 0 24px",
  "k_482": "16px 0 20px",
  "k_483": "每月花時間向租客追租",
  "k_484": "人手核對銀行帳單及更新 Excel 表格",
  "k_485": "租客遲交租，影響現金流",
  "k_486": "花費大量時間編製結單",
  "k_487": "缺乏租金拖欠的預警機制",
  "k_488": "AI 會在到期日前自動向租客扣賬",
  "k_489": "系統自動對帳及生成結單",
  "k_490": "租金會在租約生效日或之前準時入帳",
  "k_491": "一個管理平台，輕鬆掌控所有物業",
  "k_492": "任何付款問題，即時發送通知",
  "k_493": "repeat(auto-fit, minmax(260px, 1fr))",
  "k_494": "靈活擴展的收租方案",
  "k_495": "只需點擊幾下，即可獲得收租保障。AI 自動扣賬支援任何規模，無論是 10 個還是 10,000 個單位，都能體驗完全自動化的收租流程。",
  "k_496": "單次收款",
  "k_497": "定期收款",
  "k_498": "分期收款",
  "k_499": "營運數據分析",
  "k_500": "物業狀態、回報率、收支分析 —— 全面整合於一個團隊共享的儀表板中。",
  "k_501": "物業組合報表",
  "k_502": "開支及回報追蹤",
  "k_503": "水電雜費支出",
  "k_504": "系統整合",
  "k_505": "與您的會計及物業管理系統進行安全的文件交換。支援 API 整合選項。",
  "k_506": "會計系統同步",
  "k_507": "安全文件交換",
  "k_508": "提供 REST API",
  "k_509": "銀行級別安全標準",
  "k_510": "受英國 FCA 監管、獲 PCI DSS 認證，全面採用代碼化信用卡處理技術。",
  "k_511": "持有 FCA SPI 牌照",
  "k_512": "PCI DSS 安全認證",
  "k_513": "信用卡代碼化",
  "k_514": "32px 28px",
  "k_515": "20px 0 20px",
  "k_516": "壞帳撥備",
  "k_517": "較過往平均下降",
  "k_518": "管理單位數目",
  "k_519": "尊貴住宅",
  "k_520": "準時",
  "k_521": "平均收款率",
  "k_522": "在租約生效日當天",
  "k_523": "↓ 40%",
  "k_524": "行政人手",
  "k_525": "重新調配至住戶服務工作",
  "k_526": "個人業主",
  "k_527": "0 起^",
  "k_528": "每次交易",
  "k_529": "最多 5 個物業",
  "k_530": "AI 收費排程",
  "k_531": "自動化收據",
  "k_532": "管理面板存取權限",
  "k_533": "立即開始",
  "k_534": "發展商 / 物業管理",
  "k_535": "無限個物業",
  "k_536": "物業組合分析",
  "k_537": "會計系統整合",
  "k_538": "優先支援服務",
  "k_539": "自訂品牌形象",
  "k_540": "申請企業方案",
  "k_541": "scale(1.02)",
  "k_542": "clamp(28px,4vw,46px)",
  "k_543": "hsbc_premier_mc",
  "k_544": "滙豐",
  "k_545": "rc",
  "k_546": "獎賞錢",
  "k_547": "2.40% 獎賞錢",
  "k_548": "uploads/hsbc_3d_mastercard_premier.png",
  "k_549": "hsbc_visa_sig",
  "k_550": "3.60% 獎賞錢",
  "k_551": "uploads/hsbc_3d_visa_signature.png",
  "k_552": "hsbc_everymile",
  "k_553": "滙豐 EveryMile 信用卡",
  "k_554": "里數",
  "k_555": "0.08 里/港元",
  "k_556": "hsbc_easy",
  "k_557": "滙豐 easy 信用卡",
  "k_558": "現金回贈",
  "k_559": "現金回贈",
  "k_560": "hsbc_red",
  "k_561": "滙豐 Red 信用卡",
  "k_562": "0.40% 獎賞錢",
  "k_563": "uploads/hsbc_3d_red.png",
  "k_564": "hsbc_pulse_up",
  "k_565": "滙豐 Pulse 銀聯雙幣鑽石信用卡",
  "k_566": "uploads/hsbc_pulse_unionpay.png",
  "k_567": "hs_mmpower",
  "k_568": "恒生",
  "k_569": "恒生 MMPOWER 信用卡",
  "k_570": "積分",
  "k_571": "易賞錢積分",
  "k_572": "5% +FUN Dollars",
  "k_573": "uploads/hangseng_3d_mpower.png",
  "k_574": "bea_titanium",
  "k_575": "東亞",
  "k_576": "東亞 i-Titanium 卡",
  "k_577": "4.0% i-Dollar",
  "k_578": "bea_goal",
  "k_579": "東亞 GOAL 信用卡",
  "k_580": "4.40% i-Dollar",
  "k_581": "uploads/bea_3d_mastercard_goal.png",
  "k_582": "bea_flyer",
  "k_583": "東亞 Flyer World Mastercard",
  "k_584": "亞洲萬里通",
  "k_585": "10% 亞洲萬里通",
  "k_586": "amex_plat",
  "k_587": "Amex 白金卡 / Explorer",
  "k_588": "3 分/港元",
  "k_589": "uploads/amex_3d.png",
  "k_590": "sc_cathay",
  "k_591": "渣打",
  "k_592": "渣打國泰 Mastercard",
  "k_593": "0.16 里/港元",
  "k_594": "uploads/sc_3d_cathay.png",
  "k_595": "sc_simplycash",
  "k_596": "渣打 Simply Cash Visa 卡",
  "k_597": "1.50% 現金回贈",
  "k_598": "mox",
  "k_599": "Mox",
  "k_600": "Mox Credit",
  "k_601": "1% 現金回贈",
  "k_602": "dbs_black",
  "k_603": "星展",
  "k_604": "星展 Black World Mastercard",
  "k_605": "0.16 亞洲萬里通、Avios、KrisFlyer、鳳凰知音里數/港元",
  "k_606": "dahsing_ana",
  "k_607": "大新",
  "k_608": "大新 ANA World Mastercard",
  "k_609": "ANA 里數",
  "k_610": "0.125 ANA 里數/港元",
  "k_611": "dahsing_ba",
  "k_612": "大新英國航空白金卡",
  "k_613": "Avios",
  "k_614": "0.16 Avios/港元",
  "k_615": "fubon_in",
  "k_616": "富邦",
  "k_617": "富邦 iN VISA 白金卡",
  "k_618": "8% 現金回贈",
  "k_619": "bochk_chill",
  "k_620": "中銀",
  "k_621": "中銀 Chill Card",
  "k_622": "0.4% 現金回贈",
  "k_623": "bochk_hkairlines",
  "k_624": "中銀香港航空 Visa Signature 卡",
  "k_625": "0.3 FWC 積分/港元",
  "k_626": "bochk_sogo",
  "k_627": "中銀 SOGO Visa Signature 卡",
  "k_628": "積分",
  "k_629": "5% 現金回贈",
  "k_630": "cncbi_motion",
  "k_631": "信銀國際",
  "k_632": "信銀國際 Motion 信用卡",
  "k_633": "6% 現金回贈",
  "k_634": "aeon_waku",
  "k_635": "AEON",
  "k_636": "AEON WAKUWAKU",
  "k_637": "6% 現金回贈",
  "k_638": "aeon_jal",
  "k_639": "AEON JAL Mastercard",
  "k_640": "JAL 里數",
  "k_641": "0.125 里/港元",
  "k_642": "prime_wewa",
  "k_643": "安信",
  "k_644": "安信 WeWa Visa Signature 卡",
  "k_645": "4% 現金回贈",
  "k_646": "prime_earnmore",
  "k_647": "安信 EarnMORE 銀聯卡",
  "k_648": "2% 現金回贈",
  "k_649": "sim",
  "k_650": "sim 信用卡",
  "k_651": "其他",
  "k_652": "其他",
  "k_653": "其他信用卡",
  "k_654": "refer",
  "k_655": "以發卡機構為準",
  "k_656": "滙豐",
  "k_657": "滙豐 easy信用卡",
  "k_658": "獎賞錢",
  "k_659": "bea_it",
  "k_660": "東亞",
  "k_661": "東亞 i-Titanium卡",
  "k_662": "i-Dollar",
  "k_663": "hsbc_pulse",
  "k_664": "滙豐 Pulse銀聯雙幣鑽石信用卡",
  "k_665": "ae",
  "k_666": "美國運通",
  "k_667": "美國運通 白金信用卡 / Explorer 信用卡",
  "k_668": "美國運通積分",
  "k_669": "dsb_ana",
  "k_670": "大新",
  "k_671": "大新 ANA World Mastercard",
  "k_672": "ANA 里數",
  "k_673": "dsb_ba",
  "k_674": "大新英國航空白金卡",
  "k_675": "boc_chill",
  "k_676": "中銀",
  "k_677": "中銀 Chill Card",
  "k_678": "現金回贈",
  "k_679": "boc_hka",
  "k_680": "中銀香港航空 Visa Signature 卡",
  "k_681": "FWC 積分",
  "k_682": "aeon_wakuwaku",
  "k_683": "AEON 信用卡",
  "k_684": "AEON 卡 WAKUWAKU",
  "k_685": "AEON 卡 JAL Mastercard",
  "k_686": "日航里數",
  "k_687": "12.50% 日航里數",
  "k_688": "cncbi",
  "k_689": "信銀",
  "k_690": "信銀國際 Motion 信用卡",
  "k_691": "fubon",
  "k_692": "富邦",
  "k_693": "富邦 iN VISA 白金卡",
  "k_694": "boc_sogovs",
  "k_695": "中銀崇光 Visa Signature 卡",
  "k_696": "pc_wewa",
  "k_697": "安信",
  "k_698": "安信 WeWa Visa Signature 卡",
  "k_699": "pc_earnmore",
  "k_700": "安信 EarnMORE",
  "k_701": "安信 EarnMORE 銀聯鑽石卡",
  "k_702": "其他信用卡",
  "k_703": "-0.5px",
  "k_704": "0 1px 3px rgba(0,0,0,0.4)",
  "k_705": "2px 5px",
  "k_706": "2px 6px 6px 2px",
  "k_707": "6px 2px 2px 6px",
  "k_708": "undefined",
  "k_709": "向發卡機構查詢",
  "k_710": "transform 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s ease",
  "k_711": "scale(1)",
  "k_712": "drop-shadow(0 20px 40px rgba(0,0,0,0.3))",
  "k_713": "drop-shadow(0 10px 20px rgba(0,0,0,0.15))",
  "k_714": "blur(10px)",
  "k_715": "blur(8px)",
  "k_716": "nowrap",
  "k_717": "0 4px 12px rgba(0,0,0,0.2)",
  "k_718": "0 25px 50px -12px rgba(0,0,0,0.25)",
  "k_719": "0 10px 15px -3px rgba(0,0,0,0.1)",
  "k_720": "inset 0 1px 2px rgba(0,0,0,0.1)",
  "k_721": "0 4px 12px rgba(0,0,0,0.1)",
  "k_722": "start",
  "k_723": "13px 14px 13px 56px",
  "k_724": "border 0.2s",
  "k_725": "3px 11px",
  "k_726": "all 0.15s",
  "k_727": "1張卡",
  "k_728": "2張卡",
  "k_729": "最少 HK$10,000",
  "k_730": "3張卡",
  "k_731": "最少 HK$20,000",
  "k_732": "9px 6px",
  "k_733": "not-allowed",
  "k_734": "14px 16px",
  "k_735": "0 2px 10px rgba(0,0,0,0.04)",
  "k_736": "9px 10px",
  "k_737": "Inter,sans-serif",
  "k_738": "1fr auto 1fr auto 1fr",
  "k_739": "min(320px,100%)",
  "k_740": "min(240px,62%)",
  "k_741": "all 0.35s ease",
  "k_742": "width 0.35s ease",
  "k_743": "18px 20px",
  "k_744": "10px 12px",
  "k_745": "10px 0",
  "k_746": "26px 0",
  "k_747": "all 0.25s",
  "k_748": "M2 8L6 4L10 8",
  "k_749": "M2 4L6 8L10 4",
  "k_750": "140px 24px 100px",
  "k_751": "clamp(38px,5.5vw,66px)",
  "k_752": "smooth",
  "k_753": "uploads/mastercard_v5.svg",
  "k_754": "uploads/visa_v4.png",
  "k_755": "uploads/amex_v4.png",
  "k_756": "uploads/unionpay_v4.svg",
  "k_757": "Apple Pay",
  "k_758": "uploads/apple_pay_v4.svg",
  "k_759": "Google Pay",
  "k_760": "uploads/google_pay_v4.svg",
  "k_761": "AI 會在您的租約生效日前，為您釐定最佳的扣賬日期。",
  "k_762": "28px 20px",
  "k_763": "0 4px 20px rgba(0,0,0,0.04)",
  "k_764": "0 auto 20px",
  "k_765": "clamp(26px,3.5vw,40px)",
  "k_766": "40px auto 80px",
  "k_767": "14px 28px",
  "k_768": "代碼化技術",
  "k_769": "您的信用卡號碼會即時轉換成安全代碼。我們絕不會儲存您的真實信用卡資料。",
  "k_770": "榮獲全球最高級別的支付卡資料安全標準認證。",
  "k_771": "由您全面掌控",
  "k_772": "全天候 24/7 隨時於應用程式內查看或取消您的智能合約。",
  "k_773": "雙重認證",
  "k_774": "每次授權均採用基於風險的雙重認證，確保最高安全性。",
  "k_775": "如何繳付公屋租金？",
  "k_776": "公屋租金可於手機應用程式或網頁版上繳交，並須每月遞交申請。您需要提供您的電子繳費租戶號碼及房署繳費通圖片。",
  "k_777": "如果我使用 Keychain 交租，業主需要註冊嗎？",
  "k_778": "不需要。不過，您可以先知會業主您將透過 Keychain 交租。因為您的業主會收到來自 KeyChain Fintech Ltd 的款項，而不是您本人。轉賬時，我們會把租客姓名填入備註欄，但未必一定能顯示，因為每間銀行處理該欄位方法未必相同，亦視乎業主使用的查賬方式。",
  "k_779": "你們何時會從我的信用卡或扣賬卡收取租金？我可以自訂扣賬日期嗎？",
  "k_780": "我們的 AI 會為您決定扣賬日期。AI 會預測最適當的扣賬時間，確保租金能準時到賬。扣賬日約為每月租約生效日前的 1 至 10 個工作天。我們不提供手動設定扣賬日期的功能。",
  "k_781": "我應該何時遞交申請？",
  "k_782": "由於處理交易及到賬需時，請於租務生效日期前7-10天遞交申請。",
  "k_783": "pre-wrap",
  "k_784": "120px 24px 80px",
  "k_785": "160px 24px 110px",
  "k_786": "clamp(40px, 5.5vw, 72px)",
  "k_787": "clamp(18px, 2vw, 22px)",
  "k_788": "1fr",
  "k_789": "1fr 1.2fr",
  "k_790": "clamp(32px, 4vw, 44px)",
  "k_791": "24px 0 28px",
  "k_792": "支付流程零散",
  "k_793": "傳統銀行轉帳及支票付款缺乏現代資產組合管理所需的自動化功能。",
  "k_794": "信貸盲點",
  "k_795": "銀行缺乏結構化的租金支付數據，難以為新一代租客提供準確的信貸審批。",
  "k_796": "營運成本高昂",
  "k_797": "物業管理人員需要花費大量時間進行人手對帳及處理欠租問題。",
  "k_798": "48px 40px",
  "k_799": "AI 信貸引擎",
  "k_800": "專屬的信貸評分、KYC/AML 及交易監控模型。建基於區塊鏈的信貸紀錄，可供銀行作審批參考。",
  "k_801": "自動收款",
  "k_802": "基於智能合約的自動交租系統，確保在到期日前妥善處理款項。",
  "k_803": "靈活支付處理",
  "k_804": "完善的支付基建，支援分拆付款、跨境結算及機構級財務報表。",
  "k_805": "無需人手干預即可處理營運、通訊及工作流程的生成式自動化技術。",
  "k_806": "1.2fr 1fr",
  "k_807": "數碼支付",
  "k_808": "持續增長",
  "k_809": "加速由傳統人手操作轉向自動化系統。",
  "k_810": "AI 應用普及",
  "k_811": "規模龐大",
  "k_812": "工作流程自動化已從「加分項目」轉變為核心基建。",
  "k_813": "另類信貸數據",
  "k_814": "強勢崛起",
  "k_815": "對利用另類數據進行信貸審批的需求日益增加。",
  "k_816": "地產科技與金融科技",
  "k_817": "深度融合",
  "k_818": "房地產營運與金融服務正逐步結合。",
  "k_819": "24px 0 24px",
  "k_820": "clamp(32px, 5vw, 52px)",
  "k_821": "28px 0 32px",
  "k_822": "降低成本",
  "k_823": "自動化處理超過 80% 的日常行政工作",
  "k_824": "提升客戶留存率",
  "k_825": "更快速的回應及更流暢的支付體驗",
  "k_826": "即時擴展",
  "k_827": "管理 10,000 個單位與管理 10 個單位一樣輕鬆",
  "k_828": "客戶終身價值",
  "k_829": "遠超同業",
  "k_830": "客戶獲取成本",
  "k_831": "極低",
  "k_832": "回本期",
  "k_833": "極短",
  "k_834": "流失率",
  "k_835": "ltv-pulse-card",
  "k_836": "transform 0.3s, box-shadow 0.3s",
  "k_837": "0 10px 25px rgba(0,0,0,0.05)",
  "k_838": "信貸參考混合變現模式",
  "k_839": "保險 / 擔保交叉銷售",
  "k_840": "按金替代融資方案",
  "k_841": "房地產科技工作流程自動化授權",
  "k_842": "日益普及",
  "k_843": "業主物業組合及租客註冊量按月實現強勁增長。",
  "k_844": "經常性行為",
  "k_845": "自動化智能合約驅動超過 99% 的支付留存率。",
  "k_846": "全球業務擴展",
  "k_847": "業務版圖由香港擴展至英國及其他地區。",
  "k_848": "64px 48px",
  "k_849": "repeat(auto-fit, minmax(200px, 1fr))",
  "k_850": "卓越的單位經濟效益",
  "k_851": "規模化下達成 50 倍 客戶終身價值/客戶獲取成本 比例",
  "k_852": "可擴展的獲客模式",
  "k_853": "高自然增長與推薦比例",
  "k_854": "堅固的數據循環壁壘",
  "k_855": "專屬 AI 與信貸反饋機制",
  "k_856": "生態系統驗證",
  "k_857": "獲 Mastercard 及 Google 支援",
  "k_858": "dark",
  "k_859": "<div style=\"margin-bottom: 20px\"> 我們只收取交易手續費！ </div> <style>#fee-rate-table-remark { display: none; font-size: 13px; color: #6B7280; margin-bottom: 8px; } @media (max-width: 570px) { #fee-rate-table-remark { display: block; } }</style><div id=\"fee-rate-table-remark\">（向右滑動查看更多）</div> <div class=\"fee-rate-table\"> <table> <tbody><tr> <td></td> <th scope=\"col\">住宅及車位</th> <th scope=\"col\">商業</th> </tr> <tr> <th scope=\"col\"> 香港發行之個人 HSBC Mastercard 或 Visa 信用卡 </th> <td>1.8%</td> <td>1.98%</td> </tr> <tr> <th scope=\"col\"> 香港發行之個人 HSBC UnionPay 信用卡* </th> <td>0.8%</td> <td>0.98%</td> </tr> <tr> <th scope=\"col\"> 香港發行之個人 Mastercard 或 Visa 信用卡（非 HSBC） </th> <td>1.98%</td> <td>2.5%</td> </tr> <tr> <th scope=\"col\"> 香港發行之個人 UnionPay 信用卡（非 HSBC）* </th> <td>0.98%</td> <td>1.98%</td> </tr> <tr> <th scope=\"col\"> 中國內地發行之 UnionPay 信用卡* / 國際信用卡 / 公司信用卡 / Apple Pay^ / Google Pay^ </th> <td colspan=\"3\">2.98%</td> </tr> <tr> <th scope=\"col\">American Express</th> <td colspan=\"3\">3.5%</td> </tr> </tbody></table> <br> <p> *UnionPay 信用卡僅適用於租金港幣 10,000 元或以上（不包括交易手續費）。 </p> <p> ^Apple Pay / Google Pay 僅適用於租金低於港幣 10,000 元（不包括交易手續費）。 </p> </div>",
  "k_860": "是的。Keychain 手機應用程式及網上平台均已獲得 PCI-DSS（支付卡產業資料安全標準）認證，數據受銀行級別的安全措施保護。<a href=\"/tc/home/#security\" target=\"_blank\" style=\"color: #0d333f\">了解更多</a>。<br><br> Keychain 不會儲存您使用的信用卡或扣帳卡完整號碼。當您使用信用卡或扣帳卡時，交易過程僅涉及 (i) Apple Pay 或 Google Pay 的授權代碼，或 (ii) 信用卡或扣帳卡的最後 4 位數字。",
  "k_861": "如何設定智能合約？",
  "k_862": "設定過程非常簡單，最快 5 分鐘即可完成：<br> ⋅ 基本租約資料<br> ⋅ 業主聯絡電話及銀行戶口<br> ⋅ 租約及打厘印證明（或 CR109）<br> ⋅ 信用卡或扣帳卡",
  "k_863": "為什麼需要提供租約？",
  "k_864": "了解我們的服務對象及使用 Keychain 的目的，對於偵測和防止欺詐、濫用信用卡以及洗黑錢活動至關重要。請上載租約及打厘印證明。",
  "k_865": "我可以更改、新增或移除付款方式嗎？",
  "k_866": "可以。請透過我們的手機應用程式或網上平台管理您的付款方式。",
  "k_867": "我可以更改租金金額嗎？",
  "k_868": "可以。請透過我們的手機應用程式或網上平台更改租金金額。",
  "k_869": "我可以延長或終止智能合約嗎？",
  "k_870": "可以。請透過我們的手機應用程式或網上平台延長或終止您的智能合約。",
  "k_871": "不會。但您可以先通知業主，您將透過 KeyChain 支付租金。<br>KeyChain 不會儲存您使用的信用卡或扣帳卡完整號碼。當您使用信用卡或扣帳卡時，交易過程僅涉及 (i) Apple Pay 或 Google Pay 的授權代碼，或 (ii) 信用卡或扣帳卡的最後 4 位數字。",
  "k_872": "一般而言，業主會在每個月的租約起租日收到租金。<br><br> 我們的 AI 會確保您的租金準時送達。我們不允許以人手設定任何扣款或入帳日期。<br><br> 您可以登入我們的手機應用程式或網上平台查看預計或最新的過數日期。",
  "k_873": "當租金過數時，您可以通知業主嗎？",
  "k_874": "可以。如果您在申請時提供了業主的電郵地址，我們會在租金轉入其銀行戶口時發送電郵通知。您可以登入我們的手機應用程式或網上平台查看預計或最新的過數日期。",
  "k_875": "如果我的信用卡額度不足怎麼辦？",
  "k_876": "當您首次透過我們平台付款時，我們會在您的信用卡預扣租金及交易手續費。為確保您有足夠的信用額度，請在申請前結清任何欠款，或聯絡您的發卡機構提高信用卡額度。",
  "k_877": "使用哪張信用卡能賺取最多回贈？",
  "k_878": "您可以參考我們的獎賞計算機 <a href=\"/tc/tenants/#rewards-calculator\" target=\"_blank\">按此</a>。<br> *結果基於網上商戶模擬運算，僅供參考。請聯絡您的發卡機構以作確認。",
  "k_879": "如何確認我的信用卡或扣帳卡能賺取多少回贈？",
  "k_880": "您可以查閱銀行月結單或流動理財應用程式，或聯絡發卡機構查詢您的獎賞詳情。",
  "k_881": "如何開始使用 SPLIT？",
  "k_882": "只需三個簡單步驟：<br> <div class=\"flexbox\"> <div class=\"flex-item\"> <div class=\"item\"> 第一步：選擇「付款方式」。 </div> <br> <div class=\"img\"> <img src=\"./images/src/setup/split_payment_step_1.png\" layout=\"responsive\" width=\"370\" height=\"680\"> </div> </div> <br> <div class=\"flex-item\"> <div class=\"item\"> 第二步：選擇 2 張或 3 張卡進行 SPLIT（拆單）。 </div> <br> <div class=\"img\"> <img src=\"./images/src/setup/split_payment_step_2.png\" layout=\"responsive\" width=\"370\" height=\"680\"> </div> </div> <br> <div class=\"flex-item\"> <div class=\"item\"> 第三步：設定每張卡的拆單比例。 </div> <br> <div class=\"img\"> <img src=\"./images/src/setup/split_payment_step_3.png\" layout=\"responsive\" width=\"370\" height=\"680\"> </div> </div> </div>",
  "k_883": "我可以使用多少張付款卡？",
  "k_884": "每次最多可使用三張卡 ─ 歡迎以您任何信用卡或扣帳卡拆單支付。<br><br> 我們目前不支援以 Apple Pay 及 Google Pay 進行 SPLIT。",
  "k_885": "所有付款卡都可以賺取回贈嗎？",
  "k_886": "您的獎賞受發卡機構的條款及細則約束。請聯絡您的發卡機構查詢獎賞詳情。",
  "k_887": "SPLIT 對租金金額有任何限制嗎？",
  "k_888": "智能合約上 2 張卡的 SPLIT 最低租金金額需為港幣 10,000 元或以上，而 3 張卡的 SPLIT 最低租金則為港幣 20,000 元或以上。",
  "k_889": "我有一份生效中的智能合約。我仍然可以使用 SPLIT 支付租金嗎？",
  "k_890": "可以。您可以在下一次扣款日之前，在現有的智能合約新增另一張付款卡。",
  "k_891": "SPLIT 的交易手續費如何計算？",
  "k_892": "我們的收費標準維持不變！我們按比例收費，例如：<br><br> 租金：港幣 20,000 元，<br> 付款卡：3 張 Mastercard，交易手續費：1.98%，SPLIT 比例：5:3:2，<br> 所以總交易手續費僅為港幣 396 元。<br><br> ● Mastercard 1: (20,000 x 50%) x 1.98% = $198 <br> ● Mastercard 2: (20,000 x 30%) x 1.98% = $118.8 <br> ● Mastercard 3: (20,000 x 20%) x 1.98% = $79.2",
  "k_893": "回贈將何時及如何扣除？",
  "k_894": "回贈不會從信用卡授權金額中扣除，僅在信用卡正式扣款時扣除。<br><br> 當交易手續費高於或等於回贈總額時，回贈將用於抵銷交易手續費。回贈將在您下次透過我們付款時用於抵銷交易手續費。",
  "k_895": "對於公屋租戶，房屋委員會何時會收到我的租金？",
  "k_896": "一般而言，在您的申請提交並獲批後約一星期，或在每個月的最後一個工作天或之前，您的租金將會支付予房屋委員會。",
  "k_897": "如果租約即將到期，但我已準備續約，可以直接在應用程式內延長智能合約以繼續支付租金嗎？",
  "k_898": "如果您希望延長智能合約，請在登入應用程式後點擊智能合約詳情，並按下頁面頂部的「延長合約」按鈕。<br><br> 如果在延長智能合約時，原有的租約仍然有效，您無需重新上載整份租約文件。<br><br> 但是，如果在延長智能合約時，最初上載的租約已經失效，您將需要重新上載完整的租約文件。請在起租日前 7-10 天提交申請，以確保有充足時間處理交易及過數。",
  "k_899": "我可以提早繳交租金嗎？可以一次繳交多於一個月的租金嗎？",
  "k_900": "只要在您的租約列明，或有其他有效證明文件，您可以申請一次性支付特定期間的租金。請啟用一次性付款選項並輸入總租金金額。",
  "k_901": "租約為期數年。可以只支付幾個月的租金嗎？例如，我的租約期為兩年，但我只想支付一個月的租金。",
  "k_902": "可以，只需提交您本次需要支付的日期，我們將會審核您的申請。",
  "k_903": "我可以暫停繳交租金一個月嗎？",
  "k_904": "抱歉，我們無法僅暫停一個月的租金支付。您只能終止智能合約。如果您希望繼續使用我們的服務，請設定一份新的智能合約。<br><br> 請按照以下步驟終止您的智能合約：<br> 第一步：選擇「合約列表」<br> 第二步：選擇相應的智能合約<br> 第三步：點擊地址進入智能合約的詳情頁面<br> 第四步：在頁面頂部，按下「終止」按鈕<br>",
  "k_905": "我可以使用伴侶的信用卡支付租金嗎？",
  "k_906": "一般而言，我們建議使用租客本人的信用卡，但您仍可以提交使用不同信用卡組合的申請。智能合約的申請結果將由 AI 及本公司作最終決定。",
  "k_907": "如何查看付款時間表的詳細扣款日期？",
  "k_908": "請打開選單，點選「合約列表」，選擇相應的智能合約，然後點擊「付款時間表」以查看隨後的扣款日期。",
  "k_909": "如何更改付款卡？",
  "k_910": "請打開選單，點選「合約列表」，選擇相應的智能合約。然後，請點擊「付款」並按下「更改信用卡及分配」。接下來，選擇或新增您希望用作付款的信用卡。",
  "k_911": "160px 24px 80px",
  "k_912": "clamp(40px,5vw,64px)",
  "k_913": "object",
  "k_914": "0 20px 60px rgba(0,0,0,0.15)",
  "k_915": "border 0.15s",
  "k_916": "7px 12px",
  "k_917": "capitalize",
  "k_918": "404",
  "k_919": "找不到頁面",
  "k_920": "您查找的頁面不存在或已被移動。",
  "k_921": "返回主頁",
  "k_922": "https://www.swireproperties.com/zh-hk/",
  "k_923": "https://www.sunhinggroup.com/zh/%e4%b8%bb%e9%a0%81/",
  "k_924": "https://www.redhotoffers.hsbc.com.hk/tc/rewards/red-hot-rewards-of-your-choice/popup-home/",
  "k_925": "<div style=\"margin-bottom: 20px\">我們只收取交易費！</div><div style=\"overflow-x: auto; width: 100%;\"><table style=\"width: 100%; border-collapse: collapse; min-width: 500px; text-align: left; font-size: 14px;\"><thead><tr><th style=\"padding: 12px; background: #042F2E; color: white; border: 1px solid #E5E7EB; border-top-left-radius: 8px;\"></th><th style=\"padding: 12px; background: #042F2E; color: white; border: 1px solid #E5E7EB;\">住宅&車位</th><th style=\"padding: 12px; background: #042F2E; color: white; border: 1px solid #E5E7EB; border-top-right-radius: 8px;\">工商</th></tr></thead><tbody><tr><td style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB; font-weight: 600;\">個人本地滙豐銀行萬事達卡/Visa信用卡</td><td style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB;\">1.80%</td><td style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB;\">1.98%</td></tr><tr><td style=\"padding: 12px; border: 1px solid #E5E7EB; font-weight: 600;\">個人本地滙豐銀行銀聯信用卡*</td><td style=\"padding: 12px; border: 1px solid #E5E7EB;\">0.80%</td><td style=\"padding: 12px; border: 1px solid #E5E7EB;\">0.98%</td></tr><tr><td style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB; font-weight: 600;\">個人本地萬事達卡/Visa信用卡(非滙豐銀行)</td><td style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB;\">1.98%</td><td style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB;\">2.50%</td></tr><tr><td style=\"padding: 12px; border: 1px solid #E5E7EB; font-weight: 600;\">個人本地銀聯信用卡(非滙豐銀行)*</td><td style=\"padding: 12px; border: 1px solid #E5E7EB;\">0.98%</td><td style=\"padding: 12px; border: 1px solid #E5E7EB;\">1.98%</td></tr><tr><td style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB; font-weight: 600;\">中國内地銀聯信用卡* / 國際卡 / 商務信用卡 / Apple Pay^ / Google Pay^</td><td colspan=\"2\" style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB; text-align: center;\">2.98%</td></tr><tr><td style=\"padding: 12px; border: 1px solid #E5E7EB; font-weight: 600; border-bottom-left-radius: 8px;\">美國運通</td><td colspan=\"2\" style=\"padding: 12px; border: 1px solid #E5E7EB; text-align: center; border-bottom-right-radius: 8px;\">3.5%</td></tr></tbody></table></div><p style=\"font-size: 12px; color: #6B7280; margin-top: 12px;\">*銀聯信用卡只適用於支付$10,000(不包括交易費)或以上的租金。</p><p style=\"font-size: 12px; color: #6B7280; margin-top: 4px;\">^Apple Pay / Google Pay 只適用於支付$10,000(不包括交易費)以下的租金。</p>",
  "k_926": "https://www.sino.com/tc/",
  "k_927": "https://www.hanglung.com/zh-hk/home",
  "k_928": "https://www.starstudios.com.hk/zh-hk/",
  "k_929": "https://www.hamtinvillas.hk/zh-hk/",
  "k_930": "https://www.pacificpalisades.com.hk/?lang=tc",
  "k_931": "https://www.goldcoastresidences.com.hk/tc/",
  "k_932": "https://www.sinosuites.com.hk/tc/",
  "k_933": "118 TLWR",
  "k_934": "uploads/t7k2m9_118tlwr_logo.png",
  "k_935": "Pacific Place Apartments",
  "k_936": "uploads/p3n8r1_pacific_place_apartments_logo.png",
  "k_937": "https://www.118tunglowan.com/",
  "k_938": "https://www.upperhouse.com/tc/hongkong/pacific-place-apartments/",
  "k_939": "獎賞錢", // RewardCash
  "k_940": "飛行里數", // Miles
  "k_941": "飛行里數", // Asia Miles
  "k_942": "現金回贈", // Rebate
  "k_943": "現金回贈", // CashBack
  "k_944": "現金回贈", // Cash Rebate
  "k_945": "現金等值", // Cash equiv.
  "k_946": "飛行里數", // JMB miles
  "k_947": "Points", // Points (product name, keep EN)
  "k_948": "i-Dollar", // i-Dollar (product name)
  "k_949": "+FUN Dollars", // +FUN Dollars (product name)
  "k_950": "FWC Points", // FWC Points (product name)
  "k_951": "Avios Conversion", // Avios Conversion (product name)
  "k_952": "DBS$", // DBS$ (product name)
  "k_953": "基本 0.4% 回贈；4% 網上獎賞不適用於租金付款（見 HSBC Red 信用卡條款）。", // Base 0.4% only — 4% online bonus tier excludes rent payments per HSBC Red T&C.
  "k_954": "5.0% +FUN Dollars", // 5.0% +FUN Dollars (product name, keep EN)
  "k_955": "4.0% i-Dollar", // 4.0% i-Dollar (product name)
  "k_956": "4.4% i-Dollar", // 4.4% i-Dollar (product name)
  "k_957": "HK$1 = 3 積分", // HK$1 = 3 points
  "k_958": "1.0% 現金回贈", // 1.0% Rebate
  "k_959": "1.0% 積分回贈", // 1.0% Points Rebate
  "k_960": "每年 HK$100,000", // HK$100,000/yr RYC cap
  "k_961": "獎賞錢等值: ", // RC equiv.
  "k_962": "已達上限", // Cap reached
  "k_963": "最紅自主獎賞 2.4% 以每年 HK$100,000 消費為累積上限。", // RYC 2.4% subject to HK$100,000 annual spending cap.
  "k_964": "最紅自主獎賞 2.4% 只適用於每年首 HK$100,000 消費；超出部分只賺取基本回贈。", // RYC 2.4% applies to first HK$100,000 spent per year; remaining earns base rate only.
  "k_965": "*以上結果基於網上商戶模擬，僅供參考。結果不包括任何迎新優惠或其他推廣及優惠。Keychain FinTech Ltd. 對所提供資訊的準確性、時效性、有效性或完整性概不作任何保證，亦不對因此而引致的任何損失或費用承擔任何責任。客戶應以每月結單所列示的實際里數／獎賞錢／現金回贈作為最終金額，如有疑問請聯絡發卡機構。", // *The results are dependent on an online-merchant simulation and displayed for reference only. They do not include any welcome offer or other promotions and offers. KeyChain FinTech Ltd. does not guarantee the accuracy, timeliness, validity or completeness of such information, and no responsibility or liability is accepted in relation to any loss or cost you may incur. Customer should refer to the actual Mileages / RewardCash / Cash Rebates stated in your monthly statement for the final amount entitled or reach out to card issuer for any questions.
  "k_966": "简", // SC language button label
  "k_967": "（銀聯）需租金 ≥ HK$10,000。", // (UnionPay) requires rent ≥ HK$10,000.
  "k_968": "每月",
  "k_969": "請輸入資料以查看您的獎賞估算。",
  "k_970": "滙豐信用卡 × KEYCHAIN",
  "k_971": "交租，都可以賺「獎賞錢」",
  "k_972": "以滙豐信用卡透過 Keychain 繳付租金，交易費低至 0.8%，更可賺取高達 3.6%「獎賞錢」。",
  "k_974": "查看滙豐優惠",
  "k_975": "uploads/hsbc-promo-hero.webp",
  "k_976": "查看滙豐最紅全年優惠",
  "k_977": "https://www.redhotoffers.hsbc.com.hk/tc/yro/?cardType=Others&spendingCat=Travel+%26+Lifestyle&subCat=Others",
  "k_978": "優惠及獎賞",
  "k_979": "推廣優惠",
};
const DICT_SC = {
  "k_0": "Keychain",
  "k_1": "Keychain — 返回首页",
  "k_2": "登录",
  "k_3": "解决方案",
  "k_4": "聊天机器人",
  "k_5": "KeyChain 智能助理",
  "k_6": "AI 智能租务代理。受英国金融行为监管局（FCA）监管之支付机构",
  "k_7": "联系我们",
  "k_8": "🇬🇧 UK Office",
  "k_9": "3rd Floor 86-90 Paul Street, London, EC2A 4NE, UK",
  "k_10": "🇭🇰 HK Office",
  "k_11": "Unit 1901, 19/F, No. 3 Lockhart Road, Wanchai, Hong Kong",
  "k_12": "© 2026 KeyChain FinTech Ltd. 版权所有。",
  "k_13": "准时收租比例",
  "k_14": "AI 监控 · 实时数据",
  "k_15": "middle",
  "k_16": "Space Grotesk, sans-serif",
  "k_17": "准时到账",
  "k_18": "14 天",
  "k_19": "平均提前",
  "k_20": "38 小时",
  "k_21": "每月节省",
  "k_22": "最近收款",
  "k_23": "rgba(229,117,0,0.4)",
  "k_24": "AI 智能租务代理",
  "k_25": "rgba(255,255,255,0.25)",
  "k_26": "FCA 持牌机构",
  "k_27": "租金准时到账。",
  "k_28": "每一次。",
  "k_29": "全自动。",
  "k_30": "Keychain AI 在到期日前锁定租金，自动化处理物业管理的回复与操作，让每一笔租金都变成奖励。",
  "k_31": "我是租客",
  "k_32": "我是房东",
  "k_33": "我是投资人",
  "k_34": "运作方式",
  "k_35": "两条无缝路径。一个目标。",
  "k_36": "无论您是收租还是付租，Keychain 都为您处理一切繁琐流程。",
  "k_37": "致",
  "k_38": "white",
  "k_39": "为何选择 Keychain",
  "k_40": "三大核心成果。",
  "k_41": "我们的产品",
  "k_42": "贴合市场需求的应用程序、平台与智能代理。",
  "k_43": "专为追求确定性的房东与期待优质体验的租客打造。",
  "k_44": "深受信赖",
  "k_45": "卓越客户与顶级合作伙伴。",
  "k_46": "地产开发商",
  "k_47": "信和集团",
  "k_48": "太古地产",
  "k_49": "恒隆地产",
  "k_50": "新兴集团",
  "k_51": "银行与合作伙伴",
  "k_52": "Mastercard Start Path",
  "k_53": "汇丰 Visa Signature 卡",
  "k_54": "汇丰卓越理财信用卡",
  "k_55": "Google for Startups",
  "k_56": "安全与合规",
  "k_57": "银行级安全保障。",
  "k_58": "您的数据与资金均按最高标准妥善保护。",
  "k_59": "常见问题",
  "k_60": "常见问题解答。",
  "k_61": "rgba(255,165,103,0.2)",
  "k_62": "立即开始",
  "k_63": "准备好告别租金拖欠了吗？",
  "k_64": "加入香港与英国的房东和租客行列。",
  "k_65": "准时收租比例",
  "k_66": "↑ 行业平均仅为 87%",
  "k_67": "物业",
  "k_68": "本季度新增 +12",
  "k_69": "VISA",
  "k_70": "AMEX",
  "k_71": "持卡人",
  "k_72": "本月",
  "k_73": "每月现金返现",
  "k_74": "HKD",
  "k_75": "年累计: HKD",
  "k_76": "每月赚取飞行里程",
  "k_77": "年累计:",
  "k_78": "miles",
  "k_79": "rgba(45,212,191,0.1)",
  "k_80": "致房东、开发商与物业管理方",
  "k_81": "告别催租烦恼。",
  "k_82": "用 AI 赋能您的物业组合。",
  "k_83": "借助 AI 驱动的智能合约提前收取租金。从单个单元到全球物业组合，零风险提升您的现金流。",
  "k_84": "登录 →",
  "k_85": "预约演示",
  "k_86": "rgba(13,148,136,0.1)",
  "k_87": "合作物业",
  "k_88": "深受顶级物业信赖",
  "k_89": "传统做法",
  "k_90": "催收租金是一项重担。",
  "k_91": "Keychain 之道",
  "k_92": "一次设置，从此搞定。",
  "k_93": "平台功能",
  "k_94": "无需额外行政成本，轻松扩展物业组合。",
  "k_95": "专为管理数百至数千单元的个人房东与地产公司打造。",
  "k_96": "案例分析",
  "k_97": "从人工催租到零拖欠。",
  "k_98": "一家管理逾 300 个高端住宅单元的香港大型地产开发商已部署 Keychain。首个季度内，租金拖欠即降至零。",
  "k_99": "「平台首月即收回成本。我们不再需要为坏账计提拨备。」",
  "k_100": "物业组合管理高级总监",
  "k_101": "收费标准",
  "k_102": "简单透明的费用。",
  "k_103": "绝无隐藏收费。由您自主决定交易费由谁承担。",
  "k_104": "^ 房东 / 物业经理可自行决定交易费由租客或房东支付。",
  "k_105": "准备好为您的租金加上保障了吗？",
  "k_106": "加入香港与英国领先的房东与物业管理公司行列。",
  "k_107": "立即登录开始 →",
  "k_108": "本月",
  "k_109": "% · HKD",
  "k_110": "每月租金",
  "k_111": "拆分付款",
  "k_112": "Card",
  "k_113": "✓ 已免除平台手续费",
  "k_114": "平台手续费: HKD",
  "k_115": "费用: HKD",
  "k_116": "手续费",
  "k_117": "总费用",
  "k_118": "付款分摊",
  "k_119": "每月预计奖励",
  "k_120": "每月",
  "k_121": "/ 年",
  "k_122": "mi",
  "k_123": "里 / 年",
  "k_124": "pts",
  "k_125": "分 / 年",
  "k_126": "奖励详情请参阅发卡机构相关条款。",
  "k_127": "*结果仅供参考。奖励以总费用（租金 + 平台手续费）按线上商户交易计算，不包含新户迎新优惠。最终金额请咨询发卡机构。受条款及细则约束。",
  "k_128": "rgba(229,117,0,0.1)",
  "k_129": "奖励计算器",
  "k_130": "测算您的港币租金可赚取多少奖励",
  "k_131": "/ 月",
  "k_132": "rgba(230,160,137,0.25)",
  "k_133": "致租客",
  "k_134": "SPLIT 拆分付款。",
  "k_135": "使用信用卡缴付房租",
  "k_136": "您理应获得奖励。",
  "k_137": "使用您喜爱的信用卡或电子钱包。最多可拆分至 3 张卡付款。付款时间由 AI 智能安排——您只需轻松赚取奖励。",
  "k_138": "下载应用程序",
  "k_139": "查看预计奖励",
  "k_140": "立即开始",
  "k_141": "5 分钟内即可启用。",
  "k_142": "无需填表，无需等待。一键授权，轻松搞定。",
  "k_143": "rgba(230,160,137,0.15)",
  "k_144": "奖励",
  "k_145": "租金是您",
  "k_146": "最大的开支。",
  "k_147": "现在让它为您赚取回报。",
  "k_148": "通过我们的信用卡合作伙伴计划，赚取飞行里程、现金返现与积分。每一笔租金都能像普通信用卡消费一样累积奖励。",
  "k_149": "拆分付款",
  "k_150": "将租金分摊至",
  "k_151": "最多 3 张信用卡。",
  "k_152": "在不同信用卡之间分配金额，赚取最多奖励。基于风险的双因素认证（2FA）确保每张卡的安全。",
  "k_153": "测算您的奖励",
  "k_154": "向我们的人工智能助理 Kate 咨询如何通过付租赚取最多奖励",
  "k_155": "与 Kate 对话 →",
  "k_156": "linear-gradient(135deg, #1F3540 0%, #494D4C 100%)",
  "k_157": "您的安全",
  "k_158": "您的银行卡信息绝不留存。",
  "k_159": "达到银行级安全标准。",
  "k_160": "租客常见问题",
  "k_161": "为您答疑解惑。",
  "k_162": "还有其他疑问？",
  "k_163": "开始从租金中赚取回报。",
  "k_164": "下载 Keychain，5 分钟即可完成设置。",
  "k_165": "下载 iOS 版本",
  "k_166": "下载 Android 版本",
  "k_167": "AI 智能租务代理：",
  "k_168": "当稳定的经常性收入",
  "k_169": "遇见 AI 信贷评估。",
  "k_170": "Keychain 正在打造面向全球租赁经济的自主化 FinTech × PropTech 生态——以资本效率为核心、以数据智能为驱动，获得全球 AI 与支付领域领导者的支持。",
  "k_171": "rgba(255,165,103,0.12)",
  "k_172": "",
  "k_173": "ASIA",
  "k_174": "PAY",
  "k_175": "资本",
  "k_176": "rgba(255,95,0,0.1)",
  "k_177": "rgba(255,255,255,0.08)",
  "k_178": "G",
  "k_179": "o",
  "k_180": "g",
  "k_181": "l",
  "k_182": "e",
  "k_183": "for Startups",
  "k_184": "rgba(20,184,166,0.1)",
  "k_185": "市场痛点",
  "k_186": "全球市场仍依赖过时系统运转。",
  "k_187": "住宅租赁市场作为全球最大资产类别之一，至今仍存在根本性的低效问题。零散的支付方式、不透明的信用记录，以及结构化数据的缺失，在房东与金融机构之间形成了庞大的「基础设施鸿沟」，蕴藏着巨大的数字化与金融升级机遇。",
  "k_188": "投资理念",
  "k_189": "我们相信，",
  "k_190": "AI 代理化",
  "k_191": "與",
  "k_192": "嵌入式信贷基础设施",
  "k_193": "的融合，将重新定义租金收入的保障方式、管理模式与资本化效率。",
  "k_194": "50×",
  "k_195": "客户终身价值 / 客户获取成本",
  "k_196": "领先同业",
  "k_197": "客户终身价值与行业对比",
  "k_198": "解决方案",
  "k_199": "AI 驱动的租赁金融基础设施。",
  "k_200": "Keychain 将整个租赁生命周期整合到单一的自动化平台——从信用评分到自动化现金流。",
  "k_201": "为何是现在？",
  "k_202": "租赁基础设施的最佳时机。",
  "k_203": "四大宏观趋势的汇聚创造了独一无二的机遇。Keychain 的基础设施正是为此而生——用 AI 解决传统运营难题，同时积累极具价值的金融数据集。",
  "k_204": "rgba(20,184,166,0.15)",
  "k_205": "核心理念",
  "k_206": "智能租务代理远不止一个聊天机器人。",
  "k_207": "它是一个",
  "k_208": "自动化的财务与物业运营平台",
  "k_209": "。它能处理租客互动、付款提醒及复杂的工作流自动化，让物业组合无需增加人手即可扩展。",
  "k_210": "商业模式",
  "k_211": "可预测、可扩展的经常性收入。",
  "k_212": "我们的混合模式融合了高毛利的经常性软件费用、基于交易量的收费以及高意向度的信贷参考。这创造了多元化的收入来源，同时加深了我们与用户的关系。",
  "k_213": "战略性嵌入式金融",
  "k_214": "业务发展",
  "k_215": "获得顶级客户认可。",
  "k_216": "我们的增长由用户的持续使用以及向全球主要金融中心的扩张所驱动。",
  "k_217": "我们脱颖而出的原因",
  "k_218": "索取投资人简报",
  "k_219": "常见问题",
  "k_220": "您需要了解的关于 Keychain 的一切。",
  "k_221": "微调",
  "k_222": "主题色",
  "k_223": "前往页面",
  "k_224": "登录",
  "k_225": "解决方案",
  "k_226": "聊天机器人",
  "k_227": "KeyChain 智能助理",
  "k_228": "联系我们",
  "k_229": "AI 智能租务代理",
  "k_230": "租客",
  "k_231": "房东",
  "k_232": "投资人",
  "k_233": "常见问题",
  "k_234": "致租客",
  "k_235": "下载应用程序",
  "k_236": "查看预计奖励",
  "k_237": "奖励",
  "k_238": "测算您的奖励",
  "k_239": "向我们的 AI 智能助理 Kate 咨询如何通过付租赚取最多奖励",
  "k_240": "与 Kate 对话 →",
  "k_241": "contain",
  "k_242": "房东、开发商与物业管理",
  "k_243": "专为物业组合打造的企业级收租平台",
  "k_244": "租客",
  "k_245": "付租同时赚奖励",
  "k_246": "投资人与合作伙伴",
  "k_247": "业务发展、投资理念与合作伙伴",
  "k_248": "blur(12px)",
  "k_249": "all 0.3s ease",
  "k_250": "0 auto",
  "k_251": "pointer",
  "k_252": "6px 12px",
  "k_253": "background 0.2s",
  "k_254": "繁",
  "k_255": "Eng",
  "k_256": "9px 18px",
  "k_257": "关闭菜单",
  "k_258": "打开菜单",
  "k_259": "4px 8px",
  "k_260": "16px 24px 32px",
  "k_261": "calc(100vh - 68px)",
  "k_262": "uppercase",
  "k_263": "left",
  "k_264": "16px 0",
  "k_265": "16px 24px",
  "k_266": "0 8px 24px rgba(229,117,0,0.25)",
  "k_267": "8px 14px",
  "k_268": "color 0.2s, background 0.2s",
  "k_269": "房东与开发商",
  "k_270": "公司信息",
  "k_271": "联系我们",
  "k_272": "mailto:enquiry@keychainpay.com",
  "k_273": "法律与条款",
  "k_274": "服务条款",
  "k_275": "隐私政策",
  "k_276": "用户条款",
  "k_277": "Cookie 政策",
  "k_278": "英国 FCA 注册",
  "k_279": "LinkedIn",
  "k_280": "Facebook",
  "k_281": "Instagram",
  "k_282": "电子邮件",
  "k_283": "column",
  "k_284": "0 20px 40px rgba(0,0,0,0.5)",
  "k_285": "space-between",
  "k_286": "grid",
  "k_287": "repeat(auto-fit, minmax(160px, 1fr))",
  "k_288": "_self",
  "k_289": "_blank",
  "k_290": "all 0.2s",
  "k_291": "default",
  "k_292": "color 0.15s",
  "k_293": "12px 16px",
  "k_294": "0 10px 30px rgba(0,0,0,0.2)",
  "k_295": "wrap",
  "k_296": "🇬🇧 英国",
  "k_297": "🇭🇰 香港",
  "k_298": "4px 10px",
  "k_299": "IntersectionObserver",
  "k_300": "0px 0px -40px 0px",
  "k_301": "up",
  "k_302": "opacity, transform",
  "k_303": "is-visible",
  "k_304": "reverse",
  "k_305": "normal",
  "k_306": "all 0.3s",
  "k_307": "inline-block",
  "k_308": "transform 0.2s",
  "k_309": "scale(1.05)",
  "k_310": "inline-flex",
  "k_311": "4px 12px",
  "k_312": "primary",
  "k_313": "13px 26px",
  "k_314": "0 8px 24px rgba(0,0,0,0.15)",
  "k_315": "96px 24px",
  "k_316": "'Space Grotesk', sans-serif",
  "k_317": "clamp(28px, 4vw, 44px)",
  "k_318": "16px 0 16px",
  "k_319": "-0.02em",
  "k_320": "已收租金",
  "k_321": "太古广场柏舍 · HKD 28,400",
  "k_322": "提前 14 天",
  "k_323": "AI 优化扣款日",
  "k_324": "赚取 +312 飞行里程",
  "k_325": "国泰航空 · 本月",
  "k_326": "支付安全保障",
  "k_327": "PCI DSS · 令牌化技术",
  "k_328": "太古广场柏舍",
  "k_329": "12A 室",
  "k_330": "HKD 28,400",
  "k_331": "已收取",
  "k_332": "恒隆",
  "k_333": "8B 室",
  "k_334": "HKD 19,800",
  "k_335": "信和广场",
  "k_336": "34F 室",
  "k_337": "HKD 22,000",
  "k_338": "已排期",
  "k_339": "太古大厦",
  "k_340": "7C 室",
  "k_341": "GBP 3,200",
  "k_342": "blur(20px)",
  "k_343": "20px 20px 16px",
  "k_344": "pulse 2s infinite",
  "k_345": "stroke-dashoffset 0.05s linear",
  "k_346": "Space Grotesk,sans-serif",
  "k_347": "7px 0",
  "k_348": "opacity 0.4s ease, transform 0.4s ease",
  "k_349": "right",
  "k_350": "blur(16px)",
  "k_351": "2d",
  "k_352": "resize",
  "k_353": "visibilitychange",
  "k_354": "gradient-roll 10s ease infinite",
  "k_355": "140px 24px 96px",
  "k_356": "1fr 1fr",
  "k_357": "clamp(40px, 6.5vw, 80px)",
  "k_358": "-0.03em",
  "k_359": "clamp(17px, 2vw, 21px)",
  "k_360": "汇丰信用卡合作伙伴",
  "k_361": "房东",
  "k_362": "上传租赁合同 / 印花税凭证",
  "k_363": "通过我们的 App 或网页版提交，无需处理繁琐文件。",
  "k_364": "租客授权",
  "k_365": "一次性双因素认证（2FA）设置。在其信用卡上建立智能合约。",
  "k_366": "AI 安排扣款",
  "k_367": "我们的模型会在租赁合同生效天前，确定最佳的扣款日期。",
  "k_368": "租金准时到账",
  "k_369": "资金于每月租赁合同生效天或之前存入。系统自动生成收条与对账单。",
  "k_370": "一次性双因素认证（2FA）设置。建立智能合约，信用卡信息令牌化保护。",
  "k_371": "AI 排期与扣款",
  "k_372": "AI 将在租赁合同生效天前，确定最佳的扣款日期。",
  "k_373": "0 4px 24px rgba(0,0,0,0.05)",
  "k_374": "'Space Grotesk',sans-serif",
  "k_375": "repeat(auto-fit, minmax(300px, 1fr))",
  "k_376": "告别欠租",
  "k_377": "准时收租",
  "k_378": "AI 在租赁合同生效天前预先扣款，确保租金每月准时到账，让您高枕无忧。",
  "k_379": "零退款争议",
  "k_380": "退款争议记录",
  "k_381": "AI 负责 KYC 身份认证，所有付款仅需最少授权，杜绝信用卡欺诈、滥用与退款争议。",
  "k_382": "赚取奖励与现金返现",
  "k_383": "高达 5%",
  "k_384": "付租现金返现",
  "k_385": "支持最多 3 张银行卡拆分付款，每笔消费均可赚取丰厚奖励、飞行里程或现金返现。",
  "k_386": "6px 0 16px",
  "k_387": "repeat(auto-fit, minmax(280px, 1fr))",
  "k_388": "房东管理平台",
  "k_389": "物业组合概览、欠租追踪、现金流分析",
  "k_390": "uploads/landlord_dash.png",
  "k_391": "租客移动应用",
  "k_392": "丰厚奖励、拆分付款、付租记录",
  "k_393": "uploads/tenant_app_v6.png",
  "k_394": "GenAI 智能物业管家",
  "k_395": "7×24 小时全天候对话，解答维修、租赁与续约疑问",
  "k_396": "uploads/genai_pm.png",
  "k_397": "cover",
  "k_398": "20px 24px",
  "k_399": "0 4px 16px rgba(0,0,0,0.12)",
  "k_400": "repeat(auto-fit, minmax(220px, 1fr))",
  "k_401": "英国注册支付机构（SPI）。",
  "k_402": "符合国际安全认证标准。我们的服务器从不存储任何信用卡信息。",
  "k_403": "令牌化技术",
  "k_404": "在传输前，所有信用卡信息都会被转换为安全的令牌（Token）。",
  "k_405": "TLS + EV SSL 加密",
  "k_406": "所有传输数据均经过加密保护，并配备扩展验证（EV）证书。",
  "k_407": "0 auto 16px",
  "k_408": "Keychain 收取哪些费用？",
  "k_409": "线上付租安全吗？你们会存储我的信用卡或借记卡信息吗？",
  "k_410": "绝对安全。Keychain 移动应用程序及网页版均已获得 PCI-DSS（支付卡行业数据安全标准）认证，数据受银行级别安全措施保护。\u003cbr\u003e\u003cbr\u003eKeychain 绝不存储您使用的信用卡或借记卡完整卡号。当您使用信用卡或借记卡时，交易过程仅涉及 (i) Apple Pay 或 Google Pay 的授权令牌，或 (ii) 您的信用卡或借记卡末 4 位数字。",
  "k_411": "建立智能合约需要准备什么？",
  "k_412": "设置流程非常简单，最快 5 分钟即可完成：\u003cbr\u003e⋅ 基本租赁信息\u003cbr\u003e⋅ 房东的联系电话及银行账户\u003cbr\u003e⋅ 租赁合同及印花税凭证（或 CR109 表格）\u003cbr\u003e⋅ 信用卡或借记卡",
  "k_413": "房东何时会收到租金？我可以自定义打款日期吗？",
  "k_414": "通常情况下，您的房东会在每月租赁合同生效天或之前收到租金。\u003cbr\u003e\u003cbr\u003e我们的 AI 会确保您的租金准时到账。我们不提供手动设定扣款或打款日期的功能。\u003cbr\u003e\u003cbr\u003e您可以登录我们的手机 App 或网页版，查看最新的到账日期。",
  "k_415": "80px 24px",
  "k_416": "clamp(30px,4vw,50px)",
  "k_417": "20px 0 16px",
  "k_418": "20px 0",
  "k_419": "10月",
  "k_420": "11月",
  "k_421": "12月",
  "k_422": "1月",
  "k_423": "2月",
  "k_424": "3月",
  "k_425": "4月",
  "k_426": "24px 24px 20px",
  "k_427": "flex-start",
  "k_428": "visible",
  "k_429": "1fr 1fr 1fr",
  "k_430": "欠租",
  "k_431": "平均提前",
  "k_432": "7 天",
  "k_433": "节省行政时间",
  "k_434": "10px 8px",
  "k_435": "VIC I P LEE",
  "k_436": "multiply",
  "k_437": "italic",
  "k_438": "-1px",
  "k_439": "Arial,sans-serif",
  "k_440": "0 1px 2px rgba(0,0,0,0.15)",
  "k_441": "16px 20px",
  "k_442": "0 20px 60px rgba(0,0,0,0.5)",
  "k_443": "border-box",
  "k_444": "rotateY(90deg) scale(0.92)",
  "k_445": "rotateY(0deg) scale(1)",
  "k_446": "monospace",
  "k_447": "flex-end",
  "k_448": "12px 14px",
  "k_449": "width 0.05s",
  "k_450": "uploads/swire_logo_v2.png",
  "k_451": "uploads/sino_logo_v2.png",
  "k_452": "uploads/shg_logo_v2.png",
  "k_453": "uploads/hang_lung_logo_v2.png",
  "k_454": "City Park",
  "k_455": "uploads/citypark_logo_v2.png",
  "k_456": "Finford",
  "k_457": "uploads/finford_logo_v2.png",
  "k_458": "星街小区",
  "k_459": "uploads/excz4l_star_studios_logo.png",
  "k_460": "咸田别墅",
  "k_461": "uploads/mpaa3m_hamtin_logo.png",
  "k_462": "宝马山花园",
  "k_463": "uploads/k0pmz1_pacific_palisades_logo.png",
  "k_464": "黄金海岸住宅",
  "k_465": "uploads/j522u4_Gold_Coast_logo.png",
  "k_466": "The Camphora",
  "k_467": "uploads/x2zrqy_camphora_logo.png",
  "k_468": "The Johnston",
  "k_469": "uploads/hyxhw2_johnston_logo.png",
  "k_470": "The Gage",
  "k_471": "uploads/992d2p_gage_logo.png",
  "k_472": "The Staunton",
  "k_473": "uploads/9vwz6v_staunton_logo.png",
  "k_474": "The Hillside",
  "k_475": "uploads/ep9dvj_hillside_logo.png",
  "k_476": "The Ventris",
  "k_477": "uploads/0ebckk_ventris_logo.png",
  "k_478": "The Humphreys",
  "k_479": "uploads/u3z1fy_humphreys_logo.png",
  "k_480": "clamp(36px,5vw,60px)",
  "k_481": "20px 0 24px",
  "k_482": "16px 0 20px",
  "k_483": "每月花时间向租客催租",
  "k_484": "人工核对银行账单并更新 Excel 表格",
  "k_485": "租客延迟付租，影响现金流",
  "k_486": "花费大量时间编制对账单",
  "k_487": "缺乏租金拖欠的预警机制",
  "k_488": "AI 在租赁合同生效天前自动向租客扣款",
  "k_489": "系统自动对账并生成对账单",
  "k_490": "租金于每月租赁合同生效天或之前准时到账",
  "k_491": "一个管理平台，轻松掌控所有物业",
  "k_492": "任何付款异常，即时推送通知",
  "k_493": "repeat(auto-fit, minmax(260px, 1fr))",
  "k_494": "灵活扩展的收租方案",
  "k_495": "只需几次点击，即可获得收租保障。AI 自动扣款支持任意规模，无论是 10 个还是 10,000 个单元，都能享受完全自动化的收租流程。",
  "k_496": "单次收款",
  "k_497": "定期收款",
  "k_498": "分期收款",
  "k_499": "运营数据分析",
  "k_500": "物业状态、回报率、收支分析——全部整合于一个团队共享的仪表板中。",
  "k_501": "物业组合报表",
  "k_502": "开支与回报追踪",
  "k_503": "水电杂费支出",
  "k_504": "系统集成",
  "k_505": "与您的财务及物业管理系统进行安全的文件交换。支持 API 集成方案。",
  "k_506": "财务系统同步",
  "k_507": "安全文件交换",
  "k_508": "提供 REST API",
  "k_509": "银行级安全标准",
  "k_510": "受英国 FCA 监管、获 PCI DSS 认证，全面采用信用卡令牌化处理技术。",
  "k_511": "持有 FCA SPI 牌照",
  "k_512": "PCI DSS 安全认证",
  "k_513": "信用卡令牌化",
  "k_514": "32px 28px",
  "k_515": "20px 0 20px",
  "k_516": "坏账拨备",
  "k_517": "较过往平均下降",
  "k_518": "管理单元数量",
  "k_519": "高端住宅",
  "k_520": "准时",
  "k_521": "平均收款率",
  "k_522": "于租赁合同生效天当天",
  "k_523": "↓ 40%",
  "k_524": "行政人手",
  "k_525": "重新调配至住户服务工作",
  "k_526": "个人房东",
  "k_527": "0 起^",
  "k_528": "每次交易",
  "k_529": "最多 5 个物业",
  "k_530": "AI 收费排期",
  "k_531": "自动化收据",
  "k_532": "管理后台访问权限",
  "k_533": "立即开始",
  "k_534": "开发商 / 物业管理",
  "k_535": "无限个物业",
  "k_536": "物业组合分析",
  "k_537": "财务系统集成",
  "k_538": "优先客户支持",
  "k_539": "自定义品牌形象",
  "k_540": "申请企业方案",
  "k_541": "scale(1.02)",
  "k_542": "clamp(28px,4vw,46px)",
  "k_543": "hsbc_premier_mc",
  "k_544": "汇丰",
  "k_545": "rc",
  "k_546": "奖赏钱",
  "k_547": "2.40% 奖赏钱",
  "k_548": "uploads/hsbc_3d_mastercard_premier.png",
  "k_549": "hsbc_visa_sig",
  "k_550": "3.60% 奖赏钱",
  "k_551": "uploads/hsbc_3d_visa_signature.png",
  "k_552": "hsbc_everymile",
  "k_553": "汇丰 EveryMile 信用卡",
  "k_554": "飞行里程",
  "k_555": "0.08 里/港元",
  "k_556": "hsbc_easy",
  "k_557": "汇丰 easy 信用卡",
  "k_558": "現金回贈",
  "k_559": "现金返现",
  "k_560": "hsbc_red",
  "k_561": "汇丰 Red 信用卡",
  "k_562": "0.40% 奖赏钱",
  "k_563": "uploads/hsbc_3d_red.png",
  "k_564": "hsbc_pulse_up",
  "k_565": "汇丰 Pulse 银联双币钻石信用卡",
  "k_566": "uploads/hsbc_pulse_unionpay.png",
  "k_567": "hs_mmpower",
  "k_568": "恒生",
  "k_569": "恒生 MMPOWER 信用卡",
  "k_570": "積分",
  "k_571": "易赏钱积分",
  "k_572": "5% +FUN Dollars",
  "k_573": "uploads/hangseng_3d_mpower.png",
  "k_574": "bea_titanium",
  "k_575": "东亚",
  "k_576": "东亚 i-Titanium 卡",
  "k_577": "4.0% i-Dollar",
  "k_578": "bea_goal",
  "k_579": "东亚 GOAL 信用卡",
  "k_580": "4.40% i-Dollar",
  "k_581": "uploads/bea_3d_mastercard_goal.png",
  "k_582": "bea_flyer",
  "k_583": "东亚 Flyer World Mastercard",
  "k_584": "飞行里程",
  "k_585": "10% 亚洲万里通",
  "k_586": "amex_plat",
  "k_587": "Amex 白金卡 / Explorer",
  "k_588": "3 分/港元",
  "k_589": "uploads/amex_3d.png",
  "k_590": "sc_cathay",
  "k_591": "渣打",
  "k_592": "渣打国泰 Mastercard",
  "k_593": "0.16 里/港元",
  "k_594": "uploads/sc_3d_cathay.png",
  "k_595": "sc_simplycash",
  "k_596": "渣打 Simply Cash Visa 卡",
  "k_597": "1.50% 现金返现",
  "k_598": "mox",
  "k_599": "Mox",
  "k_600": "Mox Credit",
  "k_601": "1% 现金返现",
  "k_602": "dbs_black",
  "k_603": "星展",
  "k_604": "星展 Black World Mastercard",
  "k_605": "0.16 亚洲万里通、Avios、KrisFlyer、凤凰知音里程/港元",
  "k_606": "dahsing_ana",
  "k_607": "大新",
  "k_608": "大新 ANA World Mastercard",
  "k_609": "ANA 里程",
  "k_610": "0.125 ANA 里程/港元",
  "k_611": "dahsing_ba",
  "k_612": "大新英国航空白金卡",
  "k_613": "Avios",
  "k_614": "0.16 Avios/港元",
  "k_615": "fubon_in",
  "k_616": "富邦",
  "k_617": "富邦 iN VISA 白金卡",
  "k_618": "8% 现金返现",
  "k_619": "bochk_chill",
  "k_620": "中银",
  "k_621": "中银 Chill Card",
  "k_622": "0.4% 现金返现",
  "k_623": "bochk_hkairlines",
  "k_624": "中银香港航空 Visa Signature 卡",
  "k_625": "0.3 FWC 积分/港元",
  "k_626": "bochk_sogo",
  "k_627": "中银 SOGO Visa Signature 卡",
  "k_628": "积分",
  "k_629": "5% 现金返现",
  "k_630": "cncbi_motion",
  "k_631": "信银国际",
  "k_632": "信银国际 Motion 信用卡",
  "k_633": "6% 现金返现",
  "k_634": "aeon_waku",
  "k_635": "AEON",
  "k_636": "AEON WAKUWAKU",
  "k_637": "6% 现金返现",
  "k_638": "aeon_jal",
  "k_639": "AEON JAL Mastercard",
  "k_640": "JAL 里程",
  "k_641": "0.125 里/港元",
  "k_642": "prime_wewa",
  "k_643": "安信",
  "k_644": "安信 WeWa Visa Signature 卡",
  "k_645": "4% 现金返现",
  "k_646": "prime_earnmore",
  "k_647": "安信 EarnMORE 银联卡",
  "k_648": "2% 现金返现",
  "k_649": "sim",
  "k_650": "sim 信用卡",
  "k_651": "其他",
  "k_652": "其他",
  "k_653": "其他信用卡",
  "k_654": "refer",
  "k_655": "以发卡机构为准",
  "k_656": "汇丰",
  "k_657": "汇丰 easy 信用卡",
  "k_658": "奖赏钱",
  "k_659": "bea_it",
  "k_660": "东亚",
  "k_661": "东亚 i-Titanium 卡",
  "k_662": "i-Dollar",
  "k_663": "hsbc_pulse",
  "k_664": "汇丰 Pulse 银联双币钻石信用卡",
  "k_665": "ae",
  "k_666": "美国运通",
  "k_667": "美国运通 白金信用卡 / Explorer 信用卡",
  "k_668": "美国运通积分",
  "k_669": "dsb_ana",
  "k_670": "大新",
  "k_671": "大新 ANA World Mastercard",
  "k_672": "ANA 里程",
  "k_673": "dsb_ba",
  "k_674": "大新英国航空白金卡",
  "k_675": "boc_chill",
  "k_676": "中银",
  "k_677": "中银 Chill Card",
  "k_678": "现金返现",
  "k_679": "boc_hka",
  "k_680": "中银香港航空 Visa Signature 卡",
  "k_681": "FWC 积分",
  "k_682": "aeon_wakuwaku",
  "k_683": "AEON 信用卡",
  "k_684": "AEON 卡 WAKUWAKU",
  "k_685": "AEON 卡 JAL Mastercard",
  "k_686": "日航里程",
  "k_687": "12.50% 日航里程",
  "k_688": "cncbi",
  "k_689": "信银",
  "k_690": "信银国际 Motion 信用卡",
  "k_691": "fubon",
  "k_692": "富邦",
  "k_693": "富邦 iN VISA 白金卡",
  "k_694": "boc_sogovs",
  "k_695": "中银崇光 Visa Signature 卡",
  "k_696": "pc_wewa",
  "k_697": "安信",
  "k_698": "安信 WeWa Visa Signature 卡",
  "k_699": "pc_earnmore",
  "k_700": "安信 EarnMORE",
  "k_701": "安信 EarnMORE 银联钻石卡",
  "k_702": "其他信用卡",
  "k_703": "-0.5px",
  "k_704": "0 1px 3px rgba(0,0,0,0.4)",
  "k_705": "2px 5px",
  "k_706": "2px 6px 6px 2px",
  "k_707": "6px 2px 2px 6px",
  "k_708": "undefined",
  "k_709": "请咨询发卡机构",
  "k_710": "transform 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s ease",
  "k_711": "scale(1)",
  "k_712": "drop-shadow(0 20px 40px rgba(0,0,0,0.3))",
  "k_713": "drop-shadow(0 10px 20px rgba(0,0,0,0.15))",
  "k_714": "blur(10px)",
  "k_715": "blur(8px)",
  "k_716": "nowrap",
  "k_717": "0 4px 12px rgba(0,0,0,0.2)",
  "k_718": "0 25px 50px -12px rgba(0,0,0,0.25)",
  "k_719": "0 10px 15px -3px rgba(0,0,0,0.1)",
  "k_720": "inset 0 1px 2px rgba(0,0,0,0.1)",
  "k_721": "0 4px 12px rgba(0,0,0,0.1)",
  "k_722": "start",
  "k_723": "13px 14px 13px 56px",
  "k_724": "border 0.2s",
  "k_725": "3px 11px",
  "k_726": "all 0.15s",
  "k_727": "1 张信用卡",
  "k_728": "2 张信用卡",
  "k_729": "最低 HKD 10,000",
  "k_730": "3 张信用卡",
  "k_731": "最低 HKD 20,000",
  "k_732": "9px 6px",
  "k_733": "not-allowed",
  "k_734": "14px 16px",
  "k_735": "0 2px 10px rgba(0,0,0,0.04)",
  "k_736": "9px 10px",
  "k_737": "Inter,sans-serif",
  "k_738": "1fr auto 1fr auto 1fr",
  "k_739": "min(320px,100%)",
  "k_740": "min(240px,62%)",
  "k_741": "all 0.35s ease",
  "k_742": "width 0.35s ease",
  "k_743": "18px 20px",
  "k_744": "10px 12px",
  "k_745": "10px 0",
  "k_746": "26px 0",
  "k_747": "all 0.25s",
  "k_748": "M2 8L6 4L10 8",
  "k_749": "M2 4L6 8L10 4",
  "k_750": "140px 24px 100px",
  "k_751": "clamp(38px,5.5vw,66px)",
  "k_752": "smooth",
  "k_753": "uploads/mastercard_v5.svg",
  "k_754": "uploads/visa_v4.png",
  "k_755": "uploads/amex_v4.png",
  "k_756": "uploads/unionpay_v4.svg",
  "k_757": "Apple Pay",
  "k_758": "uploads/apple_pay_v4.svg",
  "k_759": "Google Pay",
  "k_760": "uploads/google_pay_v4.svg",
  "k_761": "AI 会在您的租赁合同生效天前，为您确定最佳的扣款日期。",
  "k_762": "28px 20px",
  "k_763": "0 4px 20px rgba(0,0,0,0.04)",
  "k_764": "0 auto 20px",
  "k_765": "clamp(26px,3.5vw,40px)",
  "k_766": "40px auto 80px",
  "k_767": "14px 28px",
  "k_768": "令牌化技术",
  "k_769": "您的信用卡号码会即时转换为安全令牌。我们绝不存储您的真实信用卡信息。",
  "k_770": "荣获全球最高级别的支付卡数据安全标准认证。",
  "k_771": "由您完全掌控",
  "k_772": "7×24 小时随时在应用程序内查看或取消您的智能合约。",
  "k_773": "双因素认证",
  "k_774": "每次授权均采用基于风险的双因素认证，确保最高级别安全。",
  "k_775": "如何缴付公屋租金？",
  "k_776": "公屋租金可通过手机应用程序或网页版缴交，并须每月提交申请。您需要提供您的电子缴费租户号码及房署缴费通图片。",
  "k_777": "如果我使用 Keychain 付租，房东需要注册吗？",
  "k_778": "不需要。不过，您可以先告知房东您将通过 Keychain 付租。因为您的房东会收到来自 KeyChain Fintech Ltd 的款项，而不是您本人。转账时，我们会在备注栏输入租客姓名，但不一定能显示，因为各家银行处理备注栏的方式不尽相同，亦取决于房东使用的查账方式。",
  "k_779": "你们何时会从我的信用卡或借记卡扣款？我可以自定义扣款日期吗？",
  "k_780": "我们的 AI 会为您决定扣款日期。AI 会预测最合适的扣款时间，确保租金能准时到账。扣款日大约为每月租赁合同生效天前的 1 到 10 个工作天。我们不提供手动设定扣款日期的功能。",
  "k_781": "我应该何时提交申请？",
  "k_782": "由于处理交易及到账需要时间，请于租赁合同生效天前 7-10 天提交申请。",
  "k_783": "pre-wrap",
  "k_784": "120px 24px 80px",
  "k_785": "160px 24px 110px",
  "k_786": "clamp(40px, 5.5vw, 72px)",
  "k_787": "clamp(18px, 2vw, 22px)",
  "k_788": "1fr",
  "k_789": "1fr 1.2fr",
  "k_790": "clamp(32px, 4vw, 44px)",
  "k_791": "24px 0 28px",
  "k_792": "支付流程零散",
  "k_793": "传统银行转账与支票支付缺乏现代资产组合管理所需的自动化能力。",
  "k_794": "信贷盲区",
  "k_795": "银行缺乏结构化的租金支付数据，难以为新一代租客提供准确的信贷审批。",
  "k_796": "运营成本高企",
  "k_797": "物业管理人员需要耗费大量时间进行人工对账与处理欠租问题。",
  "k_798": "48px 40px",
  "k_799": "AI 信贷引擎",
  "k_800": "专属的信用评分、KYC/AML 及交易监控模型。基于区块链的信用记录，可供银行作为审批参考。",
  "k_801": "自动收款",
  "k_802": "基于智能合约的自动付租系统，确保款项在到期日前妥善处理。",
  "k_803": "灵活的支付处理",
  "k_804": "完善的支付基础设施，支持拆分付款、跨境结算及机构级财务报表。",
  "k_805": "无需人工干预即可处理运营、沟通与工作流的生成式自动化技术。",
  "k_806": "1.2fr 1fr",
  "k_807": "数字支付",
  "k_808": "持续增长",
  "k_809": "加速由传统人工操作向自动化系统的转型。",
  "k_810": "AI 应用普及",
  "k_811": "规模庞大",
  "k_812": "工作流自动化已从「加分项」转变为核心基础设施。",
  "k_813": "另类信贷数据",
  "k_814": "强势崛起",
  "k_815": "利用另类数据进行信贷审批的需求日益增长。",
  "k_816": "地产科技与金融科技",
  "k_817": "深度融合",
  "k_818": "房地产运营与金融服务正逐步整合。",
  "k_819": "24px 0 24px",
  "k_820": "clamp(32px, 5vw, 52px)",
  "k_821": "28px 0 32px",
  "k_822": "降低成本",
  "k_823": "自动化处理超过 80% 的日常行政工作",
  "k_824": "提升客户留存",
  "k_825": "更快速的响应与更流畅的支付体验",
  "k_826": "即时扩展",
  "k_827": "管理 10,000 个单元与管理 10 个单元同样轻松",
  "k_828": "客户终身价值",
  "k_829": "远超同业",
  "k_830": "客户获取成本",
  "k_831": "极低",
  "k_832": "回本周期",
  "k_833": "极短",
  "k_834": "流失率",
  "k_835": "ltv-pulse-card",
  "k_836": "transform 0.3s, box-shadow 0.3s",
  "k_837": "0 10px 25px rgba(0,0,0,0.05)",
  "k_838": "信贷参考混合变现模式",
  "k_839": "保险 / 担保交叉销售",
  "k_840": "押金替代融资方案",
  "k_841": "地产科技工作流自动化授权",
  "k_842": "日益普及",
  "k_843": "房东物业组合与租客注册量逐月实现强劲增长。",
  "k_844": "经常性使用",
  "k_845": "自动化智能合约驱动超过 99% 的付款留存率。",
  "k_846": "全球业务扩展",
  "k_847": "业务版图由香港扩展至英国及其他地区。",
  "k_848": "64px 48px",
  "k_849": "repeat(auto-fit, minmax(200px, 1fr))",
  "k_850": "卓越的单位经济模型",
  "k_851": "规模化下实现 50 倍客户终身价值 / 客户获取成本比例",
  "k_852": "可扩展的获客模式",
  "k_853": "高自然增长与推荐转化比例",
  "k_854": "坚固的数据循环壁垒",
  "k_855": "专属 AI 与信贷反馈机制",
  "k_856": "生态系统验证",
  "k_857": "获 Mastercard 与 Google 支持",
  "k_858": "dark",
  "k_859": "<div style=\"margin-bottom: 20px\"> 我们仅收取交易手续费！ </div> <style>#fee-rate-table-remark { display: none; font-size: 13px; color: #6B7280; margin-bottom: 8px; } @media (max-width: 570px) { #fee-rate-table-remark { display: block; } }</style><div id=\"fee-rate-table-remark\">（向右滑动查看更多）</div> <div class=\"fee-rate-table\"> <table> <tbody><tr> <td></td> <th scope=\"col\">住宅及车位</th> <th scope=\"col\">商业</th> </tr> <tr> <th scope=\"col\"> 香港发行的个人 HSBC Mastercard 或 Visa 信用卡 </th> <td>1.8%</td> <td>1.98%</td> </tr> <tr> <th scope=\"col\"> 香港发行的个人 HSBC UnionPay 信用卡* </th> <td>0.8%</td> <td>0.98%</td> </tr> <tr> <th scope=\"col\"> 香港发行的个人 Mastercard 或 Visa 信用卡（非 HSBC） </th> <td>1.98%</td> <td>2.5%</td> </tr> <tr> <th scope=\"col\"> 香港发行的个人 UnionPay 信用卡（非 HSBC）* </th> <td>0.98%</td> <td>1.98%</td> </tr> <tr> <th scope=\"col\"> 中国内地发行的 UnionPay 信用卡* / 国际信用卡 / 企业信用卡 / Apple Pay^ / Google Pay^ </th> <td colspan=\"3\">2.98%</td> </tr> <tr> <th scope=\"col\">American Express</th> <td colspan=\"3\">3.5%</td> </tr> </tbody></table> <br> <p> *UnionPay 信用卡仅适用于租金港币 10,000 元或以上（不包括交易手续费）。 </p> <p> ^Apple Pay / Google Pay 仅适用于租金低于港币 10,000 元（不包括交易手续费）。 </p> </div>",
  "k_860": "是的。Keychain 手机应用程序及网页平台均已获得 PCI-DSS（支付卡行业数据安全标准）认证，数据受银行级安全措施保护。<a href=\"/sc/home/#security\" target=\"_blank\" style=\"color: #0d333f\">了解更多</a>。<br><br> Keychain 不会存储您使用的信用卡或借记卡完整卡号。当您使用信用卡或借记卡时，交易过程仅涉及 (i) Apple Pay 或 Google Pay 的授权令牌，或 (ii) 信用卡或借记卡的末 4 位数字。",
  "k_861": "如何设置智能合约？",
  "k_862": "设置流程非常简单，最快 5 分钟即可完成：<br> ⋅ 基本租赁信息<br> ⋅ 房东联系电话及银行账户<br> ⋅ 租约及印花税凭证（或 CR109）<br> ⋅ 信用卡或借记卡",
  "k_863": "为什么需要提供租约？",
  "k_864": "了解我们的服务对象以及使用 Keychain 的目的，对于侦测和防止欺诈、滥用信用卡以及反洗钱至关重要。请上传租约及印花税凭证。",
  "k_865": "我可以更改、新增或移除付款方式吗？",
  "k_866": "可以。请通过我们的手机应用程序或网页平台管理您的付款方式。",
  "k_867": "我可以更改租金金额吗？",
  "k_868": "可以。请通过我们的手机应用程序或网页平台更改租金金额。",
  "k_869": "我可以延长或终止智能合约吗？",
  "k_870": "可以。请通过我们的手机应用程序或网页平台延长或终止您的智能合约。",
  "k_871": "不需要。但您可以提前通知房东，您将通过 KeyChain 支付租金。<br>KeyChain 不会存储您使用的信用卡或借记卡完整卡号。当您使用信用卡或借记卡时，交易过程仅涉及 (i) Apple Pay 或 Google Pay 的授权令牌，或 (ii) 信用卡或借记卡的末 4 位数字。",
  "k_872": "通常情况下，房东会在每月租约起租日收到租金。<br><br> 我们的 AI 会确保您的租金准时送达。我们不允许人工设定任何扣款或入账日期。<br><br> 您可以登录我们的手机应用程序或网页平台查看预计或最新的到账日期。",
  "k_873": "租金到账时，您可以通知房东吗？",
  "k_874": "可以。如果您在申请时提供了房东的电子邮箱地址，我们会在租金转入其银行账户时发送邮件通知。您可以登录我们的手机应用程序或网页平台查看预计或最新的到账日期。",
  "k_875": "如果我的信用卡额度不足怎么办？",
  "k_876": "当您首次通过我们平台付款时，我们会在您的信用卡上预授权租金及交易手续费。为确保您有足够的信用额度，请在申请前结清任何欠款，或联系您的发卡机构提高信用卡额度。",
  "k_877": "使用哪张信用卡能赚取最多奖励？",
  "k_878": "您可以参考我们的奖励计算器 <a href=\"/sc/tenants/#rewards-calculator\" target=\"_blank\">点击此处</a>。<br> *结果基于线上商户模拟运算，仅供参考。请咨询您的发卡机构确认。",
  "k_879": "如何确认我的信用卡或借记卡能赚取多少奖励？",
  "k_880": "您可以查阅银行月对账单或手机银行应用，或联系发卡机构查询您的奖励详情。",
  "k_881": "如何开始使用 SPLIT？",
  "k_882": "只需三个简单步骤：<br> <div class=\"flexbox\"> <div class=\"flex-item\"> <div class=\"item\"> 第一步：选择「付款方式」。 </div> <br> <div class=\"img\"> <img src=\"./images/src/setup/split_payment_step_1.png\" layout=\"responsive\" width=\"370\" height=\"680\"> </div> </div> <br> <div class=\"flex-item\"> <div class=\"item\"> 第二步：选择 2 张或 3 张卡进行 SPLIT（拆分付款）。 </div> <br> <div class=\"img\"> <img src=\"./images/src/setup/split_payment_step_2.png\" layout=\"responsive\" width=\"370\" height=\"680\"> </div> </div> <br> <div class=\"flex-item\"> <div class=\"item\"> 第三步：设定每张卡的拆分比例。 </div> <br> <div class=\"img\"> <img src=\"./images/src/setup/split_payment_step_3.png\" layout=\"responsive\" width=\"370\" height=\"680\"> </div> </div> </div>",
  "k_883": "我可以使用多少张付款卡？",
  "k_884": "每次最多可使用三张卡 ─ 欢迎以您任何信用卡或借记卡进行拆分付款。<br><br> 我们暂不支持以 Apple Pay 与 Google Pay 进行 SPLIT。",
  "k_885": "所有付款卡都可以赚取奖励吗？",
  "k_886": "您的奖励受发卡机构的条款及细则约束。请联系您的发卡机构查询奖励详情。",
  "k_887": "SPLIT 对租金金额有任何限制吗？",
  "k_888": "智能合约中 2 张卡的 SPLIT 最低租金金额需为港币 10,000 元或以上，而 3 张卡的 SPLIT 最低租金则为港币 20,000 元或以上。",
  "k_889": "我有一份生效中的智能合约。仍然可以使用 SPLIT 支付租金吗？",
  "k_890": "可以。您可以在下一次扣款日之前，在现有的智能合约中新增另一张付款卡。",
  "k_891": "SPLIT 的交易手续费如何计算？",
  "k_892": "我们的收费标准保持不变！我们按比例收取费用，例如：<br><br> 租金：港币 20,000 元，<br> 付款卡：3 张 Mastercard，交易手续费：1.98%，SPLIT 比例：5:3:2，<br> 因此总交易手续费仅为港币 396 元。<br><br> ● Mastercard 1: (20,000 × 50%) × 1.98% = $198 <br> ● Mastercard 2: (20,000 × 30%) × 1.98% = $118.8 <br> ● Mastercard 3: (20,000 × 20%) × 1.98% = $79.2",
  "k_893": "奖励将何时及如何扣除？",
  "k_894": "奖励不会从信用卡授权金额中扣除，仅在信用卡正式扣款时扣除。<br><br> 当交易手续费高于或等于奖励总额时，奖励将用于抵扣交易手续费。奖励将在您下次通过我们付款时用于抵扣交易手续费。",
  "k_895": "对于公屋租户，房屋委员会何时会收到我的租金？",
  "k_896": "通常情况下，在您的申请提交并获批后约一周，或在每月最后一个工作日或之前，您的租金将会支付予房屋委员会。",
  "k_897": "如果租约即将到期，但我已准备续约，可以直接在应用程序内延长智能合约以继续支付租金吗？",
  "k_898": "如果您希望延长智能合约，请在登录应用程序后点击智能合约详情，并按下页面顶部的「延长合约」按钮。<br><br> 如果在延长智能合约时，原有的租约仍然有效，您无需重新上传整份租约文件。<br><br> 但是，如果在延长智能合约时，最初上传的租约已经失效，您将需要重新上传完整的租约文件。请在起租日前 7-10 天提交申请，以确保有充足时间处理交易及到账。",
  "k_899": "我可以提前缴交租金吗？可以一次缴交多于一个月的租金吗？",
  "k_900": "只要您的租约中列明，或有其他有效证明文件，您可以申请一次性支付特定期间的租金。请启用一次性付款选项并输入总租金金额。",
  "k_901": "租约为期数年。可以只支付几个月的租金吗？例如，我的租约期为两年，但我只想支付一个月的租金。",
  "k_902": "可以，只需提交您本次需要支付的日期，我们将会审核您的申请。",
  "k_903": "我可以暂停缴交租金一个月吗？",
  "k_904": "抱歉，我们无法仅暂停一个月的租金支付。您只能终止智能合约。如果您希望继续使用我们的服务，请设立一份新的智能合约。<br><br> 请按照以下步骤终止您的智能合约：<br> 第一步：选择「合约列表」<br> 第二步：选择相应的智能合约<br> 第三步：点击地址进入智能合约的详情页面<br> 第四步：在页面顶部，按下「终止」按钮<br>",
  "k_905": "我可以使用伴侣的信用卡支付租金吗？",
  "k_906": "通常情况下，我们建议使用租客本人的信用卡，但您仍可以提交使用不同信用卡组合的申请。智能合约的申请结果将由 AI 及本公司作最终决定。",
  "k_907": "如何查看付款时间表的详细扣款日期？",
  "k_908": "请打开菜单，选择「合约列表」，选择相应的智能合约，然后点击「付款时间表」以查看后续的扣款日期。",
  "k_909": "如何更改付款卡？",
  "k_910": "请打开菜单，选择「合约列表」，选择相应的智能合约。然后点击「付款」并按下「更改信用卡及分配」。接下来，选择或新增您希望用作付款的信用卡。",
  "k_911": "160px 24px 80px",
  "k_912": "clamp(40px,5vw,64px)",
  "k_913": "object",
  "k_914": "0 20px 60px rgba(0,0,0,0.15)",
  "k_915": "border 0.15s",
  "k_916": "7px 12px",
  "k_917": "capitalize",
  "k_918": "404",
  "k_919": "页面未找到",
  "k_920": "您查找的页面不存在或已被移动。",
  "k_921": "返回首页",
  "k_922": "https://www.swireproperties.com/zh-cn/",
  "k_923": "https://www.sunhinggroup.com/zh-cn/%e4%b8%bb%e9%a1%b5/",
  "k_924": "https://www.redhotoffers.hsbc.com.hk/sc/rewards/red-hot-rewards-of-your-choice/popup-home/",
  "k_925": "<div style=\"margin-bottom: 20px\">我们仅收取交易费！</div><div style=\"overflow-x: auto; width: 100%;\"><table style=\"width: 100%; border-collapse: collapse; min-width: 500px; text-align: left; font-size: 14px;\"><thead><tr><th style=\"padding: 12px; background: #042F2E; color: white; border: 1px solid #E5E7EB; border-top-left-radius: 8px;\"></th><th style=\"padding: 12px; background: #042F2E; color: white; border: 1px solid #E5E7EB;\">住宅 & 车位</th><th style=\"padding: 12px; background: #042F2E; color: white; border: 1px solid #E5E7EB; border-top-right-radius: 8px;\">工商</th></tr></thead><tbody><tr><td style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB; font-weight: 600;\">个人本地汇丰银行万事达卡 / Visa 信用卡</td><td style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB;\">1.80%</td><td style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB;\">1.98%</td></tr><tr><td style=\"padding: 12px; border: 1px solid #E5E7EB; font-weight: 600;\">个人本地汇丰银行银联信用卡*</td><td style=\"padding: 12px; border: 1px solid #E5E7EB;\">0.80%</td><td style=\"padding: 12px; border: 1px solid #E5E7EB;\">0.98%</td></tr><tr><td style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB; font-weight: 600;\">个人本地万事达卡 / Visa 信用卡（非汇丰银行）</td><td style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB;\">1.98%</td><td style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB;\">2.50%</td></tr><tr><td style=\"padding: 12px; border: 1px solid #E5E7EB; font-weight: 600;\">个人本地银联信用卡（非汇丰银行）*</td><td style=\"padding: 12px; border: 1px solid #E5E7EB;\">0.98%</td><td style=\"padding: 12px; border: 1px solid #E5E7EB;\">1.98%</td></tr><tr><td style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB; font-weight: 600;\">中国内地银联信用卡* / 国际卡 / 企业信用卡 / Apple Pay^ / Google Pay^</td><td colspan=\"2\" style=\"padding: 12px; border: 1px solid #E5E7EB; background: #F9FAFB; text-align: center;\">2.98%</td></tr><tr><td style=\"padding: 12px; border: 1px solid #E5E7EB; font-weight: 600; border-bottom-left-radius: 8px;\">美国运通</td><td colspan=\"2\" style=\"padding: 12px; border: 1px solid #E5E7EB; text-align: center; border-bottom-right-radius: 8px;\">3.5%</td></tr></tbody></table></div><p style=\"font-size: 12px; color: #6B7280; margin-top: 12px;\">*银联信用卡仅适用于支付 $10,000（不包括交易费）或以上的租金。</p><p style=\"font-size: 12px; color: #6B7280; margin-top: 4px;\">^Apple Pay / Google Pay 仅适用于支付 $10,000（不包括交易费）以下的租金。</p>",
  "k_926": "https://www.sino.com/sc/",
  "k_927": "https://www.hanglung.com/zh-cn/home",
  "k_928": "https://www.starstudios.com.hk/zh-cn/",
  "k_929": "https://www.hamtinvillas.hk/zh-cn/",
  "k_930": "https://www.pacificpalisades.com.hk/?lang=sc",
  "k_931": "https://www.goldcoastresidences.com.hk/sc/",
  "k_932": "https://www.sinosuites.com.hk/sc/",
  "k_933": "118 TLWR",
  "k_934": "uploads/t7k2m9_118tlwr_logo.png",
  "k_935": "Pacific Place Apartments",
  "k_936": "uploads/p3n8r1_pacific_place_apartments_logo.png",
  "k_937": "https://www.118tunglowan.com/",
  "k_938": "https://www.upperhouse.com/sc/hongkong/pacific-place-apartments/",
  "k_939": "奖赏钱",
  "k_940": "飞行里程",
  "k_941": "飞行里程",
  "k_942": "现金返现",
  "k_943": "现金返现",
  "k_944": "现金返现",
  "k_945": "现金等值",
  "k_946": "飞行里程",
  "k_947": "Points",
  "k_948": "i-Dollar",
  "k_949": "+FUN Dollars",
  "k_950": "FWC 积分",
  "k_951": "Avios Conversion",
  "k_952": "DBS$",
  "k_953": "基本 0.4% 返现；4% 线上奖励不适用于租金支付（见 HSBC Red 信用卡条款）。",
  "k_954": "5.0% +FUN Dollars",
  "k_955": "4.0% i-Dollar",
  "k_956": "4.4% i-Dollar",
  "k_957": "HK$1 = 3 积分",
  "k_958": "1.0% 现金返现",
  "k_959": "1.0% 积分返现",
  "k_960": "每年 HK$100,000",
  "k_961": "奖赏钱等值: ",
  "k_962": "已达上限",
  "k_963": "最红自主奖赏 2.4% 以每年 HK$100,000 消费为累积上限。",
  "k_964": "最红自主奖赏 2.4% 仅适用于每年首 HK$100,000 消费；超出部分仅赚取基础返现。",
  "k_965": "*以上结果基于线上商户模拟，仅供参考。结果不包括任何迎新优惠或其他推广及优惠。Keychain FinTech Ltd. 对所提供信息的准确性、时效性、有效性或完整性概不作任何保证，亦不对因此引致的任何损失或费用承担任何责任。客户应以每月对账单所列示的实际里程／奖赏钱／现金返现作为最终金额，如有疑问请联系发卡机构。",
  "k_966": "简",
  "k_967": "（银联）需租金 ≥ HK$10,000。", // (UnionPay) requires rent ≥ HK$10,000.
  "k_968": "每月",
  "k_969": "请输入资料以查看您的奖赏估算。",
  "k_970": "汇丰信用卡 × KEYCHAIN",
  "k_971": "缴付租金，也可以赚「奖赏钱」",
  "k_972": "以汇丰信用卡通过 Keychain 缴付租金，交易费低至 0.8%，更可赚取高达 3.6%「奖赏钱」。",
  "k_974": "查看汇丰优惠",
  "k_975": "uploads/hsbc-promo-hero.webp",
  "k_976": "查看汇丰最红全年优惠",
  "k_977": "https://www.redhotoffers.hsbc.com.hk/sc/yro/?cardType=Others&spendingCat=Travel+%26+Lifestyle&subCat=Others",
  "k_978": "优惠及奖励",
  "k_979": "推广优惠",
};

let currentLang = 'en';
function t(key) {
  const dict = currentLang === 'tc' ? DICT_TC : currentLang === 'sc' ? DICT_SC : DICT_EN;
  const val = dict[key] !== undefined ? dict[key] : key;
  if (typeof val === 'string' && val.startsWith('uploads/')) {
    return '/' + val;
  }
  return val;
}

// Action URLs — injected at build time via env vars (see build.ts).
const APP_URL = process.env.APP_URL || "https://url.keychainpay.com/web";
const SUPPORT_URL = process.env.SUPPORT_URL || "https://support.keychainpay.com/";

// Chatbot configuration — URL is injected at build time via process.env.CHATBOT_URL
// (see build.ts). Falls back to UAT chatbot when env var is unset.
const CHATBOT_URL = process.env.CHATBOT_URL || "https://chat.keychainpay.com/chatbot/31acea6b-8eee-4d41-9121-38b421715c56";
const CHATBOT_DISCLAIMER_KEY = "keychain_chatbot_disclaimer_v1";
const COLORS = {
  tealDark: '#1A1A1A',
  tealPrimary: '#E57500',
  tealBright: '#B55B00',
  aqua: '#FFA567',
  navy: '#67919F',
  slate: '#2C424F',
  coral: '#E6A089',
  mintLight: '#F0FDFA',
  mintMid: '#CCFBF1',
  white: '#F9FAFB'
};

// Logo wordmark component
function Logo({
  size = 35,
  light = false
}) {
  return <img src="/uploads/keychain_logo_new_v3.png" alt={t("k_0")} style={{
    height: size,
    width: 'auto',
    objectFit: t("k_241"),
    display: 'block'
  }} />;
}

// Logomark icon — small monochrome mark
function Logomark({
  size = 50
}) {
  return <img src="/uploads/keychain_logo_new_v3.png" alt="Decorative icon" aria-hidden="true" width={size} height={size} style={{
    width: size,
    height: size,
    objectFit: t("k_241"),
    display: 'block'
  }} />;
}

// Language switcher dropdown
function LangSwitcher({ currentPage = 'home' }) {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (!open) return;
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey  = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDown); document.removeEventListener('keydown', onKey); };
  }, [open]);

  const langs = [
    { code: 'en', mark: 'EN', name: 'English',       sub: 'English'            },
    { code: 'tc', mark: '繁', name: '中文（繁體）',    sub: 'Traditional Chinese' },
    { code: 'sc', mark: '简', name: '中文（简体）',    sub: 'Simplified Chinese'  },
  ];
  const cur = langs.find(l => l.code === currentLang) || langs[0];

  const select = (code) => {
    setOpen(false);
    if (code !== currentLang) window.setLanguage && window.setLanguage(code);
  };

  return (
    <div ref={ref} style={{ position:'relative', display:'inline-flex', alignItems:'center' }}>
      <button type="button" aria-haspopup="menu" aria-expanded={open} aria-label="Change language"
        onClick={() => setOpen(o => !o)}
        style={{
          display:'inline-flex', alignItems:'center', gap:6,
          background: open ? '#FFF6EE' : 'transparent',
          border:'1px solid rgba(0,0,0,0.1)',
          borderColor: open ? 'rgba(229,117,0,0.45)' : 'rgba(0,0,0,0.1)',
          borderRadius:999, padding:'6px 10px 6px 11px',
          fontSize:13, fontWeight:600, letterSpacing:'0.01em',
          cursor:'pointer', color:'#1A1A1A',
          transition:'background 0.15s, border-color 0.15s',
          whiteSpace:'nowrap',
        }}
        onMouseEnter={e => { e.currentTarget.style.background='#FFF6EE'; e.currentTarget.style.borderColor='rgba(229,117,0,0.45)'; }}
        onMouseLeave={e => { if (!open) { e.currentTarget.style.background='transparent'; e.currentTarget.style.borderColor='rgba(0,0,0,0.1)'; } }}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#E57500" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
          <circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a14 14 0 010 18"/><path d="M12 3a14 14 0 000 18"/>
        </svg>
        <span>{cur.mark}</span>
        <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          style={{ opacity:0.55, transition:'transform 0.2s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}>
          <path d="M2.5 4.5L6 8L9.5 4.5"/>
        </svg>
      </button>

      {open && (
        <div role="menu" aria-label="Language" style={{
          position:'absolute', top:'calc(100% + 8px)', right:0,
          minWidth:190, background:'#fff',
          borderRadius:12, border:'1px solid rgba(0,0,0,0.06)',
          boxShadow:'0 16px 40px rgba(0,0,0,0.12), 0 2px 6px rgba(0,0,0,0.06)',
          padding:6, zIndex:2000,
        }}>
          {langs.map(l => (
            <a key={l.code} role="menuitemradio" aria-checked={l.code === currentLang}
              href={`/${l.code}/${currentPage}/`}
              onClick={(e) => { e.preventDefault(); select(l.code); }}
              style={{
                display:'flex', alignItems:'center', gap:10, width:'100%',
                background: l.code === currentLang ? '#FFF1E1' : 'none',
                border:'none', cursor:'pointer', padding:'9px 12px',
                borderRadius:8, textAlign:'left', font:'inherit', color:'#1A1A1A',
                transition:'background 0.12s',
                textDecoration:'none'
              }}
              onMouseEnter={e => { if (l.code !== currentLang) e.currentTarget.style.background='#FFF6EE'; }}
              onMouseLeave={e => { e.currentTarget.style.background = l.code === currentLang ? '#FFF1E1' : 'none'; }}
            >
              <span style={{
                width:26, height:22, display:'inline-flex', alignItems:'center', justifyContent:'center',
                fontWeight:700, fontSize:13, color:'#E57500', background:'#FFF1E1', borderRadius:6, letterSpacing:'-0.02em', flexShrink:0,
              }}>{l.mark}</span>
              <span style={{ flex:1 }}>
                <div style={{ fontSize:14, fontWeight:600 }}>{l.name}</div>
                <div style={{ fontSize:11, color:'#6B7280', marginTop:1, fontWeight:500, letterSpacing:'0.02em' }}>{l.sub}</div>
              </span>
              {l.code === currentLang && (
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="#E57500" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 8.5L6.5 12L13 4.5"/>
                </svg>
              )}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

// Navigation component
function Nav({
  currentPage = 'home',
  onNavigate
}) {
  const [scrolled, setScrolled] = React.useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  React.useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const textColor = '#1A1A1A';
  const navigate = page => {
    onNavigate(page);
    setMobileOpen(false);
    window.scrollTo(0, 0);
  };
  const solutions = [{
    id: 'landlords',
    label: t("k_242"),
    desc: t("k_243")
  }, {
    id: 'tenants',
    label: t("k_244"),
    desc: t("k_245")
  }, {
    id: 'investors',
    label: t("k_246"),
    desc: t("k_247")
  }];
  return <nav style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    background: 'rgba(255,255,255,0.97)',
    borderBottom: '1px solid rgba(0,0,0,0.07)',
    backdropFilter: t("k_248"),
    transition: t("k_249")
  }}>
      <div style={{
      maxWidth: 1200,
      margin: t("k_250"),
      padding: '0 clamp(12px, 3vw, 24px)',
      display: 'flex',
      alignItems: 'center',
      height: 68
    }}>
        <a href={`/${currentLang}/home/`} onClick={(e) => { e.preventDefault(); navigate('home'); }} aria-label={t("k_1")} style={{
        background: 'transparent',
        border: 'none',
        outline: 'none',
        cursor: t("k_251"),
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none'
      }}>
          <Logo size="clamp(30px, 6vw, 40px)" />
        </a>

        <div className="desktop-nav">
          {solutions.map(s => (
            <a 
              key={s.id} 
              href={`/${currentLang}/${s.id}/`} 
              onClick={(e) => { e.preventDefault(); navigate(s.id); }} 
              className={`desktop-nav-link ${currentPage === s.id ? 'active' : ''}`}
              style={{ textDecoration: 'none' }}
            >
              {s.label}
            </a>
          ))}
        </div>

        <div style={{
        flex: 1
      }}></div>

        <div style={{
        display: 'flex',
        gap: 'clamp(4px, 1.5vw, 10px)',
        alignItems: 'center'
      }}>
          <LangSwitcher currentPage={currentPage} />
          <a href={currentPage === 'landlords' ? SUPPORT_URL : APP_URL} style={{
          background: currentPage === 'landlords' ? '#2DD4BF' : '#E57500',
          color: currentPage === 'landlords' ? '#042F2E' : 'white',
          border: 'none',
          borderRadius: 8,
          padding: 'clamp(4px, 1.5vw, 8px) clamp(8px, 3vw, 16px)',
          fontSize: 'clamp(12px, 3.5vw, 14px)',
          whiteSpace: 'nowrap',
          fontWeight: 600,
          cursor: t("k_251"),
          transition: t("k_253"),
          textDecoration: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center'
        }} onMouseEnter={e => e.currentTarget.style.background = currentPage === 'landlords' ? '#0D9488' : '#B55B00'} onMouseLeave={e => e.currentTarget.style.background = currentPage === 'landlords' ? '#2DD4BF' : '#E57500'}>{t("k_2")}</a>
        </div>

        <button className="hamburger-btn" type="button" onClick={() => setMobileOpen(!mobileOpen)} aria-label={mobileOpen ? t("k_257") : t("k_258")} style={{
        background: 'none',
        border: 'none',
        cursor: t("k_251"),
        color: textColor,
        padding: t("k_259"),
        marginLeft: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
          {mobileOpen ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <path d="M3 12h18M3 6h18M3 18h18" />
            </svg>}
        </button>
      </div>

      {mobileOpen && <div role="menu" style={{
      background: 'white',
      borderTop: '1px solid rgba(0,0,0,0.07)',
      padding: t("k_260"),
      maxHeight: t("k_261"),
      overflowY: 'auto'
    }}>
          <div style={{
        fontSize: 12,
        fontWeight: 700,
        color: '#B55B00',
        textTransform: t("k_262"),
        letterSpacing: '0.1em',
        marginBottom: 12,
        marginTop: 8
      }}>{t("k_3")}</div>
          {solutions.map(s => (
            <a 
              key={s.id} 
              href={`/${currentLang}/${s.id}/`} 
              onClick={(e) => { e.preventDefault(); navigate(s.id); }} 
              style={{
                display: 'block',
                width: '100%',
                textAlign: t("k_263"),
                padding: t("k_264"),
                background: 'none',
                border: 'none',
                cursor: t("k_251"),
                fontSize: 17,
                fontWeight: 600,
                color: '#1A1A1A',
                borderBottom: '1px solid rgba(0,0,0,0.05)',
                textDecoration: 'none'
              }}
            >
              {s.label}
            </a>
          ))}

          <div style={{
        fontSize: 12,
        fontWeight: 700,
        color: '#B55B00',
        textTransform: t("k_262"),
        letterSpacing: '0.1em',
        marginBottom: 12,
        marginTop: 28
      }}>{t("k_978")}</div>
          <a href={`/${currentLang}/promotions/`} onClick={(e) => { e.preventDefault(); navigate('promotions'); }} style={{
        display: 'block',
        width: '100%',
        textAlign: t("k_263"),
        padding: t("k_264"),
        background: 'none',
        border: 'none',
        cursor: t("k_251"),
        fontSize: 17,
        fontWeight: 600,
        color: '#1A1A1A',
        borderBottom: '1px solid rgba(0,0,0,0.05)',
        textDecoration: 'none'
      }}>{t("k_979")}</a>

          <a href={currentPage === 'landlords' ? SUPPORT_URL : APP_URL} style={{
        marginTop: 40,
        background: '#E57500',
        color: 'white',
        border: 'none',
        borderRadius: 12,
        padding: t("k_265"),
        fontSize: 17,
        fontWeight: 700,
        cursor: t("k_251"),
        width: '100%',
        boxShadow: t("k_266"),
        textDecoration: 'none',
        display: 'block',
        textAlign: 'center'
      }}>{t("k_2")}</a>
        </div>}
    </nav>;
}
function navLinkStyle(active, color) {
  return {
    background: 'none',
    border: 'none',
    cursor: t("k_251"),
    fontSize: 14,
    fontWeight: active ? 600 : 500,
    color: active ? '#B55B00' : color,
    padding: t("k_267"),
    borderRadius: 6,
    transition: t("k_268")
  };
}

// Footer
function Footer({
  onNavigate,
  onOpenChatbot
}) {
  const [showUK, setShowUK] = React.useState(false);
  const [showHK, setShowHK] = React.useState(false);
  const cols = [{
    title: t("k_3"),
    links: [{
      label: t("k_269"),
      id: 'landlords'
    }, {
      label: t("k_244"),
      id: 'tenants'
    }, {
      label: t("k_246"),
      id: 'investors'
    }]
  }, {
    title: t("k_270"),
    links: [{
      label: t("k_59"),
      id: 'faq'
    }, {
      label: t("k_271"),
      href: t("k_272")
    }]
  }, {
    title: t("k_273"),
    links: [{
      label: t("k_274"),
      id: 'terms'
    }, {
      label: t("k_275"),
      id: 'privacy'
    }, {
      label: t("k_276"),
      id: 'user-terms'
    }, {
      label: t("k_277"),
      id: 'cookie-policy'
    }, {
      label: t("k_278"),
      href: 'https://register.fca.org.uk/s/firm?id=0014G00002tih4kQAA',
      external: true
    }]
  }];
  const socialLinks = [{
    name: t("k_279"),
    url: 'https://www.linkedin.com/company/keychain-fintech-ltd./?originalSubdomain=hk',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" /></svg>
  }, {
    name: t("k_280"),
    url: 'https://www.facebook.com/KeyChainPay/',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
  }, {
    name: t("k_281"),
    url: 'https://www.instagram.com/keychainpay/',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
  }, {
    name: t("k_282"),
    url: t("k_272"),
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
  }, {
    name: t("k_4"),
    url: '#',
    isChatbot: true,
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3 11H7v-2h10v2zm0-3H7V8h10v2zm0-3H7V5h10v2z" /></svg>
  }];
  return <footer style={{
    background: '#0F1820',
    color: 'white',
    paddingTop: 64,
    paddingBottom: 40,
    position: 'relative'
  }}>
      <div style={{
      maxWidth: 1200,
      margin: t("k_250"),
      padding: '0 24px'
    }}>
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: t("k_287"),
        gap: 40,
        marginBottom: 56
      }}>
          <div>
            <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: 16
          }}>
              <img src="/uploads/keychain_new_logo_dark.png" alt={t("k_0")} style={{
              height: 33,
              width: 'auto',
              objectFit: t("k_241")
            }} />
            </div>
            <p style={{
            fontSize: 14,
            color: 'rgba(255,255,255,0.5)',
            lineHeight: 1.6,
            maxWidth: 220
          }}>{t("k_6")}</p>
            <div style={{
            marginTop: 24,
            display: 'flex',
            gap: 16
          }}>
              {socialLinks.map(s => <a key={s.name} href={s.url} target={s.isChatbot ? t("k_288") : t("k_289")} rel="noopener noreferrer" aria-label={s.name} onClick={s.isChatbot ? e => {
              e.preventDefault();
              onOpenChatbot && onOpenChatbot();
            } : undefined} style={{
              color: 'rgba(255,255,255,0.4)',
              transition: t("k_290"),
              cursor: t("k_251")
            }} onMouseEnter={e => {
              e.currentTarget.style.color = '#FFA567';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }} onMouseLeave={e => {
              e.currentTarget.style.color = 'rgba(255,255,255,0.4)';
              e.currentTarget.style.transform = 'none';
            }}>
                  {s.icon}
                </a>)}
            </div>
          </div>
          {cols.map(col => <div key={col.title}>
              <div style={{
            fontSize: 12,
            fontWeight: 700,
            color: '#FFA567',
            textTransform: t("k_262"),
            letterSpacing: '0.1em',
            marginBottom: 16
          }}>{col.title}</div>
              {col.links.map(link => {
                const isNav = !!link.id;
                const href = isNav ? `/${currentLang}/${link.id}/` : (link.href || '#');
                return (
                  <a
                    key={link.label}
                    href={href}
                    onClick={isNav ? (e) => {
                      e.preventDefault();
                      onNavigate(link.id);
                    } : (link.href && !link.external ? (e) => {
                      e.preventDefault();
                      window.location.href = link.href;
                    } : undefined)}
                    target={link.external ? '_blank' : undefined}
                    rel={link.external ? 'noopener noreferrer' : undefined}
                    style={{
                      display: 'block',
                      width: '100%',
                      textAlign: t("k_263"),
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      margin: '0 0 10px',
                      fontSize: 14,
                      color: 'rgba(255,255,255,0.55)',
                      cursor: t("k_251"),
                      transition: t("k_292"),
                      textDecoration: 'none'
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.color = 'white';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.color = 'rgba(255,255,255,0.55)';
                    }}
                  >
                    {link.label}
                  </a>
                );
              })}
            </div>)}
          <div>
            <div style={{
            fontSize: 12,
            fontWeight: 700,
            color: '#FFA567',
            textTransform: t("k_262"),
            letterSpacing: '0.1em',
            marginBottom: 16
          }}>{t("k_7")}</div>
            <div style={{
            position: 'relative',
            marginBottom: 12
          }} onMouseEnter={() => setShowUK(true)} onMouseLeave={() => setShowUK(false)}>
              <span style={{
              fontSize: 14,
              color: 'rgba(255,255,255,0.55)',
              cursor: t("k_251"),
              display: 'flex',
              alignItems: 'center',
              gap: 6
            }}>{t("k_8")}</span>
              {showUK && <div style={{
              position: 'absolute',
              bottom: '100%',
              left: 0,
              background: 'white',
              color: '#1A1A1A',
              padding: t("k_293"),
              borderRadius: 8,
              fontSize: 12,
              width: 220,
              zIndex: 10,
              boxShadow: t("k_294"),
              marginBottom: 8
            }}>{t("k_9")}</div>}
            </div>
            <div style={{
            position: 'relative'
          }} onMouseEnter={() => setShowHK(true)} onMouseLeave={() => setShowHK(false)}>
              <span style={{
              fontSize: 14,
              color: 'rgba(255,255,255,0.55)',
              cursor: t("k_251"),
              display: 'flex',
              alignItems: 'center',
              gap: 6
            }}>{t("k_10")}</span>
              {showHK && <div style={{
              position: 'absolute',
              bottom: '100%',
              left: 0,
              background: 'white',
              color: '#1A1A1A',
              padding: t("k_293"),
              borderRadius: 8,
              fontSize: 12,
              width: 220,
              zIndex: 10,
              boxShadow: t("k_294"),
              marginBottom: 8
            }}>{t("k_11")}</div>}
            </div>
          </div>
        </div>
        <div style={{
        borderTop: '1px solid rgba(255,255,255,0.06)',
        paddingTop: 32,
        display: 'flex',
        justifyContent: t("k_285"),
        alignItems: 'center',
        flexWrap: t("k_295"),
        gap: 20
      }}>
          <div style={{
          fontSize: 13,
          color: 'rgba(255,255,255,0.3)'
        }}>{t("k_12")}</div>
          <div style={{
          display: 'flex',
          gap: 24
        }}>
            {[t("k_296"), t("k_297")].map(loc => <span key={loc} style={{
            fontSize: 12,
            color: 'rgba(255,255,255,0.4)',
            background: 'rgba(255,255,255,0.06)',
            padding: t("k_298"),
            borderRadius: 20
          }}>{loc}</span>)}
          </div>
        </div>
      </div>
    </footer>;
}

// Scroll fade-in hook
function useScrollReveal(ref, threshold = 0.05) {
  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => {
    // If IntersectionObserver is not supported, just show it
    if (!(t("k_299") in window)) {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.unobserve(entry.target);
      }
    }, {
      threshold,
      rootMargin: t("k_300")
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return visible;
}

// Reveal wrapper
function Reveal({
  children,
  delay = 0,
  direction = t("k_301")
}) {
  const ref = React.useRef();
  const visible = useScrollReveal(ref);
  const transforms = {
    up: 'translateY(20px)',
    down: 'translateY(-20px)',
    left: 'translateX(-20px)',
    right: 'translateX(20px)',
    none: 'none'
  };
  return <div ref={ref} style={{
    opacity: visible ? 1 : 0,
    transform: visible ? 'none' : transforms[direction],
    transition: `opacity 0.8s cubic-bezier(0.21, 0.6, 0.35, 1) ${delay}ms, transform 0.8s cubic-bezier(0.21, 0.6, 0.35, 1) ${delay}ms`,
    willChange: t("k_302")
  }}>
      {children}
    </div>;
}

// Client Logo Rolling Banner
function LogoRollingBanner({
  clients,
  height = 68,
  reverse = false
}) {
  const ref = React.useRef();
  const visible = useScrollReveal(ref, 0.1);
  return <div ref={ref} className={`logo-container ${visible ? t("k_303") : ''}`}>
      <div className="logo-track" style={{
      animationDirection: reverse ? t("k_304") : t("k_305")
    }}>
        {[...clients, ...clients, ...clients].map((client, idx) => {
        const imgEl = <img src={client.logo} alt={client.name} style={{
          height: height * (client.scale || 1),
          width: 'auto',
          maxWidth: 220,
          objectFit: t("k_241"),
          transition: t("k_306")
        }} />;
        return <div key={`${client.name}-${idx}`} style={{
          textAlign: 'center',
          width: 200
        }}>
              {client.url ? <a href={client.url} target="_blank" rel="noopener noreferrer" style={{
            display: t("k_307"),
            transition: t("k_308")
          }} onMouseEnter={e => e.currentTarget.style.transform = t("k_309")} onMouseLeave={e => e.currentTarget.style.transform = 'none'}>
                  {imgEl}
                </a> : imgEl}
            </div>;
      })}
      </div>
    </div>;
}

// Pill badge
function Badge({
  children,
  color = '#FFA567',
  bg,
  onClick,
  style = {}
}) {
  return <span onClick={onClick} style={{
    display: t("k_310"),
    alignItems: 'center',
    background: bg || `${color}20`,
    color,
    border: `1px solid ${color}40`,
    borderRadius: 20,
    padding: t("k_311"),
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: '0.05em',
    textTransform: t("k_262"),
    cursor: onClick ? t("k_251") : t("k_291"),
    ...style
  }}>{children}</span>;
}

// Button
function Btn({
  children,
  variant = t("k_312"),
  onClick,
  style: extraStyle = {}
}) {
  const styles = {
    primary: {
      background: '#E57500',
      color: 'white',
      border: 'none'
    },
    bright: {
      background: '#E57500',
      color: 'white',
      border: 'none'
    },
    outline: {
      background: 'transparent',
      color: '#E57500',
      border: '2px solid #E57500'
    },
    outlineDark: {
      background: 'transparent',
      color: '#1B3B5F',
      border: '2px solid #1B3B5F'
    },
    outlineLight: {
      background: 'transparent',
      color: 'white',
      border: '2px solid rgba(255,255,255,0.5)'
    },
    ghost: {
      background: 'rgba(255,255,255,0.1)',
      color: 'white',
      border: '1px solid rgba(255,255,255,0.2)'
    }
  };
  return <button onClick={onClick} style={{
    ...styles[variant],
    borderRadius: 10,
    padding: t("k_313"),
    fontSize: 15,
    fontWeight: 600,
    cursor: t("k_251"),
    transition: t("k_290"),
    display: t("k_310"),
    alignItems: 'center',
    gap: 8,
    ...extraStyle
  }} onMouseEnter={e => {
    e.currentTarget.style.transform = 'translateY(-1px)';
    e.currentTarget.style.boxShadow = t("k_314");
  }} onMouseLeave={e => {
    e.currentTarget.style.transform = 'none';
    e.currentTarget.style.boxShadow = 'none';
  }}>
      {children}
    </button>;
}

// Section container
function Section({
  children,
  bg = 'white',
  style: extraStyle = {},
  ...rest
}) {
  return <section style={{
    background: bg,
    padding: t("k_315"),
    ...extraStyle
  }} {...rest}>
      <div style={{
      maxWidth: 1200,
      margin: t("k_250")
    }}>
        {children}
      </div>
    </section>;
}

// Section header
function SectionHeader({
  eyebrow,
  title,
  subtitle,
  light = false,
  center = true
}) {
  return <div style={{
    textAlign: center ? 'center' : t("k_263"),
    marginBottom: 56
  }}>
      {eyebrow && <Badge color={light ? '#FFA567' : '#B55B00'}>{eyebrow}</Badge>}
      <h2 style={{
      fontFamily: t("k_316"),
      fontSize: t("k_317"),
      fontWeight: 700,
      color: light ? 'white' : '#1A1A1A',
      margin: t("k_318"),
      lineHeight: 1.15,
      letterSpacing: t("k_319")
    }}>{title}</h2>
      {subtitle && <p style={{
      fontSize: 18,
      color: light ? 'rgba(255,255,255,0.65)' : '#6B7280',
      maxWidth: 600,
      margin: center ? t("k_250") : 0,
      lineHeight: 1.65
    }}>{subtitle}</p>}
    </div>;
}

// Export all to window
Object.assign(window, {
  Logo,
  Logomark,
  Nav,
  Footer,
  Badge,
  Btn,
  Section,
  SectionHeader,
  Reveal,
  COLORS,
  useScrollReveal
});

// Homepage component
function HeroAnimatedPanel() {
  const [ringPct, setRingPct] = React.useState(0);
  const [txVisible, setTxVisible] = React.useState([false, false, false, false]);
  const [notifIdx, setNotifIdx] = React.useState(0);
  const [notifVisible, setNotifVisible] = React.useState(true);

  // Animate ring on mount
  React.useEffect(() => {
    let start = null;
    let rafId = 0;
    const duration = 1800;
    const animate = ts => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / duration, 1);
      setRingPct(p * 99.6);
      if (p < 1) rafId = requestAnimationFrame(animate);
    };
    const tId = setTimeout(() => {
      rafId = requestAnimationFrame(animate);
    }, 400);
    return () => {
      clearTimeout(tId);
      cancelAnimationFrame(rafId);
    };
  }, []);

  // Stagger transaction items
  React.useEffect(() => {
    const tIds = [0, 1, 2, 3].map(i => setTimeout(() => setTxVisible(v => {
      const n = [...v];
      n[i] = true;
      return n;
    }), 200 + i * 150));
    return () => tIds.forEach(clearTimeout);
  }, []);

  // Cycle notifications
  const notifs = React.useMemo(() => [{
    icon: '✓',
    label: t("k_320"),
    sub: t("k_321"),
    color: '#E57500'
  }, {
    icon: '⚡',
    label: t("k_322"),
    sub: t("k_323"),
    color: '#FFA567'
  }, {
    icon: '✦',
    label: t("k_324"),
    sub: t("k_325"),
    color: '#81B4C5'
  }, {
    icon: '🔒',
    label: t("k_326"),
    sub: t("k_327"),
    color: '#ACB5B3'
  }], []);
  React.useEffect(() => {
    let innerTimeout = 0;
    const iv = setInterval(() => {
      setNotifVisible(false);
      innerTimeout = setTimeout(() => {
        setNotifIdx(i => (i + 1) % notifs.length);
        setNotifVisible(true);
      }, 500);
    }, 3200);
    return () => {
      clearInterval(iv);
      clearTimeout(innerTimeout);
    };
  }, [notifs.length]);
  const transactions = [{
    name: t("k_328"),
    unit: t("k_329"),
    amount: t("k_330"),
    status: t("k_331")
  }, {
    name: t("k_332"),
    unit: t("k_333"),
    amount: t("k_334"),
    status: t("k_331")
  }, {
    name: t("k_335"),
    unit: t("k_336"),
    amount: t("k_337"),
    status: t("k_338")
  }, {
    name: t("k_339"),
    unit: t("k_340"),
    amount: t("k_341"),
    status: t("k_331")
  }];

  // Ring maths
  const R = 54,
    circ = 2 * Math.PI * R;
  const offset = circ - ringPct / 100 * circ;
  return <div className="hero-stats" style={{
    position: 'relative',
    width: '100%',
    maxWidth: 420,
    margin: t("k_250"),
    display: 'flex',
    flexDirection: t("k_283"),
    gap: 10
  }}>
      {/* Main dashboard card */}
      <div style={{
      background: 'rgba(255,255,255,0.07)',
      backdropFilter: t("k_342"),
      border: '1px solid rgba(255,255,255,0.15)',
      borderRadius: 20,
      padding: t("k_343")
    }}>
        {/* Header */}
        <div style={{
        display: 'flex',
        justifyContent: t("k_285"),
        alignItems: 'center',
        marginBottom: 16
      }}>
          <div>
            <div style={{
            fontSize: 11,
            color: 'rgba(255,255,255,0.45)',
            textTransform: t("k_262"),
            letterSpacing: '0.1em'
          }}>{t("k_13")}</div>
            <div style={{
            fontSize: 13,
            fontWeight: 600,
            color: 'rgba(255,255,255,0.85)',
            marginTop: 2
          }}>{t("k_14")}</div>
          </div>
          <div style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: '#E57500',
          animation: t("k_344")
        }} />
        </div>

        {/* Ring + metric */}
        <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        marginBottom: 16
      }}>
          <div style={{
          position: 'relative',
          flexShrink: 0
        }}>
            <svg width={130} height={130} viewBox="0 0 130 130">
              <circle cx={65} cy={65} r={R} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth={10} />
              <circle cx={65} cy={65} r={R} fill="none" stroke="url(#ringGrad)" strokeWidth={10} strokeLinecap="round" strokeDasharray={circ} strokeDashoffset={offset} transform="rotate(-90 65 65)" style={{
              transition: t("k_345")
            }} />
              
              <defs>
                <linearGradient id="ringGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#E57500" />
                  <stop offset="100%" stopColor="#FFA567" />
                </linearGradient>
              </defs>
              <text x={65} y={58} textAnchor={t("k_15")} fill="white" fontSize={22} fontWeight={800} fontFamily={t("k_16")}>{ringPct.toFixed(1)}%</text>
              <text x={65} y={75} textAnchor={t("k_15")} fill="rgba(255,255,255,0.45)" fontSize={9} letterSpacing={1}>{t("k_17")}</text>
            </svg>
          </div>
          <div>
            <div style={{
            marginBottom: 10
          }}>
              <div style={{
              fontSize: 22,
              fontWeight: 800,
              color: 'white',
              fontFamily: t("k_346")
            }}>{t("k_18")}</div>
              <div style={{
              fontSize: 11,
              color: 'rgba(255,255,255,0.45)'
            }}>{t("k_19")}</div>
            </div>
            <div>
              <div style={{
              fontSize: 22,
              fontWeight: 800,
              color: '#FFA567',
              fontFamily: t("k_346")
            }}>{t("k_20")}</div>
              <div style={{
              fontSize: 11,
              color: 'rgba(255,255,255,0.45)'
            }}>{t("k_21")}</div>
            </div>
          </div>
        </div>

        {/* Transaction feed */}
        <div style={{
        borderTop: '1px solid rgba(255,255,255,0.08)',
        paddingTop: 12
      }}>
          <div style={{
          fontSize: 10,
          color: 'rgba(255,255,255,0.35)',
          textTransform: t("k_262"),
          letterSpacing: '0.1em',
          marginBottom: 8
        }}>{t("k_22")}</div>
          {transactions.map((tx, i) => <div key={tx.name} style={{
          display: 'flex',
          justifyContent: t("k_285"),
          alignItems: 'center',
          padding: t("k_347"),
          borderBottom: i < 3 ? '1px solid rgba(255,255,255,0.05)' : 'none',
          opacity: txVisible[i] ? 1 : 0,
          transform: txVisible[i] ? 'none' : 'translateX(12px)',
          transition: t("k_348")
        }}>
              <div>
                <div style={{
              fontSize: 12,
              fontWeight: 600,
              color: 'rgba(255,255,255,0.85)'
            }}>{tx.name}</div>
                <div style={{
              fontSize: 10,
              color: 'rgba(255,255,255,0.35)'
            }}>{tx.unit}</div>
              </div>
              <div style={{
            textAlign: t("k_349")
          }}>
                <div style={{
              fontSize: 12,
              fontWeight: 700,
              color: 'white'
            }}>{tx.amount}</div>
                <div style={{
              fontSize: 10,
              color: tx.status === t("k_331") ? '#E57500' : '#81B4C5'
            }}>{tx.status}</div>
              </div>
            </div>)}
        </div>
      </div>

      {/* Cycling notification toast */}
      <div style={{
      background: 'rgba(255,255,255,0.07)',
      backdropFilter: t("k_350"),
      border: '1px solid rgba(255,255,255,0.12)',
      borderRadius: 14,
      padding: t("k_293"),
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      opacity: notifVisible ? 1 : 0,
      transform: notifVisible ? 'none' : 'translateY(6px)',
      transition: t("k_348")
    }}>
        <div style={{
        width: 32,
        height: 32,
        borderRadius: '50%',
        background: notifs[notifIdx].color + '25',
        border: `1px solid ${notifs[notifIdx].color}50`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 14,
        flexShrink: 0
      }}>
          {notifs[notifIdx].icon}
        </div>
        <div>
          <div style={{
          fontSize: 13,
          fontWeight: 700,
          color: 'white'
        }}>{notifs[notifIdx].label}</div>
          <div style={{
          fontSize: 11,
          color: 'rgba(255,255,255,0.45)',
          marginTop: 1
        }}>{notifs[notifIdx].sub}</div>
        </div>
      </div>
    </div>;
}

function SEO({ title, description, urlPath }) {
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://www.keychainpay.com';
  const cleanPath = urlPath.startsWith('/') ? urlPath.substring(1) : urlPath;
  const fullUrl = `${origin}/${cleanPath}`;
  const defaultImage = `${origin}/uploads/keychain_logo_new_v3.png`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content="Keychain" />
      <meta property="og:image" content={defaultImage} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={defaultImage} />
    </Helmet>
  );
}
function HomePage({
  onNavigate
}) {
  const heroRef = React.useRef();

  // Canvas node animation
  React.useEffect(() => {
    const canvas = document.getElementById('hero-canvas');
    if (!canvas) return;
    const ctx = canvas.getContext(t("k_351"));
    let animId = 0;
    let running = true;
    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener(t("k_352"), resize, {
      passive: true
    });
    const onVis = () => {
      if (document.hidden) {
        running = false;
        cancelAnimationFrame(animId);
      } else if (!running) {
        running = true;
        animId = requestAnimationFrame(draw);
      }
    };
    document.addEventListener(t("k_353"), onVis);
    const nodes = Array.from({
      length: 38
    }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      vx: (Math.random() - 0.5) * 0.4,
      vy: (Math.random() - 0.5) * 0.4,
      r: Math.random() * 2.5 + 1
    }));
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      nodes.forEach(n => {
        n.x += n.vx;
        n.y += n.vy;
        if (n.x < 0 || n.x > canvas.width) n.vx *= -1;
        if (n.y < 0 || n.y > canvas.height) n.vy *= -1;
      });
      nodes.forEach((a, i) => {
        nodes.slice(i + 1).forEach(b => {
          const d = Math.hypot(a.x - b.x, a.y - b.y);
          if (d < 140) {
            ctx.beginPath();
            ctx.moveTo(a.x, a.y);
            ctx.lineTo(b.x, b.y);
            ctx.strokeStyle = `rgba(255,165,103,${0.12 * (1 - d / 140)})`;
            ctx.lineWidth = 1;
            ctx.stroke();
          }
        });
        ctx.beginPath();
        ctx.arc(a.x, a.y, a.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,165,103,0.35)';
        ctx.fill();
      });
      if (running) animId = requestAnimationFrame(draw);
    };
    draw();
    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener(t("k_352"), resize);
      document.removeEventListener(t("k_353"), onVis);
    };
  }, []);
  return <div>
      <SEO title={(currentLang === "tc" || currentLang === "sc") ? "Keychain - 智能租務代理" : "Keychain - AI Rental Agent"} description={`Keychain is the AI Rental Agent for the global rental economy. Guarantee rent for landlords, earn rewards for tenants. FCA-licensed.`} urlPath={`/${currentLang}/home/`} />
      {/* HERO */}
      <section ref={heroRef} style={{
      position: 'relative',
      background: 'linear-gradient(135deg, #1F3540 0%, #2D4E5C 15%, #67919F 40%, #E57500 75%, #B55B00 100%)',
      backgroundSize: '200% 200%',
      animation: t("k_354"),
      padding: t("k_355"),
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden'
    }}>
        <canvas id="hero-canvas" style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        opacity: 0.8
      }} />

        {/* Gradient orbs */}
        <div style={{
        position: 'absolute',
        top: '15%',
        right: '8%',
        width: 520,
        height: 520,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(31,53,64,0.5) 0%, transparent 70%)',
        pointerEvents: 'none'
      }} />
        <div style={{
        position: 'absolute',
        bottom: '10%',
        left: '5%',
        width: 360,
        height: 360,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(229,117,0,0.4) 0%, transparent 70%)',
        pointerEvents: 'none'
      }} />
        <div style={{
        position: 'relative',
        maxWidth: 1200,
        margin: t("k_250"),
        width: '100%',
        display: t("k_286"),
        gridTemplateColumns: t("k_356"),
        gap: 64,
        alignItems: 'center'
      }} className="two-col">
          <div>
            <div style={{
            marginBottom: 24
          }}>
              <div style={{
              display: 'flex',
              gap: 10,
              flexWrap: t("k_295"),
              alignItems: 'center'
            }}>
                <Badge color="#FFA567" bg={t("k_23")}>{t("k_24")}</Badge>
                <Badge color="white" bg={t("k_25")}>{t("k_26")}</Badge>
              </div>
            </div>

            <h1 style={{
            fontFamily: t("k_316"),
            fontSize: t("k_357"),
            fontWeight: 800,
            color: 'white',
            lineHeight: 1.06,
            letterSpacing: t("k_358"),
            margin: '0 0 28px'
          }}>{t("k_27")}<br />
              <span style={{
              color: '#FFA567'
            }}>{t("k_28")}</span><br />
              <span style={{
              opacity: 0.5
            }}>{t("k_29")}</span>
            </h1>

            <p style={{
            fontSize: t("k_359"),
            color: 'rgba(255,255,255,0.65)',
            lineHeight: 1.65,
            maxWidth: 560,
            marginBottom: 44
          }}>{t("k_30")}</p>

            <div style={{
            display: 'flex',
            gap: 14,
            flexWrap: t("k_295")
          }}>
              <Btn variant="bright" onClick={() => {
              window.scrollTo(0, 0);
              onNavigate('tenants');
            }}>{t("k_31")}</Btn>
              <Btn variant="outlineLight" onClick={() => {
              window.scrollTo(0, 0);
              onNavigate('landlords');
            }}>{t("k_32")}</Btn>
              <Btn variant="outlineLight" onClick={() => {
              window.scrollTo(0, 0);
              onNavigate('investors');
            }}>{t("k_33")}</Btn>
            </div>

            {/* Trust signals */}
            <div style={{
            marginTop: 56,
            display: 'flex',
            gap: 24,
            flexWrap: t("k_295"),
            alignItems: 'center'
          }}>
              {[t("k_52"), t("k_360"), t("k_55")].map(award => <div key={award} style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8
            }}>
                  <div style={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: '#FFA567'
              }} />
                  <span style={{
                fontSize: 13,
                color: 'rgba(255,255,255,0.45)',
                fontWeight: 500
              }}>{award}</span>
                </div>)}
            </div>
          </div>

          {/* Animated hero visual */}
          <HeroAnimatedPanel />
        </div>
      </section>

      {/* HOW IT WORKS */}
      <Section bg="#F0FDFA">
        <SectionHeader eyebrow={t("k_34")} title={t("k_35")} subtitle={t("k_36")} />
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: t("k_356"),
        gap: 32
      }} className="two-col">
          {[{
          audience: t("k_361"),
          color: '#E57500',
          accent: '#B55B00',
          steps: [{
            n: '01',
            title: t("k_362"),
            desc: t("k_363")
          }, {
            n: '02',
            title: t("k_364"),
            desc: t("k_365")
          }, {
            n: '03',
            title: t("k_366"),
            desc: t("k_367")
          }, {
            n: '04',
            title: t("k_368"),
            desc: t("k_369")
          }]
        }, {
          audience: t("k_244"),
          color: '#67919F',
          accent: '#FFA567',
          steps: [{
            n: '01',
            title: t("k_362"),
            desc: t("k_363")
          }, {
            n: '02',
            title: t("k_364"),
            desc: t("k_370")
          }, {
            n: '03',
            title: t("k_371"),
            desc: t("k_372")
          }, {
            n: '04',
            title: t("k_368"),
            desc: t("k_369")
          }]
        }].map(flow => <Reveal key={flow.audience} delay={flow.audience === t("k_244") ? 150 : 0}>
              <div style={{
            background: 'white',
            borderRadius: 20,
            padding: 32,
            border: '1px solid rgba(0,0,0,0.06)',
            boxShadow: t("k_373")
          }}>
                <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              marginBottom: 28
            }}>
                  <div style={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                background: flow.color
              }} />
                  <span style={{
                fontFamily: t("k_374"),
                fontWeight: 700,
                fontSize: 18,
                color: flow.color
              }}>{t("k_37")}{flow.audience}</span>
                </div>
                {flow.steps.map((step, i) => <div key={`${flow.audience}-${step.n}`} style={{
              display: 'flex',
              gap: 16,
              marginBottom: i < 3 ? 24 : 0,
              position: 'relative'
            }}>
                    <div style={{
                position: 'relative',
                flexShrink: 0
              }}>
                      <div style={{
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  background: `${flow.color}15`,
                  border: `2px solid ${flow.color}30`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 12,
                  fontWeight: 800,
                  color: flow.color
                }}>{step.n}</div>
                      {i < 3 && <div style={{
                  position: 'absolute',
                  left: '50%',
                  top: 36,
                  transform: 'translateX(-50%)',
                  width: 1,
                  height: 24,
                  background: `${flow.color}20`
                }} />}
                    </div>
                    <div style={{
                paddingTop: 6
              }}>
                      <div style={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#1A1A1A',
                  marginBottom: 4
                }}>{step.title}</div>
                      <div style={{
                  fontSize: 14,
                  color: '#6B7280',
                  lineHeight: 1.5
                }}>{step.desc}</div>
                    </div>
                  </div>)}
              </div>
            </Reveal>)}
        </div>
      </Section>

      {/* KEY OUTCOMES */}
      <Section bg={t("k_38")}>
        <SectionHeader eyebrow={t("k_39")} title={t("k_40")} />
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: t("k_375"),
        gap: 24
      }}>
          {[{
          icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="m9 12 2 2 4-4" />
                </svg>,
          color: '#B55B00',
          title: t("k_376"),
          metric: '99.6%',
          metricLabel: t("k_377"),
          desc: t("k_378")
        }, {
          icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" />
                </svg>,
          color: '#E57500',
          title: t("k_379"),
          metric: '0',
          metricLabel: t("k_380"),
          desc: t("k_381")
        }, {
          icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>,
          color: '#E57500',
          title: t("k_382"),
          metric: t("k_383"),
          metricLabel: t("k_384"),
          desc: t("k_385")
        }].map((item, i) => <Reveal key={item.title} delay={i * 120}>
              <div style={{
            background: '#F9FAFB',
            borderRadius: 20,
            padding: 32,
            border: '1px solid rgba(0,0,0,0.05)',
            height: '100%'
          }}>
                <div style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              background: `${item.color}15`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: item.color,
              marginBottom: 20
            }}>{item.icon}</div>
                <div style={{
              fontSize: 40,
              fontFamily: t("k_374"),
              fontWeight: 800,
              color: item.color,
              lineHeight: 1
            }}>{item.metric}</div>
                <div style={{
              fontSize: 12,
              color: '#9CA3AF',
              textTransform: t("k_262"),
              letterSpacing: '0.08em',
              margin: t("k_386"),
              fontWeight: 600
            }}>{item.metricLabel}</div>
                <h3 style={{
              fontSize: 19,
              fontWeight: 700,
              color: '#1A1A1A',
              marginBottom: 10,
              fontFamily: t("k_374")
            }}>{item.title}</h3>
                <p style={{
              fontSize: 14,
              color: '#6B7280',
              lineHeight: 1.65
            }}>{item.desc}</p>
              </div>
            </Reveal>)}
        </div>
      </Section>

      {/* PRODUCT IN ACTION */}
      <Section bg="#1A1A1A">
        <SectionHeader eyebrow={t("k_41")} title={t("k_42")} subtitle={t("k_43")} light center />
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: t("k_387"),
        gap: 20
      }}>
          {[{
          label: t("k_388"),
          desc: t("k_389"),
          img: t("k_390"),
          color: '#E57500'
        }, {
          label: t("k_391"),
          desc: t("k_392"),
          img: t("k_393"),
          color: '#E57500'
        }, {
          label: t("k_394"),
          desc: t("k_395"),
          img: t("k_396"),
          color: '#B55B00'
        }].map((item, i) => <Reveal key={item.label} delay={i * 100}>
              <div style={{
            background: 'rgba(255,255,255,0.05)',
            borderRadius: 16,
            border: '1px solid rgba(255,255,255,0.1)',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: t("k_283"),
            height: '100%'
          }}>
                <div style={{
              background: `linear-gradient(135deg, ${item.color}40 0%, rgba(255,165,103,0.1) 100%)`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: 1,
              minHeight: 240
            }}>
                  <img src={item.img} alt={item.label} style={{
                width: '100%',
                height: '100%',
                maxHeight: 240,
                display: 'block',
                objectFit: item.fit ? t("k_241") : t("k_397")
              }} />
                </div>
                <div style={{
              padding: t("k_398"),
              background: 'rgba(0,0,0,0.2)'
            }}>
                  <div style={{
                fontSize: 16,
                fontWeight: 700,
                color: 'white',
                marginBottom: 6
              }}>{item.label}</div>
                  <div style={{
                fontSize: 13,
                color: 'rgba(255,255,255,0.5)'
              }}>{item.desc}</div>
                </div>
              </div>
            </Reveal>)}
        </div>
      </Section>
            {/* SOCIAL PROOF */}
      <Section bg="#F9FAFB">
        <SectionHeader eyebrow={t("k_44")} title={t("k_45")} />

        {/* Property Developers */}
        <div style={{
        marginBottom: 44
      }}>
          <div style={{
          fontSize: 10,
          fontWeight: 700,
          color: '#ACB5B3',
          textTransform: t("k_262"),
          letterSpacing: '0.12em',
          textAlign: 'center',
          marginBottom: 24
        }}>{t("k_46")}</div>
          <div style={{
          display: 'flex',
          flexWrap: t("k_295"),
          gap: 32,
          justifyContent: 'center',
          alignItems: 'center'
        }}>
            <a href="https://www.ejtech.ai/china/%E4%BF%A1%E5%92%8C%E9%BB%83%E9%87%91%E6%B5%B7%E5%B2%B8%E6%8E%A8ai%E4%BA%A4%E7%A7%9F%E5%B9%B3%E5%8F" target="_blank" rel="noopener noreferrer"><img src="data:image/svg+xml;base64,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" alt={t("k_47")} style={{
              height: 32,
              width: 'auto',
              maxWidth: 140,
              objectFit: t("k_241")
            }} /></a>
            <a href={t("k_922")} target="_blank" rel="noopener noreferrer"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM0AAABACAYAAAC5kvNvAAAACXBIWXMAAC4jAAAuIwF4pT92AAAHAmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNi4wLWMwMDIgNzkuMTY0NDYwLCAyMDIwLzA1LzEyLTE2OjA0OjE3ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iIHhtbG5zOmV4aWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vZXhpZi8xLjAvIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE1IChNYWNpbnRvc2gpIiB4bXA6Q3JlYXRlRGF0ZT0iMjAxNi0wNS0yM1QxMjo1NTo0MSswODowMCIgeG1wOk1vZGlmeURhdGU9IjIwMjAtMDktMTZUMTM6MDQ6MTMrMDg6MDAiIHhtcDpNZXRhZGF0YURhdGU9IjIwMjAtMDktMTZUMTM6MDQ6MTMrMDg6MDAiIGRjOmZvcm1hdD0iaW1hZ2UvcG5nIiBwaG90b3Nob3A6Q29sb3JNb2RlPSIzIiBwaG90b3Nob3A6SUNDUHJvZmlsZT0ic1JHQiBJRUM2MTk2Ni0yLjEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6YWNkNmJlM2UtNGRiZi00ZDg4LTljNTgtMzc2NWFkMzEyNTlhIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjk1OGRmZTBkLWZlZWItNDljYy1hZTkxLWEzNDliYTdiYzhlZiIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ4bXAuZGlkOjk1OGRmZTBkLWZlZWItNDljYy1hZTkxLWEzNDliYTdiYzhlZiIgdGlmZjpPcmllbnRhdGlvbj0iMSIgdGlmZjpYUmVzb2x1dGlvbj0iMzAwMDAwMC8xMDAwMCIgdGlmZjpZUmVzb2x1dGlvbj0iMzAwMDAwMC8xMDAwMCIgdGlmZjpSZXNvbHV0aW9uVW5pdD0iMiIgZXhpZjpDb2xvclNwYWNlPSI2NTUzNSIgZXhpZjpQaXhlbFhEaW1lbnNpb249IjIwNSIgZXhpZjpQaXhlbFlEaW1lbnNpb249IjEzMCI+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249ImNyZWF0ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6OTU4ZGZlMGQtZmVlYi00OWNjLWFlOTEtYTM0OWJhN2JjOGVmIiBzdEV2dDp3aGVuPSIyMDE2LTA1LTIzVDEyOjU1OjQxKzA4OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNSAoTWFjaW50b3NoKSIvPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0ic2F2ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6YWNkNmJlM2UtNGRiZi00ZDg4LTljNTgtMzc2NWFkMzEyNTlhIiBzdEV2dDp3aGVuPSIyMDIwLTA5LTE2VDEzOjA0OjEzKzA4OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgMjEuMiAoTWFjaW50b3NoKSIgc3RFdnQ6Y2hhbmdlZD0iLyIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4P9pUtAAAf5klEQVR4nO2dedwUxZnHvzPzXiCXJ16AUVFBV+O52TWrRtCK0saoGxXvI8kCXp14xXggiolRo6UmKN4HKlGjqKWxshqNLlGJcXcVz4gKXkFeAQG5Z2b/eKrfrum3Z96Z950Xyeb9fT7zme7q7urq6n6qnrsywB7A/kCev2+sAq5VYbCq3hVbbdYFBieKG4H+Kgyervf9qoHVZgNgs0RxH2CFCoOXv4ImlYXVpgXpv4IrygIbAi+pMFi9Bu6/P3AosBh4H5iuwuB/O1tfA3DIfgMG/OSgiy5k9ZAtKHzyCaxY0aVGNmUzPPlf7/HEY6/RtF7vkmMr5y/lxJO+wc7bDmRlodil+9DcTHbTTVl19xQumfYwX8JNCPHUG0cCk1LKzwa+EqIBfgD8LKVcremGVIEdgZcSZVellHUnRgP9oh2rzbPAOBUGb9ZaUQPw2cErVjDuj8+TuXwUHHpoXVq4zpYf88Sjk2kZFA/QhdUrWLn6C04761x23jpXl/tw31SY+RrXZrOLvywUCh1f0CmkjSKPqzC4qpvuVw3SBocJKgx+X+8bWW3GAcOIZ4qNgQtVGLxTZRXZxP67KgzOrlf7OoLrk/5WmxeAb7jifYDXrDaDVBh8Wkt9WYDPmpvJPPoI+WHbUTjmWGj9vMsNnfvJe1BcSGH53LZffsV8KCxgzgd/7XL9vP4GhREj4eijWFmH9naAlpSy33T3TTtAGjt9Szfd60zgVOB09xsMfFLuZKtNJlGUHMzSZu01gf2ABd5+DpmxO4T/TA0AFAqw1VaweAnFe6aQt5bs1KlkRuxbzwbXDcWf/YzCReMp5leTjWayRV905y2bU8q+7M4bdgLLgPndVPf7wJZuewWwV1J2tNrsiQwkq4BGq811KgyuKFPf7K42yGqzJTCzxstagXUTZROsNmcjfZcD1itzbdZqc4cKgzHxtLk6Dw0NMHgItM6jMHIExR/9uMY2dS+Kf/4zhd13p3D++dC7N5nBQ+RAt3FlbWhMKVvS3TetEYvoHnkuif8uo2wZgCgmtnD/QyrUUVb4d0qDatGrxt8ghHDmer9FwGfI7LkZMkDMB5oS1za7MjfT+MjnYfAQMosXU9DXkDOPUbz2WjIHHljDs9QfxfHjKVxyiexsPkj+83nIJtnlbkHflLJ5nanIatPYHRo+YCUVPsYK7cmqMKhl1FlYpnx5Yn9RhTrafXdWmxHAROBuqmDfVBi8Z7XJIbNDHiiqMOiUZslqczRwJ0JQBngSeAshqghNSB+nEA1APk9xnXWgb1/y775LcdQosiecSPZX18M663SmXZ3HrHconP4jik88AX37wbrrCrGsWfRL7BeBv9VSgdVmGHAScCndMyNkgQzStmrakwGuQD6WWtictFm3Vrzv2rARcByi2drFHbu92kocsRdcXf2sNgcDGyCD3PrI7LAYkb/eQdjCD1QYtHEJVpvziLWQA4FzgHHAdxIKgrZBIZ1oAIrFeNZZupTiHbeTf+opsvfdS+ab36z2ubqE4lW/pHDRRbBsKWy2OWQyXwXBAPRO7H9SrcbF2VOOAq4FXqmj1ih5/1XVzBhWmwbgEOAyYChwQZ3aUwn+SysCh1ttxgMHp5zbWbvNCmA6IpNsDWwODAf+xf23yTJWm4XA68SsZIQZwDXAg5XsR+WJJkI+Dy0tIuvMmU1hn2+ROfJIsuedB9sPr/G5qkPxllsoTp5M8eWXoVdvuXc+L4RcBzhj1ya01+qkYRWxmtKv40iENYj4w4LbHuj9NgW+SaxIOKtMe/Zw562s8hFW0t4es57V5nTko/Pb1IA860auPTu7tgFcocKgGqPckjLbleDzza2JYz8BPgTOQOSJKUhfdhruOd5zv3bGXTfT3wzsichfe6ZUsxh5V30oz4ZWQTRQMuuwdCmFe6ZQnDqV7MUXk7ng/KqqqArLl1M8cjSFR6bJvi+71BePkq4RqxabAfd14rrny5SfAxzW+eYAwkJeW+M1T6YVWm02RmbHIjJo+KPjcKvNqQhRNAG/U2Hweko1H7q6xiLEESGDGBVvcMc3p4sEUw5ulv8OYpzezzv0KvINzAfGIjMuwAj3w2ozQYXBxWn1Vkc0EfJ5aG4WrdWCBRQuvIDMI9PITJpEZvfda6oqieK0aRTOCCnOmU1m4MbQ2Fi3mSUFFwA7Ud3I3ggcTenIORPoD3zsttO0Ef4s1oJoncpN+Xe5tiyroj1R3TsiLlARlgFTKS/T+O3Jufv9qcy5Xwd+WebYUOB6b78/cCHt5bSxVptrifsmT0wcb3nnbVrmPp2C1WYH4NuI8XJHRMaZg3ggPKDCYEbikmsc13AxsK1XPt5qc7UKg3YKjdqIJkI+D/37Q//+FF5+mcwee5CbNAnGjo3PqfTB571vp/VzCmFI8Z4pAEKQhUJ3Egy1WPKtNlmEaHxcgbyU+fWQUVQYPIqMfFXDaXymeEXzVBic1NW2OLwCnOLtn078Qb0NXOcdu9/9J7Vnw109ZyEsmO/rlbSV1AyrzbeB3YgHvm0Rlsv/8GcAjwNvAh8BG7p+W5/YYL3EHZuBDAj+AHij1eZlhE6akIHv8c4RDbR91NGss3rcOLLGkL3uGthqG+jTBwopA+uqVWScQbJ4x50Uzj4bWudBNLt8NYJ+JXyX9jPJR0hn/xDxP/sqsFFiP9cJ9XEqVBh8hqf2dTJg9DG+pcLAP5ax2lyAeAz40CoMfuTO2YH6s2BnIDNKJexB6WxcK0a7X4Q3gC4QTQQ362T69aP4xBPkn3mW3L2TgeHQO0U93a8/mb/NhfsuJD/xOjK5hroL+nXGzillfwa2A/pZbdZVYbAg5Zz/T+iTtm21ORZRWUcuJj4L5vdJUvtYDyS1h3OJXZsKyMzXQjrrDMJaJweY3sgslIZmnEzadaKB+GMfPATmzYNDj6Mw9BDYRsEqzwaYzcHAgaw++fsw+/lYdln7ZhcfSZ57hQqDJVabV93+DxB27R8Rd7n/gxFbiO+13GsNt+UtFQZndHxaOiJPBBUGSTazHepDNBHyeVh/fVj6KSxdCml20FXL5djAFmjoVmG/Xkjq1SPh+TX3fx7/gERjtfkGonTYR4XBc05tvkbcM8qgjUitNgMAC3yA2G5mAG9EQr2TU9P80A6mCtmy/g9ZLEJTI/SuMCNHx9ZygnHBZ/+cKH4MwL2AN4ABVpvvrem2rQXoBXxdhcFzbj/N1agcfNvQwrq1KEYDIsscjqjhXwAeSpyTZG+udgqZDlF/osnlYNEyaG2FXGIiyzrWt7UVVq4SC//ajTHE/DrIy/bdPCJX/MlWm+7g2yshaTDM10MJUC1UGDyjwuDVjs9Mhe+KMzRxrB7cz9YpZW3cgOunpd6xogqDM6utvH7smSOA4pzZsHEv+Poe8FHCeFwoQlOOzG67wR/fhGWfw4Ybrs0yTdLN+3YVBgv9feBqZJq/m64bKNvgLNiVRu9dEvu9HctUiXDmqzB4t8uN6xqKwINWm1sQp9cwcbzasOEkm+JPAGl+XgdYbQ5y2w2UhgAUrTY3IramtIkkC1yuwmB2dHHXkcvBggWweBHZ3XaDqfeQfaMRDrkGhg2MzyvkYe5nZKdcD2+NhMOOgzmzY7+ytYhds9p8FzGM+bjM31FhsNBq8zgwCjjUanOoCoMkG9BZTKE9YVTCBggbUglPAyM73aLKqFalvBLRXP1HmePVho/3Sez7g0VayHdYoa5shfZEeBAXB9Q1oslkxDV/zmzINZC96CIyEybIsd8/n26nWfQFxYUL4dBjyc3clcLpp1P8w9PiY7Z2zTqXJfZvV2HwUcp5ExGiARlB16+TCnpxYv9VREMVfZx52vPlTd52Hvgapca+esQAlYzEzgbzAZVDAXw0IwL3qbT/UMeV6eNy9fiY79rTCPjRky8C5xKrw6P/3xIPissQe9yXpBN/DjEzAF0hmlxOtGCt82DwELIPPtDelSabUn1jo1wHsP1wsk8/ReH66ymef8FaM+s4Y56vNXuvnLVdhcGLTv28IyL/3AscUIdmJEec0zyhuypYbb4DPOIVdXZE8l/GAlf3/oi1fzukr2rJxpJXYTDGWed7IR7HN0b+aFUiqZuNiM3X4q0AVJorjNXGl2lW1ZJboXZFQCYjBDNnNrTOIzN2HLm33+qS71n2tNPIvT6T7MHfhY8/gi++kHt8dUjG2neUNSX0tr9ttbm+3IldQLkw3ErosruKg08Q/2y1mYWodPcDAhefsmEN9e3g/r8GbKrCYKcaCQbaxzhFbjrneWWbpRFMV1HbTJPLSUTngvlkhm9P9rrr6pdHYNAgMtMeJjvxMgoXXgCLF8Vezmtw1rHanIOExUb4K3CQ1eYLhK+9TIXBe/41Kgyesdq8SBxCcKrVpkGFwVjqh85oOmseeaw2zYhGayDC2g0D/tU7JYo/eRE4wFOMVJrFkoFrkSGxRAPoDIzFKsMVkm5E9zgN5iiE3RoFbGy12S/RtjzCxvpKlkbn3ZDGnuWBR31n2+qIxpNdikDunHPJ/OLyqi6tFZkLzid30EEUx42l8Kc/rVFZx2ozBPhFonhH4AjgDiTy8kSrzQ9VGCRno2MRAoswxmqzoQqDf++u9nYTGhF3kQEVzrmqRkfVLyiNDi2XyWYEsBcig5SF1aYfEiMU4WMVBgusNvORj3wbFQYfWW2qHW17EXs3pGE9PLegjokmlxPXGBc9mZ16X/dHbu60I5np08m6yM3inNlkNthQjKLdSzz/mdg/zrlV3Gm1uQZhdzLAzVabOT4frMLgXavN5UiAVYTDrDZvAaNVGPx3dza8XnAuQj+n/eABTuulwuDxGuucCfxTFadugtjGKhINkgTDVwTc5OS3D4FRjmAywGmUV9v/hJjFW4GEPKeFoa8goUApTzSZDKxaJTLGwI3JXnIJmbFj1miOgMxZZ5I74nCKv/o1hSvcO+ym0AGrzV3EhrYi8O8J9fHNSLBYhKlWmy18nlmFwXlWmwOR2SnCtsArVpvrgEuTLMnaCBUGV1htvk+p4XEiwpp26JvVBRyAOMFumWSBE9gpsX8v8LkKg7Zyl2TjV+UqsNr8EI9oVBhcUm0j04kml4OPP4b8ajJHHEH2yith0KDUU7sdgwaR+cXlZPfei8LYcaKAqPOsY7U5C2GvQCztI1Ny/SYzHK4L/BsSr+HjsJRzQWJSTrLaaCRY7M01acHvBM5CNG/PI5q7WnMf15Stx0VZRuldA0pjdpLw3f3vrtVg63zPfDkra7Xp4yfcqHDtqFKiiVS9TvWbu/JKGH1kLe3pNmQOPJDc229R+PGZFG9w4RyDh3R5xrHanARc6Xb/iMwwabNBWiK+pckCx6YdThyc5aMPEjV6FKKqXZuJ5glEM1YTK+bhICdTdJS9ZjWieTvKv5bKRBPJBwXax/F0CBUGBauNP+IWKhGMY/UOBC4C/ikmmoYczJ1LcdlSsvuOIPvgA5IuaW1CSwvZSb+meNhhFMIQZr4GGw2E5s6F+7sperLbvboD/6PHEQNjxHq9QpmYfxUGD1htTgZuLVPXEZ3IfVY2DWwFzO34lHQ4bVFnCQYksnWfTl47slx+OKvN+sSeEkd6nsubI6xwNf2aozTGp9FFgkaDYB5RhGwF7A58i1hrOKUBIFsswqxZZAasS+6XV5WGLXcS2SiJX8bTlGYzQIZstms2mMyIfcm99irF8ePh0kvJdaI+J+z+BIkf/1FH7i8qDFZYbXZG/NEagesrpflRYXCb1WYuwuL4DRzdyaUw9rfaNFG9GjlP5z/azqCWzJgd4VzKp3KK/PseV2HwgFd+JpVdZSqhF/C7Ks99qgHI9StC8exzyNZRjdx/3Y0gMwBysQ0q5xIebbDhxnW5R2bCBDj0MLLjxpJ74YWqPiY3It2FjB7nVsg33A5OBqk6v4AKg8etNtshEYW7IFbvqVVevnlif0K1962AuiaxSOBzJH9AZzEHMSI/WE5+cqrmyUj+uCB5GIm6rNZ1PplUpTFxbZqbErhw596TKfLSksUsHzMG/lZT4shUNDXlmPn2Z1D8lGWzEizt0lWEY55myGYDWLmyi4J8Nkt2q61Y3dLC/GKxN9UZAIcj2Ra/U43g11U4IXVXl5OsFk+Bh5HEEdGI6+dYqxYF4hffgMhs3QIVBi8iclp3YhAwWYXBmJT7P0mZlFT1RgbJBv91avMdWtuQQ2LC/1CJZepBD+qBjAqTs1wPetCDSvgqY7p70IO/S/QQTQ96UCN6iKYHPagRPUTTgx7UiB6i6UEPakQP0fSgBzWih2h60IMakbZg6BAkhjvKvbQQmAXMWhMW9B70YG1Hm3HTLWxzKunLqkVoWz6hBz34R0UWwGpzL7Ic3p5IwuhjkJiFfd32dUg0Y+hW5O1BD/5hkUGi5X7r9meoMEgm/AbAZfq4GniolhxRPagvrDZ9kLj3xT3scvfAeVOvA3yZlgIqA9yAJDMAOEOFQaWIOaw2LSoMlrsQ4Z2Ikw78Z1pMitVmJyTi7W4VBtNSjp+D5L9qAmarMLjEanM8kpVkpWvjbBUGP7fa7IlkZfzSXT4ICRZahbimPwf8KRmvYrUZhWSU+ZLYSbWF0sjJVmBKWhtdHUPcc0Qu5ZsgGRpXuz54DnjRT+hntdkeWSktWktzC+SDX43Iiv8FPN1R0g2rzW7Aycis76djnYOETt+hwuDNMtednnju3kh/fQo8Bfzez2rp8kGPI+7jTZBsLH5fLUEG2EvcNd9GIi/T3stnSLDe9ORzurRJARK52YRkFf3AHW5AvosWxBn3E+BOFQZPu/COCcTvYjVwlot5utLroz6UpuPCXfMRcKafCdWFW5+NrHyWvOYp4KYofqeB0mCfb1A5zNRf9GYGcZgwlA/iuQuJdtwOmJZyvJU480kUYPQ2kjIpwgnu/6/EsfwR3kA6Z5/oepdf+XAVBlEk3kzAeNcsQTKr+HELeyPZY5rKRFXORRQkfnz6G8hL3RKXmtZqc78KgyPc8Q+R3MlR1N8y4H13zd5IelasNlOA49NyBlhtbkVSR4Es930j8sHvjBDROcA5VpufqjD4eeLyWcD+xEqdJQih9Ub6azSQt9pc46Vkmk37Pn6b0r7aEhhltXnIZZp5M+WaaDHffZAlL7DaPAIc482QUdqkj5EUSTtRuiRgVL41kt7pAITA5hGvsQmSiD4ioC8pXXr+A+Jl4vPIINAHeZ/nuXZtiSyjHoUq34j03UCk/0Yi0aRZFQbFJHsGcLIKg9uoAi6tUeh2d0kZSRqJ12YH2FaFwTuJczZGPoInVRgc4JW/hHygC1QYrOeV/xoZCdvVZ7W5FInBh4TSwmWF/w/gAxUGX0t5lt6IIuQ3UXb4lHOOJF4KfaQKg6e9Y8cTE/p9KgyOcuVnIYNLAVjHz+aSCLe+W4XBcd6xZmT2ioj0YJVYP8W1+RbidSHPVolFeK02FwPjgSUqDPp65S1I8sMoD/V4b+bw+3gnlbKkhstW85GLY8FqczPwfXd4UDR7ufj6y4kz+TyuwiBwXMME4FgVBp969S5FIilfUWGwq1e+MxKPdJIKg3cSKXd3UG5ZdkcAs1x5apCh1eZbwFAVBje5/WnIALbEPe97ifOHIaLJz1UYPJd1LJV/0q1Wm2pThPov8d9Sju9PaX6qU1LO2cf9/zZRHo26yUTgflhtyRJ1KgwuJM4EM9plHYkQRXampilVYbDUdfCctOMO/rOU5LJSYXAn8TOMduwcxLHoRRKZ7t1Le9btHutYhAgTiQlm3yTBeG0+iji47Er3Mfro7/4LjhCja5cjM3MUR3WRd7zD0GUVBrdEBJOCnHdeUYXBucRs195WmwbgryoMRiYIppE4xr9keXg3IO9FSjKTRHv92P+FZdr+TEQwDru5/w/SUkepMHjTDeivQWzc3JfShUXHWG3esZKguhJeIO70tPy00UgffagnuJHHR5SBMpmoL2pbLvHx+9enZdSIRsWBlH6k0YusmIXD5csqBz+kOi391XRvO8rB5bc97WN839seAm0zSDTA3K/C4JkKbQI4hHiQuaPMOcm0RShJ/xqFKOcQtgtK+7ja2H+/b9IWuHrdO69FyQrSSTQT91e7LDYqDAqe/OX3f67MdrVJ+r5w/1tZbdIWhIruv4CogY4dGQ74L2coMMVq8xc3FaZVshwRZgH28gnCTf8jkGk+oup+yAv2EQDLyrFEncAw999K+qjUnfCzOS6s8prB3vaH7v8E4ln0lx1V4F7mvW53ayfMVws/5VByVof6pZmK3kseEezXJkQsdy9ghlNslEXbKKjC4G8qDPZF+H4/9c8uwCNWm2llbDTPuv91kbDpCEe5em9Als2OcHq04bQgzaQrCKpBUj46iXiJjAfLhD7XK6w7LaXSMe5/GaIoKYFKrL3ieOsRbvchb/SNVuxahAio1cCP/x+Vcrxdbi/3cUSaoleT7XOodr2YNiQ1eS4/QjSLvbQGQ9LTZrM0XIak5AL5jn9ntbnLyoK37dCOxVBhcJMzdo5DCCh62IMRfvSbkdDlMA241DsnUgac79U502rzMaJF2ttqM8x1bJRRsVLy6Uq41WrzLjJCDicWiB8Bflrmmm2dksFHC5LU++4a7v09l4OrL8KKnYiwhHORpB3J0TRrJfXtXCTx4FB3DcjSg+OgTXDexpW/m6ZRKwM/wWFyRWqQ3F7HI2x4X0QGjRZVegUot9jus1abxcQDbAOipi6bAN1q8xtENvwCyeF8uDv0EOlybXfhF45go++8ATFNHOi/HxUGRavN7gjxnIM867FIwsMpwCR/IEhNS+tGpCusNlchH19EFAOQTtzc8cMRQcxB2IxRwMVWm00QYvMz619HrFo+C7E7RDLTUzV2RoT9iQkPRAlwRAd2j6W0nwV2QGwCteDHlK7J2YpoWCakGcQQOeEQSuWsRYiQ/5fEuZ3JfuizomnX96K9vPMissLbTe1Pb8P7iIo3g7BWmwI7R/a6MtccSOlzvookk681tW1XMReR2SKxoQkxqwwjHtyBtvRc5zkt60SEaxiAaFRPtdq0aZUrrhrgKppotXkGWQuxGTHoHQ34aumnkVFzZ7cfyS3aO+c2YqJRTlOzB/B2F6brzRCeO+LFmzsyFAIfqjA4rZP383Eyse1naRXW+bwKg762/Rr2/hIU0ai3AHm2rZ1toJrZxhecP005voTYGF0AFlbZ70eplOUQnaYrFe45+xC/lz5fAcEAXKlS8sy5tqXCydbHOuK5lXj5xVutNitUGNxTVWiACoPplObs2itxSqRAyDkPgJMR4b6NjVOSHzlSUa5HPE1PqaYNZfA197Fe6PYHW21MpQvo3CiehtkqDD5zv6rcWaw2GzkCiOwZ/RCPjCTe8I4nM+SXwwBv+88pxwsqDN5z7W2tYaBKLlkOgKqQVtdK1v8liH0GYEurzYNV3q+e2CStsJr3pcJgugqD7YjtaAB3W236ZZ0wXg18A1evxLFniNdlvA1RHqRpfaIPpBeyHgjAY1XePw3NACoMJhLz9KNSbBXdgf4dn9IOTQDONhYJnid6Np0Iv/G2T6iybt9TIS3FbrbSCFtnRO/lPGJzw2FWm13LX7J2QkliwsiInQH2yQJPOQGxI/gvJbl83kfE2qQoObVPodF5jxLbg5qB1jpO2yd425Vmr7Vl+ehjvO17/AOOqKJB4BQrDoRl4dT7P3C7k9RXvwaO38ff97bvSZ64BtuRCqvNMNd/leAblvtmkRHvDqvNRRUq3hxhuSLcnnLah972y2XUl1Cqfv5DhYZG038hwdP7OXjb1MdKloR40e1ukWJbis6tyJZYbfZMGfnb3a+jesqc19Z2p42JtHV7Wm2+m7gueh852ht+k3gCmb3n0j4JeHT/AtVl1C9pJxVWHrDabOPZhPxr2p5ZiZNjNKtu69xvymEVsV2oo7b6/VruvVRaPqPRarMHIiq87sSKcvAN9y81IML6aGCCe6BfIcmk30csqgcA1xCzZD9VCf8xhxnEC7VWcsP5NfGLrfQxRPzoplabjGep90fdpEx2NLHf0SSrzXQVBp+7/cjGNNRqswPiDBhhHWBjRO17ELHKN4nOsGSRsiVHe0PhOGJHx4etNsMj1aYKgxusNsMR7c0eVpu/AKc7+RIQAke0krsgM/huKbJGNIr2Tbl/Ofh9vJ/zzYpG7XWQfjgA8anb25X7We2TcuMxxHLajVab36YpF7x2QvuFaJPw34WvlPAJaKSTcaM+aUFY5H9BEtnfosLgYuev9j9Wln+80Te0O9/Bg93ubSoM3s2oMMBqMxYJD/CXvUtiEaKNmJh20HOgew9xhiv7gtyDjAK2SvP1ce47Pos1XknIwA44/x+HR5BFmFZ7134Pmc16IR14OEIg1RoJb1NhcHKy0PmFvUJsDHwIUW+XnXHcDP0asZB+I3CK3zdW3OPvJFaLnou4oS90x48HLkbCCkA+3lZiz2UQBcuYpFeF1WYbRBaNPuLLnZxRFlbCGWZWOsfDAhUG67lR+n+88vsRb+Y2AnaG50muLcuAsYhz7HJ3PIOo7EOvnmNUGLRj6ZzRcTqxPepJZK3NgtXmDqAacQPc9+fewc3E/bQE8Zb2+3iSCoNTwI2CblR7GNGvD0VG2vWQqW4WQgjPKckMXw7TES3WY1WoSMcgI+wHZY5/CZyBjBAZYtVlI/JR+fslvmxKFlSaC2yPfGjNyMh5NnG8x6aU+lStRl7kQoTVSUMLMgtH984n752CJuAKYpeadjy2CoO7rTbzEDvRpshs0OQdv9Nq8wIyyOxE7I7yLvC/SKzK/WX6vAlh8xa7tlbjvpKhtI8HIN9ChNXuN5+YUJoT17Rb4UDJej2zkW9rS3eNb/LIIP5ppyBKpUbi95VEAzLQRPfz3+UMZMkOkIFzoNeWaIBbAMyPBmz3Dt5E2LBdiQ36byKD7QvKixX7PykwWwCzH8pKAAAAAElFTkSuQmCC" alt={t("k_48")} style={{
              height: 32,
              width: 'auto',
              maxWidth: 140,
              objectFit: t("k_241")
            }} /></a>
            <a href="https://inews.hket.com/article/2769045/%E3%80%90%E6%85%B3%E9%8C%A2%E6%9C%89%E6%96%B9%E3%80%91%E6%81%92%E9%9A%86%E5%9C%B0%E7%94%A2%E5%A4%A5Mastercard%E3%80%80%E6%89%8B%E6%A9%9FAPP%E4%BA%A4%E7%A7%9F%E7%8D%B2%E9%81%8E%E5%8D%83%E5%85%83%E7%A6%AE%E5%93%81" target="_blank" rel="noopener noreferrer"><img src="data:image/png;base64,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" alt={t("k_49")} style={{
              height: 32,
              width: 'auto',
              maxWidth: 160,
              objectFit: t("k_241")
            }} /></a>
            <a href="https://www.sunhinggroup.com" target="_blank" rel="noopener noreferrer"><img src="data:image/png;base64,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" alt={t("k_50")} style={{
              height: 32,
              width: 'auto',
              maxWidth: 100,
              objectFit: t("k_241")
            }} /></a>

          </div>
        </div>

        {/* Banks & Partners */}
        <div>
          <div style={{
          fontSize: 10,
          fontWeight: 700,
          color: '#ACB5B3',
          textTransform: t("k_262"),
          letterSpacing: '0.12em',
          textAlign: 'center',
          marginBottom: 24
        }}>{t("k_51")}</div>
          <div style={{
          display: 'flex',
          flexWrap: t("k_295"),
          gap: 24,
          justifyContent: 'center',
          alignItems: 'center'
        }}>
            <a href="https://www.mastercard.com/news/latin-america/en/newsroom/press-releases/pr-en/2021/july/11-fintech-builders-join-mastercard-start-path-global-network-to-scale-innovation" target="_blank" rel="noopener noreferrer"><img src="data:image/webp;base64,UklGRsAeAABXRUJQVlA4WAoAAAAQAAAANwMAWQEAQUxQSA8WAAAB8J1tUx1tm2yFCeFBYQImxHZtyQRMkAmYgAmYIBMwARPYrqrupteb90YGCIFSmV/24omICaCZZfM+pNfovRNDc7M472N6Dd5vwvQbL/4oGJjCxlPw5lPF+Zq8/LixO3Bl9vYisydceezmZ80duL7sZhjvGdcnxz9o7CsmjTLERExag/kxMxEzJzklCTNH80PGHrMn22UiZo/8K+YqFgzcYI8Fq/8JMwlr1k2RgjWz/f1yFcseTBSwrv/x4oiVy79mrJz4l8tmvPNqf7dsxXuv7lfL4f273yyHJ+h+sRyeofu92vAU3a+VrY8B228VVzzHan+qMp5k4R+qgGd5/ONgvG6+Dxue5v5Pg0CXrwPXx1HNj9SB55memhXV/lMmeKLuoSWo6Z+y8kgq/0A5PFP/+8T1oVT+edrxVP3PU3kslX+cHJ6r/3FKD6b8Nhk82e2nKTyaOIUR/YXdkQGU5G0Xu5gAIB27uWALqQDIx25eWHQ+Jf5IeE0pONtlRM1all5zzu5HAlBTdDxAdENEvB8FqCk6PiH+SABQUtzNmC2kAiAfu3lh0bllRH+RmADkw9sT4lMBkJO3X4vyaOoUHjoR+4rOJA2O6E4yxoSK3iREAl362FecrFFaHuP9GVfQfcgp6J7IV7Slx4SK/uxOmVDRm4RIoEvLQyeyCe2jh31Fb5LvhMWz3aayGScjv2wVZ8MIX3E2DNorRhY32VZwOvAgTuis1OaIgVn6fMXZcIlDr+vYK85G/kb4hxNnMhWnMxM5DEx8xmQMTNuIiNFpqoCR2Y5J6I0tqRgbOkzGwLSN29DNDU4YmLcvRHo4ZaaMgQc5DI0nbMXQPCBgeJwpYmy1Iyq6t4bD6GoatmJoHle7MumcMbR+IfB0zURjIwbvXabi2g7B8MoTRYwuPKC/ku4w3JNuKq4d0L9rnHHtF0Eej1tseOWejFlyT0kp1Q5P8+zozSnVDqSLomYxvJDOGSsZLeFb4h9PmKzsYlj2cupwwkZCbWHv8OjMXgzJFusYi2b1hlTx+aWy5pJatZp6XcPUVnJMRGRCC9uYtIvIFsqmcOk5dmEWF6sijYDO7MWQuFivq0FEZD8yqTs6ixdLssX6pTgeT5qq7tT0fVlI56OVWwbtItTkMGRvFKZe4ys8nUxaopERzZ3atjTKiCp00qN9GGq7AhykG7SLUJPDVZGpn2urOmqy/07kx4OZqqVO35OZOlMD3IitxNS71QGh4egk7zSPQdNRr60a3ABLJ7m2durfi2nEVmLq3eolB531aGamXlu/EXi+PNFO3aXDUq9picZoZqb+bUBqyJmBV4TGQf2ucZyLdHZHc6fRjGZm6t+uqHyqNjJTv/1C8Fv474vJPIX691ak/qPhtb1RDZ31547GvlBpmBNUNPApcyo3Eg3fG9XQ2XBBpLMOTUtn9++DLPbfJ/kv7yKcMC054c4cDU+nuZ7yDXhexUA/6Oze2M4UOmvQNOOOhqfTXMdtp2Ij0vnyZfovk/z7Yvs82wlq0Uk5Uxt8jsKprQUk74QXcA13yjT8mXRqayQajyafozDOnioNM2D/ypXF/DxyJmn5DJ8w0BMNlFNUO/QUdzuXb0R/unGc8ad8Yx9nGokGyjg6Db3QQPN12Bf792fBg9IZOiENP4LO7adeizcTxcb4dFVsyDhp+BE0jW3EEVS/DX6x8ixopX1IOUVxBADP06TVUoOv24eUWaThh6TfBBmSzlEcg8xvhq6TIelnxQ3JA2grQ5D5Ybgh+Qu1L/ZfPgY/BCOI3DECcZJjtaMh1/khmC0MKd8G+fBs4xhhBxHx5o98BmYO3wh+tLvKN9w42zhG2GmokUcwvnH/ZTF3a9SoPGAfphvZY+3wc+yNja4e5hpxHDUqD9jnqRrMAPdl+t9vQe4taXADykWqq400h23EVWwDPC5pcAPKPEfDD0hfB1ps1v/9ZHyj8KkdM5DMRVWDWYRKI47zjcKndszjGpVPbfjKrU73ZhqIZ2ydg66oI2LjWCU0sA0zDcQztk7EDRxnuH4h0uOpN0epgdhnC0bk/Zy5AnaANOBO7YWnMK0qJ+zBGqUGYp+tmIhiA7GPM74Q8fGku5MWDtOxVYzwQJIzRyN0+UZqycEapQZCnyTgmIJiA/A9JgK+IS0cpmOrmMq0kEyHVHwj9sfj746OFmqUF+MyulumAkDZbceW0dy6XANpIyK7Z8A1bAvFsWZcxus2haktFG9fjDvwajQ6WqhRXozL6J6BQguIGxORcQndXwT7eLbb49oa3TrQrOnw3sdU0S7UbVq9R4NCC0BOPqaCZuUZyHWcTg2urdFTcOkY/EWgx8O3R3YSwZVbHx0DwA3KPaePKSgOw6aR3ADZ+jU5Hk6m+yM3qJ4pV0Q6KSNci/O4ylNQHFZYIzeoTkW2fkv2hxPeAUkdkbczUsZFOh0GHC3iY1Q2NAfto1KLpI7I21xk64i6n+CYk/34zMORt0AmncssZ4j2OqY6GhjPlQ6ivY6oO/VeRDaPqJ56TTqXWCYjPs5lIyf2GI/88VF+NJXeA5GkvroTDSBy6VzxTEP32lc9dxH7eqZ4pomIXD5To6GTkvrqTjQdkaS+6onOeA9fP7/90YQpjOinrKj2lOjmDJH1SauHYyJi0bmHiF1IrZq80HB2R9Vy2GjgFnOjJm/prOhmHJHZU23k6JgGWp+0ejgmIhadW0b0cURmT1o9HBMRi86KlD2Hz888GjvFnbKI0IxGRAxNKCKGLmQRMbSyFRGmK1lEaHUWERptvaMv4PFgMv02y4NxP06UH0uhX2f3WPzPE5WHUvn3SR6Kox/o9EgK/UKbRyI/UeQfSKQf6fw4Kv9K2cchRC6l7fh9ov1hBCIi74EfKIqPItOriOy/UJwfRGHlZ5rrY6iWfqxtfQjV0s+1rc9gox9sWx9AFfrJtvXtVUs/2pzfXLH0s83HYv+2WGL65d6XOv4lLhXox9uWZepORFtdpgr9fLNfJBl6NccikekX3KYFqqP2VhbIQr/irkxWPVO3r5MVR7/krkxUPdNZ9nWi4ujXfEuTlJ1pJLsySXb0i258uaxGofE21stKsPSzbn26oMSNrpaQL8jB0q+7+COfqslvhubkzadyqiS/Mf3KGxGvbyI0v5XN6yKW/vz/5/8////5/8//f/7/8/+f///8/+f/P///+f/P/3/+//P/n////P+XXFH5/8CAKn/++/Pfn/8+LIH6oXm8pq9Rwqv/89+f//789+e/P/99M8T5I6WK15pS8l7MI2HxISU0U/K73JVxIWXoOYVdnpp1PiU0cwpe+H5Y9pASmimFXR6TdT4lNFOKXniyLWSMrclvfFXC8n6qLWQMTbsZI1CvgyonbCgYeOzmDNaXW0h49WPMfmBoDtudSMgYmnYzRqCOEaw/G7ujYmQJ2zRbrLg2e/sQbKy4MO98Jy5j+CEPil3GhTXKPdhYcWHe+clsBy6sUWZwBTOWYN6fy7g8mruQjEvjUzKx4uri1nMJl0fzVFzB1dld5QqmTe69uYIpo7kDDrg4PCMTMWVxa7mCKQ/zRLaCGYtcYRLO56SOAIp7X5IxMKeUzwGel7MZ/TmllHLf9oh8xfmcUj4HlG0dSRiYU8rngMBPwyScrimleg44eNhW0Z38ZqmXxYV0AihuhPMDo+Znles4oD+HXZiaRvZYulBksa2iXcJmqC0uFqVStx+ZlOJnNfdkM7pL3MVQk8WF3AUcvAYH9Oe4C1OTZY+5C3WbxPiRRUl+1klcRW/ym1Dbio+lC3Ub5NBZ40aD7X50AdmeGyoa3aUU9B6OaaBxRwcQlnJoR0vnzV6Ao2+oVxK903M7evNuaCC7owd1W8EW9B7O0EDjjg4gzDE2KZ4WPxHReTimgWbPHYAf4tAujq7dYg8Q3s6OzrIzDTe+tpB4HYdmNDR4y+7xcES7BkPDeS8tIMy3o7N4Q8ONry1kfgqc0Kze0HATawtxgEOzOrqeXe7A/mYi2sXRtexrA9muskEvQgu/Pc5oVs90rSstJJ4sol0cXexKA9U+A85oeqZLObQQT1k0D6Y5JTUKvRXOaNadrmffQLVr2KodTM+NM5qB6fq9NpB5Jj7QrJ6uZ181VPsEOENPhi43qYF4Jjd2mleSIm+FM5qHoSlt1lDtCpyhBlr7zXGGni1NaY4GMs/DGc1kaEqTNFT7ACL0nab0Dfg+D93R1FKAg94JZzR3mtZrqLxAgOrowXGGHmjavYHM0yQ0d5rWa6j27XmoVWjSrWqQHq5aoMnZw7yVA3q1NPFWFWSezkMN9OQOqNXRxLZqyLNE6FVoYqkKMr85gVotTWurVrjDQ000v6F3EqBnQ1PbqiBOp0d6cgFqtTS1yRriHB56sTS1rQqO97ZVpVqa2FYFoaNoZoFJ72KDnpkmt1XBvkThJ7dBrZYm56xhn0GgZ6bJOSvwby3jtVqa2mmwDQs10qMxVctM09uqVLOC0IPjqlRL03PWYK/jqlVD09uqwL4zfaPJg5Yau2afTYJaLS1oFaQFAj25A6rQgqZq+boDarW0oK1KfnuBZueiQLSoVHo0DrrQkk5BnK7yk0tQd1pSNPirNugbLbkpSG+u8HQkWtSScjwarpqnRaPSnMjTk9MPWtRr1VzDRQu0aFCab0towaTAKEXxj8ZDzbQqlzX4+VVehZKCeI2HWngVzg8g0Yqi7Qqej4FulyFZItLz22hZo8FcwVUTWlYegCxBRclPKWiBFj5WkOeXaGGvxSs81EgLx7eXaM1dgXlGXJXKK5kFCj0/WYmrAnNB1cxK5u25RYzmXrISH8wO1dPScb74/CIt7bUwzkGNtHR8c5VWzUp8SUp5MEXjtcx82/OTtbgqdVzWzFrmzcVlgpJfggLzWCzUSIun6fjxJVo8KNhGGaiRFo/vzS2zKXhxWnwsQbOrbbMVenxuNaPFUbu2rSbvzSxjNEtErME8lawUWr5Olh5f5dUoK3VUVgotX95ZoXU1ISI6tPRQDNSwXpzMP75Iy+8KZAxDDeuFd5YWSop7EQ3xmTjNrrd9WG49o/kxm7atJ+/ML+dfKGmI/ESCUml9nkwen1mPipLGeI1u8JkdXbaBbB9IUtINUP6oCt3godQxSUl3kN7YtpDvItcAonkcUP0dhI/quAOvgIcUJdyBf2NyFxRbwLE9C9a2O9g/Kn8HoskQqO4Otg+AYgdQozPPQTR7B/JRyR0YbRthNbkD+QTI9byWwzvhB0F3aL8tpPkRovEd0EdANvc1S0reb2Le2H4j9FHxLdTL6GtA5MqA3pT8LvyGvFK+LnSLadz+fSBy5QK9RGfeUvrixRH+TvLHQCSxXvOad/NPWhqX7yF9EERkfarXADjkB6B8IV7N5mPKFwBJ/ikL43AP5fNoGxHvY0oDgMDvBF88P2K7E3wuvVZ8zH0o9i1sXxpzCxgnXxaVt1A6UN07EI3vQD4qeQv2Dszn9LodLcC9D/m2uDuwmowwmtyBfFZE5mhVe3+kuTvwH5W/g+0C0vwd7J8WkVQNhe+vKOEOjo8q3YHXaGhW4h3Ez4s4a/D3l5R8B+WjqneQlDzmUMod5A+MOGuVb88r4PUMPirYG4Aax+wKzHqMT4y4KthvT7RtPfdh7euJ5sZYza3nPjNyWr490uJ6x4eV1wuaGUNVOdaLHxoVBXx7h1KXY3xYMMsVpdDgQwGvxvjUdk1ub1fgVts/Lr/aBjWMcppbzX1sRvOXkcbrsJZWKx9XXS1pdhRrZbX8sVGZS9ahQ4Gs5fBxwa1loGYaHhXIWoLPLSnx/jYtrVXe1abgPZW1oubGiZbWSgtE5fgY0izbQlQUyEoO70reGdxKFmqlC7OCbSXBAl5JH8NxXVb8Sk7LC3F5d/Y9VV4oaf4Kp5WVyjr1Y/DXJeVYiYqCfZ2At0Xa9p4Q1nFQK19BRYFfx2MFUcDPr8wSlLKU06pZRfDGquLfFGQVrtpOl4oGu4rFElaTx8dQt+ucArMSJQV5ES5KfU9Jye+q8iIJaqGLk5Z5Dc5KnY208PicZq6z2r6U1RDXOKDu78kr4LcT6wvSGgG6XGU0xDUiVD9dUvLjS0qhCauSlyKvYV8hQvXynjZtfzt+VxBXcNADXe41hBU81CDTBQX24QnUOMOhwC5FWYObz0HN9KZIK++HkoI4n4Oe+TpKGtx8Dmrh+USLT8HwIlmzMzgtrmWqBjfbDrXat3UocO+Hq4I4m4NeLU3IVYObzUG3NB9VBeYZcMl2iQA10YxcFchSJA34uSJ0R29r0wq/HRINcS6HpqMpbQNhLg/d0QpBO55BAOAXcNBlCopa4aXINRB5Hj6ge3pfVBSE90NOQ+KJApo7TeoaOHgePqBHWsJo2J6AxWuW2Rz0QHMaDcd1HP0F5BrIdhYp0CO9M6/BXWezvRkKGqrMYjKakaZ1DRQ7i83QI61BSav2Opf47rICRDMTR+iZJ6GgIV5lM2AvINcA/BQc0Iz01rhocFe5inw3FDUg8BR7RTPSxK4BBJ6BPZqRVrEaqr0qAOHmLDqjmWYr0KulWblqOPgSDwD5CnItFHedq2hGem+0NbBfYg4A8HdDoYHqrpOMtqepXQvFXecKmpGWoaChyiWSAUDujWxuAcc2hSQ0q6V5twaKjHMFqr+CpDaA4q5xBe1A745iAwcPYw/d3g25BlDcNZLQro4mt7UBFHeNK2hHWoizBvhx5oBa+N6IfAdQ43aR2Qva1dLMoQFEM4T3gma9hExuAcWbUSZUtKuj98e5gep5iI1ox9shqQ2gBjvK7AWdxdL0JreA4s0o4ws6Ha1EtjZQ3JjtQNvdHZnU8Zq88BizhYLebGnu2AKS4xNmP9BZ7DVEoQNA9nJOQkZvtvQAiHMDqHE7I6Gg8+D7IZNaAEoQPiU+ozswreg7AOQg58Rn9GZLa5GtDaAEe4K3WNDp6faIJHW91hS9l07vY6o4GZhmjx0AcvRORGTzIVV0H0yXS+55zYf3onp/ZJz01PvOiHPrNQUvr7uPCf073eE5or12vObk/Sav3h8ZJ4vQojb1vObDe1G9PzJOeqbVyNYWgJr8Lq/eHxndVegdEEk6cX0RWnDvGl43mtLVviuToadAnLqGJ0s3RSb2XVk9LexK35XJUvcqZEvP+Mj0JohsnKg4WtOWyzzTpOzrDEno5Hsj2utVxdFNDiGSNEP1TGvvZYYkdHIZ4nBZEhp/Q0Ts8hyH0Lq+XlGDoZldvipaOv3uyMRLiqPbHERkYr0oO6b1Xb4qCp1eh0jSJUnoylsiIuOOek09HNPSvJdR2THNbkMZdzimgW+PyMQ6Kgrd6DAidse4EizdpAllXHJMA1cikmNUCYauvatXu8c0JsXd0h1an06V6AytafaYz6WwMY21Sb0uqfaWiGgL+VQOG93rBUTEW0jnctwN3apxMZ/LYWMaa5O6CBG7WE4lb+nypNqFXHp1Q1QW8d0iTLdqxbc3odVFfHsXSw9YNt8WS/d7jWpk920Rumkrvr2LpVtncb65i6Ffzgn+j8U///35789/f/7789+f//5Ps5Be3RcMAFZQOCCKCAAAkJIAnQEqOANaAT7RaKxRqCYkIqDRqnkAGglpbuFvvoD+AfgB+hvydwAkBCQH4AfrN/M0cxauppes5lTpGZQ/ucO9UG2o8xv7Qert6JPQA/qHUW+gB+oHp1exj+8X7ee2Fq4Hh/+CfgJ+i3/4/d/vkFwuZfdnFhC6EowAZaED4acOq3Xd3d3d3d3d3d3d3d3d3d3d3d3d3YG3oXan/5IDslvnncWIKgJ4jn57OzAAAFwJoUCbL7BOBsOHPU7dc7bwi0k6dHJpWJaKxKIGG2XfEqgxUqHo9jybw69j7CDQ03JVepDXdZFqzd6VRyGvX5Y3Yuc8zMzMzMzMzMzKon7cYr7QWRQcv9OP3n96SI5Im+opokY1nftQnfU+HbRoNM3McqxHTiUTQV8lMKBmZmZmZmZmZVlKbRo91+B0IM0yWkL1mJ/QYjU4rqkRwuYzr1V6P69cCIq2nWOS9flhYEVLzfQCfIGu/WhVruhOpAS+kLZVVVVVVVVTSrU0o/S0PDAnTcmoxEKlFFkHYDW7ZnNKHmkHnOc5znOc5XMzMzMzMzMzMzMzMy0hmOzUbff+yfbNLzpc0Vx5ZT5T7ZpklHMzMzMzMzMzMzMzMzMzMzMzMzMzMzNE34IPCZmZmZmZmZmZmZmZmZmZmZmZmZmZmbjERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERE9d3d3d3d3d3d3d3d3d3d3d3d3d3d3disfiEERERENfo87AzMzMzMzI8crjWiqqqqqqqqqqqpDmCkobMrOmZmZmZE/21VVVVVVTGyczMzMzMzMzMzDn21L8buOcmv1zsIOK53S/GrJ3bAWy2vEWTh9TEqZmOug0NNyYKUi5flHmGNGaoa5n/pDtLxSTTVMWlUKC1Tacvhy+keJKJP9N/mpr7LvuwY298wbIsRX7ECmrjYovU67sGfLOln+eeyHP4WTpQkGPpjMjUkuiLaoYY99qqAdjgJZrIO0wHt7SDM6YNlSdrUy7yGKR2U10D4iCRtrW7H11hLqr7uu0qJOygKvEOSwAvpESDKH6WR8+UAoQrzI6HE9kT20rNmxsnCW2entsksaSXckQWDQ3HeUp6qqoYwnGGau3v7v8y/qlQ+PS+6jS4OIMSFgu1ACwYn3sx61H9xsu8t42TgzeqDf1UCxaj5Cj5WMwlVVBKIMF7sThqiE3v0CrWmTDKAytAgxXMJuKPSqlpJSfIPBrzJ6jgWZouAqlcCQGr5amEZCuftAgpYVVgYOKA1TCMhbHZ6omyzWUXoGUCEFl9dQ4AV1bIXqOGk5K1uqbtQJBcMuHLrWamdPGwAWIsEh7b5SRlHFfKEjV0bGWDLl6/++vFNgxtpN8Xnf+92OnYnmVR/FRNyiYjKdLIepHbVKYFtdeucUdz187AEQXEoY+297ARUa8xUOWj0PahmnthXZZ2H7FtucuT40qqqo/aszHBFSJtuWQzyt6opzWqqqqqqqqqqqqqqqqqqqqqkVPDMzMzMzMzMzMy2AA+uBWWn/2yb//duu3OYSm88drNQ/9dmTCdqvOxf9jU3q+NiJTHwmup4Jxjye/nm6/PvAX2RUzn6u+AsLuf2Y+TvNKB5o+wv9msX/vfd1c66G6PUqx5pB9eA+P35Ph4fF1JcLMAjNy0Su0OkCQ3avV9Ib6hzfmLG79GUXjjRCrHphtTcE/E+Vc2mvqj5kEBD/TF/u6JCobTua8Lo62S83/rr//yL270ld3ggBZwxSMqgXO6uzE5VlOaYo5fgud1dmJyrKc0xRy/Bc7q7MTlWU5pijl+C53V2YnKspzTFHL8FzursxOVZTmmKOX4Lndcf4x+WLvzDKcDer42IlMd1fvh65lfEXFu/h2dKCPWW/0a4Jgd8DMQVw4rKgxFt3Uf/a2tBZwOrkwRjSG/3acYCT+JkJv/Up6BJRFwGcAP+tAAATdklpVCoyU1tih3XC/u+SgSvEUEnMEvgoyTMIDrmr/SkPhSG9k12P9Y3cfREXkKDbFFv8R5TrPnJOUEnTnFvNAs0oeGIwGqmyz3lvgJ8AzbFdkjoeh2vWVWLRADICz8k1QViQgoECJ+aZgd+YvoeLKmDT+lTXGoENTm59hOH/karCK3U3XYURmF3hIL5I4JltBMtZEMDbB4v/SN/rayfzL3N9KKJpN0x/qysXizec+uTgdichZ+ZZX+vPijPk67HuZd2zPY+n/TWIAZIZiqZT9YNb52UX/BHOgf7VtrAC6dEqpu/4Bk2h1/HaHv/a+0FAL0oJAQm7CclPjQH9J3jV3re5+c40p2mjGqHA+QpfPKgaUE4MjKVi4vQnODU6FAgiFunJMIA3OecDIvci6bzUeoG16T8pXQiAm/cJ2wR6KnlHhwWCCD3huqBTCtqlKt3z+MPYO15t2vtEo7/HU0iAAGrW+P5gdie9q1RH+bCJ6KuqBpDUkTj0hX34rCJHpbcgD0DhkAXHGnCzhcfod/IkW+tN4ncSn8L9WpDIKvqhooyzHiG9ROjRUKR85a9ZNixGsllbNolJumMTPic0b/gUpUtWE9zc12CPDL+JwwvBwNqG/aCekIVf8AAAAxMuuDAAAAAtlMiPgAADjOKAAAAAAADoqlAABMvVUklfGYXWgg9aHRoAANnZO/rB1wXjEtSVELmpGjWuDXe/pcz9wIhmNn7+sSNDMSsxLsnAMLl086f+kEP8YBD0nU1ZDe3/SBkm0gecL9KDZrSuNI5JxIZ7J+F1xROeyiYd68AyBbeMoW63ad4rYghF764QMzNnVd7zsxw7GbF43IL0TxCi19edVWj0zp7wbMqbiMJe13uEQJwlA/QkOhQzXBdqz04SCisIAAS2wF52UAAAAAAA=" alt={t("k_52")} style={{
              height: 52,
              width: 'auto',
              maxWidth: 140,
              objectFit: t("k_241")
            }} /></a>
            <a href={t("k_924")} target="_blank" rel="noopener noreferrer"><img src="data:image/webp;base64,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" alt={t("k_53")} style={{
              height: 52,
              width: 'auto',
              maxWidth: 88,
              objectFit: t("k_241"),
              borderRadius: 6,
              boxShadow: t("k_399")
            }} /></a>
            <a href={t("k_924")} target="_blank" rel="noopener noreferrer"><img src="data:image/webp;base64,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" alt={t("k_54")} style={{
              height: 52,
              width: 'auto',
              maxWidth: 88,
              objectFit: t("k_241"),
              borderRadius: 6,
              boxShadow: t("k_399")
            }} /></a>
            <a href="https://cloud.google.com/free?utm_source=googleutm_medium=cpcutm_campaign=Cloud-SS-DR-GCP-1713664-GCP-DR-APAC-HK-zh-Google-BKWS-MIX-GenericCloudutm_content=c-Hybrid+%7C+BKWS+-+EXA+%7C+Txt" target="_blank" rel="noopener noreferrer"><img src="data:image/jpeg;base64,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" alt={t("k_55")} style={{
              height: 36,
              width: 'auto',
              maxWidth: 160,
              objectFit: t("k_241")
            }} /></a>
          </div>
        </div>
      </Section>

      {/* SECURITY */}
      <Section id="security" bg="#F0FDFA">
        <SectionHeader eyebrow={t("k_56")} title={t("k_57")} subtitle={t("k_58")} />
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: t("k_400"),
        gap: 20
      }}>
          {[{
          title: t("k_26"),
          desc: t("k_401"),
          icon: props => <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                <path d="m9 12 2 2 4-4" />
              </svg>
        }, {
          title: 'PCI DSS',
          desc: t("k_402"),
          icon: props => <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect width="20" height="14" x="2" y="5" rx="2" />
                <line x1="2" x2="22" y1="10" y2="10" />
              </svg>
        }, {
          title: t("k_403"),
          desc: t("k_404"),
          icon: props => <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4" />
                <path d="m21 2-9.6 9.6" />
                <circle cx="7.5" cy="15.5" r="5.5" />
              </svg>
        }, {
          title: t("k_405"),
          desc: t("k_406"),
          icon: props => <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
        }].map((item, i) => <Reveal key={item.title} delay={i * 80}>
              <div style={{
            textAlign: 'center',
            padding: 24
          }}>
                <div style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              background: 'rgba(229, 117, 0, 0.1)',
              color: '#E57500',
              margin: t("k_407"),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
                  <item.icon style={{
                width: 24,
                height: 24
              }} />
                </div>
                <div style={{
              fontSize: 15,
              fontWeight: 700,
              color: '#1A1A1A',
              marginBottom: 8
            }}>{item.title}</div>
                <div style={{
              fontSize: 13,
              color: '#6B7280',
              lineHeight: 1.6
            }}>{item.desc}</div>
              </div>
            </Reveal>)}        </div>
      </Section>

      {/* FAQ PREVIEW */}
      <Section bg={t("k_38")}>
        <SectionHeader eyebrow={t("k_59")} title={t("k_60")} />
        <div style={{
        maxWidth: 720,
        margin: t("k_250")
      }}>
          {[{
          q: t("k_408"),
          a: t("k_925")
        }, {
          q: t("k_409"),
          a: t("k_410")
        }, {
          q: t("k_411"),
          a: t("k_412")
        }, {
          q: t("k_413"),
          a: t("k_414")
        }].map(faq => <FAQItem key={faq.q} faq={faq} />)}
        </div>
      </Section>

      {/* CTA BANNER */}
      <section style={{
      background: 'linear-gradient(135deg, #1F3540 0%, #494D4C 100%)',
      padding: t("k_415"),
      textAlign: 'center'
    }}>
        <Badge color="#FFA567" bg={t("k_61")}>{t("k_62")}</Badge>
        <h2 style={{
        fontFamily: t("k_374"),
        fontSize: t("k_416"),
        fontWeight: 800,
        color: 'white',
        margin: t("k_417"),
        letterSpacing: t("k_319")
      }}>{t("k_63")}</h2>
        <p style={{
        fontSize: 18,
        color: 'rgba(255,255,255,0.75)',
        marginBottom: 40
      }}>{t("k_64")}</p>
        <div style={{
        display: 'flex',
        gap: 14,
        justifyContent: 'center',
        flexWrap: t("k_295")
      }}>
          <Btn variant="ghost" onClick={() => {
          window.scrollTo(0, 0);
          onNavigate('tenants');
        }}>{t("k_31")}</Btn>
          <Btn variant="outlineLight" onClick={() => {
          window.scrollTo(0, 0);
          onNavigate('landlords');
        }}>{t("k_32")}</Btn>
          <Btn variant="outlineLight" onClick={() => {
          window.scrollTo(0, 0);
          onNavigate('investors');
        }}>{t("k_33")}</Btn>
        </div>
      </section>
    </div>;
}
function FAQItem({
  faq
}) {
  const [open, setOpen] = React.useState(false);
  return <div style={{
    borderBottom: '1px solid rgba(0,0,0,0.07)',
    padding: t("k_418"),
    cursor: t("k_251")
  }} onClick={() => setOpen(!open)}>
      <div style={{
      display: 'flex',
      justifyContent: t("k_285"),
      alignItems: 'center',
      gap: 16
    }}>
        <div style={{
        fontSize: 16,
        fontWeight: 600,
        color: '#1A1A1A'
      }}>{faq.q}</div>
        <div style={{
        fontSize: 18,
        color: '#B55B00',
        flexShrink: 0,
        transition: t("k_308"),
        transform: open ? 'rotate(45deg)' : 'none'
      }}>+</div>
      </div>
      {open && <p style={{
      fontSize: 14,
      color: '#6B7280',
      lineHeight: 1.7,
      marginTop: 12,
      marginBottom: 0
    }} dangerouslySetInnerHTML={{
      __html: faq.a
    }} />}
    </div>;
}
Object.assign(window, {
  HomePage
});

// ── LANDLORD CHART PANEL ──────────────────────────────────────────────────────
function LandlordChartPanel() {
  const [bars, setBars] = React.useState([0, 0, 0, 0, 0, 0, 0]);
  const [lineProgress, setLineProgress] = React.useState(0);
  const [collected, setCollected] = React.useState(0);
  const targetBars = [62, 74, 68, 81, 78, 91, 99];
  const months = [t("k_419"), t("k_420"), t("k_421"), t("k_422"), t("k_423"), t("k_424"), t("k_425")];
  React.useEffect(() => {
    let start = null;
    let rafId = 0;
    const dur = 1600;
    const animate = ts => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / dur, 1);
      const ease = 1 - Math.pow(1 - p, 3);
      setBars(targetBars.map(t => t * ease));
      setLineProgress(ease);
      setCollected(Math.round(ease * 996) / 10);
      if (p < 1) rafId = requestAnimationFrame(animate);
    };
    const tId = setTimeout(() => {
      rafId = requestAnimationFrame(animate);
    }, 400);
    return () => {
      clearTimeout(tId);
      cancelAnimationFrame(rafId);
    };
  }, []);
  const chartH = 110,
    W = 280,
    barW = 26,
    gap = 12;
  const totalW = targetBars.length * (barW + gap) - gap;
  const offsetX = (W - totalW) / 2;
  const lineData = [72, 76, 74, 82, 85, 93, 99.6];
  const linePoints = lineData.map((v, i) => ({
    x: offsetX + i * (barW + gap) + barW / 2,
    y: chartH - v / 100 * chartH
  }));
  const visibleCount = Math.max(1, Math.ceil(lineProgress * linePoints.length));
  return <div style={{
    background: 'rgba(255,255,255,0.05)',
    backdropFilter: t("k_350"),
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: 22,
    padding: t("k_426"),
    minWidth: 300
  }}>
      <div style={{
      display: 'flex',
      justifyContent: t("k_285"),
      alignItems: t("k_427"),
      marginBottom: 16
    }}>
        <div>
          <div style={{
          fontSize: 11,
          color: 'rgba(255,255,255,0.4)',
          textTransform: t("k_262"),
          letterSpacing: '0.1em'
        }}>{t("k_65")}</div>
          <div style={{
          fontSize: 36,
          fontFamily: t("k_374"),
          fontWeight: 800,
          color: 'white',
          lineHeight: 1.1,
          marginTop: 4
        }}>{collected}%</div>
          <div style={{
          fontSize: 12,
          color: '#2DD4BF',
          marginTop: 2
        }}>{t("k_66")}</div>
        </div>
        <div style={{
        textAlign: t("k_349")
      }}>
          <div style={{
          fontSize: 11,
          color: 'rgba(255,255,255,0.4)',
          textTransform: t("k_262"),
          letterSpacing: '0.1em'
        }}>{t("k_67")}</div>
          <div style={{
          fontSize: 28,
          fontFamily: t("k_374"),
          fontWeight: 800,
          color: '#2DD4BF',
          lineHeight: 1.1,
          marginTop: 4
        }}>142</div>
          <div style={{
          fontSize: 11,
          color: 'rgba(255,255,255,0.35)',
          marginTop: 2
        }}>{t("k_68")}</div>
        </div>
      </div>
      <svg width="100%" viewBox={`0 0 ${W} ${chartH + 24}`} style={{
      overflow: t("k_428"),
      marginBottom: 4
    }}>
        {targetBars.map((target, i) => {
        const h = bars[i] / 100 * chartH;
        return <g key={months[i]}>
              <rect x={offsetX + i * (barW + gap)} y={chartH - h} width={barW} height={Math.max(h, 0)} rx={4} fill={i === targetBars.length - 1 ? '#0D9488' : 'rgba(45,212,191,0.35)'} />
              <text x={offsetX + i * (barW + gap) + barW / 2} y={chartH + 18} textAnchor={t("k_15")} fill="rgba(255,255,255,0.35)" fontSize={9}>{months[i]}</text>
            </g>;
      })}
        {visibleCount > 1 && <path d={linePoints.slice(0, visibleCount).map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y}`).join(' ')} fill="none" stroke="#2DD4BF" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" opacity={0.9} />}
        <circle cx={linePoints[visibleCount - 1].x} cy={linePoints[visibleCount - 1].y} r={4} fill="#2DD4BF" />
      </svg>
      <div style={{
      display: t("k_286"),
      gridTemplateColumns: t("k_429"),
      gap: 8,
      marginTop: 8
    }}>
        {[{
        label: t("k_430"),
        value: '0',
        color: '#2DD4BF'
      }, {
        label: t("k_431"),
        value: t("k_432"),
        color: 'white'
      }, {
        label: t("k_433"),
        value: t("k_20"),
        color: 'white'
      }].map(s => <div key={s.label} style={{
        background: 'rgba(255,255,255,0.05)',
        borderRadius: 10,
        padding: t("k_434"),
        textAlign: 'center'
      }}>
            <div style={{
          fontSize: 16,
          fontWeight: 800,
          color: s.color,
          fontFamily: t("k_374")
        }}>{s.value}</div>
            <div style={{
          fontSize: 10,
          color: 'rgba(255,255,255,0.4)',
          marginTop: 3
        }}>{s.label}</div>
          </div>)}
      </div>
    </div>;
}

// ── TENANT REWARDS PANEL ──────────────────────────────────────────────────────
function TenantRewardsPanel() {
  const cards = [{
    network: 'Mastercard',
    holder: t("k_435"),
    last4: '4821',
    grad: 'linear-gradient(135deg,#111111 0%,#2a2a2a 50%,#1a1a1a 100%)',
    cashback: 180,
    miles: 432,
    Logo: () => <div style={{
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      width: 40,
      height: 26
    }}>
          <div style={{
        width: 24,
        height: 24,
        borderRadius: '50%',
        background: '#EB001B',
        position: 'absolute',
        left: 0,
        opacity: 0.95
      }} />
          <div style={{
        width: 24,
        height: 24,
        borderRadius: '50%',
        background: '#FF5F00',
        position: 'absolute',
        left: 10,
        opacity: 0.8,
        mixBlendMode: t("k_436")
      }} />
          <div style={{
        width: 24,
        height: 24,
        borderRadius: '50%',
        background: '#F79E1B',
        position: 'absolute',
        left: 16,
        opacity: 0.95
      }} />
        </div>
  }, {
    network: 'Visa',
    holder: t("k_435"),
    last4: '9966',
    grad: 'linear-gradient(135deg,#8E9EAB 0%,#B0BEC5 50%,#CFD8DC 100%)',
    cashback: 144,
    miles: 360,
    Logo: () => <span style={{
      fontSize: 18,
      fontWeight: 900,
      fontStyle: t("k_437"),
      color: '#1A1F71',
      letterSpacing: t("k_438"),
      fontFamily: t("k_439"),
      textShadow: t("k_440")
    }}>{t("k_69")}</span>
  }, {
    network: 'AMEX',
    holder: t("k_435"),
    last4: '0005',
    grad: 'linear-gradient(135deg,#006FCF 0%,#0079C1 50%,#005BA1 100%)',
    cashback: 0,
    miles: 720,
    Logo: () => <img src="data:image/png;base64,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" alt={t("k_70")} style={{
      height: 34,
      width: 34,
      objectFit: t("k_241"),
      borderRadius: 3
    }} />
  }];
  const [activeIdx, setActiveIdx] = React.useState(0);
  const [flipping, setFlipping] = React.useState(false);
  const [cashback, setCashback] = React.useState(0);
  const [miles, setMiles] = React.useState(0);
  const [totalCashback, setTotalCashback] = React.useState(0);
  const [totalMiles, setTotalMiles] = React.useState(0);
  React.useEffect(() => {
    let inner = 0;
    const iv = setInterval(() => {
      setFlipping(true);
      inner = setTimeout(() => {
        setActiveIdx(i => (i + 1) % cards.length);
        setFlipping(false);
      }, 400);
    }, 3000);
    return () => {
      clearInterval(iv);
      clearTimeout(inner);
    };
  }, [cards.length]);
  React.useEffect(() => {
    setCashback(0);
    setMiles(0);
    const tC = cards[activeIdx].cashback,
      tM = cards[activeIdx].miles;
    let start = null;
    let rafId = 0;
    const animate = ts => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / 800, 1);
      const e = 1 - Math.pow(1 - p, 2);
      setCashback(Math.round(e * tC));
      setMiles(Math.round(e * tM));
      if (p < 1) rafId = requestAnimationFrame(animate);
    };
    rafId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafId);
  }, [activeIdx]);
  React.useEffect(() => {
    let c = 0,
      m = 0;
    const iv = setInterval(() => {
      c = Math.min(c + 18, 2160);
      m = Math.min(m + 52, 6240);
      setTotalCashback(c);
      setTotalMiles(m);
      if (c >= 2160) clearInterval(iv);
    }, 40);
    return () => clearInterval(iv);
  }, []);
  const card = cards[activeIdx];
  const CardLogo = card.Logo;
  return <div style={{
    display: 'flex',
    flexDirection: t("k_283"),
    gap: 12,
    alignItems: 'center'
  }}>
      {/* Virtual card */}
      <div style={{
      width: 300,
      height: 176,
      borderRadius: 16,
      background: card.grad,
      padding: t("k_441"),
      border: '1px solid rgba(255,255,255,0.15)',
      boxShadow: t("k_442"),
      position: 'relative',
      overflow: 'hidden',
      boxSizing: t("k_443"),
      transition: t("k_348"),
      opacity: flipping ? 0 : 1,
      transform: flipping ? t("k_444") : t("k_445")
    }}>
        <div style={{
        position: 'absolute',
        top: -40,
        right: -40,
        width: 160,
        height: 160,
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.04)'
      }} />
        <div style={{
        position: 'absolute',
        bottom: -60,
        left: -20,
        width: 200,
        height: 200,
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.03)'
      }} />
        <div style={{
        display: 'flex',
        justifyContent: t("k_285"),
        alignItems: 'center',
        marginBottom: 14
      }}>
          <div style={{
          width: 34,
          height: 24,
          borderRadius: 4,
          background: 'linear-gradient(135deg,#C8A84B,#F0D060,#C8A84B)',
          display: t("k_286"),
          gridTemplateColumns: t("k_429"),
          gap: 1,
          padding: 3
        }}>
            {[...Array(6)].map((_, i) => <div key={i} style={{
            background: 'rgba(0,0,0,0.2)',
            borderRadius: 1
          }} />)}
          </div>
          <CardLogo />
        </div>
        <div style={{
        fontSize: 13,
        letterSpacing: '3px',
        color: card.network === 'Mastercard' || card.network === 'AMEX' ? 'rgba(255,255,255,0.75)' : 'rgba(0,0,0,0.55)',
        fontFamily: t("k_446"),
        marginBottom: 12
      }}>
          ···· ···· ···· {card.last4}
        </div>
        <div style={{
        display: 'flex',
        justifyContent: t("k_285"),
        alignItems: t("k_447")
      }}>
          <div>
            <div style={{
            fontSize: 8,
            color: card.network === 'Mastercard' || card.network === 'AMEX' ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
            textTransform: t("k_262"),
            letterSpacing: '0.1em'
          }}>{t("k_71")}</div>
            <div style={{
            fontSize: 11,
            fontWeight: 600,
            color: card.network === 'Mastercard' || card.network === 'AMEX' ? 'white' : '#1A1A1A',
            letterSpacing: 1
          }}>{card.holder}</div>
          </div>
          <div style={{
          textAlign: t("k_349")
        }}>
            <div style={{
            fontSize: 8,
            color: card.network === 'Mastercard' || card.network === 'AMEX' ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
            textTransform: t("k_262"),
            letterSpacing: '0.08em'
          }}>{t("k_72")}</div>
            <div style={{
            fontSize: 12,
            fontWeight: 800,
            color: card.network === 'AMEX' ? '#FFD700' : card.network === 'Mastercard' ? '#FFA567' : '#B55B00',
            fontFamily: t("k_374")
          }}>{card.network === 'AMEX' ? `+${miles} miles` : `HKD ${cashback}`}</div>
          </div>
        </div>
        <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 2,
        background: card.network === 'Mastercard' || card.network === 'AMEX' ? 'linear-gradient(90deg,transparent,rgba(255,255,255,0.3),transparent)' : 'linear-gradient(90deg,transparent,rgba(0,0,0,0.15),transparent)'
      }} />
      </div>

      {/* Dots */}
      <div style={{
      display: 'flex',
      gap: 6
    }}>
        {cards.map((c, i) => <button key={c.last4} type="button" onClick={() => setActiveIdx(i)} aria-label={`Show ${c.network} card ending ${c.last4}`} aria-current={i === activeIdx} style={{
        width: i === activeIdx ? 20 : 6,
        height: 6,
        borderRadius: 3,
        padding: 0,
        border: 'none',
        background: i === activeIdx ? '#FFA567' : 'rgba(255,255,255,0.25)',
        transition: t("k_306"),
        cursor: t("k_251")
      }} />)}
      </div>

      {/* Two accumulator boxes */}
      <div style={{
      display: t("k_286"),
      gridTemplateColumns: t("k_356"),
      gap: 10,
      width: 300
    }}>
        <div style={{
        background: 'rgba(255,255,255,0.07)',
        border: '1px solid rgba(255,255,255,0.12)',
        borderRadius: 12,
        padding: t("k_448")
      }}>
          <div style={{
          fontSize: 9,
          color: 'rgba(255,255,255,0.4)',
          textTransform: t("k_262"),
          letterSpacing: '0.1em',
          marginBottom: 6
        }}>{t("k_73")}</div>
          <div style={{
          fontSize: 22,
          fontWeight: 800,
          color: '#FFA567',
          fontFamily: t("k_374"),
          lineHeight: 1
        }}>{t("k_74")}{cashback}</div>
          <div style={{
          height: 3,
          background: 'rgba(255,255,255,0.08)',
          borderRadius: 2,
          marginTop: 8,
          overflow: 'hidden'
        }}>
            <div style={{
            height: '100%',
            width: `${cashback / card.cashback * 100}%`,
            background: 'linear-gradient(90deg,#E57500,#FFA567)',
            borderRadius: 2,
            transition: t("k_449")
          }} />
          </div>
          <div style={{
          fontSize: 9,
          color: 'rgba(255,255,255,0.3)',
          marginTop: 6
        }}>{t("k_75")}{totalCashback.toLocaleString()}</div>
        </div>
        <div style={{
        background: 'rgba(255,255,255,0.07)',
        border: '1px solid rgba(255,255,255,0.12)',
        borderRadius: 12,
        padding: t("k_448")
      }}>
          <div style={{
          fontSize: 9,
          color: 'rgba(255,255,255,0.4)',
          textTransform: t("k_262"),
          letterSpacing: '0.1em',
          marginBottom: 6
        }}>{t("k_76")}</div>
          <div style={{
          fontSize: 22,
          fontWeight: 800,
          color: '#81B4C5',
          fontFamily: t("k_374"),
          lineHeight: 1
        }}>{miles.toLocaleString()}</div>
          <div style={{
          height: 3,
          background: 'rgba(255,255,255,0.08)',
          borderRadius: 2,
          marginTop: 8,
          overflow: 'hidden'
        }}>
            <div style={{
            height: '100%',
            width: `${miles / card.miles * 100}%`,
            background: 'linear-gradient(90deg,#67919F,#81B4C5)',
            borderRadius: 2,
            transition: t("k_449")
          }} />
          </div>
          <div style={{
          fontSize: 9,
          color: 'rgba(255,255,255,0.3)',
          marginTop: 6
        }}>{t("k_77")}{totalMiles.toLocaleString()}{t("k_78")}</div>
        </div>
      </div>
    </div>;
}

// ── LANDLORDS PAGE ───────────────────────────────────────────────────────────
function LandlordDeveloperPage({
  onNavigate
}) {
  const clients = [{
    name: t("k_48"),
    logo: t("k_450"),
    url: t("k_922")
  }, {
    name: t("k_47"),
    logo: t("k_451"),
    url: t("k_926")
  }, {
    name: t("k_50"),
    logo: t("k_452"),
    url: t("k_923")
  }, {
    name: t("k_49"),
    logo: t("k_453"),
    url: t("k_927")
  }, {
    name: t("k_454"),
    logo: t("k_455")
  }, {
    name: t("k_456"),
    logo: t("k_457")
  }];
  const properties = [{
    name: t("k_458"),
    logo: t("k_459"),
    url: t("k_928")
  }, {
    name: t("k_460"),
    logo: t("k_461"),
    url: t("k_929")
  }, {
    name: t("k_462"),
    logo: t("k_463"),
    url: t("k_930")
  }, {
    name: t("k_464"),
    logo: t("k_465"),
    url: t("k_931")
  }, {
    name: t("k_466"),
    logo: t("k_467"),
    url: t("k_932")
  }, {
    name: t("k_468"),
    logo: t("k_469"),
    url: t("k_932")
  }, {
    name: t("k_470"),
    logo: t("k_471"),
    url: t("k_932")
  }, {
    name: t("k_472"),
    logo: t("k_473"),
    url: t("k_932")
  }, {
    name: t("k_474"),
    logo: t("k_475"),
    url: t("k_932")
  }, {
    name: t("k_476"),
    logo: t("k_477"),
    url: t("k_932")
  }, {
    name: t("k_478"),
    logo: t("k_479"),
    url: t("k_932")
  }, {
    name: t("k_933"),
    logo: t("k_934"),
    url: t("k_937")
  }, {
    name: t("k_935"),
    logo: t("k_936"),
    url: t("k_938")
  }];
  return <div>
      <SEO title={(currentLang === "tc" || currentLang === "sc") ? "Keychain - 智能租務代理 | 業主及發展商" : "Keychain - AI Rental Agent | Landlords & Developers"} description={`Eliminate rental arrears. Our AI schedules charges ahead of the due date so you get paid on time. Trusted by premium properties.`} urlPath={`/${currentLang}/landlords/`} />
      <section style={{
      background: 'linear-gradient(135deg, #1F3540 0%, #2D4E5C 20%, #064E3B 50%, #0D9488 80%, #0F766E 100%)',
      backgroundSize: '200% 200%',
      animation: t("k_354"),
      padding: t("k_355"),
      position: 'relative',
      overflow: 'hidden'
    }}>
        <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: '55%',
        height: '100%',
        background: 'radial-gradient(ellipse at 80% 40%, rgba(45,212,191,0.15) 0%, transparent 65%)',
        pointerEvents: 'none'
      }} />
        <div style={{
        maxWidth: 1200,
        margin: t("k_250"),
        display: t("k_286"),
        gridTemplateColumns: t("k_356"),
        gap: 64,
        alignItems: 'center'
      }} className="two-col">
          <div>
            <Badge color="#2DD4BF" bg={t("k_79")}>{t("k_80")}</Badge>
            <h1 style={{
            fontFamily: t("k_374"),
            fontSize: t("k_480"),
            fontWeight: 800,
            color: 'white',
            lineHeight: 1.08,
            letterSpacing: t("k_358"),
            margin: t("k_481")
          }}>{t("k_81")}<br /><span style={{
              color: '#2DD4BF'
            }}>{t("k_82")}</span>
            </h1>
            <p style={{
            fontSize: 18,
            color: 'rgba(255,255,255,0.65)',
            lineHeight: 1.65,
            marginBottom: 40,
            maxWidth: 480
          }}>{t("k_83")}</p>
            <div style={{
            display: 'flex',
            gap: 14,
            flexWrap: t("k_295")
          }}>
              <Btn variant="bright" onClick={() => window.location.href = SUPPORT_URL} style={{
              background: '#2DD4BF',
              color: '#042F2E'
            }}>{t("k_84")}</Btn>
              <Btn variant="outlineLight" onClick={() => window.location.href = 'https://api.whatsapp.com/send?phone=85260281376'}>{t("k_85")}</Btn>
            </div>
          </div>
          <LandlordChartPanel />
        </div>
      </section>

      {/* OUR CLIENTS */}
      <Section bg={t("k_38")}>
        <div style={{
        textAlign: 'center',
        marginBottom: 48
      }}>
          <div style={{
          marginBottom: 48
        }}>
            <Badge color="#0D9488" bg={t("k_86")}>{t("k_87")}</Badge>
            <div style={{
            fontSize: 16,
            color: '#6B7280',
            fontWeight: 600,
            marginTop: 12
          }}>{t("k_88")}</div>
          </div>
          <LogoRollingBanner clients={clients} height={68} />
          <div style={{
          height: 32
        }} />
          <LogoRollingBanner clients={properties} height={68} reverse />
        </div>
      </Section>

      <Section bg="#F9FAFB">
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: t("k_356"),
        gap: 48,
        alignItems: 'center'
      }} className="two-col">
          <Reveal>
            <div>
              <Badge color="#EF4444" bg="#FEE2E2">{t("k_89")}</Badge>
              <h2 style={{
              fontFamily: t("k_374"),
              fontSize: 32,
              fontWeight: 700,
              color: '#1A1A1A',
              margin: t("k_482")
            }}>{t("k_90")}</h2>
              {[t("k_483"), t("k_484"), t("k_485"), t("k_486"), t("k_487")].map(pain => <div key={pain} style={{
              display: 'flex',
              gap: 12,
              marginBottom: 14,
              alignItems: t("k_427")
            }}>
                  <div style={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                background: '#FEE2E2',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: 1,
                fontSize: 10,
                color: '#EF4444',
                fontWeight: 700
              }}>✕</div>
                  <span style={{
                fontSize: 15,
                color: '#6B7280'
              }}>{pain}</span>
                </div>)}
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div>
              <Badge color="#2DD4BF" bg={t("k_79")}>{t("k_91")}</Badge>
              <h2 style={{
              fontFamily: t("k_374"),
              fontSize: 32,
              fontWeight: 700,
              color: '#1A1A1A',
              margin: t("k_482")
            }}>{t("k_92")}</h2>
              {[t("k_488"), t("k_489"), t("k_490"), t("k_491"), t("k_492")].map(sol => <div key={sol} style={{
              display: 'flex',
              gap: 12,
              marginBottom: 14,
              alignItems: t("k_427")
            }}>
                  <div style={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                background: 'rgba(45,212,191,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: 1,
                fontSize: 10,
                color: '#2DD4BF',
                fontWeight: 700
              }}>✓</div>
                  <span style={{
                fontSize: 15,
                color: '#374151'
              }}>{sol}</span>
                </div>)}
            </div>
          </Reveal>
        </div>
      </Section>

      <Section bg={t("k_38")}>
        <SectionHeader eyebrow={t("k_93")} title={t("k_94")} subtitle={t("k_95")} />
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: t("k_493"),
        gap: 24
      }}>
          {[{
          num: '01',
          color: '#0D9488',
          title: t("k_494"),
          desc: t("k_495"),
          bullets: [t("k_496"), t("k_497"), t("k_498")]
        }, {
          num: '02',
          color: '#67919F',
          title: t("k_499"),
          desc: t("k_500"),
          bullets: [t("k_501"), t("k_502"), t("k_503")]
        }, {
          num: '03',
          color: '#0F766E',
          title: t("k_504"),
          desc: t("k_505"),
          bullets: [t("k_506"), t("k_507"), t("k_508")]
        }, {
          num: '04',
          color: '#494D4C',
          title: t("k_509"),
          desc: t("k_510"),
          bullets: [t("k_511"), t("k_512"), t("k_513")]
        }].map((item, i) => <Reveal key={item.num} delay={i * 100}>
              <div style={{
            background: '#F9FAFB',
            borderRadius: 20,
            padding: t("k_514"),
            border: '1px solid rgba(0,0,0,0.05)',
            height: '100%',
            display: 'flex',
            flexDirection: t("k_283")
          }}>
                <div style={{
              fontSize: 11,
              fontWeight: 800,
              color: item.color,
              letterSpacing: '0.15em',
              marginBottom: 16
            }}>{item.num}</div>
                <h3 style={{
              fontSize: 19,
              fontWeight: 700,
              color: '#1A1A1A',
              marginBottom: 14,
              fontFamily: t("k_374")
            }}>{item.title}</h3>
                <p style={{
              fontSize: 14,
              color: '#6B7280',
              lineHeight: 1.65,
              marginBottom: 20,
              flex: 1
            }}>{item.desc}</p>
                {item.bullets.map(b => <div key={b} style={{
              display: 'flex',
              gap: 8,
              marginBottom: 8
            }}>
                    <div style={{
                width: 16,
                height: 16,
                borderRadius: '50%',
                background: item.color + '15',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 8,
                color: item.color,
                fontWeight: 800,
                marginTop: 1
              }}>→</div>
                    <span style={{
                fontSize: 13,
                color: '#374151'
              }}>{b}</span>
                  </div>)}
              </div>
            </Reveal>)}
        </div>
      </Section>


      <Section bg="#0D2B35">
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: t("k_356"),
        gap: 64,
        alignItems: 'center'
      }} className="two-col">
          <Reveal>
            <div>
              <Badge color="#2DD4BF">{t("k_96")}</Badge>
              <h2 style={{
              fontFamily: t("k_374"),
              fontSize: 36,
              fontWeight: 700,
              color: 'white',
              margin: t("k_515"),
              lineHeight: 1.2
            }}>{t("k_97")}</h2>
              <p style={{
              fontSize: 16,
              color: 'rgba(255,255,255,0.6)',
              lineHeight: 1.7,
              marginBottom: 32
            }}>{t("k_98")}</p>
              <div style={{
              background: 'rgba(255,255,255,0.06)',
              borderRadius: 14,
              padding: t("k_398"),
              border: '1px solid rgba(45,212,191,0.2)'
            }}>
                <p style={{
                fontSize: 15,
                color: 'rgba(255,255,255,0.8)',
                lineHeight: 1.7,
                fontStyle: t("k_437"),
                margin: 0
              }}>{t("k_99")}</p>
                <div style={{
                fontSize: 13,
                color: '#2DD4BF',
                marginTop: 12,
                fontWeight: 600
              }}>{t("k_100")}</div>
              </div>
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div style={{
            display: t("k_286"),
            gridTemplateColumns: t("k_356"),
            gap: 16
          }}>
              {[{
              value: '0',
              label: t("k_516"),
              sub: t("k_517")
            }, {
              value: '300+',
              label: t("k_518"),
              sub: t("k_519")
            }, {
              value: t("k_520"),
              label: t("k_521"),
              sub: t("k_522")
            }, {
              value: t("k_523"),
              label: t("k_524"),
              sub: t("k_525")
            }].map(stat => <div key={stat.label} style={{
              background: 'rgba(255,255,255,0.05)',
              borderRadius: 14,
              padding: '20px',
              border: '1px solid rgba(255,255,255,0.08)',
              textAlign: 'center'
            }}>
                  <div style={{
                fontSize: 28,
                fontFamily: t("k_374"),
                fontWeight: 800,
                color: '#2DD4BF'
              }}>{stat.value}</div>
                  <div style={{
                fontSize: 12,
                color: 'rgba(255,255,255,0.6)',
                marginTop: 4
              }}>{stat.label}</div>
                  <div style={{
                fontSize: 11,
                color: 'rgba(255,255,255,0.3)',
                marginTop: 2
              }}>{stat.sub}</div>
                </div>)}
            </div>
          </Reveal>
        </div>
      </Section>

      <Section bg={t("k_38")}>
        <SectionHeader eyebrow={t("k_101")} title={t("k_102")} subtitle={t("k_103")} />
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: t("k_387"),
        gap: 24,
        maxWidth: 860,
        margin: t("k_250")
      }}>
          {[{
          tier: t("k_526"),
          price: t("k_527"),
          unit: t("k_528"),
          features: [t("k_529"), t("k_530"), t("k_531"), t("k_532")],
          cta: t("k_533"),
          link: APP_URL,
          highlight: false
        }, {
          tier: t("k_534"),
          price: t("k_527"),
          unit: t("k_528"),
          features: [t("k_535"), t("k_536"), t("k_537"), t("k_538"), t("k_539")],
          cta: t("k_540"),
          link: 'https://api.whatsapp.com/send?phone=85260281376',
          highlight: true
        }].map(plan => <Reveal key={plan.tier}>
              <div style={{
            background: plan.highlight ? '#0D2B35' : 'white',
            borderRadius: 20,
            padding: 32,
            border: plan.highlight ? 'none' : '1px solid rgba(0,0,0,0.07)',
            transform: plan.highlight ? t("k_541") : 'none'
          }}>
                <div style={{
              fontSize: 13,
              fontWeight: 700,
              color: plan.highlight ? '#2DD4BF' : '#9CA3AF',
              textTransform: t("k_262"),
              letterSpacing: '0.1em',
              marginBottom: 16
            }}>{plan.tier}</div>
                <div style={{
              fontSize: 36,
              fontFamily: t("k_374"),
              fontWeight: 800,
              color: plan.highlight ? 'white' : '#1A1A1A'
            }}>{plan.price}</div>
                <div style={{
              fontSize: 13,
              color: plan.highlight ? 'rgba(255,255,255,0.5)' : '#9CA3AF',
              marginBottom: 24
            }}>{plan.unit}</div>
                {plan.features.map(f => <div key={f} style={{
              display: 'flex',
              gap: 10,
              marginBottom: 12
            }}>
                    <div style={{
                color: '#2DD4BF',
                fontSize: 14,
                fontWeight: 700
              }}>✓</div>
                    <span style={{
                fontSize: 14,
                color: plan.highlight ? 'rgba(255,255,255,0.8)' : '#374151'
              }}>{f}</span>
                  </div>)}
                <button onClick={() => window.location.href = plan.link} style={{
              marginTop: 24,
              width: '100%',
              background: plan.highlight ? '#2DD4BF' : '#0D9488',
              color: plan.highlight ? '#064E3B' : 'white',
              border: 'none',
              borderRadius: 10,
              padding: '13px',
              fontSize: 15,
              fontWeight: 700,
              cursor: t("k_251")
            }}>{plan.cta}</button>
              </div>
            </Reveal>)}
        </div>
        <div style={{
        textAlign: 'center',
        marginTop: 24,
        fontSize: 13,
        color: '#6B7280'
      }}>{t("k_104")}</div>
      </Section>

      <section style={{
      background: 'linear-gradient(135deg, #2DD4BF 0%, #0D9488 100%)',
      padding: t("k_415"),
      textAlign: 'center'
    }}>
        <h2 style={{
        fontFamily: t("k_374"),
        fontSize: t("k_542"),
        fontWeight: 800,
        color: '#042F2E',
        marginBottom: 16
      }}>{t("k_105")}</h2>
        <p style={{
        fontSize: 17,
        color: 'rgba(4,47,46,0.75)',
        marginBottom: 36
      }}>{t("k_106")}</p>
        <Btn variant="outline" style={{
        color: '#042F2E',
        border: '2px solid #042F2E'
      }} onClick={() => window.location.href = SUPPORT_URL}>{t("k_107")}</Btn>
      </section>
    </div>;
}

// ── REWARDS CALCULATOR ───────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────────────────────
// KeyChain Pay — Rewards Engine
// Fee table & reward logic ported verbatim from the validation script.
// All rates verified against issuer T&Cs (HSBC, Hang Seng, Citi, SC, DBS, BEA, AMEX).
// ─────────────────────────────────────────────────────────────────────────────

// Fee buckets (effective 1 Oct 2025, residential / car park / public housing).
const FEE_RATES = {
  HSBC_MC_VISA:     0.0180, // HSBC Mastercard / Visa (domestic individual)
  HSBC_UNIONPAY:    0.0080, // HSBC UnionPay (rent >= 10,000 only)
  OTHER_MC_VISA:    0.0198, // Non-HSBC Mastercard / Visa
  OTHER_UNIONPAY:   0.0098, // Non-HSBC UnionPay (rent >= 10,000)
  CN_UNIONPAY:      0.0298, // Mainland China UnionPay (rent >= 10,000)
  INTERNATIONAL:    0.0298, // International / Corporate
  APPLE_GOOGLE_PAY: 0.0298, // Apple / Google Pay wallet (rent < 10,000 only)
  AMEX:             0.0350, // American Express
};

// Reward computers: input = total amount CHARGED to card (rent + platform fee).
// Output = { monthly, annual, unit, capHit, note?, secondary?, capLabel? }
const REWARDS = {
  // HSBC Red — base 0.4% only; 4% online bonus excluded for rent per T&C.
  hsbc_red(amt) {
    const monthly = amt * 0.004;
    return { monthly, annual: monthly * 12, unit: 'RewardCash', capHit: false, note: t('k_953') };
  },
  // HSBC RYC cards — 2.4% total; annual cap HK$100,000 eligible spend.
  hsbc_ryc(amt) {
    const monthly = Math.min(100000, amt) * 0.024 + Math.max(0, amt - 100000) * 0.004;
    const annualCharged = amt * 12;
    const annual = Math.min(100000, annualCharged) * 0.024 + Math.max(0, annualCharged - 100000) * 0.004;
    const capHit = annualCharged > 100000;
    return { monthly, annual, unit: 'RewardCash', capHit, capLabel: t('k_960'),
             note: capHit ? t('k_964') : t('k_963') };
  },
  // HSBC Visa Signature — first HK$100k at 1.2% + 2.4%, remainder at 0.4%; annual cap HK$100,000 eligible spend.
  hsbc_vs(amt) {
    const monthly = Math.min(100000, amt) * 0.012 + Math.min(100000, amt) * 0.024 + Math.max(0, amt - 100000) * 0.004;
    const annualCharged = amt * 12;
    const annual = Math.min(100000, annualCharged) * 0.012 + Math.min(100000, annualCharged) * 0.024 + Math.max(0, annualCharged - 100000) * 0.004;
    const capHit = annualCharged > 100000;
    return { monthly, annual, unit: 'RewardCash', capHit, capLabel: t('k_960'),
             note: capHit ? t('k_964') : t('k_963') };
  },
  // HSBC EveryMile — HK$12.5 = 1 mile (no cap).
  hsbc_everymile(amt) {
    const monthly = amt / 12.5;
    const rc = monthly / 20;
    return { monthly, annual: monthly * 12, unit: 'Miles', capHit: false,
             secondary: `${t('k_961')} ${rc.toFixed(0)}` };
  },
  hsbc_basic(amt) {
    const monthly = amt * 0.004;
    return { monthly, annual: monthly * 12, unit: 'RewardCash', capHit: false };
  },
  // Hang Seng MMPOWER — 0.4% base + 4.6% bonus if ≥ HK$3k; monthly cap HK$500 bonus.
  hangseng_mmpower(amt) {
    const base = amt * 0.004;
    if (amt < 3000) {
      return { monthly: base, annual: base * 12, unit: '+FUN Dollars', capHit: false, note: t('k_954') };
    }
    const extra = Math.min(amt * 0.046, 500);
    const monthly = base + extra;
    return { monthly, annual: monthly * 12, unit: '+FUN Dollars',
             capHit: amt * 0.046 > 500, capLabel: t('k_954') };
  },
  // BEA i-Titanium — 0.4% base + 3.6% bonus if ≥ HK$2k; monthly cap HK$300 bonus.
  bea_it(amt) {
    const base = amt * 0.004;
    if (amt < 2000) {
      return { monthly: base, annual: base * 12, unit: 'i-Dollar', capHit: false, note: t('k_955') };
    }
    const extra = Math.min(amt * 0.036, 300);
    const monthly = base + extra;
    return { monthly, annual: monthly * 12, unit: 'i-Dollar',
             capHit: amt * 0.036 > 300, capLabel: t('k_955') };
  },
  // BEA GOAL — 0.4% base + 4.0% bonus if ≥ HK$2k; monthly cap HK$200 bonus.
  bea_goal(amt) {
    const base = amt * 0.004;
    if (amt < 2000) {
      return { monthly: base, annual: base * 12, unit: 'i-Dollar', capHit: false, note: t('k_956') };
    }
    const extra = Math.min(amt * 0.04, 200);
    const monthly = base + extra;
    return { monthly, annual: monthly * 12, unit: 'i-Dollar',
             capHit: amt * 0.04 > 200, capLabel: t('k_956') };
  },
  hangseng_basic(amt)       { const m = amt*0.004;   return { monthly:m, annual:m*12, unit:'+FUN Dollars', capHit:false }; },
  amex_explorer(amt)        { const m = amt*3;        return { monthly:m, annual:m*12, unit:'Points',       capHit:false, note:t('k_957') }; },
  aeon_wakuwaku(amt)        { const m = amt*0.06;     return { monthly:m, annual:m*12, unit:'Rebate',       capHit:false }; },
  aeon_jal(amt)             { const m = amt/8;        return { monthly:m, annual:m*12, unit:'JMB miles',    capHit:false }; },
  boc_sogo(amt)             { const m = amt*0.054;    return { monthly:m, annual:m*12, unit:'cash rebate',  capHit:false }; },
  boc_hka(amt)              { const m = amt/5;        return { monthly:m, annual:m*12, unit:'FWC Points',   capHit:false }; },
  bea_flyer(amt)            { const m = amt/5;        return { monthly:m, annual:m*12, unit:'Asia Miles',   capHit:false }; },
  citi_cashback(amt)        { const m = amt*0.01;     return { monthly:m, annual:m*12, unit:'Rebate',       capHit:false, note:t('k_958') }; },
  citi_pmm(amt)             { const m = amt/8;        return { monthly:m, annual:m*12, unit:'Miles',        capHit:false }; },
  citi_rewards(amt)         { const m = amt*0.01;     return { monthly:m, annual:m*12, unit:'Cash equiv.',  capHit:false, note:t('k_959') }; },
  cncbi(amt)                { const m = amt*0.06;     return { monthly:m, annual:m*12, unit:'Cash Rebate',  capHit:false }; },
  dahsing_ana(amt)          { const m = amt/8;        return { monthly:m, annual:m*12, unit:'Miles',        capHit:false }; },
  dahsing_ba(amt)           { const m = amt/6;        return { monthly:m, annual:m*12, unit:'Avios Conversion', capHit:false }; },
  fubon(amt)                { const m = amt*0.08;     return { monthly:m, annual:m*12, unit:'Cash Rebate',  capHit:false }; },
  mox(amt)                  { const m = amt/4;        return { monthly:m, annual:m*12, unit:'Asia Miles',   capHit:false }; },
  primecredit_wewa(amt)     { const m = amt*0.04;     return { monthly:m, annual:m*12, unit:'cash rebate',  capHit:false }; },
  primecredit_earnmore(amt) { const m = amt*0.02;     return { monthly:m, annual:m*12, unit:'cash rebate',  capHit:false }; },
  sc_cathay(amt)            { const m = amt/6;        return { monthly:m, annual:m*12, unit:'Asia Miles',   capHit:false }; },
  sc_simply(amt)            { const m = amt*0.015;    return { monthly:m, annual:m*12, unit:'CashBack',     capHit:false }; },
  sc_smart(amt)             { const m = amt*0.0056;   return { monthly:m, annual:m*12, unit:'CashBack',     capHit:false }; },
  sim(amt)                  { const m = amt*0.08;     return { monthly:m, annual:m*12, unit:'Cash Rebate',  capHit:false }; },
  dbs_black(amt)            { const m = amt/6;        return { monthly:m, annual:m*12, unit:'Miles',        capHit:false }; },
  dbs_eminent(amt)          { const m = amt*0.004;    return { monthly:m, annual:m*12, unit:'DBS$',         capHit:false }; },
};

// Unit display translation map (keeps `unit` as English for isCash logic)
const UNIT_KEYS = {
  'RewardCash':       'k_939',
  'Miles':            'k_940',
  'Asia Miles':       'k_941',
  'Rebate':           'k_942',
  'CashBack':         'k_943',
  'Cash Rebate':      'k_944',
  'cash rebate':      'k_944',
  'Cash equiv.':      'k_945',
  'JMB miles':        'k_946',
  'Points':           'k_947',
  'i-Dollar':         'k_948',
  '+FUN Dollars':     'k_949',
  'FWC Points':       'k_950',
  'Avios Conversion': 'k_951',
  'DBS$':             'k_952',
};
function unitLabel(u) { return t(UNIT_KEYS[u] || u) || u; }

// Card catalog. Each entry binds a fee bucket + reward computer.
// `img` (when present) renders a transparent-PNG card render; otherwise the UI
// falls back to a marked-up CSS card placeholder.
const CARDS = [
  { id:'hsbc_visa_sig',    bank:'HSBC',                label:'Visa Signature (RYC: Home)',            net:'Visa',       bucket:'HSBC_MC_VISA',  fn:'hsbc_vs',          tag:'3.60% RewardCash',       img:'/uploads/hsbc_3d_visa_signature.png',     grad:'linear-gradient(135deg,#2d3561 0%,#67919F 100%)' },
  { id:'hsbc_premier',     bank:'HSBC',                label:'Premier Mastercard (RYC: Home)',        net:'Mastercard', bucket:'HSBC_MC_VISA',  fn:'hsbc_ryc',         tag:'2.40% RewardCash',       img:'/uploads/hsbc_3d_mastercard_premier.png', grad:'linear-gradient(135deg,#1a1a2e 0%,#2D4E5C 100%)' },
  { id:'hsbc_everymile',   bank:'HSBC',                label:'EveryMile Credit Card',                 net:'Visa',       bucket:'HSBC_MC_VISA',  fn:'hsbc_everymile',   tag:'HK$12.5 = 1 Mile',       img:'/uploads/hsbc_3d_everymile.png',          grad:'linear-gradient(135deg,#1c3d5a 0%,#67919F 100%)' },
  { id:'hsbc_basic',       bank:'HSBC',                label:'easy / Visa Platinum (RYC: Home)',      net:'Visa',       bucket:'HSBC_MC_VISA',  fn:'hsbc_ryc',         tag:'2.40% RewardCash',       img:'/uploads/hsbc_easy.png',                  grad:'linear-gradient(135deg,#1F3540 0%,#494D4C 100%)' },
  { id:'hsbc_red',         bank:'HSBC',                label:'Red Credit Card',                       net:'Mastercard', bucket:'HSBC_MC_VISA',  fn:'hsbc_red',         tag:'0.40% RewardCash', img:'/uploads/hsbc_3d_red.png',               grad:'linear-gradient(135deg,#C0392B 0%,#1F3540 100%)' },
  { id:'hsbc_pulse',       bank:'HSBC',                label:'Pulse UnionPay Dual Currency Diamond Credit Card (RYC: Home)',    net:'HSBC_UNIONPAY', bucket:'HSBC_UNIONPAY',  fn:'hsbc_ryc',         tag:'2.40% RewardCash', img:'/uploads/hsbc_pulse_unionpay.png',               grad:'linear-gradient(135deg,#C0392B 0%,#1F3540 100%)' },
  { id:'hangseng_mmpower', bank:'Hang Seng',           label:'MMPOWER World Mastercard',              net:'Mastercard', bucket:'OTHER_MC_VISA', fn:'hangseng_mmpower', tag:'5.0% +FUN Dollars',     img:'/uploads/hangseng_3d_mpower.png',         grad:'linear-gradient(135deg,#00897b 0%,#1F3540 100%)' },
  { id:'hangseng_basic',   bank:'Hang Seng',           label:'enJoy / Travel+',                       net:'Visa',       bucket:'OTHER_MC_VISA', fn:'hangseng_basic',   tag:'0.40% +FUN Dollars',                                                             grad:'linear-gradient(135deg,#494D4C 0%,#2D4E5C 100%)' },
  { id:'bea_it',           bank:'BEA',                 label:'i-Titanium Card',                       net:'Mastercard', bucket:'OTHER_MC_VISA', fn:'bea_it',           tag:'4.0% i-Dollar',       img:'/uploads/bea_3d_mastercard_ititanium.png',grad:'linear-gradient(135deg,#494D4C 0%,#2D4E5C 100%)' },
  { id:'bea_goal',         bank:'BEA',                 label:'GOAL Credit Card',                      net:'Mastercard', bucket:'OTHER_MC_VISA', fn:'bea_goal',         tag:'4.4% i-Dollar',       img:'/uploads/bea_3d_mastercard_goal.png',grad:'linear-gradient(135deg,#494D4C 0%,#2D4E5C 100%)' },
  { id:'bea_flyer',        bank:'BEA',                 label:'Flyer World Mastercard',                net:'Mastercard', bucket:'OTHER_MC_VISA', fn:'bea_flyer',        tag:'$1 = 1 Bonus Point',             img:'/uploads/bea_3d_mastercard_goal.png',     grad:'linear-gradient(135deg,#003566 0%,#001d3d 100%)' },
  { id:'citi_cashback',    bank:'Citibank',            label:'Cash Back Card',                        net:'Mastercard', bucket:'OTHER_MC_VISA', fn:'citi_cashback',    tag:'1.0% Rebate',                                                       grad:'linear-gradient(135deg,#003B6F 0%,#67919F 100%)' },
  { id:'citi_pmm',         bank:'Citibank',            label:'PremierMiles Card',                     net:'Visa',       bucket:'OTHER_MC_VISA', fn:'citi_pmm',         tag:'HK$8 = 1 Mile',                                                            grad:'linear-gradient(135deg,#1F3540 0%,#003B6F 100%)' },
  { id:'citi_rewards',     bank:'Citibank',            label:'Rewards Card (Apple Pay / Google Pay)',                          net:'Mastercard', bucket:'OTHER_MC_VISA', fn:'citi_rewards',     tag:'1.0% Points Rebate',                                                                grad:'linear-gradient(135deg,#494D4C 0%,#003B6F 100%)' },
  { id:'sc_cathay',        bank:'Standard Chartered',  label:'Cathay Mastercard',                     net:'Mastercard', bucket:'OTHER_MC_VISA', fn:'sc_cathay',        tag:'HK$6 = 1 Asia Mile',             img:'/uploads/sc_3d_cathay.png',               grad:'linear-gradient(135deg,#1b4332 0%,#2d6a4f 100%)' },
  { id:'sc_simply',        bank:'Standard Chartered',  label:'Simply Cash Visa',                      net:'Visa',       bucket:'OTHER_MC_VISA', fn:'sc_simply',        tag:'1.50% CashBack',                                                           grad:'linear-gradient(135deg,#00b4d8 0%,#0077b6 100%)' },
  { id:'sc_smart',         bank:'Standard Chartered',  label:'Smart Card',                            net:'Mastercard', bucket:'OTHER_MC_VISA', fn:'sc_smart',         tag:'0.56% CashBack',                                                              grad:'linear-gradient(135deg,#494D4C 0%,#67919F 100%)' },
  { id:'dahsing_ana',      bank:'Dah Sing Bank',       label:'ANA World Mastercard',         net:'Mastercard', bucket:'OTHER_MC_VISA', fn:'dahsing_ana',      tag:'HK$8 = 1 mile',                                                           grad:'linear-gradient(135deg,#00b4d8 0%,#0077b6 100%)' },
  { id:'dahsing_ba',       bank:'Dah Sing Bank',       label:'British Airways Platinum Card',net:'Visa',       bucket:'OTHER_MC_VISA', fn:'dahsing_ba',       tag:'HK$6 = 1 Avios Conversion',                                                           grad:'linear-gradient(135deg,#00b4d8 0%,#0077b6 100%)' },
  { id:'mox',              bank:'MOX',                 label:'Credit Card',                           net:'Mastercard', bucket:'OTHER_MC_VISA', fn:'mox',              tag:'HKD4 = 1 Asia Mile',     img:'/uploads/mox.png',                      grad:'linear-gradient(135deg,#494D4C 0%,#67919F 100%)' },
  { id:'dbs_black',        bank:'DBS',                 label:'Black World Mastercard',                net:'Mastercard', bucket:'OTHER_MC_VISA', fn:'dbs_black',        tag:'HK$6 = 1 mile',                                                      grad:'linear-gradient(135deg,#1a1a1a 0%,#2D4E5C 100%)' },
  { id:'dbs_eminent',      bank:'DBS',                 label:'Eminent Visa Signature',                net:'Visa',       bucket:'OTHER_MC_VISA', fn:'dbs_eminent',      tag:'0.4% DBS$',                                                                     grad:'linear-gradient(135deg,#67919F 0%,#1F3540 100%)' },
  { id:'boc_sogo',         bank:'Bank of China',       label:'SOGO Visa Signature Card (Apple Pay / Google Pay)',          net:'Visa',       bucket:'OTHER_MC_VISA', fn:'boc_sogo',        tag:'5.40% cash rebate',                                                      grad:'linear-gradient(135deg,#1a1a1a 0%,#2D4E5C 100%)' },
  { id:'boc_hka',          bank:'Bank of China',       label:'Hong Kong Airlines Visa Signature Card',net:'Visa',       bucket:'OTHER_MC_VISA', fn:'boc_hka',          tag:'HK$5 = 1 FWC Point',                                                      grad:'linear-gradient(135deg,#1a1a1a 0%,#2D4E5C 100%)' },
  { id:'fubon',            bank:'Fubon Bank',          label:'iN VISA Platinum Card',                 net:'Visa',       bucket:'OTHER_MC_VISA', fn:'fubon',            tag:'8% Cash Rebate',                                                      grad:'linear-gradient(135deg,#1a1a1a 0%,#2D4E5C 100%)' },
  { id:'cncbi',            bank:'China CITIC Bank International',          label:'Motion Credit Card',net:'Mastercard',       bucket:'OTHER_MC_VISA', fn:'cncbi',            tag:'6% Cash Rebate',                                                      grad:'linear-gradient(135deg,#1a1a1a 0%,#2D4E5C 100%)' },
  { id:'amex_explorer',    bank:'American Express',    label:'Explorer',                              net:'AMEX',       bucket:'AMEX',          fn:'amex_explorer',    tag:'HK$1 = 3 points',        img:'/uploads/amex_3d.png',                    grad:'linear-gradient(135deg,#4b6cb7 0%,#1F3540 100%)' },
  { id:'aeon_wakuwaku',    bank:'AEON',                label:'AEON CARD WAKUWAKU',                    net:'Mastercard', bucket:'OTHER_MC_VISA', fn:'aeon_wakuwaku',    tag:'6% Rebate',                         grad:'linear-gradient(135deg,#4b6cb7 0%,#1F3540 100%)' },
  { id:'aeon_jal',         bank:'AEON',                label:'AEON Card JAL',                         net:'Mastercard', bucket:'OTHER_MC_VISA', fn:'aeon_jal',         tag:'HK$8 = 1 JMB mile',                 grad:'linear-gradient(135deg,#4b6cb7 0%,#1F3540 100%)' },
  { id:'primecredit_wewa', bank:'PrimeCredit',         label:'WeWa Visa Signature Card (Apple Pay)',  net:'Visa',       bucket:'OTHER_MC_VISA', fn:'primecredit_wewa', tag:'4.0% cash rebate',                 grad:'linear-gradient(135deg,#4b6cb7 0%,#1F3540 100%)' },
  { id:'primecredit_earnmore', bank:'PrimeCredit',     label:'EarnMORE UnionPay DiamondCard',  net:'OTHER_UNIONPAY',  bucket:'OTHER_UNIONPAY', fn:'primecredit_earnmore', tag:'2.0% cash rebate',                 grad:'linear-gradient(135deg,#4b6cb7 0%,#1F3540 100%)' },
  { id:'sim',              bank:'SIM',                 label:'Credit Card',                           net:'Mastercard', bucket:'OTHER_MC_VISA', fn:'sim',              tag:'8.0% cash rebate',                         grad:'linear-gradient(135deg,#4b6cb7 0%,#1F3540 100%)' },
];

const CARDS_BY_ID = Object.fromEntries(CARDS.map(c => [c.id, c]));
const BANKS = [...new Set(CARDS.map(c => c.bank))];

const BANK_TC = {
  'HSBC':                           '匯豐銀行',         // HSBC
  'Hang Seng':                      '恒生銀行',         // Hang Seng
  'BEA':                            '東亞銀行',         // BEA (Bank of East Asia)
  'Citibank':                       '花旗銀行',         // Citibank
  'Standard Chartered':             '渣打銀行',         // Standard Chartered
  'Dah Sing Bank':                  '大新銀行',         // Dah Sing Bank
  'DBS':                            '星展銀行',         // DBS
  'Bank of China':                  '中國銀行（香港）',  // Bank of China
  'Fubon Bank':                     '富邦銀行',         // Fubon Bank
  'China CITIC Bank International': '中信銀行國際',     // China CITIC Bank International
  'American Express':               '美國運通',         // American Express
  'PrimeCredit':                    '安信信貸',         // PrimeCredit
  // MOX, AEON, SIM — keep English (brand names)
};

const CARDS_TC = {
  'hsbc_visa_sig':        { label: 'Visa Signature（最紅自主獎賞：賞家居）',                    tag: '3.60% 獎賞錢'         }, // Visa Signature (RYC: Home) | 3.60% RewardCash
  'hsbc_premier':         { label: 'Premier Mastercard（最紅自主獎賞：賞家居）',                tag: '2.40% 獎賞錢'         }, // Premier Mastercard (RYC: Home) | 2.40% RewardCash
  'hsbc_everymile':       { label: 'EveryMile 信用卡',                                      tag: 'HK$12.5 = 1 飛行里數' }, // EveryMile Credit Card | HK$0.08 = 1 Mile
  'hsbc_basic':           { label: 'easy / Visa Platinum（最紅自主獎賞：賞家居）',              tag: '2.40% 獎賞錢'         }, // easy / Visa Platinum (RYC: Home) | 2.40% RewardCash
  'hsbc_red':             { label: 'Red 信用卡',                                             tag: '0.40% 獎賞錢'         }, // Red Credit Card | 0.40% RewardCash
  'hsbc_pulse':           { label: 'Pulse 雙幣鑽石信用卡（最紅自主獎賞：賞家居）',               tag: '2.40% 獎賞錢'         }, // Pulse UnionPay Dual Currency Diamond Credit Card (RYC: Home) | 2.40% RewardCash
  // hangseng_mmpower, hangseng_basic — labels & tags keep EN (product names)
  'bea_it':               { label: 'i-Titanium 卡'                                          }, // i-Titanium Card (tag keeps EN — product name)
  'bea_goal':             { label: 'GOAL 信用卡'                                             }, // GOAL Credit Card (tag keeps EN — product name)
  'bea_flyer':            { tag: '$1 = 1 積分'                                               }, // $1 = 1 Bonus Point
  'citi_cashback':        { label: 'Cash Back 信用卡',                                      tag: '1.0% 現金回贈'        }, // Cash Back Card | 1.0% Rebate
  'citi_pmm':             { label: 'PremierMiles 信用卡',                                   tag: 'HK$8 = 1 飛行里數'    }, // PremierMiles Card | HK$8 = 1 Mile
  'citi_rewards':         { label: 'Rewards 信用卡（Apple Pay / Google Pay）',              tag: '1.0% 積分回贈'        }, // Rewards Card (Apple Pay / Google Pay) | 1.0% Points Rebate
  'sc_cathay':            { label: '國泰 Mastercard',                                       tag: 'HK$6 = 1 飛行里數'    }, // Cathay Mastercard | HK$6 = 1 Asia Mile
  'sc_simply':            { tag: '1.50% 現金回贈'                                            }, // 1.50% CashBack
  'sc_smart':             { tag: '0.56% 現金回贈'                                            }, // 0.56% CashBack
  'dahsing_ana':          { tag: 'HK$8 = 1 飛行里數'                                        }, // HK$8 = 1 mile
  'dahsing_ba':           { label: 'British Airways 白金卡'                                  }, // British Airways Platinum Card (tag keeps EN — Avios product name)
  'mox':                  { label: '信用卡',                                                 tag: 'HKD4 = 1 飛行里數'    }, // Credit Card | HKD4 = 1 Asia Mile
  'dbs_black':            { tag: 'HK$6 = 1 飛行里數'                                        }, // HK$6 = 1 mile
  // dbs_eminent — label & tag keep EN (product names)
  'boc_sogo':             { label: 'SOGO Visa Signature 信用卡（Apple Pay / Google Pay）',  tag: '5.40% 現金回贈'       }, // SOGO Visa Signature Card (Apple Pay / Google Pay) | 5.40% cash rebate
  'boc_hka':              { label: '香港航空 Visa Signature 信用卡'                           }, // Hong Kong Airlines Visa Signature Card (tag keeps EN — FWC product name)
  'fubon':                { label: 'iN VISA 白金信用卡',                                    tag: '8% 現金回贈'          }, // iN VISA Platinum Card | 8% Cash Rebate
  'cncbi':                { label: 'Motion 信用卡',                                         tag: '6% 現金回贈'          }, // Motion Credit Card | 6% Cash Rebate
  'amex_explorer':        { tag: 'HK$1 = 3 積分'                                            }, // HK$1 = 3 points
  'aeon_wakuwaku':        { tag: '6% 現金回贈'                                              }, // 6% Rebate
  'aeon_jal':             { tag: 'HK$8 = 1 飛行里數'                                        }, // HK$8 = 1 JMB mile
  'primecredit_wewa':     { label: 'WeWa Visa Signature 信用卡（Apple Pay）',               tag: '4.0% 現金回贈'        }, // WeWa Visa Signature Card (Apple Pay) | 4.0% cash rebate
  'primecredit_earnmore': { label: 'EarnMORE 銀聯鑽石卡',                                  tag: '2.0% 現金回贈'        }, // EarnMORE UnionPay DiamondCard | 2.0% cash rebate
  'sim':                  { label: '信用卡',                                                tag: '8.0% 現金回贈'        }, // Credit Card | 8.0% cash rebate
};

function bankLabel(b) { return (currentLang === 'tc' || currentLang === 'sc') ? (BANK_TC[b] || b) : b; }
function cardLabel(c) { return (currentLang === 'tc' || currentLang === 'sc') ? (CARDS_TC[c.id]?.label || c.label) : c.label; }
function cardTag(c)   { return (currentLang === 'tc' || currentLang === 'sc') ? (CARDS_TC[c.id]?.tag   || c.tag)   : c.tag; }

// Calculator engine — input validation + per-card breakdown.
function calculate(rent, splits) {
  if (!splits.length || splits.length > 3) return { error: 'Must use 1 to 3 cards.' };
  if (splits.length > 1 && rent < 10000)   return { error: 'Split payment requires rent ≥ HK$10,000.' };

  const sum = splits.reduce((s, x) => s + x.rent, 0);
  if (Math.abs(sum - rent) > 0.01) return { error: `Split sum HK$${sum.toLocaleString()} ≠ rent HK$${rent.toLocaleString()}.` };

  const rows = [];
  let totalFee = 0, totalCharged = 0;
  for (const s of splits) {
    const card = CARDS_BY_ID[s.cardId];
    if (!card) return { error: `Unknown card: ${s.cardId}` };
    if (['HSBC_UNIONPAY','OTHER_UNIONPAY','CN_UNIONPAY'].includes(card.bucket) && rent < 10000) {
      return { error: `${bankLabel(card.bank)} ${cardLabel(card)} ${t('k_967')}` };
    }
    const feeRate = FEE_RATES[card.bucket];
    const fee = +(s.rent * feeRate).toFixed(2);
    const charged = +(s.rent + fee).toFixed(2);
    const r = REWARDS[card.fn](charged);
    rows.push({
      card, rentPortion: s.rent, feeRate, fee, charged,
      reward: +r.monthly.toFixed(2), annualReward: +r.annual.toFixed(2), unit: r.unit,
      capHit: !!r.capHit, capLabel: r.capLabel || '', note: r.note || '', secondary: r.secondary || '',
    });
    totalFee += fee;
    totalCharged += charged;
  }
  return { rent, totalFee: +totalFee.toFixed(2), totalCharged: +totalCharged.toFixed(2), rows };
}


// ─────────────────────────────────────────────────────────────────────────────
// KeyChain Pay — Rewards Calculator (UI)
// Theme: keychainpay.com tenants (burnt orange #E57500, slate teal #2D4E5C,
// peach #E6A089, dark #1F3540, cream #F8F4EE).
// Logic delegated to window.calculate / CARDS (see rewards_engine.jsx).
// ─────────────────────────────────────────────────────────────────────────────

// Palette
const RC = {
  orange:   '#E57500',
  orangeDk: '#B55B00',
  peach:    '#E6A089',
  peachLt:  '#FFA567',
  slate:    '#67919F',
  slateDk:  '#2D4E5C',
  ink:      '#1F3540',
  cream:    '#F8F4EE',
  paper:    '#FFFFFF',
  text:     '#1A1A1A',
  muted:    '#6B7280',
  rule:     'rgba(31,53,64,0.10)',
};
const SLOT_COLORS = ['#E57500', '#67919F', '#B55B00'];

function fmt(n)    { return Math.round(n).toLocaleString('en-US'); }
function fmt2(n)   { return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
function commas(s) { return String(s).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

// ── Network glyph ────────────────────────────────────────────────────────────
function Net({ net, light = true }) {
  const tint = light ? 'rgba(255,255,255,0.95)' : RC.slateDk;
  if (net === 'Mastercard') return (
    <div style={{ position:'relative', width:32, height:20, flexShrink:0 }}>
      <div style={{ position:'absolute', left:0,  top:0, width:20, height:20, borderRadius:'50%', background:'#EB001B' }} />
      <div style={{ position:'absolute', left:12, top:0, width:20, height:20, borderRadius:'50%', background:'#F79E1B', mixBlendMode:'multiply' }} />
    </div>
  );
  if (net === 'Visa') return <span style={{ fontFamily:'Arial,sans-serif', fontStyle:'italic', fontWeight:900, fontSize:13, letterSpacing:'-0.5px', color:tint, textShadow:light?'0 1px 2px rgba(0,0,0,0.25)':'none' }}>VISA</span>;
  if (net === 'AMEX')      return <span style={{ fontSize:8, fontWeight:800, color:tint, letterSpacing:'0.06em', background:'rgba(255,255,255,0.18)', padding:'2px 5px', borderRadius:3 }}>AMEX</span>;
  if (net === 'UnionPay' || net === 'HSBC_UNIONPAY' || net === 'OTHER_UNIONPAY' || net === 'CN_UNIONPAY')
    return <div style={{ display:'flex', gap:2 }}><div style={{ width:13, height:18, borderRadius:'2px 6px 6px 2px', background:'#EF3340' }}/><div style={{ width:13, height:18, borderRadius:'6px 2px 2px 6px', background:'#003087' }}/></div>;
  return null;
}

// ── Card face ─ real image when available, else marked-up CSS placeholder ──
function CardFace({ card, rentPortion, fee, charged, reward, unit, capHit, active, pct, showPct }) {
  const rewardStr = (() => {
    if (!reward) return '—';
    if (unit === 'RewardCash' || unit === 'Cash Rebate' || unit === 'Cash equiv.' || unit === 'DBS$' || unit === '+FUN Dollars')
      return `+HK$${fmt(reward)} ${unitLabel(unit)}`;
    return `+${fmt(reward)} ${unitLabel(unit)}`;
  })();

  // ── Real-image variant ────────────────────────────────────────────────────
  if (card.img) {
    return (
      <div style={{
        width:'100%', aspectRatio:'1.586', position:'relative',
        transition:'transform 0.35s cubic-bezier(0.4,0,0.2,1), filter 0.3s',
        transform: active ? 'scale(1.06)' : 'scale(1)',
        filter: active ? 'drop-shadow(0 22px 36px rgba(31,53,64,0.45))' : 'drop-shadow(0 10px 18px rgba(31,53,64,0.25))',
      }}>
        <img src={card.img} alt={`${bankLabel(card.bank)} ${cardLabel(card)}`} style={{ width:'100%', height:'100%', objectFit:'contain', display:'block' }} />

        {/* Reward badge */}
        <div style={{
          position:'absolute', bottom:'12%', right:'4%',
          background:'rgba(31,53,64,0.78)', backdropFilter:'blur(10px)',
          borderRadius:10, padding:'6px 12px', textAlign:'right',
          border:'1px solid rgba(255,255,255,0.14)',
          boxShadow:'0 6px 16px rgba(0,0,0,0.18)',
        }}>
          <div style={{ fontSize:8, color:'rgba(255,255,255,0.55)', textTransform:'uppercase', letterSpacing:'0.1em', fontWeight:700 }}>{t('k_108')}</div>
          <div style={{ fontSize:13, fontWeight:800, color:RC.peachLt, fontFamily:"'Space Grotesk',sans-serif", lineHeight:1.1 }}>{rewardStr}</div>
        </div>

        {/* Bank/label chip (bottom-left) */}
        <div style={{
          position:'absolute', bottom:'12%', left:'4%',
          background:'rgba(255,255,255,0.86)', backdropFilter:'blur(8px)',
          borderRadius:8, padding:'5px 9px',
          boxShadow:'0 4px 10px rgba(31,53,64,0.18)',
          maxWidth:'52%',
        }}>
          <div style={{ fontSize:7.5, color:RC.slate, textTransform:'uppercase', letterSpacing:'0.12em', fontWeight:700 }}>{bankLabel(card.bank)}</div>
          <div style={{ fontSize:10, fontWeight:700, color:RC.ink, lineHeight:1.15, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{cardLabel(card)}</div>
        </div>

        {showPct && (
          <div style={{ position:'absolute', top:'6%', left:'50%', transform:'translateX(-50%)', background:'rgba(229,117,0,0.95)', borderRadius:20, padding:'4px 11px', fontSize:10.5, fontWeight:800, color:'white', whiteSpace:'nowrap', boxShadow:'0 6px 14px rgba(229,117,0,0.4)' }}>
            {pct}% · HK${fmt(rentPortion)}
          </div>
        )}
        {capHit && (
          <div style={{ position:'absolute', top:'6%', right:'4%', background:'rgba(255,165,103,0.95)', color:RC.ink, fontSize:8.5, fontWeight:800, padding:'3px 8px', borderRadius:4, textTransform:'uppercase', letterSpacing:'0.06em', boxShadow:'0 2px 6px rgba(0,0,0,0.18)' }}>Cap hit</div>
        )}
      </div>
    );
  }

  // ── Marked-up CSS placeholder (no image available) ────────────────────────
  return (
    <div style={{
      width:'100%', aspectRatio:'1.586', borderRadius:18,
      background: card.grad,
      padding:'18px 20px', position:'relative', overflow:'hidden',
      boxShadow: active ? '0 24px 40px -10px rgba(31,53,64,0.45)' : '0 8px 18px -6px rgba(31,53,64,0.25)',
      transform: active ? 'scale(1.04)' : 'scale(1)',
      transition: 'transform 0.35s cubic-bezier(0.4,0,0.2,1), box-shadow 0.3s',
      display:'flex', flexDirection:'column', justifyContent:'space-between',
      color:'white', fontFamily:'Inter,sans-serif',
    }}>
      {/* Dashed "PLACEHOLDER" marker so users know this is a stand-in */}
      <div aria-hidden style={{
        position:'absolute', inset:8, borderRadius:14,
        border:'1px dashed rgba(255,255,255,0.22)',
        pointerEvents:'none',
      }} />
      <div style={{ position:'absolute', top:6, right:10, fontSize:7.5, fontWeight:800, color:'rgba(255,255,255,0.45)', textTransform:'uppercase', letterSpacing:'0.16em', fontFamily:"'Space Grotesk',sans-serif" }}>placeholder</div>

      {/* decorative orbs */}
      <div style={{ position:'absolute', top:-50, right:-30, width:160, height:160, borderRadius:'50%', background:'rgba(255,255,255,0.08)', pointerEvents:'none' }} />
      <div style={{ position:'absolute', bottom:-60, left:-30, width:200, height:200, borderRadius:'50%', background:'rgba(255,255,255,0.05)', pointerEvents:'none' }} />

      {/* top row: chip + network */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', position:'relative' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div style={{ width:30, height:22, borderRadius:5, background:'linear-gradient(135deg,#C8A84B,#F0D060,#C8A84B)', display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:1.5, padding:3, boxShadow:'inset 0 1px 2px rgba(0,0,0,0.15)' }}>
            {Array.from({length:6}).map((_, i) => <div key={i} style={{ background:'rgba(0,0,0,0.22)', borderRadius:1 }} />)}
          </div>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M2 7 Q4 3 7 3 Q10 3 12 7" stroke="rgba(255,255,255,0.55)" strokeWidth="1.4" strokeLinecap="round" fill="none"/>
            <path d="M4 7 Q5.5 4.5 7 4.5 Q8.5 4.5 10 7" stroke="rgba(255,255,255,0.4)" strokeWidth="1.4" strokeLinecap="round" fill="none"/>
            <path d="M6 7 Q6.5 6 7 6 Q7.5 6 8 7" stroke="rgba(255,255,255,0.65)" strokeWidth="1.4" strokeLinecap="round" fill="none"/>
          </svg>
        </div>
        <Net net={card.net} />
      </div>

      {/* dotted PAN row */}
      <div style={{ display:'flex', gap:9, alignItems:'center', position:'relative' }}>
        {[0,1,2].map(g => (
          <div key={g} style={{ display:'flex', gap:3 }}>
            {Array.from({length:4}).map((_, i) => <div key={i} style={{ width:4, height:4, borderRadius:'50%', background:'rgba(255,255,255,0.32)' }} />)}
          </div>
        ))}
        <div style={{ display:'flex', gap:3 }}>
          {Array.from({length:4}).map((_, i) => <div key={i} style={{ width:4, height:4, borderRadius:'50%', background:'rgba(255,255,255,0.72)' }} />)}
        </div>
      </div>

      {/* bottom row: bank/label + reward */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end', gap:12, position:'relative' }}>
        <div style={{ minWidth:0 }}>
          <div style={{ fontSize:9, color:'rgba(255,255,255,0.55)', textTransform:'uppercase', letterSpacing:'0.12em', fontWeight:700, marginBottom:3 }}>{bankLabel(card.bank)}</div>
          <div style={{ fontSize:11, fontWeight:700, color:'white', lineHeight:1.2, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{cardLabel(card)}</div>
        </div>
        <div style={{ textAlign:'right', flexShrink:0 }}>
          <div style={{ fontSize:8, color:'rgba(255,255,255,0.55)', textTransform:'uppercase', letterSpacing:'0.1em', fontWeight:700 }}>{t('k_108')}</div>
          <div style={{ fontSize:13, fontWeight:800, color:RC.peachLt, fontFamily:"'Space Grotesk',sans-serif", lineHeight:1 }}>{rewardStr}</div>
        </div>
      </div>

      {/* split badge */}
      {showPct && (
        <div style={{ position:'absolute', top:10, left:'50%', transform:'translateX(-50%)', background:'rgba(31,53,64,0.78)', backdropFilter:'blur(6px)', borderRadius:20, padding:'3px 10px', fontSize:10, fontWeight:700, color:'white', whiteSpace:'nowrap', boxShadow:'0 4px 10px rgba(0,0,0,0.2)' }}>
          {pct}% · HK${fmt(rentPortion)}
        </div>
      )}

      {/* cap-hit ribbon */}
      {capHit && (
        <div style={{ position:'absolute', top:10, right:10, background:'rgba(255,165,103,0.95)', color:RC.ink, fontSize:8.5, fontWeight:800, padding:'3px 8px', borderRadius:4, textTransform:'uppercase', letterSpacing:'0.06em', boxShadow:'0 2px 6px rgba(0,0,0,0.18)' }}>Cap hit</div>
      )}
    </div>
  );
}

// ── Inputs: card-slot row ────────────────────────────────────────────────────
function CardSlot({ idx, slot, row, numCards, onTypeChange, onPctChange }) {
  const dot = SLOT_COLORS[idx];
  return (
    <div style={{ marginBottom:12, background:RC.paper, borderRadius:14, padding:'14px 16px', border:`1.5px solid ${dot}30`, boxShadow:'0 2px 10px rgba(31,53,64,0.05)' }}>
      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:10 }}>
        <div style={{ width:9, height:9, borderRadius:'50%', background:dot, flexShrink:0 }} />
        <span style={{ fontSize:11, fontWeight:700, color:dot, textTransform:'uppercase', letterSpacing:'0.08em' }}>Card {idx + 1}</span>
        {numCards > 1 && (
          <span style={{ marginLeft:'auto', fontSize:11, color:RC.muted, fontFamily:"'Space Grotesk',sans-serif", fontWeight:600 }}>
            {slot.pct}% · HK${fmt(row.rentPortion)}
          </span>
        )}
      </div>

      <select value={slot.cardId} onChange={e => onTypeChange(idx, e.target.value)}
        style={{ width:'100%', border:'1.5px solid rgba(31,53,64,0.10)', borderRadius:8, padding:'10px 12px', fontSize:13, fontWeight:500, color:RC.text, background:RC.cream, outline:'none', fontFamily:'Inter,sans-serif', marginBottom:10, cursor:'pointer', appearance:'none', backgroundImage:`url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'><path d='M2 4l3 3 3-3' stroke='${encodeURIComponent('#67919F')}' fill='none' stroke-width='1.6' stroke-linecap='round'/></svg>")`, backgroundRepeat:'no-repeat', backgroundPosition:'right 12px center', paddingRight:32 }}>
        {BANKS.map(bank => (
          <optgroup key={bank} label={bankLabel(bank)}>
            {CARDS.filter(c => c.bank === bank).map(c => (
              <option key={c.id} value={c.id}>{cardLabel(c)} — {cardTag(c)}</option>
            ))}
          </optgroup>
        ))}
      </select>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', fontSize:11, color:RC.muted, marginBottom: numCards > 1 ? 10 : 0, gap:8, flexWrap:'wrap' }}>
        <span>
          Platform fee · <strong style={{ color:RC.orange }}>{(row.feeRate*100).toFixed(2)}%</strong> = HK${fmt(row.fee)}
        </span>
        <span style={{ color:RC.slateDk, fontWeight:600 }}>Charged: HK${fmt(row.charged)}</span>
      </div>

      {numCards > 1 && (
        <input type="range" min={1} max={100 - (numCards - 1)} value={slot.pct}
          onChange={e => onPctChange(idx, parseInt(e.target.value, 10))}
          style={{ width:'100%', accentColor:dot, cursor:'pointer' }} />
      )}
    </div>
  );
}

// ── Main component ──────────────────────────────────────────────────────────
function RewardsCalculator({ embedded = false }) {
  const [open, setOpen] = React.useState(false);
  const [rent, setRent] = React.useState(15000);
  const [rentInput, setRentInput] = React.useState('15,000');
  const [numCards, setNumCards] = React.useState(1);
  const [slots, setSlots] = React.useState([
    { cardId:'hsbc_visa_sig', pct:100 },
    { cardId:'hsbc_premier',  pct:0   },
    { cardId:'sc_cathay',     pct:0   },
  ]);

  const canSplit2 = rent >= 10000;
  const canSplit3 = rent >= 20000;

  React.useEffect(() => {
    if (numCards === 3 && !canSplit3) setNumCards(canSplit2 ? 2 : 1);
    else if (numCards === 2 && !canSplit2) setNumCards(1);
  }, [rent]); // eslint-disable-line

  React.useEffect(() => {
    setSlots(prev => {
      const base = Math.floor(100 / numCards);
      const rem  = 100 - base * numCards;
      return prev.map((s, i) => i < numCards
        ? { ...s, pct: base + (i === 0 ? rem : 0) }
        : { ...s, pct: 0 });
    });
  }, [numCards]);

  const onRentInput = e => {
    const raw = e.target.value.replace(/,/g, '').replace(/[^0-9]/g, '');
    const n = parseInt(raw || '0', 10);
    setRentInput(commas(n));
    setRent(n);
  };

  const onTypeChange = (idx, id) => setSlots(prev => prev.map((s, i) => i === idx ? { ...s, cardId:id } : s));

  const onPctChange = (idx, raw) => {
    const min = 1, max = 100 - (numCards - 1);
    const v = Math.max(min, Math.min(max, raw));
    setSlots(prev => {
      const next = prev.map(s => ({ ...s }));
      const diff = v - next[idx].pct;
      next[idx].pct = v;
      const others = Array.from({length:numCards}, (_,i)=>i).filter(i => i !== idx);
      let rem = diff;
      for (let k = others.length - 1; k >= 0; k--) {
        const oi = others[k];
        const take = k === 0 ? rem : Math.round(rem / (k + 1));
        const nv = Math.max(1, next[oi].pct - take);
        rem -= (next[oi].pct - nv);
        next[oi].pct = nv;
      }
      const sum = next.slice(0, numCards).reduce((a, s) => a + s.pct, 0);
      if (sum !== 100) next[others[0]].pct += (100 - sum);
      return next;
    });
  };

  // Build split inputs for engine
  const liveSplits = slots.slice(0, numCards).map(s => ({ cardId: s.cardId, rent: Math.round(rent * s.pct / 100) }));
  // Adjust rounding drift so sum exactly == rent
  if (liveSplits.length) {
    const drift = rent - liveSplits.reduce((a, s) => a + s.rent, 0);
    liveSplits[0].rent += drift;
  }
  const result = calculate(rent, liveSplits);
  const rows = result.error ? [] : result.rows;

  // Reward totals
  const totals = {};
  const annualTotals = {};
  rows.forEach(r => {
    totals[r.unit]       = (totals[r.unit]       || 0) + r.reward;
    annualTotals[r.unit] = (annualTotals[r.unit] || 0) + r.annualReward;
  });
  const totalKeys = Object.keys(totals);

  const inner = (
    <div style={{ display:'grid', gridTemplateColumns:'minmax(0,1fr) minmax(0,1fr)', gap:44, alignItems:'start' }} className="two-col">

      {/* ─────────── LEFT ─────────── */}
      <div>
        {/* Monthly rent */}
        <div style={{ marginBottom:24 }}>
          <label style={{ fontSize:11, fontWeight:700, color:RC.slate, textTransform:'uppercase', letterSpacing:'0.1em', display:'block', marginBottom:8 }}>Monthly Rent</label>
          <div style={{ position:'relative' }}>
            <span style={{ position:'absolute', left:16, top:'50%', transform:'translateY(-50%)', fontSize:13, fontWeight:700, color:RC.orangeDk, letterSpacing:'0.06em', pointerEvents:'none' }}>HKD</span>
            <input type="text" value={rentInput} onChange={onRentInput}
              style={{ width:'100%', border:`2px solid ${RC.orange}33`, borderRadius:12, padding:'14px 16px 14px 58px', fontSize:22, fontWeight:800, color:RC.text, background:RC.paper, outline:'none', fontFamily:"'Space Grotesk',sans-serif", boxSizing:'border-box', transition:'border-color 0.2s' }}
              onFocus={e => e.target.style.borderColor = RC.orange}
              onBlur={e => e.target.style.borderColor = `${RC.orange}33`}
            />
          </div>
          <div style={{ display:'flex', gap:6, marginTop:10, flexWrap:'wrap' }}>
            {[5000, 10000, 15000, 20000, 30000, 50000].map(v => (
              <button key={v} onClick={() => { setRent(v); setRentInput(commas(v)); }} style={{
                background: rent===v ? RC.orange : `${RC.orange}10`,
                color: rent===v ? 'white' : RC.orangeDk,
                border: `1px solid ${rent===v ? RC.orange : RC.orange + '30'}`,
                borderRadius:20, padding:'4px 11px', fontSize:11, fontWeight:600, cursor:'pointer', transition:'all 0.15s', fontFamily:"'Space Grotesk',sans-serif",
              }}>{commas(v)}</button>
            ))}
          </div>
        </div>

        {/* Split selector */}
        <div style={{ marginBottom:20 }}>
          <label style={{ fontSize:11, fontWeight:700, color:RC.slate, textTransform:'uppercase', letterSpacing:'0.1em', display:'block', marginBottom:8 }}>Split Payment</label>
          <div style={{ display:'flex', gap:8 }}>
            {[
              { n:1, label:'1 Card',  ok:true },
              { n:2, label:'2 Cards', ok:canSplit2, hint:'min HK$10,000' },
              { n:3, label:'3 Cards', ok:canSplit3, hint:'min HK$20,000' },
            ].map(({n,label,ok,hint}) => {
              const active = numCards === n;
              return (
                <button key={n} onClick={() => ok && setNumCards(n)} style={{
                  flex:1, padding:'11px 6px', borderRadius:10,
                  background: active ? RC.orange : ok ? RC.paper : '#F3F0EB',
                  color: active ? 'white' : ok ? RC.text : '#C0C7CE',
                  border: `1.5px solid ${active ? RC.orange : ok ? 'rgba(31,53,64,0.10)' : 'rgba(31,53,64,0.05)'}`,
                  fontSize:13, fontWeight:700, cursor: ok ? 'pointer' : 'not-allowed', transition:'all 0.15s', lineHeight:1.2,
                }}>
                  {label}
                  {!ok && hint && <div style={{ fontSize:9, fontWeight:500, marginTop:2, color:'#C0C7CE' }}>{hint}</div>}
                </button>
              );
            })}
          </div>
        </div>

        {/* Card slots */}
        {slots.slice(0, numCards).map((slot, idx) => {
          const row = rows[idx] || (() => {
            const rp = liveSplits[idx]?.rent || 0;
            const fr = FEE_RATES[CARDS_BY_ID[slot.cardId].bucket];
            const fe = +(rp * fr).toFixed(2);
            return { rentPortion: rp, feeRate: fr, fee: fe, charged: rp + fe };
          })();
          return <CardSlot key={idx} idx={idx} slot={slot} row={row} numCards={numCards}
                           onTypeChange={onTypeChange} onPctChange={onPctChange} />;
        })}

        {/* Fee summary strip — hidden when calculation is invalid */}
        {!result.error && (
        <div style={{
          background:`${RC.orange}0A`, borderRadius:12, padding:'14px 16px',
          border:`1px solid ${RC.orange}28`,
          display:'grid', gridTemplateColumns:'1fr auto 1fr auto 1fr', alignItems:'center', gap:10, marginTop:6,
        }}>
          <div style={{ textAlign:'center' }}>
            <div style={{ fontSize:9, color:RC.muted, textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:3 }}>Monthly Rent</div>
            <div style={{ fontSize:16, fontWeight:800, color:RC.text, fontFamily:"'Space Grotesk',sans-serif" }}>HK${fmt(rent)}</div>
          </div>
          <span style={{ color:RC.orange, fontSize:18, fontWeight:700 }}>+</span>
          <div style={{ textAlign:'center' }}>
            <div style={{ fontSize:9, color:RC.muted, textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:3 }}>Transaction Fee</div>
            <div style={{ fontSize:16, fontWeight:800, color:RC.orange, fontFamily:"'Space Grotesk',sans-serif" }}>HK${fmt(result.totalFee || 0)}</div>
          </div>
          <span style={{ color:RC.orange, fontSize:18, fontWeight:700 }}>=</span>
          <div style={{ textAlign:'center' }}>
            <div style={{ fontSize:9, color:RC.muted, textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:3 }}>Total Charged</div>
            <div style={{ fontSize:16, fontWeight:800, color:RC.text, fontFamily:"'Space Grotesk',sans-serif" }}>HK${fmt(result.totalCharged || rent)}</div>
          </div>
        </div>
        )}

        {result.error && (
          <div style={{ marginTop:14, background:'#FEF3E2', border:'1px solid #F8C77E', borderRadius:10, padding:'10px 12px', fontSize:12, color:'#8A4B00' }}>
            ⚠ {result.error}
          </div>
        )}
      </div>

      {/* ─────────── RIGHT ─────────── */}
      <div style={{ display:'flex', flexDirection:'column', gap:18 }}>
        {/* Card faces */}
        {numCards === 1 ? (
          <div style={{ width:'min(340px,100%)', margin:'0 auto' }}>
            {(() => {
              const r = rows[0];
              const card = CARDS_BY_ID[slots[0].cardId];
              if (!card) return null;
              if (r) return <CardFace card={r.card} rentPortion={r.rentPortion} fee={r.fee} charged={r.charged} reward={r.reward} unit={r.unit} capHit={r.capHit} active showPct={false} />;
              return <CardFace card={card} rentPortion={liveSplits[0]?.rent || 0} fee={0} charged={0} reward={0} unit="" capHit={false} active showPct={false} />;
            })()}
          </div>
        ) : (
          <div style={{ position:'relative', height: numCards === 2 ? 220 : 260 }}>
            {(() => {
              const order = Array.from({length:numCards},(_,i)=>i).sort((a,b)=> (slots[a].pct - slots[b].pct));
              const fan2 = [{x:-50,y:18,rot:-7},{x:50,y:0,rot:7}];
              const fan3 = [{x:-72,y:30,rot:-10},{x:62,y:18,rot:9},{x:0,y:0,rot:0}];
              const fan = numCards===2 ? fan2 : fan3;
              return order.map((origIdx, ord) => {
                const r = rows[origIdx]; if (!r) return null;
                const f = fan[ord];
                const front = ord === order.length - 1;
                return (
                  <div key={origIdx} style={{ position:'absolute', top:f.y, left:`calc(50% + ${f.x}px)`, transform:`translateX(-50%) rotate(${f.rot}deg)`, width:'min(250px,64%)', zIndex:ord+1, transition:'all 0.35s ease' }}>
                    <CardFace card={r.card} rentPortion={r.rentPortion} fee={r.fee} charged={r.charged} reward={r.reward} unit={r.unit} capHit={r.capHit} active={front} showPct pct={slots[origIdx].pct} />
                  </div>
                );
              });
            })()}
          </div>
        )}

        {/* Split bar */}
        {numCards > 1 && rows.length > 0 && (
          <div style={{ background:RC.paper, borderRadius:12, padding:'14px 16px', border:`1px solid ${RC.rule}` }}>
            <div style={{ fontSize:10, fontWeight:700, color:RC.slate, textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:10 }}>Payment Split</div>
            <div style={{ display:'flex', height:8, borderRadius:4, overflow:'hidden', background:'#EDE7DE' }}>
              {rows.map((r, i) => <div key={i} style={{ width:`${slots[i].pct}%`, background:SLOT_COLORS[i], transition:'width 0.35s ease' }} />)}
            </div>
            <div style={{ display:'flex', gap:14, marginTop:10, flexWrap:'wrap' }}>
              {rows.map((r, i) => (
                <div key={i} style={{ display:'flex', alignItems:'center', gap:6 }}>
                  <div style={{ width:7, height:7, borderRadius:'50%', background:SLOT_COLORS[i] }} />
                  <span style={{ fontSize:10.5, color:RC.muted }}>{bankLabel(r.card.bank)} {cardLabel(r.card)}: <strong style={{ color:RC.slateDk }}>{slots[i].pct}%</strong></span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Reward panel */}
        <div style={{
          background:`linear-gradient(135deg, ${RC.ink} 0%, ${RC.slateDk} 100%)`,
          borderRadius:16, padding:'20px 22px', border:`1px solid rgba(255,255,255,0.06)`,
          boxShadow:'0 12px 28px -10px rgba(31,53,64,0.35)',
        }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
            <div style={{ fontSize:10, fontWeight:700, color:'rgba(255,255,255,0.45)', textTransform:'uppercase', letterSpacing:'0.14em' }}>{t('k_119')}</div>
            <div style={{ fontSize:9, color:'rgba(255,255,255,0.3)', textTransform:'uppercase', letterSpacing:'0.1em' }}>{t('k_968')}</div>
          </div>

          {rows.length === 0 ? (
            <div style={{ fontSize:13, color:'rgba(255,255,255,0.5)', padding:'10px 0' }}>{t('k_969')}</div>
          ) : (
            <>
              {rows.map((r, i) => {
                const isCash = ['RewardCash','Cash Rebate','Cash equiv.','DBS$','+FUN Dollars'].includes(r.unit);
                const rstr = isCash ? `HK$${fmt(r.reward)} ${unitLabel(r.unit)}` : `${fmt(r.reward)} ${unitLabel(r.unit)}`;
                const rstrAnnual = isCash ? `HK$${fmt(r.annualReward)}` : fmt(r.annualReward);
                return (
                  <div key={i} style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:10, paddingBottom:10, marginBottom:10, borderBottom:'1px solid rgba(255,255,255,0.07)' }}>
                    <div style={{ display:'flex', alignItems:'flex-start', gap:8, minWidth:0 }}>
                      <div style={{ width:8, height:8, borderRadius:'50%', background:SLOT_COLORS[i], flexShrink:0, marginTop:5 }} />
                      <div style={{ minWidth:0 }}>
                        <div style={{ fontSize:11.5, color:'rgba(255,255,255,0.85)', lineHeight:1.35, fontWeight:600 }}>{bankLabel(r.card.bank)} {cardLabel(r.card)}</div>
                        {(r.note || r.secondary || r.capHit) && (
                          <div style={{ fontSize:10, color:'rgba(255,255,255,0.4)', marginTop:3, lineHeight:1.4 }}>
                            {r.capHit && <span style={{ color:RC.peachLt, fontWeight:600 }}>⊕ {t('k_962')} ({r.capLabel}). </span>}
                            {r.secondary && <span>{r.secondary}. </span>}
                            {r.note}
                          </div>
                        )}
                      </div>
                    </div>
                    <div style={{ textAlign:'right', flexShrink:0 }}>
                      <div style={{ fontSize:12.5, fontWeight:800, color:RC.peachLt, fontFamily:"'Space Grotesk',sans-serif", whiteSpace:'nowrap' }}>{rstr}</div>
                      <div style={{ fontSize:9, color:'rgba(255,255,255,0.35)', marginTop:2, whiteSpace:'nowrap' }}>{rstrAnnual} / yr</div>
                    </div>
                  </div>
                );
              })}

              {/* Totals by unit */}
              <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginTop:6 }}>
                {totalKeys.map(unit => {
                  const v = totals[unit];
                  const va = annualTotals[unit];
                  const isCash = ['RewardCash','Cash Rebate','Cash equiv.','DBS$','+FUN Dollars'].includes(unit);
                  const head = isCash ? `HK$${fmt(v)}` : fmt(v);
                  return (
                    <div key={unit} style={{ flex:'1 1 110px', minWidth:110, background:`${RC.orange}1F`, borderRadius:10, padding:'10px 12px', border:`1px solid ${RC.orange}40` }}>
                      <div style={{ fontSize:8, color:'rgba(255,255,255,0.45)', textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:4 }}>{unitLabel(unit)}</div>
                      <div style={{ fontSize:18, fontWeight:800, color:RC.peachLt, fontFamily:"'Space Grotesk',sans-serif", lineHeight:1 }}>{head}</div>
                      <div style={{ fontSize:9, color:'rgba(255,255,255,0.35)', marginTop:4 }}>
                        {isCash ? `HK$${fmt(va)}` : `${fmt(va)}`} / year
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}

          <div style={{ fontSize:9.5, color:'rgba(255,255,255,0.32)', marginTop:14, lineHeight:1.55 }}>
            {t('k_965')}
          </div>
        </div>

      </div>
    </div>
  );

  if (embedded) {
    return (
      <div style={{ borderTop:`1px solid ${RC.rule}`, paddingTop:40, paddingBottom:56 }}>
        <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:32, flexWrap:'wrap' }}>
          <Badge color={RC.orange} bg={`${RC.orange}1A`}>Rewards Calculator</Badge>
          <span style={{ fontSize:14, color:RC.muted }}>See how much you could earn on HK${commas(rent)} / month</span>
        </div>
        {inner}
      </div>
    );
  }

  return (
    <section style={{ background:RC.cream, borderTop:`1px solid ${RC.rule}` }}>
      <div style={{ maxWidth:1200, margin:'0 auto', padding:'0 24px' }}>
        <button onClick={() => setOpen(o => !o)} style={{
          width:'100%', display:'flex', alignItems:'center', justifyContent:'space-between',
          padding:'26px 0', background:'none', border:'none', cursor:'pointer', textAlign:'left',
        }}>
          <div style={{ display:'flex', alignItems:'center', gap:14, flexWrap:'wrap' }}>
            <Badge color={RC.orange} bg={`${RC.orange}1A`}>Rewards Calculator</Badge>
            {!open && <span style={{ fontSize:14, color:RC.muted }}>See how much you could earn on HK${commas(rent)} / month</span>}
          </div>
          <div style={{ width:32, height:32, borderRadius:'50%', background: open ? RC.orange : `${RC.orange}1A`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, transition:'all 0.25s' }}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d={open ? 'M2 8L6 4L10 8' : 'M2 4L6 8L10 4'} stroke={open ? 'white' : RC.orange} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </button>
        {open && <div style={{ paddingBottom:52 }}>{inner}</div>}
      </div>
    </section>
  );
}


// ── TENANTS PAGE ─────────────────────────────────────────────────────────────
function TenantsPage({
  onNavigate,
  onOpenChatbot
}) {
  const [activeCard, setActiveCard] = React.useState(0);
  return <div>
      <SEO title={currentLang === "tc" ? "交租 App｜信用卡交租賺積分、飛行里數｜Keychain" : (currentLang === "sc" ? "Keychain - 智能租務代理 | 租戶" : "Pay Rent by Credit Card in Hong Kong — Earn Miles & Cashback | Keychain")} description={currentLang === "tc" ? "用信用卡交租，賺積分及飛行里數；綁定信用卡，租金 100% 準時入業主戶口，業主免下載 App。" : (currentLang === "sc" ? "Split your rent across multiple credit cards and earn air miles, cash rebate, or points on every payment." : "Pay your Hong Kong rent with any credit card and earn miles, points or cashback. No landlord sign-up needed. See fees by card and get started in minutes.")} urlPath={`/${currentLang}/tenants/`} />
      <section style={{
      background: 'linear-gradient(135deg, #B55B00 0%, #E57500 25%, #67919F 65%, #2D4E5C 85%, #1F3540 100%)',
      padding: t("k_750"),
      position: 'relative',
      overflow: 'hidden'
    }}>
        <div style={{
        position: 'absolute',
        top: '10%',
        right: '15%',
        width: 400,
        height: 400,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(230,160,137,0.25) 0%, transparent 70%)',
        pointerEvents: 'none'
      }} />
        <div style={{
        position: 'absolute',
        bottom: '5%',
        left: '10%',
        width: 280,
        height: 280,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(45,212,191,0.2) 0%, transparent 70%)',
        pointerEvents: 'none'
      }} />
        <div style={{
        maxWidth: 1200,
        margin: t("k_250"),
        display: t("k_286"),
        gridTemplateColumns: t("k_356"),
        gap: 60,
        alignItems: 'center'
      }} className="two-col">
          <div>
            <div style={{
            marginBottom: 24
          }}>
              <Badge color="#E6A089" bg={t("k_132")}>{t("k_133")}</Badge>
            </div>
            <h1 style={{
            fontFamily: t("k_374"),
            fontSize: t("k_751"),
            fontWeight: 800,
            color: 'white',
            lineHeight: 1.06,
            letterSpacing: t("k_358"),
            margin: t("k_481")
          }}>{t("k_134")}<br />
              <span style={{
              color: '#E6A089'
            }}>{t("k_135")}</span><br />{t("k_136")}</h1>
            <p style={{
            fontSize: 18,
            color: 'rgba(255,255,255,0.65)',
            lineHeight: 1.65,
            marginBottom: 40,
            maxWidth: 460
          }}>{t("k_137")}</p>
            <div style={{
            display: 'flex',
            gap: 14,
            flexWrap: t("k_295")
          }}>
              <button style={{
              background: '#E6A089',
              color: '#1E1B4B',
              border: 'none',
              borderRadius: 10,
              padding: t("k_313"),
              fontSize: 15,
              fontWeight: 700,
              cursor: t("k_251")
            }} onClick={() => window.location.href = APP_URL}>{t("k_138")}</button>
              <Btn variant="outlineLight" onClick={() => {
              const el = document.getElementById('rewards-calculator');
              if (el) el.scrollIntoView({
                behavior: t("k_752")
              });
            }}>{t("k_139")}</Btn>
            </div>
            <div style={{
            marginTop: 36,
            display: 'flex',
            gap: 32,
            alignItems: 'center',
            flexWrap: t("k_295")
          }}>
              {[{
              id: 'Mastercard',
              type: 'img',
              logo: t("k_753")
            }, {
              id: 'Visa',
              type: 'img',
              logo: t("k_754")
            }, {
              id: 'AMEX',
              type: 'img',
              logo: t("k_755")
            }, {
              id: 'UnionPay',
              type: 'img',
              logo: t("k_756")
            }, {
              id: t("k_757"),
              type: 'img',
              logo: t("k_758")
            }, {
              id: t("k_759"),
              type: 'img',
              logo: t("k_760")
            }].map(p => <div key={p.id} style={{
              display: 'flex',
              alignItems: 'center'
            }}>
                  {p.type === 'img' ? <img src={p.logo} alt={p.id} style={{
                height: 30,
                width: 'auto',
                objectFit: t("k_241")
              }} /> : p.content}
                </div>)}
            </div>
          </div>
          <TenantRewardsPanel />
        </div>
      </section>

      {/* HOW IT WORKS — tenant flow */}
      <Section bg="#FAFAFA">
        <SectionHeader eyebrow={t("k_140")} title={t("k_141")} subtitle={t("k_142")} />
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: t("k_400"),
        gap: 24
      }}>
          {[{
          step: '01',
          title: t("k_362"),
          desc: t("k_363"),
          color: '#E57500'
        }, {
          step: '02',
          title: t("k_364"),
          desc: t("k_370"),
          color: '#B55B00'
        }, {
          step: '03',
          title: t("k_371"),
          desc: t("k_761"),
          color: '#E6A089'
        }, {
          step: '04',
          title: t("k_368"),
          desc: t("k_369"),
          color: '#E57500'
        }].map((item, i) => <Reveal key={item.step} delay={i * 80}>
              <div style={{
            textAlign: 'center',
            padding: t("k_762"),
            background: 'white',
            borderRadius: 18,
            border: '1px solid rgba(0,0,0,0.05)',
            boxShadow: t("k_763")
          }}>
                <div style={{
              width: 52,
              height: 52,
              borderRadius: '50%',
              background: item.color + '18',
              border: '2px solid ' + item.color + '30',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: t("k_764"),
              fontSize: 14,
              fontWeight: 800,
              color: item.color
            }}>{item.step}</div>
                <h3 style={{
              fontSize: 16,
              fontWeight: 700,
              color: '#1A1A1A',
              marginBottom: 10
            }}>{item.title}</h3>
                <p style={{
              fontSize: 13,
              color: '#6B7280',
              lineHeight: 1.65
            }}>{item.desc}</p>
              </div>
            </Reveal>)}
        </div>
      </Section>

      {/* HSBC × KEYCHAIN PROMO BANNER */}
      <section style={{
        position: 'relative',
        overflow: 'hidden',
        background: '#14263B',
        minHeight: 'clamp(420px, 32vw, 620px)',
        display: 'flex',
        alignItems: 'center',
        padding: '64px 24px'
      }}>
        <img src={t("k_975")} alt="" style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: '55% 30%'
        }} />
        <div style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(90deg, rgba(20,38,59,0.92) 0%, rgba(20,38,59,0.78) 38%, rgba(20,38,59,0.15) 75%, rgba(20,38,59,0) 100%)'
        }} />
        <div style={{
          position: 'relative',
          width: '100%',
          maxWidth: 1200,
          margin: '0 auto'
        }}>
          <div style={{ maxWidth: 640 }}>
          <Reveal>
            <Badge color="#ffffff" bg="rgba(219,0,17,0.92)" style={{ border: 'none' }}>{t("k_970")}</Badge>
            <h2 style={{
              fontFamily: t("k_374"),
              color: 'white',
              fontSize: 'clamp(28px, 4vw, 42px)',
              fontWeight: 900,
              lineHeight: 1.2,
              margin: '20px 0 14px'
            }}>{t("k_971")}</h2>
            <p style={{
              color: 'rgba(255,255,255,0.85)',
              fontSize: 17,
              lineHeight: 1.7,
              marginBottom: 28,
              maxWidth: 480
            }}>{t("k_972")}</p>
            <div style={{
              display: 'flex',
              gap: 14,
              flexWrap: 'wrap'
            }}>
              <Btn variant="bright" onClick={() => onNavigate('promotions/hsbc')}>{t("k_974")}</Btn>
            </div>
          </Reveal>
          </div>
        </div>
      </section>

      {/* REWARDS & SPLIT + CALCULATOR — merged section */}
      <Section bg={t("k_38")} style={{
      paddingBottom: 0
    }}>
        {/* Top: two-col headers */}
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: t("k_356"),
        gap: 60,
        alignItems: t("k_722"),
        marginBottom: 48
      }} className="two-col">
          <Reveal>
            <div>
              <Badge color="#E6A089" bg={t("k_143")}>{t("k_144")}</Badge>
              <h2 style={{
              fontFamily: t("k_374"),
              fontSize: t("k_765"),
              fontWeight: 800,
              color: '#1A1A1A',
              margin: t("k_482"),
              lineHeight: 1.15
            }}>{t("k_145")}<br /><span style={{
                color: '#0D9488'
              }}>{t("k_146")}</span><br />{t("k_147")}</h2>
              <p style={{
              fontSize: 16,
              color: '#6B7280',
              lineHeight: 1.7
            }}>{t("k_148")}</p>
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div>
              <Badge color="#B55B00">{t("k_149")}</Badge>
              <h2 style={{
              fontFamily: t("k_374"),
              fontSize: t("k_765"),
              fontWeight: 800,
              color: '#1A1A1A',
              margin: t("k_482"),
              lineHeight: 1.15
            }}>{t("k_150")}<br /><span style={{
                color: '#B55B00'
              }}>{t("k_151")}</span>
              </h2>
              <p style={{
              fontSize: 16,
              color: '#6B7280',
              lineHeight: 1.7
            }}>{t("k_152")}</p>
            </div>
          </Reveal>
        </div>
        <div id="rewards-calculator">
          <RewardsCalculator embedded />
        </div>
        <div style={{ paddingTop:32, paddingBottom:48, textAlign:'center' }}>
          <p style={{ fontSize:18, color:'#374151', lineHeight:1.6, marginTop:16, marginBottom:24 }}>{t('k_154')}</p>
          <Btn variant="solid" style={{ background:'#E57500', color:'white', padding:t('k_767'), fontSize:16, border:'none' }}
            onClick={() => onOpenChatbot && onOpenChatbot()}>{t('k_155')}</Btn>
        </div>
      </Section>

      {/* SECURITY */}
      <Section bg={t("k_156")}>
        <SectionHeader eyebrow={t("k_157")} title={t("k_158")} subtitle={t("k_159")} light />
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: t("k_400"),
        gap: 20
      }}>
          {[{
          title: t("k_768"),
          desc: t("k_769"),
          icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFA567" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" /></svg>
        }, {
          title: 'PCI DSS',
          desc: t("k_770"),
          icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFA567" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="m9 12 2 2 4-4" /></svg>
        }, {
          title: t("k_771"),
          desc: t("k_772"),
          icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFA567" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="3" rx="2" ry="2" /><path d="M9 9h6v6H9z" /><path d="M15 3v6" /><path d="M9 3v6" /><path d="M3 15h6" /><path d="M3 9h6" /><path d="M15 15h6" /><path d="M15 9h6" /></svg>
        }, {
          title: t("k_773"),
          desc: t("k_774"),
          icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFA567" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="11" width="14" height="10" rx="2" /><circle cx="12" cy="16" r="1" /><path d="M8 11v-4a4 4 0 1 1 8 0v4" /></svg>
        }].map((item, i) => <Reveal key={item.title} delay={i * 80}>
              <div style={{
            background: 'rgba(255,255,255,0.06)',
            borderRadius: 16,
            padding: 24,
            border: '1px solid rgba(255,255,255,0.1)',
            textAlign: 'center',
            height: '100%',
            display: 'flex',
            flexDirection: t("k_283")
          }}>
                <div style={{
              width: 40,
              height: 40,
              borderRadius: 10,
              background: 'rgba(229,117,0,0.2)',
              margin: t("k_407"),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
                  {item.icon}
                </div>
                <div style={{
              fontSize: 15,
              fontWeight: 700,
              color: 'white',
              marginBottom: 8
            }}>{item.title}</div>
                <div style={{
              fontSize: 13,
              color: 'rgba(255,255,255,0.5)',
              lineHeight: 1.6,
              flex: 1
            }}>{item.desc}</div>
              </div>
            </Reveal>)}
        </div>
      </Section>

      {/* TENANT FAQ */}
      <Section bg="#FAFAFA">
        <SectionHeader eyebrow={t("k_160")} title={t("k_161")} />
        <div style={{
        maxWidth: 680,
        margin: t("k_250")
      }}>
          {[{
          q: t("k_775"),
          a: t("k_776")
        }, {
          q: t("k_777"),
          a: t("k_778")
        }, {
          q: t("k_779"),
          a: t("k_780")
        }, {
          q: t("k_781"),
          a: t("k_782")
        }].map((faq, i) => <TenantFAQItem key={i} faq={faq} />)}
        </div>
        <div style={{
        textAlign: 'center',
        marginTop: 40
      }}>
          <Btn variant="outline" style={{
          color: '#B55B00',
          border: '2px solid #B55B00'
        }} onClick={() => onNavigate('faq')}>{t("k_162")}</Btn>
        </div>
      </Section>

      <section style={{
      background: 'linear-gradient(135deg, #B55B00 0%, #E57500 50%, #FFA567 100%)',
      padding: t("k_415"),
      textAlign: 'center'
    }}>
        <h2 style={{
        fontFamily: t("k_374"),
        fontSize: t("k_542"),
        fontWeight: 800,
        color: 'white',
        marginBottom: 16
      }}>{t("k_163")}</h2>
        <p style={{
        fontSize: 17,
        color: 'rgba(255,255,255,0.75)',
        marginBottom: 36
      }}>{t("k_164")}</p>
        <div style={{
        display: 'flex',
        gap: 14,
        justifyContent: 'center',
        flexWrap: t("k_295")
      }}>
          <button style={{
          background: 'white',
          color: '#B55B00',
          border: 'none',
          borderRadius: 10,
          padding: t("k_313"),
          fontSize: 15,
          fontWeight: 700,
          cursor: t("k_251")
        }} onClick={() => window.location.href = APP_URL}>{t("k_165")}</button>
          <button style={{
          background: 'rgba(255,255,255,0.15)',
          color: 'white',
          border: '1px solid rgba(255,255,255,0.3)',
          borderRadius: 10,
          padding: t("k_313"),
          fontSize: 15,
          fontWeight: 700,
          cursor: t("k_251")
        }} onClick={() => window.location.href = APP_URL}>{t("k_166")}</button>
        </div>
      </section>
    </div>;
}

// HSBC x Keychain rent-payment promo page — copy per locale. Kept as a plain
// data object (like CARDS/REWARDS above) rather than atomized into DICT_*,
// since it's a large self-contained block used by exactly one page.
const HSBC_PROMO_CONTENT = {
  tc: {
    seoTitle: "滙豐信用卡交租優惠 | Keychain",
    heroEyebrow: "滙豐信用卡 × KEYCHAIN",
    heroTitle: "交租，\n都可以賺「獎賞錢」",
    heroSub: "以滙豐信用卡透過 Keychain 繳付租金，交易費低至 0.8%，更可賺取高達 3.6%「獎賞錢」。",
    kcTitle: "由 Keychain 提供的優惠",
    kcCards: [
      { tag: "個人滙豐 Visa / Mastercard 信用卡", rate: "1.8%", rateLabel: "交易費低至",
        rows: [ { name: "住宅及車位", val: "1.8%" }, { name: "商業單位", val: "1.98%" } ] },
      { tag: "個人滙豐銀聯信用卡", rate: "0.8%", rateLabel: "交易費低至",
        rows: [ { name: "住宅及車位", val: "0.8%" }, { name: "商業單位", val: "0.98%" } ] }
    ],
    hsTitle: "由滙豐銀行提供的優惠",
    rewardTitle: "賺取高達 3.6%「獎賞錢」",
    rewardItems: [
      { pct: "2.4%", text: "登記「最紅自主獎賞」，並將全數額外「獎賞錢」分配於「賞家居」類別" },
      { pct: "1.2%", text: "滙豐 Visa Signature 卡額外「獎賞錢」（毋須額外登記）" }
    ],
    promos: [
      { period: "2026年1月1日至12月31日", title: "最紅自主獎賞",
        body: "登記「最紅自主獎賞」，並將全數額外「獎賞錢」分配於「賞家居」類別中，交租即可賺取高達 3.6%「獎賞錢」回贈。",
        foot: "持卡人須於2026年10月31日或之前完成登記。" },
      { period: "2026年4月1日至10月31日", title: "滙豐卓越理財信用卡 賺盡高達 $3,500「獎賞錢」",
        body: "使用滙豐卓越理財信用卡每月累積合資格本地或海外簽賬達指定金額，即可享每月高達 $500「獎賞錢」回贈，全期最高可賺 $3,500 回贈。",
        foot: "每月簽賬門檻：HKD 15,000 – 39,999 享 $150 回贈；HKD 40,000 或以上享 $500 回贈。" },
      { period: "2026年6月26日至8月31日", title: "最紅大折日",
        body: "成功登記後消費額達個人目標，於實體店完成的合資格本地餐飲及海外簽賬可享高達額外 6%「獎賞錢」回贈，最多可獲高達額外 $800「獎賞錢」。",
        foot: "使用滙豐 Visa 信用卡累積合資格簽賬達組別 2 的個人目標消費額，可多享額外 $200「獎賞錢」。" }
    ],
    appTitle: "用 Keychain App，交租從此更有價值",
    appSub: "將滙豐信用卡加入 Keychain，輕鬆繳付住宅、車位及商業單位租金，一邊交租一邊賺取信用卡獎賞。",
    appCta: "交租即賺，立即開始",
    disclaimer: "以上優惠均受有關條款及細則約束。滙豐信用卡優惠由香港上海滙豐銀行有限公司提供，詳情請參閱滙豐官方網站；Keychain 交易費優惠詳情請參閱 keychainpay.com。借定唔借？還得到先好借！"
  },
  en: {
    seoTitle: "HSBC Credit Card Rent Payment Offers | Keychain",
    heroEyebrow: "HSBC CREDIT CARDS × KEYCHAIN",
    heroTitle: "Earn RewardCash on your rent",
    heroSub: "Pay rent with your HSBC credit card via Keychain — transaction fee as low as 0.8%, and earn up to 3.6% RewardCash.",
    kcTitle: "Promotions offered by Keychain",
    kcCards: [
      { tag: "Individual HSBC Visa / Mastercard credit card", rate: "1.8%", rateLabel: "transaction fee as low as",
        rows: [ { name: "Residential & carpark", val: "1.8%" }, { name: "Commercial", val: "1.98%" } ] },
      { tag: "Individual HSBC UnionPay credit card", rate: "0.8%", rateLabel: "transaction fee as low as",
        rows: [ { name: "Residential & carpark", val: "0.8%" }, { name: "Commercial", val: "0.98%" } ] }
    ],
    hsTitle: "Promotions offered by HSBC",
    rewardTitle: "Earn up to 3.6% RewardCash",
    rewardItems: [
      { pct: "2.4%", text: "Register Red Hot Rewards of Your Choice with all extra RewardCash allocated to the Home category" },
      { pct: "1.2%", text: "HSBC Visa Signature Card extra RewardCash (no registration required)" }
    ],
    promos: [
      { period: "1 Jan – 31 Dec 2026", title: "Red Hot Rewards of Your Choice",
        body: "Sign up for “Red Hot Rewards of Your Choice” and allocate all extra RewardCash to the Home category to earn up to 3.6% RewardCash on rental payments.",
        foot: "Cardholders must complete registration by 31 October 2026." },
      { period: "1 Apr – 31 Oct 2026", title: "Earn up to $3,500 RewardCash with the HSBC Premier Mastercard",
        body: "Meet the monthly eligible spending requirement with the HSBC Premier Mastercard to unlock up to $500 extra RewardCash per month and up to $3,500 total rewards during the promotion.",
        foot: "Monthly spend tiers: HKD 15,000 – 39,999 earn extra $150 RewardCash; HKD 40,000+ earn extra $500 RewardCash." },
      { period: "26 Jun – 31 Aug 2026", title: "Red Hot Festival",
        body: "Upon meeting your personal spending target after registration, enjoy up to an extra 6% RewardCash rebate on eligible local dining and overseas in-store spending, with a maximum of up to $800 extra RewardCash.",
        foot: "Use an HSBC Visa credit card and reach the Group 2 personal spending target to enjoy an additional $200 RewardCash." }
    ],
    appTitle: "Rent, rewarded — with the Keychain App",
    appSub: "Add your HSBC credit card to Keychain to pay residential, carpark and commercial rent with ease — and earn card rewards every time you pay.",
    appCta: "Start earning on your rent",
    disclaimer: "All offers above are subject to relevant terms and conditions. HSBC credit card offers are provided by The Hongkong and Shanghai Banking Corporation Limited — see the HSBC website for details. For Keychain transaction fee offer details, visit keychainpay.com. To borrow or not to borrow? Borrow only if you can repay!"
  },
  sc: {
    seoTitle: "汇丰信用卡交租优惠 | Keychain",
    heroEyebrow: "汇丰信用卡 × KEYCHAIN",
    heroTitle: "缴付租金，也可以赚「奖赏钱」",
    heroSub: "以汇丰信用卡通过 Keychain 缴付租金，交易费低至 0.8%，更可赚取高达 3.6%「奖赏钱」。",
    kcTitle: "由 Keychain 提供的优惠",
    kcCards: [
      { tag: "个人滙丰 Visa / Mastercard 信用卡", rate: "1.8%", rateLabel: "交易费低至",
        rows: [ { name: "住宅及车位", val: "1.8%" }, { name: "商业单位", val: "1.98%" } ] },
      { tag: "个人汇丰银联信用卡", rate: "0.8%", rateLabel: "交易费低至",
        rows: [ { name: "住宅及车位", val: "0.8%" }, { name: "商业单位", val: "0.98%" } ] }
    ],
    hsTitle: "由汇丰银行提供的优惠",
    rewardTitle: "赚取高达 3.6%「奖赏钱」",
    rewardItems: [
      { pct: "2.4%", text: "登记「最红自主奖赏」，并将全数额外「奖赏钱」分配于「赏家居」类别" },
      { pct: "1.2%", text: "汇丰 Visa Signature 卡额外「奖赏钱」（毋须额外登记）" }
    ],
    promos: [
      { period: "2026年1月1日至12月31日", title: "最红自主奖赏",
        body: "登记「最红自主奖赏」，并把全数额外「奖赏钱」分配于「赏家居」类别中，缴交租金即可获取高达 3.6%「奖赏钱」回赠。",
        foot: "持卡人必须在2026年10月31日或之前完成登记。" },
      { period: "2026年4月1日至10月31日", title: "汇丰卓越理财信用卡 赚尽高达 $3,500「奖赏钱」",
        body: "使用汇丰卓越理财信用卡每月累积合资格本地或海外签账达指定金额，即可享每月高达 $500「奖赏钱」回赠，全期最高可赚 $3,500 回赠。",
        foot: "每月签账门槛：HKD 15,000 – 39,999 享 $150 回赠；HKD 40,000 或以上享 $500 回赠。" },
      { period: "2026年6月26日至8月31日", title: "最红大折日",
        body: "成功登记后消费额达个人目标，于实体店完成的合资格本地餐饮及海外签账可享高达额外 6%「奖赏钱」回赠，最多可获高达额外 $800「奖赏钱」。",
        foot: "使用汇丰 Visa 信用卡累积合资格签账达组别 2 的个人目标消费额，可多享额外 $200「奖赏钱」。" }
    ],
    appTitle: "使用 Keychain App，缴付租金从此更有价值",
    appSub: "把汇丰信用卡加入 Keychain，轻松缴付住宅、车位及商业单位租金，一边交租一边赚取信用卡奖赏。",
    appCta: "缴租即赚，马上开始",
    disclaimer: "以上优惠均受有关条款及细则约束。汇丰信用卡优惠由香港上海汇丰银行有限公司提供，详情请参阅汇丰官方网站；Keychain 交易费优惠详情请参阅 keychainpay.com。借定唔借？还得到先好借！"
  }
};

function HsbcPromoPage({ onNavigate }) {
  const c = HSBC_PROMO_CONTENT[currentLang] || HSBC_PROMO_CONTENT.en;
  return <div>
      <SEO title={c.seoTitle} description={c.heroSub} urlPath={`/${currentLang}/promotions/hsbc/`} />

      {/* Hero */}
      <section id="hero-section" style={{
        position: 'relative',
        overflow: 'hidden',
        background: '#14263B',
        minHeight: 520,
        display: 'flex',
        alignItems: 'center',
        padding: '140px 0 60px'
      }}>
        <img id="hero-img" src="/uploads/hsbc-promo-hero.webp" alt="" style={{
          position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: '55% 30%'
        }} />
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(90deg, rgba(20,38,59,0.92) 0%, rgba(20,38,59,0.78) 38%, rgba(20,38,59,0.15) 75%, rgba(20,38,59,0) 100%)'
        }} />
        <div id="hero-content" style={{ position: 'relative', padding: '0 5%', maxWidth: 720 }}>
          <Reveal>
            <Badge color="#ffffff" bg="rgba(219,0,17,0.92)" style={{ border: 'none' }}>{c.heroEyebrow}</Badge>
            <h1 id="hero-title" style={{ color: 'white', fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: 900, lineHeight: 1.2, margin: '20px 0 16px' }}>
              {c.heroTitle.split('\n').map((line, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <br />}
                  {line}
                </React.Fragment>
              ))}
            </h1>
            <p id="hero-sub" style={{ color: 'rgba(255,255,255,0.88)', fontSize: 18, lineHeight: 1.7, maxWidth: 520 }}>{c.heroSub}</p>
          </Reveal>
        </div>
      </section>

      {/* Keychain offers */}
      <Section bg="#FBF8F4">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
          <div style={{ width: 34, height: 4, background: '#E57500' }} />
          <div style={{ fontSize: 14, fontWeight: 700, color: '#E57500', letterSpacing: 2 }}>KEYCHAIN</div>
        </div>
        <h2 style={{ fontSize: 34, fontWeight: 900, margin: '0 0 40px', color: '#1B3B5F' }}>{c.kcTitle}</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(320px, 100%), 1fr))', gap: 24 }}>
          {c.kcCards.map((card, i) => (
            <Reveal key={card.tag} delay={i * 80}>
              <div style={{ background: '#ffffff', borderRadius: 16, padding: '34px 34px 28px', boxShadow: '0 2px 14px rgba(27,59,95,0.08)', display: 'flex', flexDirection: 'column', gap: 18, height: '100%' }}>
                <div style={{ alignSelf: 'flex-start', background: '#EEF3F8', color: '#1B3B5F', fontSize: 14, fontWeight: 700, padding: '6px 14px', borderRadius: 999 }}>{card.tag}</div>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: 12 }}>
                  <div style={{ fontSize: 64, fontWeight: 900, color: '#E57500', lineHeight: 1 }}>{card.rate}</div>
                  <div style={{ fontSize: 16, fontWeight: 500, color: '#6B7A8C' }}>{card.rateLabel}</div>
                </div>
                <div style={{ borderTop: '1px solid #E8ECF1', paddingTop: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {card.rows.map(row => (
                    <div key={row.name} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 16 }}>
                      <span style={{ color: '#45566B' }}>{row.name}</span>
                      <span style={{ fontWeight: 700, color: '#1B3B5F' }}>{row.val}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <div style={{ textAlign: 'center', marginTop: 32 }}>
          <Btn variant="outlineDark" onClick={() => window.open(t("k_977"), '_blank', 'noopener,noreferrer')}>
            {t("k_976")}
          </Btn>
        </div>
      </Section>

      {/* HSBC offers */}
      <Section bg="#ffffff" id="hsbc-offers">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
          <div style={{ width: 34, height: 4, background: '#DB0011' }} />
          <div style={{ fontSize: 14, fontWeight: 700, color: '#DB0011', letterSpacing: 2 }}>HSBC</div>
        </div>
        <h2 style={{ fontSize: 34, fontWeight: 900, margin: '0 0 40px', color: '#1B3B5F' }}>{c.hsTitle}</h2>

        <Reveal>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(320px, 100%), 1fr))', gap: 40, alignItems: 'center', background: '#14263B', borderRadius: 20, padding: 'clamp(20px, 5vw, 48px)', marginBottom: 28 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
              <h3 style={{ color: '#ffffff', fontSize: 30, fontWeight: 900, margin: 0, lineHeight: 1.35 }}>{c.rewardTitle}</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                {c.rewardItems.map(it => (
                  <div key={it.pct + it.text} style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                    <div style={{ flex: '0 0 auto', minWidth: 64, textAlign: 'center', background: '#DB0011', color: '#ffffff', fontWeight: 900, fontSize: 18, padding: '6px 10px', borderRadius: 6 }}>{it.pct}</div>
                    <div style={{ color: 'rgba(255,255,255,0.88)', fontSize: 16, lineHeight: 1.65, paddingTop: 4 }}>{it.text}</div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <img src="/uploads/hsbc-promo-card.webp" alt="HSBC Visa Signature Card" style={{ width: '100%', maxWidth: 400, filter: 'drop-shadow(0 18px 34px rgba(0,0,0,0.45))' }} />
            </div>
          </div>
        </Reveal>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(300px, 100%), 1fr))', gap: 24 }}>
          {c.promos.map((pm, i) => (
            <Reveal key={pm.title} delay={i * 80}>
              <div style={{ border: '1px solid #E8ECF1', borderTop: '4px solid #DB0011', borderRadius: 12, padding: '30px 28px', display: 'flex', flexDirection: 'column', gap: 14, background: '#ffffff', height: '100%' }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#DB0011', letterSpacing: 0.5 }}>{pm.period}</div>
                <h3 style={{ fontSize: 21, fontWeight: 900, margin: 0, color: '#1B3B5F', lineHeight: 1.4 }}>{pm.title}</h3>
                <p style={{ fontSize: 15, lineHeight: 1.75, color: '#45566B', margin: 0 }}>{pm.body}</p>
                <p style={{ fontSize: 14, lineHeight: 1.7, color: '#1B3B5F', fontWeight: 500, margin: 0, background: '#FBF8F4', borderRadius: 8, padding: '12px 14px' }}>{pm.foot}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>

      {/* App section */}
      <Section bg="#1B3B5F">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(320px, 100%), 1fr))', gap: 48, alignItems: 'center' }}>
          <Reveal>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <img src="/uploads/hsbc-promo-app.webp" alt="Keychain App with HSBC Visa Signature Card" style={{ display: 'block', width: '100%', maxWidth: 480, borderRadius: 18, boxShadow: '0 24px 48px rgba(0,0,0,0.4)' }} />
            </div>
          </Reveal>
          <Reveal delay={100}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
              <h2 style={{ color: '#ffffff', fontSize: 34, fontWeight: 900, margin: 0, lineHeight: 1.35 }}>{c.appTitle}</h2>
              <p style={{ color: 'rgba(255,255,255,0.82)', fontSize: 17, lineHeight: 1.8, margin: 0 }}>{c.appSub}</p>
              <div>
                <Btn variant="bright" onClick={() => window.location.href = APP_URL}>{c.appCta}</Btn>
              </div>
              <p style={{ color: '#ffffff', fontSize: 12.5, lineHeight: 1.8, margin: 0, maxWidth: 480 }}>{c.disclaimer}</p>
            </div>
          </Reveal>
        </div>
      </Section>
    </div>;
}

function TenantFAQItem({
  faq
}) {
  const [open, setOpen] = React.useState(false);
  return <div style={{
    borderBottom: '1px solid rgba(0,0,0,0.07)',
    padding: t("k_418"),
    cursor: t("k_251")
  }} onClick={() => setOpen(!open)}>
      <div style={{
      display: 'flex',
      justifyContent: t("k_285"),
      alignItems: 'center',
      gap: 16
    }}>
        <div style={{
        fontSize: 16,
        fontWeight: 600,
        color: '#1A1A1A'
      }}>{faq.q}</div>
        <div style={{
        fontSize: 18,
        color: '#E57500',
        flexShrink: 0,
        transition: t("k_308"),
        transform: open ? 'rotate(45deg)' : 'none'
      }}>+</div>
      </div>
      {open && <p style={{
      fontSize: 14,
      color: '#6B7280',
      lineHeight: 1.7,
      marginTop: 12,
      marginBottom: 0,
      whiteSpace: t("k_783")
    }}>{faq.a}</p>}
    </div>;
}

// ── INVESTORS PAGE ────────────────────────────────────────────────────────────

function InvestorsPage({
  onNavigate
}) {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener(t("k_352"), handleResize);
    return () => window.removeEventListener(t("k_352"), handleResize);
  }, []);
  return <div style={{
    color: '#1A1A1A',
    background: '#F9FAFB'
  }}>
      <SEO title={(currentLang === "tc" || currentLang === "sc") ? "Keychain - 智能租務代理 | 投資者關係" : "Keychain - AI Rental Agent | Investors"} description={`Backed by ASIAPAY CAPITAL. We are building the autonomous financial layer for the global rental economy with a 50x LTV/CAC ratio.`} urlPath={`/${currentLang}/investors/`} />
      {/* HERO: Positioning as AI Rental Agent */}
      <section style={{
      background: 'linear-gradient(135deg, #1F3540 0%, #2D4E5C 20%, #1A2E38 50%, #064E3B 80%, #0D9488 100%)',
      backgroundSize: '200% 200%',
      animation: t("k_354"),
      padding: isMobile ? t("k_784") : t("k_785"),
      position: 'relative',
      overflow: 'hidden'
    }}>
        <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: '60%',
        height: '100%',
        background: 'radial-gradient(ellipse at 80% 40%, rgba(20,184,166,0.1) 0%, transparent 65%)',
        pointerEvents: 'none'
      }} />
        <div style={{
        maxWidth: 1200,
        margin: t("k_250")
      }}>
          <h1 style={{
          fontFamily: t("k_374"),
          fontSize: t("k_786"),
          fontWeight: 800,
          color: 'white',
          lineHeight: 1.04,
          letterSpacing: t("k_358"),
          margin: '0 0 32px',
          maxWidth: 900
        }}>{t("k_167")}<br />
            <span style={{
            color: '#14B8A6',
            display: 'block',
            marginTop: 12
          }}>{t("k_168")}<br className="mobile-break" />{t("k_169")}</span>
          </h1>
          <p style={{
          fontSize: t("k_787"),
          color: 'rgba(255,255,255,0.65)',
          lineHeight: 1.6,
          marginBottom: 56,
          maxWidth: 640
        }}>{t("k_170")}</p>
          <div style={{
          display: 'flex',
          gap: 12,
          flexWrap: t("k_295")
        }}>
            <Badge color="#FFA567" bg={t("k_171")}>{t("k_172")}<span style={{
              color: '#FFBF00'
            }}>{t("k_173")}</span><span style={{
              color: '#000080'
            }}>{t("k_174")}</span>{t("k_175")}</Badge>
            <Badge color="#FF5F00" bg={t("k_176")}>{t("k_52")}</Badge>
            <Badge color="white" bg={t("k_177")}>
              <span style={{
              color: '#4285F4'
            }}>{t("k_178")}</span>
              <span style={{
              color: '#EA4335'
            }}>{t("k_179")}</span>
              <span style={{
              color: '#FBBC05'
            }}>{t("k_179")}</span>
              <span style={{
              color: '#4285F4'
            }}>{t("k_180")}</span>
              <span style={{
              color: '#34A853'
            }}>{t("k_181")}</span>
              <span style={{
              color: '#EA4335'
            }}>{t("k_182")}</span> {t("k_183")}</Badge>
          </div>
        </div>
      </section>

      {/* THE PROBLEM: Infrastructure Gap */}
      <Section bg={t("k_38")}>
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: isMobile ? t("k_788") : t("k_789"),
        gap: isMobile ? 40 : 80,
        alignItems: 'center'
      }}>
          <Reveal>
            <div>
              <Badge color="#115E59" bg={t("k_184")}>{t("k_185")}</Badge>
              <h2 style={{
              fontSize: t("k_790"),
              fontWeight: 800,
              margin: t("k_791"),
              lineHeight: 1.1
            }}>{t("k_186")}</h2>
              <p style={{
              fontSize: 18,
              color: '#4B5563',
              lineHeight: 1.6,
              marginBottom: 32
            }}>{t("k_187")}</p>
              <div style={{
              display: t("k_286"),
              gap: 20
            }}>
                {[{
                t: t("k_792"),
                d: t("k_793")
              }, {
                t: t("k_794"),
                d: t("k_795")
              }, {
                t: t("k_796"),
                d: t("k_797")
              }].map(item => <div key={item.t} style={{
                display: 'flex',
                gap: 16
              }}>
                    <div style={{
                  width: 4,
                  background: '#14B8A6',
                  borderRadius: 2,
                  flexShrink: 0
                }} />
                    <div>
                      <div style={{
                    fontWeight: 700,
                    fontSize: 16,
                    color: '#1A1A1A',
                    marginBottom: 4
                  }}>{item.t}</div>
                      <div style={{
                    fontSize: 14,
                    color: '#6B7280'
                  }}>{item.d}</div>
                    </div>
                  </div>)}
              </div>
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div style={{
            background: '#1F3540',
            borderRadius: 32,
            padding: t("k_798"),
            color: 'white',
            position: 'relative',
            overflow: 'hidden'
          }}>
              <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: 4,
              background: 'linear-gradient(90deg, #14B8A6, #2DD4BF)'
            }} />
              <div style={{
              fontSize: 13,
              fontWeight: 700,
              color: '#14B8A6',
              textTransform: t("k_262"),
              letterSpacing: '0.1em',
              marginBottom: 32
            }}>{t("k_188")}</div>
              <div style={{
              fontSize: 24,
              fontWeight: 600,
              lineHeight: 1.5,
              marginBottom: 40
            }}>{t("k_189")}<span style={{
                color: '#14B8A6'
              }}>{t("k_190")}</span>{t("k_191")}<span style={{
                color: '#14B8A6'
              }}>{t("k_192")}</span>{t("k_193")}</div>
              <div style={{
              paddingTop: 32,
              borderTop: '1px solid rgba(255,255,255,0.1)',
              display: 'flex',
              justifyContent: t("k_285")
            }}>
                <div>
                  <div style={{
                  fontSize: 28,
                  fontWeight: 800
                }}>{t("k_194")}</div>
                  <div style={{
                  fontSize: 12,
                  color: 'rgba(255,255,255,0.5)',
                  marginTop: 4
                }}>{t("k_195")}</div>
                </div>
                <div>
                  <div style={{
                  fontSize: 28,
                  fontWeight: 800
                }}>{t("k_196")}</div>
                  <div style={{
                  fontSize: 12,
                  color: 'rgba(255,255,255,0.5)',
                  marginTop: 4
                }}>{t("k_197")}</div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </Section>

      {/* THE SOLUTION: AI-Powered Financial Infrastructure */}
      <Section bg="#F3F4F6">
        <SectionHeader eyebrow={t("k_198")} title={t("k_199")} subtitle={t("k_200")} center />
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: t("k_387"),
        gap: 24
      }}>
          {[{
          t: t("k_799"),
          d: t("k_800"),
          icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  <path d="M12 8v4" /><path d="M12 16h.01" />
                </svg>,
          color: '#14B8A6'
        }, {
          t: t("k_801"),
          d: t("k_802"),
          icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                </svg>,
          color: '#F59E0B'
        }, {
          t: t("k_803"),
          d: t("k_804"),
          icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="5" width="20" height="14" rx="2" /><line x1="2" y1="10" x2="22" y2="10" />
                </svg>,
          color: '#6366F1'
        }, {
          t: t("k_24"),
          d: t("k_805"),
          icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 8V4H8" /><rect x="4" y="8" width="16" height="12" rx="2" /><path d="M2 14h2" /><path d="M20 14h2" /><path d="M15 13v2" /><path d="M9 13v2" />
                </svg>,
          color: '#EC4899'
        }].map((item, i) => <Reveal key={item.t} delay={i * 100}>
              <div style={{
            background: 'white',
            borderRadius: 24,
            padding: 32,
            border: '1px solid rgba(0,0,0,0.05)',
            height: '100%'
          }}>
                <div style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              background: `${item.color}15`,
              color: item.color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 20
            }}>
                  {item.icon}
                </div>
                <h3 style={{
              fontSize: 20,
              fontWeight: 700,
              marginBottom: 12
            }}>{item.t}</h3>
                <p style={{
              fontSize: 15,
              color: '#6B7280',
              lineHeight: 1.6
            }}>{item.d}</p>
              </div>
            </Reveal>)}
        </div>
      </Section>

      {/* WHY NOW: Market Dynamics */}
      <Section bg={t("k_38")}>
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: isMobile ? t("k_788") : t("k_806"),
        gap: isMobile ? 40 : 80,
        alignItems: 'center'
      }}>
          <Reveal>
            <div style={{
            display: t("k_286"),
            gridTemplateColumns: isMobile ? t("k_788") : t("k_356"),
            gap: 24
          }}>
              {[{
              label: t("k_807"),
              val: t("k_808"),
              desc: t("k_809")
            }, {
              label: t("k_810"),
              val: t("k_811"),
              desc: t("k_812")
            }, {
              label: t("k_813"),
              val: t("k_814"),
              desc: t("k_815")
            }, {
              label: t("k_816"),
              val: t("k_817"),
              desc: t("k_818")
            }].map(stat => <div key={stat.label} style={{
              padding: 24,
              background: '#F9FAFB',
              borderRadius: 20,
              border: '1px solid rgba(0,0,0,0.04)'
            }}>
                  <div style={{
                fontSize: 12,
                fontWeight: 700,
                color: '#9CA3AF',
                textTransform: t("k_262"),
                marginBottom: 8
              }}>{stat.label}</div>
                  <div style={{
                fontSize: 22,
                fontWeight: 800,
                color: '#115E59',
                marginBottom: 8
              }}>{stat.val}</div>
                  <div style={{
                fontSize: 13,
                color: '#6B7280',
                lineHeight: 1.4
              }}>{stat.desc}</div>
                </div>)}
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div>
              <Badge color="#115E59" bg={t("k_184")}>{t("k_201")}</Badge>
              <h2 style={{
              fontSize: 36,
              fontWeight: 800,
              margin: t("k_819")
            }}>{t("k_202")}</h2>
              <p style={{
              fontSize: 17,
              color: '#4B5563',
              lineHeight: 1.6,
              marginBottom: 28
            }}>{t("k_203")}</p>
            </div>
          </Reveal>
        </div>
      </Section>

      {/* AI RENTAL AGENT: Core Story */}
      <Section bg="#1F3540" style={{
      color: 'white'
    }}>
        <div style={{
        maxWidth: 860,
        margin: t("k_250"),
        textAlign: 'center'
      }}>
          <Badge color="#14B8A6" bg={t("k_204")}>{t("k_205")}</Badge>
          <h2 style={{
          fontSize: t("k_820"),
          fontWeight: 800,
          margin: t("k_821"),
          lineHeight: 1.1
        }}>{t("k_206")}</h2>
          <p style={{
          fontSize: 20,
          color: 'rgba(255,255,255,0.7)',
          lineHeight: 1.65,
          marginBottom: 48
        }}>{t("k_207")}<span style={{
            color: 'white',
            fontWeight: 600
          }}>{t("k_208")}</span>{t("k_209")}</p>
          <div style={{
          display: t("k_286"),
          gridTemplateColumns: isMobile ? t("k_788") : t("k_429"),
          gap: 24
        }}>
            {[{
            t: t("k_822"),
            d: t("k_823")
          }, {
            t: t("k_824"),
            d: t("k_825")
          }, {
            t: t("k_826"),
            d: t("k_827")
          }].map(item => <div key={item.t} style={{
            textAlign: t("k_263"),
            padding: '24px',
            background: 'rgba(255,255,255,0.04)',
            borderRadius: 16
          }}>
                <div style={{
              fontWeight: 700,
              fontSize: 18,
              marginBottom: 8,
              color: '#14B8A6'
            }}>{item.t}</div>
                <div style={{
              fontSize: 14,
              color: 'rgba(255,255,255,0.5)'
            }}>{item.d}</div>
              </div>)}
          </div>
        </div>
      </Section>

      {/* BUSINESS MODEL & UNIT ECONOMICS */}
      <Section bg={t("k_38")}>
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: isMobile ? t("k_788") : t("k_789"),
        gap: isMobile ? 40 : 80,
        alignItems: 'center'
      }}>
          <Reveal>
            <div>
              <Badge color="#115E59" bg={t("k_184")}>{t("k_210")}</Badge>
              <h2 style={{
              fontSize: 36,
              fontWeight: 800,
              margin: t("k_819")
            }}>{t("k_211")}</h2>
              <p style={{
              fontSize: 17,
              color: '#4B5563',
              lineHeight: 1.6,
              marginBottom: 32
            }}>{t("k_212")}</p>
              <div style={{
              display: t("k_286"),
              gridTemplateColumns: isMobile ? t("k_788") : t("k_356"),
              gap: 16
            }}>
                {[{
                l: t("k_828"),
                v: t("k_829"),
                highlight: true
              }, {
                l: t("k_830"),
                v: t("k_831")
              }, {
                l: t("k_832"),
                v: t("k_833")
              }, {
                l: t("k_834"),
                v: t("k_831")
              }].map((stat, i) => <Reveal key={stat.l} delay={i * 100}>
                    <div className={stat.highlight ? t("k_835") : ''} style={{
                  border: '1px solid #E5E7EB',
                  borderRadius: 12,
                  padding: t("k_441"),
                  transition: t("k_836"),
                  cursor: t("k_251"),
                  position: 'relative',
                  overflow: 'hidden'
                }} onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = t("k_837");
                  e.currentTarget.style.borderColor = '#14B8A6';
                }} onMouseLeave={e => {
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.borderColor = '#E5E7EB';
                }}>
                      <div style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: '#9CA3AF',
                    textTransform: t("k_262"),
                    position: 'relative',
                    zIndex: 1
                  }}>{stat.l}</div>
                      <div style={{
                    fontSize: 16,
                    fontWeight: 800,
                    color: '#1A1A1A',
                    marginTop: 4,
                    position: 'relative',
                    zIndex: 1
                  }}>{stat.v}</div>
                    </div>
                  </Reveal>)}
              </div>
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div style={{
            background: '#F9FAFB',
            borderRadius: 28,
            padding: 48,
            border: '1px solid rgba(0,0,0,0.05)'
          }}>
              <div style={{
              fontSize: 18,
              fontWeight: 700,
              marginBottom: 32
            }}>{t("k_213")}</div>
              {[t("k_838"), t("k_839"), t("k_840"), t("k_841")].map(item => <div key={item} style={{
              display: 'flex',
              gap: 14,
              marginBottom: 20,
              alignItems: 'center'
            }}>
                  <div style={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                background: '#CCFBF1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#0D9488',
                fontSize: 14,
                fontWeight: 800
              }}>✓</div>
                  <span style={{
                fontSize: 15,
                color: '#374151',
                fontWeight: 500
              }}>{item}</span>
                </div>)}
            </div>
          </Reveal>
        </div>
      </Section>

      {/* TRACTION & WHY WE WIN */}
      <Section bg="#F3F4F6">
        <SectionHeader eyebrow={t("k_214")} title={t("k_215")} subtitle={t("k_216")} center />
        <div style={{
        display: t("k_286"),
        gridTemplateColumns: t("k_375"),
        gap: 32,
        marginBottom: 64
      }}>
          {[{
          t: t("k_842"),
          d: t("k_843")
        }, {
          t: t("k_844"),
          d: t("k_845")
        }, {
          t: t("k_846"),
          d: t("k_847")
        }].map(item => <div key={item.t} style={{
          textAlign: 'center'
        }}>
              <h3 style={{
            fontSize: 20,
            fontWeight: 700,
            marginBottom: 12
          }}>{item.t}</h3>
              <p style={{
            fontSize: 15,
            color: '#6B7280',
            lineHeight: 1.6
          }}>{item.d}</p>
            </div>)}
        </div>

        <div style={{
        background: '#1F3540',
        borderRadius: 32,
        padding: t("k_848"),
        color: 'white',
        textAlign: 'center'
      }}>
          <h2 style={{
          fontSize: 32,
          fontWeight: 800,
          marginBottom: 40
        }}>{t("k_217")}</h2>
          <div style={{
          display: t("k_286"),
          gridTemplateColumns: t("k_849"),
          gap: 40
        }}>
            {[{
            t: t("k_850"),
            d: t("k_851")
          }, {
            t: t("k_852"),
            d: t("k_853")
          }, {
            t: t("k_854"),
            d: t("k_855")
          }, {
            t: t("k_856"),
            d: t("k_857")
          }].map(item => <div key={item.t}>
                <div style={{
              fontSize: 18,
              fontWeight: 700,
              color: '#14B8A6',
              marginBottom: 8
            }}>{item.t}</div>
                <div style={{
              fontSize: 14,
              color: 'rgba(255,255,255,0.5)'
            }}>{item.d}</div>
              </div>)}
          </div>
          <div style={{
          marginTop: 56
        }}>
            <Btn variant="bright" style={{
            background: '#14B8A6',
            color: '#042F2E'
          }} onClick={() => window.location.href = t("k_272")}>{t("k_218")}</Btn>
          </div>
        </div>
      </Section>
    </div>;
}
const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
  "accentColor": "#FFA567",
  "primaryColor": "#E57500",
  "heroStyle": t("k_858"),
  "showRewardsAnimation": true
} /*EDITMODE-END*/;

// ── GLOBAL FAQ PAGE ──────────────────────────────────────────────────────────
const getGlobalFaqData = () => [{
  "q": t("k_408"),
  "a": t("k_859")
}, {
  "q": t("k_409"),
  "a": t("k_860")
}, {
  "q": t("k_861"),
  "a": t("k_862")
}, {
  "q": t("k_863"),
  "a": t("k_864")
}, {
  "q": t("k_775"),
  "a": t("k_776")
}, {
  "q": t("k_865"),
  "a": t("k_866")
}, {
  "q": t("k_867"),
  "a": t("k_868")
}, {
  "q": t("k_869"),
  "a": t("k_870")
}, {
  "q": t("k_777"),
  "a": t("k_871")
}, {
  "q": t("k_779"),
  "a": t("k_780")
}, {
  "q": t("k_413"),
  "a": t("k_872")
}, {
  "q": t("k_873"),
  "a": t("k_874")
}, {
  "q": t("k_875"),
  "a": t("k_876")
}, {
  "q": t("k_781"),
  "a": t("k_782")
}, {
  "q": t("k_877"),
  "a": t("k_878")
}, {
  "q": t("k_879"),
  "a": t("k_880")
}, {
  "q": t("k_881"),
  "a": t("k_882")
}, {
  "q": t("k_883"),
  "a": t("k_884")
}, {
  "q": t("k_885"),
  "a": t("k_886")
}, {
  "q": t("k_887"),
  "a": t("k_888")
}, {
  "q": t("k_889"),
  "a": t("k_890")
}, {
  "q": t("k_891"),
  "a": t("k_892")
}, {
  "q": t("k_893"),
  "a": t("k_894")
}, {
  "q": t("k_895"),
  "a": t("k_896")
}, {
  "q": t("k_897"),
  "a": t("k_898")
}, {
  "q": t("k_899"),
  "a": t("k_900")
}, {
  "q": t("k_901"),
  "a": t("k_902")
}, {
  "q": t("k_903"),
  "a": t("k_904")
}, {
  "q": t("k_905"),
  "a": t("k_906")
}, {
  "q": t("k_907"),
  "a": t("k_908")
}, {
  "q": t("k_909"),
  "a": t("k_910")
}];
function GlobalFAQItem({
  faq
}) {
  const [open, setOpen] = React.useState(false);
  return <div style={{
    borderBottom: "1px solid rgba(0,0,0,0.07)",
    padding: t("k_418"),
    cursor: t("k_251")
  }} onClick={() => setOpen(!open)}>
      <div style={{
      display: "flex",
      justifyContent: t("k_285"),
      alignItems: "center",
      gap: 16
    }}>
        <div style={{
        fontSize: 16,
        fontWeight: 600,
        color: "#1A1A1A"
      }}>{faq.q}</div>
        <div style={{
        fontSize: 18,
        color: "#B55B00",
        flexShrink: 0,
        transition: t("k_308"),
        transform: open ? "rotate(45deg)" : "none"
      }}>+</div>
      </div>
      {open && <div className="faq-html-content" style={{
      fontSize: 14,
      color: "#6B7280",
      lineHeight: 1.7,
      marginTop: 12,
      marginBottom: 0
    }} dangerouslySetInnerHTML={{
      __html: faq.a
    }} />}
    </div>;
}
function GlobalFAQPage({
  onNavigate
}) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div style={{
    color: "#1A1A1A",
    background: "white"
  }}>
      <SEO title={currentLang === "tc" ? "信用卡交租與網上交租常見問題 FAQ ｜ 手續費、分卡與安全指南 - Keychain" : (currentLang === "sc" ? "Keychain - 智能租務代理 | 常見問題" : "Pay Rent by Credit Card in Hong Kong — Fees, Cards & FAQ | Keychain")} description={currentLang === "tc" ? "解答 Keychain 信用卡交租及網上交租常見疑問：手續費低至 0.8%、SPLIT 分拆 3 張卡付款、滙豐 3.6% 獎賞錢回贈、業主 FPS 直過數及 security 安全保障。" : "Find answers on paying rent by credit card in Hong Kong with Keychain: fees from 0.8%, SPLIT across 3 cards, HSBC RewardCash up to 3.6%, security & landlord direct deposit."} urlPath={`/${currentLang}/faq/`} />
      <style>{`
        .faq-html-content table { width: 100%; border-collapse: collapse; margin-top: 16px; margin-bottom: 16px; }
        .faq-html-content th, .faq-html-content td { border: 1px solid rgba(0,0,0,0.1); padding: 12px; text-align: left; }
        .faq-html-content th { background: rgba(0,0,0,0.03); font-weight: 600; color: #1A1A1A; }
        .faq-html-content a { color: #E57500; text-decoration: none; }
        .faq-html-content a:hover { text-decoration: underline; }
        .faq-html-content p { margin-top: 12px; margin-bottom: 12px; }
        .faq-html-content ul { margin-top: 12px; margin-bottom: 12px; padding-left: 20px; }
      `}</style>
      <section style={{
      background: "linear-gradient(135deg, #1F3540 0%, #2D4E5C 20%, #E57500 80%, #B55B00 100%)",
      padding: t("k_911"),
      textAlign: "center",
      color: "white"
    }}>
        <h1 style={{
        fontFamily: t("k_374"),
        fontSize: t("k_912"),
        fontWeight: 800,
        margin: 0
      }}>{t("k_219")}</h1>
        <p style={{
        fontSize: 18,
        opacity: 0.8,
        marginTop: 16
      }}>{t("k_220")}</p>
      </section>
      <Section bg={t("k_38")}>
        <div style={{
        maxWidth: 860,
        margin: t("k_250")
      }}>
          {getGlobalFaqData().map((faq, i) => <GlobalFAQItem key={i} faq={faq} />)}
        </div>
      </Section>
    </div>;
}
// ── CHATBOT POPUP ────────────────────────────────────────────────────────────
// First-time disclaimer card anchored to bottom-right. After acceptance the
// Flowise embed widget is opened (configured via /dist/chat-ai-init.js).
function openFlowiseChat(retries = 20) {
  if (typeof window === 'undefined') return;
  if (typeof window.openKateChat === 'function' && window.openKateChat()) return;
  // Embed script may not have finished loading yet — retry briefly.
  if (retries > 0) setTimeout(() => openFlowiseChat(retries - 1), 150);
}

function ChatbotPopup({ open, onClose, onNavigate }) {
  const tc = currentLang === 'tc' || currentLang === 'sc';
  const [closing, setClosing] = React.useState(false);
  React.useEffect(() => {
    if (!open) return;
    let alreadyAccepted = false;
    try { alreadyAccepted = localStorage.getItem(CHATBOT_DISCLAIMER_KEY) === '1'; } catch {}
    if (alreadyAccepted) {
      // Skip disclaimer — open Flowise widget directly and dismiss our card.
      openFlowiseChat();
      onClose && onClose();
      return;
    }
    const onKey = (e) => { if (e.key === 'Escape') triggerClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
  const triggerClose = () => {
    setClosing(true);
    setTimeout(() => { setClosing(false); onClose && onClose(); }, 180);
  };
  const handleAccept = () => {
    try { localStorage.setItem(CHATBOT_DISCLAIMER_KEY, '1'); } catch {}
    triggerClose();
    setTimeout(() => openFlowiseChat(), 220);
  };
  const goLegal = (id) => (e) => {
    e.preventDefault();
    triggerClose();
    setTimeout(() => onNavigate && onNavigate(id), 220);
  };
  if (!open) return null;
  const copy = tc ? {
    title: 'Kate',
    subtitle: '您嘅租務助理',
    welcome: '歡迎使用 Kate',
    primary: 'Kate 提供嘅外部資料只供參考，請自行核實。Kate 嘅回覆僅作知識分享，並不構成任何財務或法律意見。如涉及信用卡或回贈相關查詢，請聯絡您嘅發卡機構。',
    bullets: [
      '對話內容可能被記錄及檢閱以改善服務。請勿喺對話中分享敏感資料，例如完整信用卡號碼、密碼或一次性驗證碼。',
      'Kate 唔可以代您完成付款、修改帳戶或讀取您嘅租約資料。',
      '使用 Kate 須遵守我哋嘅服務條款及私隱政策。'
    ],
    accept: '我明白，開始對話',
    cancel: '取消',
    agreePrefix: '繼續即代表您同意我哋嘅',
    tos: '服務條款',
    and: '及',
    privacy: '私隱政策'
  } : {
    title: 'Kate',
    subtitle: 'your rental assistant',
    welcome: 'Welcome to Kate',
    primary: 'Any external content is for reference and should be independently verified. My responses are for knowledge sharing and do not constitute financial or legal advice. For card or rebate inquiries, please refer to your card issuer.',
    bullets: [
      'Conversations may be logged and reviewed to improve our service. Please don\'t share sensitive details such as full card numbers, passwords, or one-time codes.',
      'Kate cannot make payments, modify your account, or access your tenancy data.',
      'Use of Kate is subject to our Terms of Service and Privacy Policy.'
    ],
    accept: 'I understand. Start chat',
    cancel: 'Cancel',
    agreePrefix: 'By continuing, you agree to our',
    tos: 'Terms of Service',
    and: 'and',
    privacy: 'Privacy Policy'
  };
  return <div role="dialog" aria-modal="false" aria-label={copy.title} style={{
      position: 'fixed', right: 'clamp(16px, 3vw, 24px)', bottom: 'clamp(16px, 3vw, 24px)',
      zIndex: 10000, width: 'min(380px, calc(100vw - 32px))',
      animation: closing ? 'kc-chat-out 0.18s ease forwards' : 'kc-chat-in 0.22s cubic-bezier(0.21, 0.6, 0.35, 1) both'
    }}>
      <style>{`
        @keyframes kc-chat-in { from { opacity: 0; transform: translateY(16px) scale(0.98); } to { opacity: 1; transform: translateY(0) scale(1); } }
        @keyframes kc-chat-out { from { opacity: 1; transform: translateY(0) scale(1); } to { opacity: 0; transform: translateY(16px) scale(0.98); } }
        .kc-chat-link { color: #FFA567; text-decoration: none; font-weight: 600; }
        .kc-chat-link:hover { text-decoration: underline; }
      `}</style>
      <div style={{
        width: '100%', maxHeight: 'min(78vh, 640px)',
        background: '#1F3540', borderRadius: 20, overflow: 'hidden',
        display: 'flex', flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0,0,0,0.4), 0 4px 12px rgba(0,0,0,0.18)',
        border: '1px solid rgba(255,255,255,0.08)'
      }}>
        <header style={{
          padding: '12px 16px',
          background: 'linear-gradient(135deg, #1F3540 0%, #2D4E5C 50%, #B55B00 130%)',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          borderBottom: '1px solid rgba(255,255,255,0.08)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 34, height: 34, borderRadius: '50%', background: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}>
              <img src="/uploads/kate_icon.png" alt="Decorative icon" aria-hidden="true" style={{ width: 34, height: 34, objectFit: 'cover' }} />
            </div>
            <div style={{ minWidth: 0 }}>
              <div style={{ color: 'white', fontWeight: 700, fontSize: 14, lineHeight: 1.1, letterSpacing: '-0.01em' }}>{copy.title}</div>
              <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 11.5, marginTop: 2 }}>{copy.subtitle}</div>
            </div>
          </div>
          <button onClick={triggerClose} aria-label={copy.cancel} style={{
            background: 'rgba(255,255,255,0.1)', border: 'none', color: 'white',
            width: 28, height: 28, borderRadius: '50%', cursor: 'pointer',
            fontSize: 18, lineHeight: 1, padding: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: 'background 0.15s'
          }} onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.22)'}
             onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}>×</button>
        </header>
        <div style={{ padding: '20px 22px 18px', overflowY: 'auto', color: 'white', display: 'flex', flexDirection: 'column' }}>
            <h3 style={{ margin: 0, fontSize: 19, fontWeight: 700, letterSpacing: '-0.01em', fontFamily: "'Space Grotesk', sans-serif" }}>{copy.welcome}</h3>
            <div style={{ marginTop: 12, padding: '12px 14px', background: 'rgba(255,165,103,0.1)', border: '1px solid rgba(255,165,103,0.25)', borderRadius: 10, fontSize: 13, lineHeight: 1.6, color: 'rgba(255,255,255,0.92)' }}>
              <span style={{ fontWeight: 700, color: '#FFA567', marginRight: 6 }}>{tc ? '免責聲明：' : 'Disclaimer:'}</span>{copy.primary}
            </div>
            <ul style={{ paddingLeft: 18, marginTop: 12, marginBottom: 0, fontSize: 12.5, lineHeight: 1.55, color: 'rgba(255,255,255,0.78)' }}>
              {copy.bullets.map((b, i) => <li key={i} style={{ marginBottom: 6 }}>{b}</li>)}
            </ul>
            <div style={{ marginTop: 14, fontSize: 11.5, color: 'rgba(255,255,255,0.55)', lineHeight: 1.5 }}>
              {copy.agreePrefix}{' '}
              <a href={tc ? '/tc/terms' : '/terms'} className="kc-chat-link" onClick={goLegal('terms')}>{copy.tos}</a>{' '}{copy.and}{' '}
              <a href={tc ? '/tc/privacy' : '/privacy'} className="kc-chat-link" onClick={goLegal('privacy')}>{copy.privacy}</a>{tc ? '。' : '.'}
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
              <button onClick={triggerClose} style={{
                flex: '0 0 auto', padding: '10px 16px', borderRadius: 10,
                background: 'transparent', color: 'rgba(255,255,255,0.7)',
                border: '1px solid rgba(255,255,255,0.18)', fontSize: 13,
                fontWeight: 600, cursor: 'pointer', transition: 'all 0.15s'
              }} onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.4)'; e.currentTarget.style.color = 'white'; }}
                 onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.18)'; e.currentTarget.style.color = 'rgba(255,255,255,0.7)'; }}>{copy.cancel}</button>
              <button onClick={handleAccept} style={{
                flex: 1, padding: '10px 18px', borderRadius: 10,
                background: 'linear-gradient(135deg, #FFA567 0%, #E57500 100%)',
                color: 'white', border: 'none', fontSize: 13, fontWeight: 700,
                cursor: 'pointer', boxShadow: '0 6px 18px rgba(229,117,0,0.35)',
                transition: 'transform 0.15s, box-shadow 0.15s'
              }} onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 8px 22px rgba(229,117,0,0.45)'; }}
                 onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 6px 18px rgba(229,117,0,0.35)'; }}>{copy.accept}</button>
            </div>
          </div>
      </div>
    </div>;
}

// ── LEGAL PAGES (bilingual EN / TC, except Cookie Policy which stays EN-only) ─
function LegalLayout({ title, subtitle, lastUpdated, onNavigate, children }) {
  React.useEffect(() => { window.scrollTo(0, 0); }, []);
  const tc = currentLang === 'tc' || currentLang === 'sc';
  const labels = {
    lastUpdated: tc ? '最後更新' : 'Last updated',
    backHome: tc ? '← 返回首頁' : '← Back to home',
    backTop: tc ? '↑ 返回頂部' : '↑ Back to top'
  };
  return <div style={{ color: '#1A1A1A', background: 'white' }}>
      <SEO title={title + (tc ? " - 法律文件" : " - Legal")} description={subtitle || "Keychain Pay Legal Document"} urlPath="" />
      <style>{`
        .legal-content h2 { font-family: 'Space Grotesk', sans-serif; font-size: clamp(22px, 2.4vw, 28px); font-weight: 700; color: #1A1A1A; margin-top: 56px; margin-bottom: 16px; letter-spacing: -0.01em; padding-bottom: 12px; border-bottom: 2px solid #FFE8D2; }
        .legal-content h2:first-child { margin-top: 0; }
        .legal-content h3 { font-family: 'Space Grotesk', sans-serif; font-size: 17px; font-weight: 700; color: #1F3540; margin-top: 28px; margin-bottom: 10px; }
        .legal-content h4 { font-size: 15px; font-weight: 700; color: #1F3540; margin-top: 20px; margin-bottom: 8px; }
        .legal-content p { font-size: 15px; line-height: 1.75; color: #374151; margin: 12px 0; }
        .legal-content ul, .legal-content ol { font-size: 15px; line-height: 1.75; color: #374151; padding-left: 24px; margin: 12px 0; }
        .legal-content li { margin-bottom: 8px; }
        .legal-content strong { color: #1A1A1A; font-weight: 600; }
        .legal-content a { color: #E57500; text-decoration: none; }
        .legal-content a:hover { text-decoration: underline; }
        .legal-content table { width: 100%; border-collapse: collapse; margin: 16px 0; font-size: 14px; display: block; overflow-x: auto; }
        .legal-content thead { display: table-header-group; }
        .legal-content tbody { display: table-row-group; }
        .legal-content tr { display: table-row; }
        .legal-content th, .legal-content td { display: table-cell; }
        .legal-content th { background: #042F2E; color: white; padding: 12px; text-align: left; font-weight: 600; border: 1px solid #E5E7EB; }
        .legal-content td { padding: 12px; border: 1px solid #E5E7EB; color: #374151; vertical-align: top; }
        .legal-content td:first-child { font-weight: 600; color: #1A1A1A; background: #F9FAFB; white-space: nowrap; }
        .legal-callout { background: #FFF7ED; border-left: 4px solid #E57500; padding: 16px 20px; border-radius: 8px; margin: 20px 0; font-size: 14px; color: #4B5563; line-height: 1.7; }
        .legal-emphasis { background: #FEF3C7; border-left: 4px solid #B45309; padding: 14px 18px; border-radius: 6px; margin: 16px 0; font-size: 13px; color: #78350F; line-height: 1.65; text-transform: uppercase; letter-spacing: 0.02em; font-weight: 600; }
      `}</style>
      <section style={{ background: 'linear-gradient(135deg, #1F3540 0%, #2D4E5C 20%, #E57500 80%, #B55B00 100%)', padding: '160px 24px 80px', textAlign: 'center', color: 'white' }}>
        <h1 style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 'clamp(36px,4.6vw,58px)', fontWeight: 800, margin: 0, letterSpacing: '-0.02em' }}>{title}</h1>
        {subtitle && <p style={{ fontSize: 18, opacity: 0.85, marginTop: 16, maxWidth: 720, marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.5 }}>{subtitle}</p>}
        {lastUpdated && <p style={{ fontSize: 12, opacity: 0.7, marginTop: 24, letterSpacing: '0.12em', textTransform: 'uppercase', fontWeight: 600 }}>{labels.lastUpdated} · {lastUpdated}</p>}
      </section>
      <Section bg="white">
        <div className="legal-content" style={{ maxWidth: 820, margin: '0 auto' }}>{children}</div>
        <div style={{ maxWidth: 820, margin: '40px auto 0', paddingTop: 24, borderTop: '1px solid #E5E7EB', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, fontSize: 14 }}>
          <a href={`/${currentLang}/home/`} onClick={(e) => { e.preventDefault(); onNavigate && onNavigate('home'); }} style={{ color: '#E57500', textDecoration: 'none', fontWeight: 600 }}>{labels.backHome}</a>
          <a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} style={{ color: '#6B7280', textDecoration: 'none' }}>{labels.backTop}</a>
        </div>
      </Section>
    </div>;
}

function TermsPageEN({ onNavigate }) {
  return <LegalLayout title="Terms of Service" subtitle="The General Terms of Use for Keychain's payment institution services in the United Kingdom." onNavigate={onNavigate}>
      <h2>1. General Terms of Use</h2>
      <h3>1.1 Definitions</h3>
      <p>When used in this Agreement, each of the following words and phrases shall have the meanings set out below:</p>
      <ol>
        <li><strong>"User Profile"</strong> means a User's account created and the data and record thereof for unique identification.</li>
        <li><strong>"Agreement"</strong> means this agreement including these General Terms of Use (including related schedules, policies and other supplemental terms and agreements) subject to which Keychain may make available the App and Services for the User and published at its website, as may be amended from time to time.</li>
        <li><strong>"Business Day"</strong> means Monday through Friday, excluding public holidays and any day when banking services are suspended in the United Kingdom.</li>
        <li><strong>"Debit / credit card Payment"</strong> means the use of the Services in the United Kingdom or other relevant jurisdictions to make a payment of Rent via debit / credit card by the Payer to their Landlord or such relevant third parties where applicable.</li>
        <li><strong>"Direct Debit Payment"</strong> means the use of the Services in the United Kingdom to make a payment of Rent from the Payer's bank account to their Landlord or such relevant third parties where applicable, using a direct debit mandate.</li>
        <li><strong>"United Kingdom"</strong> means England, Wales, Scotland, and Northern Ireland.</li>
        <li><strong>"Payer"</strong> means a party (such as a tenant) who has entered a tenancy agreement, lease, licence agreement or other similar agreement or arrangement for the grant of rights to use real property and/or rights appertaining to real property with a Landlord and who has agreed to use this App and the Services.</li>
        <li><strong>"Payment"</strong> means a Debit / credit card Payment or a Direct Debit Payment made by a tenant to his/her Landlord through this App or the Services.</li>
        <li><strong>"Payment Amount"</strong> refers to the aggregate pound value of a Payment exclusive of the Service Fee.</li>
        <li><strong>"Service Fee"</strong> means the flat percentage fee charged by Keychain to a User on a Debit / credit card Payment made to the User through the Service and/or such other promotional service fee that may be charged to Payer for using the Services to make a Payment to a User. The rate of the fees and charges for the Services are set out and published at the website of Keychain from time to time.</li>
        <li><strong>"Services"</strong> means the internet payment services offered through the App to facilitate the collection of Rent Payments by Landlords.</li>
        <li><strong>"Paying Bank"</strong> means the tenant's debit / credit card issuing bank or payment gateway — Stripe through which a payment is made for the Payer.</li>
        <li><strong>"Users"</strong> means persons or entities using Keychain Services or App as a Landlord or Payer and "you" shall refer to the User who has registered to use the Keychain Services or App.</li>
        <li><strong>"App"</strong> means online application and/or the website provided or operated by Keychain or its associates located at www.keychainpay.com and all related webpages as well as any further app or any other media in an electronic form supplemental to or in lieu of the current App.</li>
        <li><strong>"Landlord"</strong> means the property owner, operator, letting agent or property manager.</li>
        <li><strong>"Rent"</strong> means amounts payable to a Landlord by a Payer, including without limitation, security deposit, rent, licence fee, condominium, and other property management fees, and other charges and disbursements.</li>
      </ol>

      <h3>1.2 Services Overview</h3>
      <p>Keychain Services allows the User to register to make or receive online payments using debit / credit cards, Apple Pay or Google Pay in relation to Rent payments for the use of real property or rights appertaining to real property in the United Kingdom.</p>

      <h3>1.3 Governing Law and Jurisdiction</h3>
      <p>This Agreement shall be governed by and interpreted in accordance with the laws of England and Wales and the parties hereby submit to the exclusive jurisdiction of the English courts to settle any dispute arising out of or in connection with this Agreement.</p>

      <h2>2. User Obligations and Representations</h2>
      <p>As a condition of your use of this App or Services, you agree, represent and warrant that:</p>

      <h3>2.1 Compliance</h3>
      <p>Your use of this App or Services will at all times comply with this Agreement.</p>

      <h3>2.2 Account Creation and Use</h3>
      <p>If you elect to create an account:</p>
      <ul>
        <li>(a) You may create only one account for your commercial use.</li>
        <li>(b) You may only use this App or the Services to undertake genuine and lawful transactions.</li>
        <li>(c) You must safeguard your password and supervise the use of your account, and accept and agree that you are responsible for the use of your account by anyone you allow or suffer to access it with your password. Your Touch ID / Face ID may be required when you login this App in iPhone.</li>
      </ul>
      <p>If you are not willing or are unable to comply, you must not use the App or the Service. Keychain has policies and measures to randomly check and inquire into the authenticity of the information provided by a User, and may suspend its access to and use of the App and Services if and when that User refuses to cooperate or Keychain has reasonable reservation or doubt as to the authenticity of material information provided by the User.</p>

      <h3>2.3 Information Accuracy and Rights</h3>
      <p>You represent that you have the right and capacity to provide all information you submit to Keychain, without infringing any right or privacy of others or in breach of any restrictions you are subject to, and that all such information is and will remain accurate, true, current and complete.</p>

      <h3>2.4 Discretionary Access Rights</h3>
      <p>Keychain reserves the rights to refuse or suspend anyone or any User to use the App or the Service in its absolute discretion.</p>

      <h2>3. Receiving Payments</h2>
      <h3>3.1 Role of Keychain and Responsibilities of User</h3>
      <p>Keychain, as a payment institution (Reference number: 967989) registered and regulated by the Financial Conduct Authority (FCA) in the United Kingdom, provides hosting and data processing services for property managers, letting agents, and landlords either directly or through their authorized representatives. Keychain explicitly states that it operates solely as a payment service provider and does not hold itself out as offering property or estate agency services, banking services, remittance agent services, or operating payment systems as defined by UK laws and regulations.</p>
      <p>In the course of providing its services, Keychain collects, analyzes, and transmits information related to payment transactions between payers and recipients. By using our services, you authorize Keychain to disclose such information to your designated bank or other entities as necessary to facilitate payment transactions.</p>
      <p>Keychain acts solely as a facilitator in collecting payments on behalf of Landlords from their tenants (Payers) through authorized payment channels, including debit / credit cards, Apple Pay, or Google Pay. However, it should be noted that Keychain cannot guarantee the punctuality or completeness of payments made by tenants.</p>
      <p>Upon receipt of payments from Payers, Keychain will promptly remit the balance, after deducting applicable Service Fees, to the designated account of the recipient Landlord. Payment remittance typically occurs within fourteen (14) calendar days from the date of receipt. It is important to note that all payments made by Keychain are subject to recourse in the event of legitimate claims from other parties.</p>
      <p>In carrying out its activities, Keychain is committed to compliance with all relevant laws and regulations, including but not limited to the General Data Protection Regulation (GDPR) (EU) 2016/679, as incorporated into UK law by the Data Protection Act 2018, the Payment Services Regulations 2017, and applicable Financial Conduct Authority guidelines. We prioritize transparency, data security, and client fund protection in our operations to ensure the trust and confidence of our users.</p>

      <h3>3.2 Service Fee</h3>
      <p>Upon receiving a Payment from a Payer to you as the Landlord, Keychain will charge a non-refundable Service Fee on the Payment (and will deduct the relevant amount of the Service Fee from the total Payment received) before remitting the balance of the Payment to you (which balance shall be paid into such Landlord bank accounts as you may designated in the App from time to time).</p>

      <h3>3.3 Taxes</h3>
      <p>It is your sole responsibility to ascertain what taxes may be charged or payable by you for the Payments Keychain collects on your behalf or pays to you, and it is your sole responsibility to collect, report, file returns and remit the applicable tax to the relevant authority. Keychain is not responsible for inquiring and determining whether taxes are payable for your Payment transactions, or for collecting, reporting or remitting any taxes arising from your Payment transactions.</p>
      <p>Should you require additional tax reporting services beyond the standard provision outlined above, such services will incur additional fees. The fees for such services will be subject to negotiation and agreement between you and Keychain, taking into consideration the specific tax requirements applicable in the United Kingdom.</p>

      <h3>3.4 Debit / credit card Delays and Non-Completion</h3>
      <p>You acknowledge and accept that Debit / credit card Payment processing times depend on administrative factors and institutional backlogs which are beyond the control of Keychain. Debit / credit card Payments initiated by Payers may take at least five (5) Business Days or such longer period as Keychain may notify you. Furthermore, completion of a Debit / credit card Payment is contingent on both the authorisation of the Debit / credit card Payment and acceptance of the Debit / credit card Payment. In the event that Payment from a Debit / credit card is unable to be completed, Keychain will use its reasonable efforts to notify you up to two weeks in advance (before the Rent payment is due) through this App or using the contact information in your User Profile. Any delay or non-completion of Payments and all claims and liabilities arising therefrom are to be resolved exclusively between you and the Payer (and/or your tenant) and Keychain shall have no liability in this regard unless it is caused by any omission, negligence or default of Keychain. Any penalties, late fees, and interest charges applied against a late Payment are solely the responsibility of the Payer and Keychain shall have no liability in this regard unless it is caused by any omission, negligence or default of Keychain.</p>
      <div className="legal-emphasis">Keychain makes no warranty or guarantee as to the timely payment of any amounts and assumes no responsibility or liability due or owing to or resulting from any delay that is caused by the Payer, the Landlord, any third party, or which is outside of the reasonable control of Keychain or which arises or results from the default, negligence or act or omission of the Payer or other parties.</div>

      <h3>3.5 No Reversals</h3>
      <p>Keychain's Services are completed for a transaction upon a Payment having been deposited into your designated bank account. You accept and agree that Keychain will not provide any refund, cancellation or charge-back of a Payment or Service Fees or any part thereof, save and except for any error or omission on the part of Keychain.</p>

      <h3>3.6 Payment Limits</h3>
      <p>Keychain may, at its sole discretion, from time to time impose and adjust limits on the amount of each individual Payment or the aggregate amount of Payments you may receive through this App or Services, which is reasonable in the opinion of Keychain having taken into account the amounts of Rent payable. Provided that Keychain will use its reasonable efforts to provide prior written notice of at least one month before the imposition or adjustment of such a limit.</p>

      <h3>3.7 Money in Transit</h3>
      <p>All funds collected from Payers in transit will be held in dedicated client bank accounts maintained by Keychain in accordance with the safeguarding requirements outlined by the FCA for payment institutions. These accounts will ensure proper segregation from any other operational funds of Keychain, and will be managed in compliance with the applicable regulations and guidelines set forth by the FCA.</p>
      <p>Keychain will use its best efforts to adhere to the safeguarding requirements and ensure the security of these funds. Any additional measures or arrangements requested by a User must comply with the terms and conditions specified by Keychain and meet the regulatory standards established by the FCA.</p>

      <h3>3.8 Insufficient Funds or Credit</h3>
      <div className="legal-emphasis">Keychain is not responsible for the payment of Rent or fees to you by a Payer. Keychain only facilitates the processing of such payment. Any failure or inability on the part of a Payer to make payment is the sole responsibility of such Payer. Keychain shall not be liable, in any way, for any failure or inability of a Payer to make a Payment to you, including but not limited to situations where a Payer has insufficient fund or credit available to make a Payment to you as a result of Keychain charging any applicable Service Fee for use of the Services.</div>

      <h3>3.9 Default and Fraudulent Transactions</h3>
      <p>Keychain may suspend or terminate a User's account if Keychain reasonably suspects or believes, or is advised by any competent authority that any transaction or Payment of, or relating to the User is a sham, or is fraudulent, illegal or for or facilitating unlawful or immoral ends and activities (or otherwise breaches any applicable regulation or law). Keychain shall also be at liberty to report the case and disclose all information and records to the competent authorities.</p>
      <p>In case a suspicious payment is detected or alerted from a card acquirer, Keychain reserves the final decision in holding the payout of the Payment and issuing a refund to avoid a dispute. If a dispute has been raised to Keychain in relation to a fraudulent payment made by a stolen or unauthorized card, the Landlord User is obligated to pay back all related transaction amounts and transaction fees (including any fees levied by the card-issuing bank and any costs incurred by Keychain in resolving the dispute in such amount agreeable to the Landlord User) to Keychain in 45 business days upon request accompanied with supporting evidence.</p>

      <h3>3.10 Additional Charges and Disbursements</h3>
      <p>Tenants acknowledge and agree that, in addition to the monthly rent, they may be responsible for additional charges as specified by the landlord or property manager. These charges can include, but are not limited to, cleaning fees, maintenance costs, and other related expenses. Such charges will be treated as disbursements and will be processed through the Keychain platform in accordance with the terms set forth in the tenancy agreement or as notified by the landlord or property manager.</p>

      <h2>4. Receiving Payments</h2>
      <p>When a Payment is made to you using the Services, the Payment Amount will be transferred into such bank account as is designated by you and/or your agent, subject to the terms herein or any such other agreement that you may be required to enter into with Keychain.</p>

      <h2>5. Termination</h2>
      <h3>5.1 By Notice</h3>
      <p>You shall give Keychain not less than 10 Business Days' notice (via the App) in advance to terminate the Payment arrangement when the relevant agreement between you and the Payer is to be terminated or is due to expire. Failure to provide the required notice period may result in a further Payment being taken from the Payer (and Keychain shall have no liability to you in respect of this Payment, other than to remit the Payment balance to you in the usual way). If the Payer disputes the Payment then you shall resolve this directly with the Payer without any liability to Keychain.</p>

      <h3>5.2 Termination by Payer</h3>
      <p>The Payment arrangement will also be terminated after the Payer has given notice to Keychain to terminate the Payment arrangement and Keychain shall duly inform the Landlord User of such termination within 7 days after receipt of the termination notice from the Payer.</p>

      <h3>5.3 Email Notification</h3>
      <p>Where it is reasonable and practicable in the circumstances, Keychain will advise the Payer via email that a notice of termination has been received from you, and when the Payment arrangement will cease to operate, within 2 Business Days after Keychain has received the notice of termination from the Payer.</p>

      <div className="legal-callout">
        Questions about these Terms? Contact us at <a href="mailto:enquiry@keychainpay.com">enquiry@keychainpay.com</a>.
      </div>
    </LegalLayout>;
}

function PrivacyPageEN({ onNavigate }) {
  return <LegalLayout title="Privacy Policy" subtitle="How KeyChain FinTech (UK) Limited collects, uses, and safeguards your personal information." lastUpdated="May 2024" onNavigate={onNavigate}>
      <h2>Privacy Statement for Keychain</h2>

      <h3>Data Controller</h3>
      <p>KeyChain FinTech (UK) Limited manages personal information for Keychain and related services in accordance with applicable data protection laws.</p>

      <h3>Information Collected</h3>
      <h4>Contact Data</h4>
      <ul>
        <li>Name, phone, email, address (tenant only), social media handles</li>
      </ul>
      <h4>Payment Data</h4>
      <ul>
        <li>Debit / credit card issuing bank (tenant only, not Apple Pay / Google Pay)</li>
        <li>Card last 4 digits (tenant only, not Apple Pay / Google Pay)</li>
        <li>Bank name, beneficiary name, account number (landlord only)</li>
        <li>Full card numbers processed by PCI-compliant gateway, not retained</li>
      </ul>
      <h4>Device Data</h4>
      <ul>
        <li>Computer / tablet / mobile device type</li>
        <li>Unique device identifier (IMEI, MAC address)</li>
        <li>IP address, mobile network information, operating system</li>
        <li>Browser type, plugins, timezone, access technology</li>
      </ul>
      <h4>Usage Data</h4>
      <ul>
        <li>Website / service usage details, traffic data, communication records, browsing patterns</li>
      </ul>

      <h3>Collection Methods</h3>
      <p>Information provided directly through Keychain or received from third parties like landlords and analytics providers.</p>

      <h3>Special Categories</h3>
      <p>We do not collect any special categories of Personal Information, or any information about criminal convictions from website visitors.</p>

      <h3>Use of Personal Information</h3>
      <p>The company processes data under these lawful bases:</p>
      <table>
        <thead><tr><th>Purpose</th><th>Data Types</th><th>Legal Basis</th></tr></thead>
        <tbody>
          <tr><td>User registration & service access</td><td>Contact, Device</td><td>Consent; Contract performance</td></tr>
          <tr><td>Relationship management & notifications</td><td>Contact</td><td>Consent; Contract; Legitimate interests; Legal compliance</td></tr>
          <tr><td>Payment processing</td><td>Contact, Payment</td><td>Consent; Contract; Legitimate interests</td></tr>
          <tr><td>Business administration & security</td><td>Contact, Device</td><td>Legitimate interests</td></tr>
          <tr><td>Analytics & service improvement</td><td>Device, Usage</td><td>Legitimate interests</td></tr>
          <tr><td>Customer inquiries & support</td><td>Contact, Device, Usage</td><td>Legitimate interests</td></tr>
          <tr><td>Product recommendations</td><td>Contact, Device, Usage</td><td>Legitimate interests</td></tr>
        </tbody>
      </table>

      <h3>Third-Party Disclosures</h3>
      <p>Personal information shared with:</p>
      <ul>
        <li>Subsidiaries and affiliates</li>
        <li>Service providers and payment gateways</li>
        <li>Professional advisors (lawyers, bankers, auditors, insurers)</li>
        <li>Financial Conduct Authority, HMRC, UK regulators</li>
        <li>Potential business acquirers or merger partners</li>
      </ul>
      <p>This does not include selling, renting, sharing, or otherwise disclosing Personal Information for commercial purposes in violation of this Privacy Statement.</p>
      <p>The company may disclose information when required by law, court order, or to protect rights and safety.</p>

      <h3>International Data Transfers</h3>
      <p>Business operations span the UK and other countries. Data transfers outside the UK are protected by:</p>
      <ul>
        <li>Transfer to countries with adequate data protection</li>
        <li>Approved contracts providing UK-equivalent protection</li>
      </ul>
      <p>Contact: <a href="mailto:reg_compliance@keychainpay.com">reg_compliance@keychainpay.com</a></p>

      <h3>Data Retention</h3>
      <p>Information retained for periods necessary to fulfill stated purposes or as required by law.</p>

      <h3>Security</h3>
      <p>The company adheres to the Payment Card Industry Data Security Standard (PCI DSS). Information is securely processed, stored and archived in databases and backups which may reside outside jurisdiction, including Hong Kong Special Administration.</p>

      <h3>Risk Management</h3>
      <p>There is always the possibility that Keychain could be mis-used as a tool for hacking and / or phishing and / or money laundering. The company uses payment tokenization, replacing card numbers with unique digital tokens, to reduce fraud threats.</p>

      <h3>Your Legal Rights</h3>
      <h4>Data Access</h4>
      <p>Right to check whether the company holds personal information or request access; corrections available upon request; no fee unless request is manifestly unfounded / excessive.</p>
      <h4>Erasure, Restriction, Objection</h4>
      <p>Right to request data erasure, processing restriction, or object to processing in certain circumstances.</p>
      <h4>Data Portability</h4>
      <p>Right to request transfer to third parties or machine-readable copies (applies to automated information provided with consent or used for contract performance).</p>

      <h3>Contact Information</h3>
      <div className="legal-callout">
        <p style={{ margin: '4px 0' }}><strong>Data Requests & Legal Rights</strong></p>
        <p style={{ margin: '4px 0' }}>KeyChain FinTech (UK) Limited<br />Email: <a href="mailto:reg_compliance@keychainpay.com">reg_compliance@keychainpay.com</a></p>
        <p style={{ margin: '12px 0 4px' }}><strong>General Privacy Questions</strong></p>
        <p style={{ margin: '4px 0' }}>Email: <a href="mailto:enquiry@keychainpay.com">enquiry@keychainpay.com</a></p>
      </div>
    </LegalLayout>;
}

function UserTermsPageEN({ onNavigate }) {
  return <LegalLayout title="User Terms" subtitle="Terms governing the use of Keychain's app and services in Hong Kong by tenants and landlords." onNavigate={onNavigate}>
      <h2>About Keychain App and Services</h2>
      <p>Keychain operates app and online services and platform to facilitate rent, licence fee and similar periodic payments payable for the use of real property in Hong Kong be paid by the paying party (generally a tenant) to his landlord.</p>
      <p>The App and Services are efficient means for collecting rent, deposit, disbursement or similar payments to be made periodically over a period of time from the user (tenant) granted with that right to use real property or rights appertaining to real property in Hong Kong (including but without limitation to residential and non-residential units, co-living spaces, co-working spaces, car parking spaces, advertising boards and signs, business centre, serviced offices or business booth sharing).</p>
      <p>The smooth and effective collection and payment of the rent will rely on the voluntary cooperation of the payer, and the operation and support of payment services provided and operated by third parties services providers.</p>
      <p>Keychain will levy services charges (usually 2.9%) for such payment services. Keychain is only collecting the payments as agent for the relevant user (generally a landlord) and will pay to the landlord on a pay-when-paid basis with recourse.</p>
      <p>Keychain also offers other free of charge Services to its Users for ease of analysis and recording rental payments. The terms and conditions for the use of Keychain App and Services are set out hereinbelow.</p>

      <h2>Tenants and Landlords</h2>
      <p>Your use of the Services offered by KeyChain FinTech Limited, a company incorporated in Hong Kong ("Keychain", which expression shall include, where applicable, its partners, affiliates and associates) is subject to and governed by terms and conditions set out by Keychain and is a binding agreement between you and Keychain ("this Agreement").</p>
      <div className="legal-emphasis">Please read this Agreement carefully. It is a legal and enforceable contract between you and Keychain. In order to use the Services, you must read, agree with and accept all of the terms and conditions contained in this Agreement.</div>
      <p>In addition, you must read in conjunction and agree with and accept our:</p>
      <ul>
        <li>General Terms of Use, available at: <a href="/terms" onClick={(e) => { e.preventDefault(); onNavigate && onNavigate('terms'); }}>www.KeyChainPay.com/terms.html</a></li>
        <li>Privacy Policy, available at: <a href="/privacy" onClick={(e) => { e.preventDefault(); onNavigate && onNavigate('privacy'); }}>www.KeyChainPay.com/privacy.html</a></li>
      </ul>
      <p>By using the Services, or by clicking the "I Accept" button, you: (1) agree to be bound by this Agreement, including all amendments and modifications Keychain may make from time to time; (2) represent and warrant that, if you are an individual, you have the capacity to contract, you are not an undischarged bankrupt or, if you are acting on behalf of a third party (natural person(s), entity or partnership) (the "Principal"), that you have power and authority to bind the Principal, and in case of an entity also that entity is a corporation, or other legal entity duly established and existing in good standing; and (3) represent and warrant that the User has the power and authority to enter into this Agreement and perform acts as required under this Agreement. If you (as User) permit or enable another party to access and operate your account, the User shall be bound by the acts of that third party. If you are accessing and / or operating an account on behalf of a User you agree that these terms apply, mutatis mutandis, to your activities on behalf of the User and that you are duly authorised by the User to enter into this Agreement on his behalf.</p>
      <p>If you do not agree to be bound by the terms of this Agreement, do not react to the "Slide to Accept" button, otherwise indicate refusal and do not use the Services.</p>

      <h2>1.1 Definitions</h2>
      <p>When used in this Agreement, each of the following words and phrases shall have the meanings set out below:</p>
      <ul>
        <li>(a) <strong>"User"</strong> means, in this part, the party using the App or Services as a Landlord or a Tenant.</li>
        <li>(b) <strong>"User Profile"</strong> means a User's account created and the data and record thereof for unique identification.</li>
        <li>(c) <strong>"Agreement"</strong> means these Terms of Use, including related schedules, policies and other supplemental terms and agreements subject to which Keychain may make available the App and Services for the User and published at its website, as may be amended from time to time.</li>
        <li>(d) <strong>"Business Day"</strong> means Monday through Friday, excluding public holidays and any day when banking services is suspended in Hong Kong.</li>
        <li>(e) <strong>"Credit Card Payment"</strong> means and refers to the use of the Services in Hong Kong or other relevant jurisdictions to make a payment of rents or fees via credit card by tenants to their Landlords or such relevant third parties where applicable.</li>
        <li>(f) <strong>"Direct Debit Payment"</strong> means and refers to the use of the Services in Hong Kong or other relevant jurisdiction to make a payment of rents or fees via cash, paper cheque or transfer via bank account of tenants to their Landlords or such relevant third parties where applicable.</li>
        <li>(g) <strong>"Hong Kong"</strong> means the Special Administrative Region of Hong Kong of The People's Republic of China.</li>
        <li>(h) <strong>"Merchant Account"</strong> means a merchant account established at the Paying Bank into which one or more Payments may be made.</li>
        <li>(i) <strong>"Payer"</strong> means a party who has entered a tenancy agreement, lease or other similar agreement or arrangement for the grant of right to use real property and / or rights appertaining to real property and has agreed to use this App or the Services. In this part, generally refers to you, as tenant.</li>
        <li>(j) <strong>"Payment"</strong> means a Credit Card Payment or a Direct Debit Payment made by a tenant to a landlord through this App or the Services.</li>
        <li>(k) <strong>"Payment Amount"</strong> refers to the aggregate Hong Kong dollar value of a Payment exclusive of the Service Fee.</li>
        <li>(l) <strong>"Service Fee"</strong> means the flat percentage fee charged by Keychain to you on Credit Card Payment made by Tenant through this App or the Service or such other promotional device fee that may be charged to you for using the Services to make a Payment to Landlord or its agent. The rate of the fees and charges for the Services are set out and published at the website of Keychain from time to time.</li>
        <li>(m) <strong>"Services"</strong> shall include the internet Payment services offered through the App to facilitate the collection of certain payments by landlords, property owners and property managers including rent, condominium, and other property management fees.</li>
        <li>(n) <strong>"Paying Bank"</strong> means the tenant's credit card issuing bank or payment gateway through which payment will be made.</li>
        <li>(o) <strong>"Users"</strong> means persons or entities using our Services or the App.</li>
        <li>(p) <strong>"App"</strong> means online application and / or the website provided or operated by Keychain or its associates and all related webpages as well as any further app or any other media in an electronic form supplemental to or in lieu of the current App.</li>
      </ul>

      <h3>1.2 Service Registration</h3>
      <p>Keychain Service and / or App allows Users to register oneself to make online payment services through credit cards, Apple Pay or Google Pay to Keychain for that User's own use or for other's use of real property or rights appertaining to real property in Hong Kong.</p>
      <div className="legal-emphasis">Keychain is not liable, in any way, for your fraudulent or wilful action to make payments to anyone in any situation where you are not deemed lawful.</div>

      <h3>1.3 Governing Law</h3>
      <p>This Agreement shall be governed by and interpreted in accordance with the laws of Hong Kong.</p>

      <h2>2. Conditions of Use</h2>
      <p>As a condition of your use of this App or Services, you agree, represent and warrant that:</p>

      <h3>2.1 Compliance</h3>
      <p>Your use of this App or Services will at all times comply with this Agreement.</p>

      <h3>2.2 Account Creation</h3>
      <p>If you elect to create an account:</p>
      <ul>
        <li>(a) You may create only one account for your personal use.</li>
        <li>(b) You may only use this App or the Services to undertake genuine and lawful transactions.</li>
        <li>(c) You must safeguard your password and supervise the use of your account, and accept and agree that you are responsible for the use of your account by anyone you allow or suffer to access it with your password. Your Touch ID / Face ID may be required when you login this App in iPhone.</li>
      </ul>
      <p>If you are not willing or are unable to comply, you could not use the App or the Service. Keychain has policy and measures to randomly check and inquire into the authenticity of the information provided by a User, and may suspend its access to and use of the App and Services if and when that User refuses to cooperate or Keychain has a reasonable reservation or doubt to the authenticity of material information.</p>

      <h3>2.3 Information Accuracy</h3>
      <p>You represent that you have the right and capacity to provide all information you submit to Keychain, without infringing any right or privacy of others or in breach of any restrictions you are subject to, and that all such information is and will remain accurate, true, current and complete.</p>

      <h3>2.4 Right to Refuse Service</h3>
      <p>Keychain reserves the rights to refuse or suspend anyone or any User to use the App or the Service in its absolute discretion.</p>

      <h2>3. Settlement & Receiving Payments</h2>
      <h3>3.1 Role of Keychain and Responsibilities of Users</h3>
      <p>Keychain provides hosting and data processing services for property owners, landlords themselves directly or through their authorised and appointed property managers. Keychain is only providing a service to facilitate transactions and does not offer or hold out itself as providing any property or estate agency services, banking services, remittance agent or payment systems as defined by the applicable laws or the law of Hong Kong. It is an intrinsic part of operating the Services and this App that Keychain is to collect, analyse and relay information generated in connection with payments between the Payer and the Landlord. You authorise Keychain to disclose such information to your own bank or other entities as may be designated by you in order for the Paying Bank to facilitate the transactions between the Landlord and the Payer.</p>
      <p>For Landlord, Keychain is only collecting payments on your behalf from your tenant through the Paying Bank, and where applicable through or with the assistance of credit card or Apple Pay or Google Pay. Keychain makes no assurance that your tenant will punctually or fully make the payments as and when due. Keychain will pay the balance (after deducting Service Fee) of payment actually received by Keychain to your designated account as soon as reasonably practicable in the circumstances, and usually within seven (7) to ten (10) calendar days after receipt in normal cases. All payments by Keychain to you are subject to recourse, should there be legitimate claim from other parties.</p>
      <p>For Tenant, Keychain could only make the Payment Amount to the bank account designated by your landlord when and after through this App and the Services your Payment has been effected between the Paying Bank, and the respective banks of Keychain and the bank of your landlord. Keychain takes no part and has no role in the transaction between you and the Paying Bank, and settlement of funds between Paying Bank and you.</p>

      <h3>3.2 Service Fee</h3>
      <p>Upon receiving a Payment, Keychain will charge a non-refundable Service Fee (usually 2.9%) and the relevant amount will be deducted and appropriated by Keychain every time on or before making a Payment to Landlord per the Services. Service Fee is payable in addition to (and immediately after) the Payment Amount, and will be deducted from or adjusted against Payment amounts before remittance. Service Fee is to be paid into such bank accounts as may be designated by Keychain from time to time.</p>

      <h3>3.3 Settlement Date</h3>
      <p>Immediately after a payer makes a Payment to Keychain using this App or the Services, Keychain will charge the payer's card a non-refundable amount based on the rent and transaction fee if applicable agreed between tenants and landlords. The transaction fee is payable by the tenant and the landlord, based on the condition being chosen by both parties. In case of Credit Card Payment, normally the payer will be only required to settle the rental payment when the payer is requested by the card issuing bank to do so according to the following settlement date per the agreement between the payer and the card issuing bank and as shown on the credit card statement.</p>

      <h3>3.4 Taxes</h3>
      <p>It is your sole responsibility to ascertain what taxes may be charged or payable by you for the Payments Keychain collects or pays to you, and it is your sole responsibility to collect, report, file returns and remit the applicable tax to the relevant authority. Keychain is not responsible for inquiring and determining whether taxes are payable for your Payment transactions, or for collecting, reporting or remitting any taxes arising from your Payment transactions.</p>

      <h3>3.5 Credit Card Delays and Non-Completion</h3>
      <p>You acknowledge and accept that Credit Card Payment processing times depend on administrative factors and institutional backlogs which are beyond the control of Keychain. For landlord, Credit Card Payments initiated by Payers may take at least seven (7) Calendar Days or such longer period as Keychain may notify you. For tenant, your Credit Card Payments will be made immediately once you accept the Smart Contract or automatically be processed around fourteen (14) Calendar Days in advance to the leasing effective date of each month stated in the App. The exact date of card charge for a recurring payment is depending on your historical payment record and credit card status. Keychain may notify and remind you to follow up and complete. Furthermore, completion of a Credit Card Payment is contingent on both the authorization of the Credit Card Payment and acceptance of the Credit Card Payment. In the event that a Credit Card Payment is unable to be completed, Keychain will attempt to notify you as soon as reasonable practicable through this App or using the contact information in your User Profile. All cases of delay or non-completion and all claims and liabilities arising therefrom should be matters and affairs entirely between the landlord and the tenant. Any penalties, late fees, and interest charges applied against a late Payment are solely the responsibility of the Payer.</p>

      <h3>3.6 No Reversals</h3>
      <p>The services of Keychain is completed for a transaction upon a Payment has been deposited into the landlord's bank account, and you accept and agree that this App and Services provide no refund, cancellation or charge-back of a Payment or Service Fees or any part thereof. You accept and agree in no event Keychain shall be answerable or responsible for any Payment made but which could be avoided or cancelled as between tenants and landlords including all bank, transaction and service fees or charges thus arising.</p>

      <h3>3.7 Credit Card Security</h3>
      <p>Credit Card Payment requires the processing, transmission, or storage of credit card data, and will be handled, for security benefit and protection to you, through using Transport Layer Security (TLS) so that HTTPS may be made use of for complying with the Payment Card Industry Data Security Standards (PCI DSS). Keychain will not keep your full credit card number in our server but only (i) the authorised token in case of Apple Pay or Google Pay, or (ii) the card issuing bank and the last 4 digits of your credit card number. Your card holder name input will be used for compliance check. Full credit card information will be processed, checked and kept in the Payment Gateway with PCI Compliance.</p>

      <h3>3.8 Payments Limit</h3>
      <p>Keychain may, at its sole discretion, from time to time impose and adjust limits on the amount of each or aggregate Payment you may receive through this App or Services, which is reasonable in the opinion of Keychain having taken into account the amounts of rent payable.</p>

      <h3>3.9 Money in Transit</h3>
      <p>All the money collected from Payers in transit will be kept in dedicated client deposit bank account of Keychain with proper segregation from any other operation funds of Keychain in accordance with the rules and policy Keychain may deem reasonably appropriate and practicable and adopt from time to time. Additional measures and arrangements may be agreed and arranged at the request of a User, and on terms and conditions accepted by Keychain.</p>

      <h3>3.10 Insufficient Funds or Credit</h3>
      <div className="legal-emphasis">Keychain is not responsible for the payment of rent or fees to a landlord (or its agent) by a Payer. Keychain only facilitates the processing of such payment. Any failure or inability on the payment made or settlement of repayment is the sole responsibility of such Payer. Keychain shall not be liable, in any way, for any failure or inability of a Payer to make a Payment to a landlord, including but not limited to situation where a Payer has insufficient fund or credit available to make a Payment to a landlord as a result of Keychain charging any applicable Service Fee for use of the Services.</div>

      <h3>3.11 Default and Fraudulent Transactions</h3>
      <p>Keychain may suspend or terminate a User's account if Keychain reasonably suspects or believe, or is advised by any competent authority that any transaction or Payment of or relating to the User is a sham, or is fraudulent, illegal or for or facilitating unlawful or immoral ends and activities. Keychain shall also be at liberty to report the case and disclose all information and record related to the competent authorities.</p>

      <h3>3.12 Receiving Payments</h3>
      <p>You may only receive Payments from Payers who have agreed to General / Payer Terms of Use, available at www.KeyChainPay.com and its services providers (as applicable). When a Payment is made to you using the Services, the Payment Amount will be transferred into bank account as designated by you and / or your Payer, subject to the terms herein or any such other agreement that you may be required to enter into with Keychain.</p>

      <h3>3.13 Additional Charges and Disbursements</h3>
      <p>Tenants acknowledge and agree that, in addition to the monthly rent, they may be responsible for additional charges as specified by the landlord or property manager. These charges can include, but are not limited to, cleaning fees, maintenance costs, and other related expenses. Such charges will be treated as disbursements and will be processed through the Keychain platform in accordance with the terms set forth in the tenancy agreement or as notified by the landlord or property manager.</p>

      <h2>4. Termination</h2>
      <h3>4.1 By Notice</h3>
      <p>You shall give Keychain notice in advance to terminate the Payment arrangement when the relevant agreement between the Landlord and the Tenant is to be terminated or early terminated. Notice shall be given through the App, and at least 1 calendar month in advance.</p>

      <h3>4.2 Termination by Tenant or Landlord</h3>
      <p>The Payment arrangement will also be terminated after the Tenant or the Landlord has given notice to Keychain to terminate the Payment arrangement.</p>

      <h3>4.3 Email Notification</h3>
      <p>Where it is reasonable and practicable in the circumstances, Keychain will through email advise the User that a notice of termination has been received, and when the Payment arrangement will cease to operate.</p>

      <div className="legal-callout">
        Questions about these User Terms? Contact us at <a href="mailto:enquiry@keychainpay.com">enquiry@keychainpay.com</a>.
      </div>
    </LegalLayout>;
}

function TermsPageTC({ onNavigate }) {
  return <LegalLayout title="服務條款" subtitle="Keychain 應用程式及服務之一般使用條款。" onNavigate={onNavigate}>
      <h2>應用程式可用性</h2>
      <ol>
        <li>應用程式可能因超出控制範圍的情況發生中斷。儘管盡合理努力保持可用性，但該應用程式可能因任何原因（包括常規維護或系統升級）而暫時不可用。本公司有權自行決定在任何時間拒絕任何人或帳戶使用本應用程式。</li>
        <li>本公司對應用程式的運作保留完全酌情權，包括：
          <ul>
            <li>如用戶在政策規定時間內未被訪問，則刪除通信或私人消息</li>
            <li>向第三方提供與應用程式和用戶相關的資訊</li>
            <li>撤銷、暫停或中止應用程式的任何功能或服務</li>
            <li>審查上載的文件、會議、博客、論壇、聊天和用戶提交的內容</li>
          </ul>
        </li>
      </ol>

      <h2>應用程式的擁有權</h2>
      <p>閣下必須經授權才能使用服務。應用程式及其內容、信息、基礎設施和所有知識產權為本公司及其許可方的專有財產。除本協議明確規定外，閣下不得修改、複製、分發、展示、執行或創建衍生作品。</p>
      <h3>資訊傳遞</h3>
      <p>由於無法控制互聯網或其他網絡的安全性，本公司不負責傳輸過程中的資料安全性或任何數據丟失。</p>

      <h2>你的責任</h2>
      <p>應用程式上的所有互動必須合法且遵守使用條款。如閣下的行為限制或禁止其他用戶使用本應用程式，本公司可限制閣下的特權並尋求其他補救措施。</p>
      <h3>禁止活動</h3>
      <p>閣下不應從事以下活動：</p>
      <ul>
        <li>將服務用於除收取或支付住宅、公屋、車位或工商物業租金或其他物業管理費，以及本公司允許的其他類型付款外的目的</li>
        <li>透過付款服務提供信用卡現金貸款</li>
        <li>未能及時合理回應本公司通訊</li>
        <li>提交不準確資訊、進行欺詐、為創建多個帳戶或讀取不適合的資料</li>
        <li>未經授權掃描或測試應用程式安全性</li>
        <li>篡改或干擾應用程式或其功能的正常運作</li>
        <li>向應用程式發送病毒或嘗試超載、氾濫、發送垃圾郵件或其他惡意程式</li>
        <li>散布或傳播可能被視為虐待、淫穢、色情、誹謗、騷擾、粗俗、威脅或惡意的資料</li>
        <li>採取導致本公司失去服務供應商的任何行動</li>
        <li>侵犯本公司或第三方的版權、專利、商標或其他知識產權</li>
        <li>使用本應用程式進行廣告、招攬或商業、政治或宗教目的</li>
        <li>轉售或重新利用對本應用程式的使用或購買</li>
        <li>利用本應用程式招攬用戶加入競爭服務</li>
        <li>將用戶或第三方資訊用於商業目的</li>
        <li>使用機器人、網絡蜘蛛或自動化方法複製內容，未經明確書面許可</li>
        <li>違反機器人限制或規避阻止使用的措施</li>
        <li>採取對服務造成過度需求的行動</li>
        <li>匯總本應用程式內容與其他網站材料，未經明確書面許可</li>
        <li>深層連結到本應用程式的任何部分，未經明確許可</li>
        <li>非法或惡意損害本公司或應用程式的商業利益或聲譽</li>
        <li>從事與本協議精神相抵觸的活動</li>
        <li>違反任何適用法律、法規或條例</li>
        <li>跟踪或騷擾他人</li>
        <li>作出欺詐或非法行為</li>
      </ul>

      <h2>建立帳戶於本應用程式</h2>
      <p>閣下只能建立和持有一個由閣下全權管理的帳戶。帳戶不可轉讓、出售、合併或共用。如違反此限制，本公司可終止或暫停帳戶。如本公司終止帳戶，除非正式邀請，否則閣下不得重新註冊。若閣下實施欺詐或偽造資料，帳戶將立即終止，本公司保留追究損失的權利，包括通過執法機構採取法律行動。</p>

      <h2>本應用程式上的資料</h2>
      <p>本公司不控制用戶提供的資料。閣下可能發現其他用戶的資訊不準確、有害或令人反感。透過使用本服務，閣下承擔相關風險，並同意本公司不對任何用戶或第三方的作為或不作為負責。本公司保留編輯或刪除放置在應用程式上的任何內容的權利。</p>
      <p>本公司目前不對用戶進行犯罪背景調查或篩選，也不驗證用戶提供的資訊。如有需要，閣下同意提供身份證明文件或其他資料，並配合調查。</p>
      <p>本公司不對應用程式用戶或其他第三方的行為做任何陳述或保證。</p>

      <h2>責任之限制</h2>
      <ol>
        <li>閣下同意本公司只是提供平台供閣下從第三方獲得服務。因此，閣下承認並同意，本公司不對與閣下簽訂合同的第三方的任何違約、欺詐、失職或未能履行責任負責，以及因付款人或第三方的作為或不作為而直接或間接遭受的任何傷害、損害、責任和成本不負責任。</li>
        <li>在法律允許的最大範圍內，閣下同意並放棄對本公司及其子公司、關聯公司、合夥人、高級職員、董事、員工、股東和代理人因任何違約行為或任何間接的、特殊的、懲罰性的、後果性的或附帶損害而產生的任何責任。本公司已被告知此類損害的可能性時亦不例外。</li>
        <li>在適用法律允許的最大範圍內，本公司不對以下任何情況承擔責任：
          <ul>
            <li>錯誤或內容不正確</li>
            <li>因訪問或使用服務導致的任何性質的人身傷害或財產損失</li>
            <li>未經授權訪問或使用安全服務器及其中的個人資訊</li>
            <li>與服務的傳輸中斷或停止</li>
            <li>任何第三方傳遞或通過服務提供的網絡錯誤、病毒或特洛伊木馬</li>
            <li>使用通過服務提供、發佈或傳輸內容導致的錯誤或遺漏</li>
            <li>用戶內容或第三方的誹謗、冒犯或非法行為</li>
          </ul>
        </li>
      </ol>

      <h2>超連結網站</h2>
      <p>本應用程式可能包含非本公司所有、運營或控制的第三方網站連結。本公司不對此類網站的內容、隱私政策或行為承擔責任，也不會審查或編輯任何第三方網站的內容。透過使用本應用程式，閣下明確免除本公司因使用任何第三方網站而引起的任何責任。</p>

      <h2>知識產權</h2>
      <h3>1. 擁有權</h3>
      <p>本應用程式中的所有內容是本公司的專有財產或在獲得許可下使用。未經本公司明確書面許可，禁止對本應用程式進行任何複製、傳輸、發佈、連結或修改。任何違反此要求的行為可能導致版權或其他知識產權的侵權，並可能對閣下處以民事和／或刑事處罰。</p>
      <p>本應用程式包含受版權保護的材料、商標和專有資訊，包括文字、軟件、照片、視頻、圖形、音樂和聲音。本應用程式的全部內容作為集體作品受香港版權法保護。本公司擁有選擇、協調、安排和增強此類內容以及原始內容的版權。閣下不得修改、出版、傳播、轉讓或銷售、創作衍生作品或以任何方式利用任何內容的全部或部分。閣下可下載、列印和／或保存受版權保護的資料，但僅供個人使用。未經本公司或版權所有人的明確書面許可，不得複製、再分發、出版或商業利用下載的資料。若允許複製或再分發，閣下不得對任何作者歸屬、商標圖例或版權聲明進行更改或刪除。閣下承認不會透過下載的受版權保護資料獲得任何所有權。</p>
      <p>未經版權、商標或專有權所有者的明確許可，閣下不得在本應用程式上上載、發佈或提供受版權保護的任何資料。本公司沒有責任向閣下提供指示或標記以幫助確定材料是否受版權保護。閣下對因侵犯版權、商標或其他損害承擔全部責任。</p>
      <p>透過向應用程式提交材料，閣下保證該材料的擁有者已明確授予本公司免版稅、永久性、不可撤銷、非排他性的權利和許可，以使用、複製、修改、改適、發布、翻譯和分發於全球此類材料，或將其併入其他作品中，以任何形式、媒體或技術，包括此類材料中的所有版權的全部期限。閣下也允許其他用戶訪問、查看、存儲或複製供個人使用的材料。閣下還授予本公司編輯、複製、發布和分發在此應用程式上提供的任何資料的權利。</p>
      <h3>2. 版權</h3>
      <p>本公司保留終止與侵犯第三方版權的任何用戶協議的權利。</p>
      <p>如閣下認為資料已被另一方以可能構成侵犯版權的方式複製或處理，或知識產權受到侵犯，請向本公司版權代理提供：</p>
      <ul>
        <li>對受版權或知識產權保護的受侵犯作品的描述</li>
        <li>涉嫌侵權的授權或關係性質</li>
        <li>涉嫌侵權材料在網站上的位置</li>
        <li>閣下的全名、地址、電話號碼和電子郵件地址</li>
        <li>閣下的聲明，表明閣下相信有爭議的使用未經版權或知識產權所有人授權</li>
        <li>閣下的聲明，說明閣下提供的資訊是準確的，且閣下是版權或知識產權擁有人或授權代表</li>
      </ul>
      <p>如閣下認為被刪除或被禁止訪問的資料沒有侵權，或已獲得版權擁有人授權，或根據法律可以發佈和使用，閣下可向版權代理發送包含以下資訊的反通知：</p>
      <ul>
        <li>閣下的全名、地址、電話號碼和電子郵件地址</li>
        <li>標識已被刪除或被禁止的材料及其先前位置</li>
        <li>聲明表明內容因錯誤或錯誤識別而被刪除或禁用</li>
        <li>閣下同意接受香港法院管轄權的聲明，及接受提供通知人程序服務的聲明</li>
      </ul>
      <h3>3. 異議處理</h3>
      <p>若版權代理收到異議通知，本公司可向原投訴人發送反通知副本，告知將在 10 個工作日內替換刪除的內容或停止禁用的內容，除非向法院提起訴訟。若原投訴人未提起訴訟，可在收到異議通知後 10 至 14 個工作日或更長時間內更換或恢復對被刪除內容的訪問。</p>
      <h3>4. 重複侵權政策</h3>
      <p>根據版權和其他適用法律，本公司已採取終止被視為重複侵權用戶的政策。本公司可自行決定限制對服務的使用和／或終止任何侵犯他人知識產權的用戶帳戶。</p>

      <h2>免責聲明</h2>
      <ol>
        <li>閣下明確同意使用本應用程式的風險由閣下自行承擔。在適用法律允許的最大範圍內，本服務不提供任何形式的保證，無論是明示或暗示的，包括但不限於對適銷性、特定目的適用性或非侵權的默示保證。</li>
      </ol>
      <p>本公司及其子公司、附屬公司、員工、代理人或許可人不保證：</p>
      <ul>
        <li>使用本應用程式不會中斷或無誤</li>
        <li>使用本網站可能獲得的結果</li>
        <li>通過本應用程式提供的任何資訊、服務或內容的準確性或可靠性</li>
      </ul>
      <p>本應用程式按「原樣」和「可用」方式訪問。本公司特此拒絕任何明示或暗示的陳述、保證和條件，包括非侵權、適銷性和特定目的適用性的保證。</p>
      <ol start="2">
        <li>本應用程式由本公司在香港的辦事處控制和提供。本公司不表示應用程式適合或可在其他地方使用。從其他司法管轄區訪問或使用本應用程式的人必須滿足自己的要求，並確保遵守當地法律。</li>
      </ol>
      <p>閣下與本公司的使用條款或任何法律關係應受香港法律管轄，不考慮法律衝突條款。雙方同意服從香港法院的非專屬管轄權。</p>
      <p>透過在應用程式中發佈或放置任何資訊或資料（如圖片、照片、視頻或任何通信形式），閣下自動授予（或保證此類內容的所有者已授予）本公司永久的、免版稅的、非排他性的、不可撤銷的、不受限制的全球使用、複製、再授權、複製、分發、修改、改適、發布、翻譯、傳輸、創作衍生作品和廣播的權利，以任何形式、媒體或技術，無論是已知或以後開發的。</p>

      <h2>彌償</h2>
      <p>閣下同意為本公司及其子公司、代理人、許可人、經理和其他關聯公司及其員工、承包商、代理人、高級職員和董事辯護、賠償並使其免受任何和所有索賠、損害賠償、義務、損失、責任、成本或債務和開支（包括律師費），由以下原因引起或相關：</p>
      <ul>
        <li>閣下對服務的使用和訪問</li>
        <li>閣下違反本使用條款的任何條款</li>
        <li>閣下侵犯任何第三方權利</li>
        <li>閣下違反任何適用法律、法規或條例</li>
        <li>用戶內容或通過帳戶提交的任何其他資訊或內容</li>
        <li>過失或故意的不當行為</li>
        <li>任何其他方使用閣下的唯一用戶名、密碼或安全代碼訪問和使用服務</li>
        <li>閣下的代理商或代表的作為、不作為和違約</li>
      </ul>

      <h2>暫停及終止</h2>
      <p>如閣下違反本協議的任何條款，特別是第 2 條或任何其他原因，本公司可隨時終止或更新這些使用條款，或立即暫停對應用程式的使用，無需事先通知或承擔責任。如本公司認為閣下的任何行為不可接受或違反本協議，本公司有權立即終止或暫停任何密碼或帳戶。儘管上述規定，本使用條款在協議終止後仍然有效。</p>

      <h2>額外披露</h2>
      <p>閣下或本公司對任何違約行為或未能行使本協議下允許的任何權利的棄權，均不代表對先前或隨後的任何違約或違約行為的棄權。此處使用的章節標題僅供參考，不具有法律效力。如具有管轄權的法院或仲裁員認為本協議的任何條款無效，該無效不應影響任何其他條款的可執行性，本協議其餘部分應繼續有效。</p>
      <p>本使用條款的規定同樣適用於本公司、其子公司、附屬公司及其第三方內容提供者和許可方，並為其利益而設。</p>

      <h2>其他事項</h2>
      <h3>保留權利</h3>
      <p>任何一方未能在任何方面行使本協議規定的任何權利，不得視為放棄該等權利。本協議的中文版本與英文版本如有不一致，概以英文版本為準。</p>

      <h2>可分割性</h2>
      <p>如本協議的任何條款被認定為不可執行或無效，該條款將在必要的最低限度內受到限制或取消，以使本協議在其他方面保持完全的效力和可執行性。</p>

      <h2>轉讓</h2>
      <p>本協議以及項下授予的任何權利和許可證，除非經本公司事先書面同意，否則閣方不得轉讓、轉移或再許可，但本公司可無限制地轉讓。任何嘗試的轉讓或轉移均違反本規條。</p>

      <h2>合併</h2>
      <p>雙方同意，本使用條款和本公司在應用程式上發佈的任何其他法律聲明是雙方相互理解的完整且排他性聲明，並取代和取消所有先前與本協議主題相關的書面和口頭協議、通信和其他諒解。除本協議另有規定外，所有修改必須以書面形式由本公司簽字。</p>

      <h2>訴訟原因</h2>
      <p>閣下可能對本公司提出的任何訴訟或索賠必須在索賠或訴因產生後一（1）年內提起。如為執行本協議和／或隱私政策的條款需要採取法律或衡平法訴訟，勝訴方將有權獲得律師、會計師和其他專業人員的合理費用，以及額外費用和支出，並享有任何其他救濟。</p>

      <div className="legal-callout">如對本條款有任何疑問，請聯絡 <a href="mailto:enquiry@keychainpay.com">enquiry@keychainpay.com</a>。本協議的中文版本與英文版本如有不一致，概以英文版本為準。</div>
    </LegalLayout>;
}

function PrivacyPageTC({ onNavigate }) {
  return <LegalLayout title="私隱政策" subtitle="KeyChain FinTech Limited 如何收集、使用及保護您的個人資訊。" onNavigate={onNavigate}>
      <p>通過安裝或使用我們的軟件，您承認、贊成並同意您的個人資訊（定義見下文）將按照本隱私權聲明中的描述進行處理。</p>
      <p>The KeyChain FinTech Limited（「本公司」、「我們」）將根據以下規定處理與我們公司 Keychain 的服務及其所有相關服務（以下統稱為「服務」）有關的所有用戶信息。</p>

      <h2>我們收集有關閣下的資料</h2>
      <p>我們致力於保護閣下的隱私，同時為閣下提供「需要知道」的服務。這些服務的運作可能需要最少收集和使用您的個人信息。本公司從閣下處收集或接收的信息取決於閣下如何使用服務，其中可能包括以下內容：</p>
      <ol>
        <li>名字</li>
        <li>電話號碼</li>
        <li>電郵地址</li>
        <li>地址（僅租戶）</li>
        <li>信用卡發卡銀行（僅租戶，不適用於 Apple Pay／Google Pay）</li>
        <li>信用卡卡號末 4 位（僅租戶，不適用於 Apple Pay／Google Pay）</li>
        <li>銀行名稱（僅業主）</li>
        <li>受益人名稱（僅業主）</li>
        <li>銀行戶口號碼（僅業主）</li>
      </ol>
      <p>或根據適用法律可能被視為個人信息的任何其他信息。當閣下使用 Keychain 向我們提供個人信息時，本公司會接收並存儲此信息，以響應閣下的使用需求和要求。你可以選擇不提供你的個人資訊，但你可能無法利用 Keychain 的所有功能。</p>

      <h3>我們收集的信息</h3>
      <p>每當閣下與我們互動時，我們都會接收並存儲某些類型的信息。例如，在閣下確認後，我們會收集您的個人信息，包括租戶的信用卡號末 4 位。本公司不會保留整個信用卡號，但將由 PCI 合規性網關處理。雖然這些資訊通常會以匯總的方式用於改進我們的產品和服務，但我們收集的一些資訊可能會用於根據閣下的偏好和使用情況為閣下提供產品和服務。</p>

      <h3>設備信息</h3>
      <p>用戶的設備資訊（IP 地址、操作系統、IMEI 號碼等）可以被不時地獲取。此信息應用於提供更好的服務，以及用於識別目的和防止任何干擾正常服務的未經授權／欺詐的做法。</p>

      <p>本公司可將收集的有關您的資訊用於以下任何目的：</p>
      <ul>
        <li>為了更好地了解用戶如何以匯總和個性化的方式訪問和使用我們的產品和服務（包括 Keychain），以改善我們的產品和服務並回應客戶的需求和喜好。</li>
        <li>通過提供個性化體驗和建議、語言和位置定制、個性化幫助和說明，或針對閣下和其他客戶使用我們的產品和服務的其他響應，改進我們的產品和服務。</li>
        <li>為閣下提供內容、服務、特別優惠。</li>
        <li>通過為您和其他客戶使用我們的產品和服務提供語言和位置定制、個性化幫助和說明或其他回應來改進我們的產品和服務。</li>
      </ul>
      <p>我們可能會向代表我們的子公司或關聯公司披露有關您的有限信息。這些第三方可能僅出於營銷目的協助公司。此外，我們可能會使用您的個人電子郵件或即時消息向您發送消息。我們將尊重閣下的私隱，不會將您的個人資訊用於第三方的優惠或廣告。如果閣下不希望我們收到您的個人資訊，請刪除本應用程式。</p>

      <h3>公司的保護</h3>
      <p>當我們認為披露您的個人資訊符合法律、司法程式、法院命令或其他法律程式時，公司保留披露您個人資訊的權利；強制執行或應用條款和細則；或保護公司、員工、用戶或其他人的權利、財產或安全。這包括與其他公司和組織交換信息，以防止欺詐和減少犯罪。這不包括銷售、出租、共享或以其他管道披露違反本隱私政策的商業目的的客戶個人資訊。</p>

      <h2>保留的信息</h2>
      <p>除非適用法律要求更長的保存期，否則我們可能會保留從閣下處收集的任何資訊，以達到本政策聲明中概述的目的。</p>

      <h2>資訊安全</h2>
      <p>PCI 合規性，是支付卡行業資料安全標準（PCI DSS）的縮寫，是一系列專有的支付安全標準和最佳實踐。公司遵守支付卡行業資料安全標準，並致力於以合理的方式保護您的個人信息的安全。我們使用各種安全技術和程式來保護您的個人資訊，使其免受遺失、誤用、未經授權的訪問、使用、披露、更改和銷毀。</p>
      <p>我們收集的任何資料都會被安全地處理、儲存和存檔在你的司法管轄區以外的資料庫和備份中，包括但不限於香港特別行政區。</p>
      <p>如果閣下對信息的安全性有任何疑問，請聯絡我們（<a href="mailto:enquiry@keychainpay.com">enquiry@keychainpay.com</a>）。</p>

      <h2>固有風險及防範措施</h2>
      <p>與其他行動支付軟件一樣，本公司服務可能被誤用作駭客攻擊和／或網路釣魚和／或洗錢工具，包括但不限於使用被盜信用卡（統稱為「風險」）。本公司將建立相關的控制措施，並採取一切合理的措施將風險降至最低，但這些控制措施不能消除或避免所有欺詐或故意行為。用戶必須提供真實身份和真實、正確的資訊，以便使用服務。</p>
      <p>本公司採用支付標記化，在線上和移動交易中用唯一的數位代幣代替傳統的支付卡帳號。代幣可用於特定移動設備、商戶或交易類型的交易。支付標記化過程以消費者看不見的方式在後台進行。支付標記化可以減少欺詐者使用敏感支付數據的威脅。</p>

      <h2>免責</h2>
      <p>本公司、其附屬公司、員工、管理人員和代理商概不負責（i）法律或相關政府機構要求披露您的個人資訊；（ii）由於閣下的行為或疏忽行為導致的任何個人信息披露（包括但不限於閣下向任何網站、論壇或社交網站披露您的個人信息）；（iii）由於駭客、電腦病毒或暫時關閉我們的服務而造成的任何後果；或（v）任何超出本公司控制範圍的後果。</p>
      <p>此外，條款及細則的所有規條，包括但不限於責任限制和賠償規條也應適用。</p>

      <h2>查閱相關資料</h2>
      <p>閣下有權向本公司查核本公司是否管有閣下的個人資料及查閱相關等資料，亦可要求本公司更改任何不準確或已變更之資料。閣下可向本公司確定本公司與數據有關的政策，並瞭解本公司持有的個人數據的種類。本公司有權向閣下收取任何查閱資料之合理費用。閣下可發送請求，要求查閱資料或更正數據，或要求查核有關政策，閣下應向下列人士提出：</p>
      <div className="legal-callout">
        <p style={{ margin: '4px 0' }}><strong>Keychain 風險管理及合規部</strong></p>
        <p style={{ margin: '4px 0' }}>Keychain FinTech Limited<br />電郵：<a href="mailto:enquiry@keychainpay.com">enquiry@keychainpay.com</a></p>
      </div>

      <h2>聯絡我們</h2>
      <p>如閣下對我們的產品及服務私隱政策有任何問題，請聯絡我們 <a href="mailto:enquiry@keychainpay.com">enquiry@keychainpay.com</a>。</p>
    </LegalLayout>;
}

function UserTermsPageTC({ onNavigate }) {
  return <LegalLayout title="用戶條款" subtitle="Keychain 應用程式及服務於香港之租戶與業主使用條款。" onNavigate={onNavigate}>
      <h2>關於 Keychain 應用程式及其服務</h2>
      <p>Keychain 營運應用程式和在線服務平台，便利支付方向業主支付租金、牌照費和類似的定期付款。該應用程式收取租金、押金及相關費用，涵蓋住宅和非住宅單位（包括但不限於住宅及非住宅單位、共居空間、共享辦公空間、停車位、廣告板及招牌、商業中心、服務式辦公室或商業攤位共享）。</p>
      <p>租金的順利及有效收取與支付，將依賴付款人的自願配合，以及第三方服務供應商所提供和操作的支付服務。</p>
      <p>Keychain 對支付服務收取服務費（通常為 2.9%），作為相關用戶（一般為業主）的代理人收取款項，並以「實收實付」（pay-when-paid）並具追索權的方式向業主支付。</p>
      <p>Keychain 亦向用戶提供其他免費服務，便利分析及記錄租金支付。下文列載本應用程式及服務的使用條款及細則。</p>

      <h2>租戶及業主</h2>
      <p>閣下使用 KeyChain FinTech Limited（一間於香港註冊成立之公司，「Keychain」，按文義及在適用情況下亦包括其合作夥伴、附屬機構及聯屬公司）所提供之服務，須受 Keychain 訂立之條款及細則之規範，並構成閣下與 Keychain 之間具約束力之協議（「本協議」）。</p>
      <div className="legal-emphasis">請仔細閱讀本協議。本協議是閣下與 Keychain 之間具法律效力且可強制執行之合約。如欲使用服務，閣下必須閱讀、同意及接受本協議所載之所有條款及細則。</div>
      <p>此外，閣下必須一併閱讀並同意接受我們的：</p>
      <ul>
        <li>一般使用條款，網址：<a href="/terms" onClick={(e) => { e.preventDefault(); onNavigate && onNavigate('terms'); }}>www.KeyChainPay.com/terms_tc.html</a></li>
        <li>私隱政策，網址：<a href="/privacy" onClick={(e) => { e.preventDefault(); onNavigate && onNavigate('privacy'); }}>www.KeyChainPay.com/privacy_tc.html</a></li>
      </ul>
      <p>透過使用服務，或透過點擊「我接受」按鈕，閣下：（1）同意受本協議（包括 Keychain 不時修訂或修改之版本）約束；（2）聲明並保證若閣下為個人，閣下具有訂立合約之能力，且並非未獲解除之破產人；若閣下代表第三方（自然人、實體或合夥組織）（「主體」）行事，閣下具有約束主體之權力與權限，且若該主體為實體，該實體為信譽良好之有效成立並存續之公司或其他法人；及（3）聲明並保證該用戶具有訂立本協議及執行本協議所要求行為之權力與權限。如閣下（作為用戶）允許或使另一方使用及操作閣下之帳戶，該用戶將受該第三方行為之約束。如閣下代表用戶使用及／或操作帳戶，閣下同意上述條款比照適用於閣下代表該用戶進行之活動，且閣下確獲該用戶妥為授權代為訂立本協議。</p>
      <p>如閣下不同意受本協議條款約束，請勿觸動「滑動接受」按鈕，或以其他方式表明拒絕，且請勿使用服務。</p>

      <h2>1.1 定義</h2>
      <p>本協議中所使用的下列詞語及短語應具有以下含義：</p>
      <ul>
        <li>（a）<strong>「用戶」</strong>於本部分中指作為業主或租戶使用應用程式或服務之一方。</li>
        <li>（b）<strong>「用戶資料」</strong>指用戶所建立之帳戶及其用於唯一識別之數據及記錄。</li>
        <li>（c）<strong>「協議」</strong>指本使用條款，包括相關附表、政策及補充條款及協議，Keychain 可據此向用戶提供應用程式及服務，並可不時於其網站發佈及修訂。</li>
        <li>（d）<strong>「營業日」</strong>指星期一至星期五，不包括公眾假期及香港銀行暫停服務之日。</li>
        <li>（e）<strong>「信用卡付款」</strong>指於香港或其他相關司法管轄區使用服務，由租戶以信用卡向其業主或相關第三方（如適用）支付租金或費用。</li>
        <li>（f）<strong>「直接付款」</strong>指於香港或其他相關司法管轄區使用服務，由租戶以現金、紙本支票或銀行轉帳方式向其業主或相關第三方（如適用）支付租金或費用。</li>
        <li>（g）<strong>「香港」</strong>指中華人民共和國香港特別行政區。</li>
        <li>（h）<strong>「商戶帳戶」</strong>指於付款銀行所設立、可進行一筆或多筆付款的商戶帳戶。</li>
        <li>（i）<strong>「付款人」</strong>指已簽訂租賃協議、租約或其他類似協議或安排，獲授使用不動產及／或不動產附屬權利之一方，並已同意使用本應用程式或服務之人士。於本部分中，一般指作為租戶之閣下。</li>
        <li>（j）<strong>「付款」</strong>指租戶透過本應用程式或服務向業主進行之信用卡付款或直接付款。</li>
        <li>（k）<strong>「付款金額」</strong>指付款的港幣總值，不包括服務費。</li>
        <li>（l）<strong>「服務費」</strong>指 Keychain 就租戶透過本應用程式或服務作出之信用卡付款向閣下收取之固定百分比費用，或可能就閣下使用服務向業主或其代理付款而收取之其他推廣性裝置費用。服務之費用率不時於 Keychain 網站列載及公布。</li>
        <li>（m）<strong>「服務」</strong>包括透過本應用程式提供之網上付款服務，便利業主、物業擁有人及物業管理人收取租金、共管費及其他物業管理費等款項。</li>
        <li>（n）<strong>「付款銀行」</strong>指租戶之信用卡發卡銀行或處理付款之支付網關。</li>
        <li>（o）<strong>「用戶」</strong>指使用我們服務或應用程式之人士或實體。</li>
        <li>（p）<strong>「應用程式」</strong>指 Keychain 或其聯屬公司所提供或營運之網上應用程式及／或網站及所有相關網頁，以及任何補充或取代現有應用程式之其他應用程式或電子形式媒體。</li>
      </ul>

      <h3>1.2 應用程式功能與責任</h3>
      <p>Keychain 服務及／或應用程式允許用戶註冊使用，以信用卡、Apple Pay 或 Google Pay 透過 Keychain 進行網上付款服務，作為該用戶自身或他人於香港使用不動產或不動產附屬權利之用。</p>
      <div className="legal-emphasis">對於閣下在任何情況下都不被視為合法的欺詐性或故意採取行動向任何人付款，Keychain 概不負責。</div>

      <h3>1.3 適用法律</h3>
      <p>本協議受香港特別行政區法律管轄並按其詮釋。</p>

      <h2>2. 使用條件</h2>
      <p>閣下使用本應用程式或服務的條件，閣下同意、聲明並保證：</p>

      <h3>2.1 遵守協議</h3>
      <p>閣下對本應用程式或服務的使用，將始終遵守本協議。</p>

      <h3>2.2 帳戶創建</h3>
      <p>若閣下選擇創建帳戶：</p>
      <ul>
        <li>（a）閣下僅可創建一個帳戶供個人使用。</li>
        <li>（b）閣下僅可使用本應用程式或服務進行真實合法的交易。</li>
        <li>（c）閣下必須妥善保管密碼並監督帳戶之使用，並接受及同意對任何閣下同意或允許使用閣下密碼訪問閣下帳戶之人士使用閣下帳戶之行為負責。在 iPhone 登入本應用程式時可能需要使用 Touch ID／Face ID。</li>
      </ul>
      <p>如閣下不願意或無法遵守，則無法使用應用程式或服務。Keychain 設有政策及措施，可隨機檢查及查問用戶所提供資訊之真實性，如該用戶拒絕合作或 Keychain 對重要資訊之真實性有合理保留或懷疑，Keychain 可暫停其使用本應用程式及服務。</p>

      <h3>2.3 資訊真實性</h3>
      <p>閣下聲明閣下擁有提交予 Keychain 一切資訊之權利及能力，並不會侵犯他人權利或私隱，亦不會違反閣下所受之任何限制；所有此等資訊均屬準確、真實、最新及完整，並將維持如此。</p>

      <h3>2.4 拒絕服務權</h3>
      <p>Keychain 保留絕對酌情權拒絕或暫停任何人或任何用戶使用本應用程式或服務。</p>

      <h2>3. 結算及收款</h2>
      <h3>3.1 Keychain 之角色及用戶之責任</h3>
      <p>Keychain 為物業擁有人、業主自行直接或透過其授權及指定之物業管理人提供託管及資料處理服務。Keychain 僅提供便利交易之服務，並不提供，亦不表明本公司提供任何適用法律或香港法律所定義之物業或地產代理服務、銀行服務、匯款代理或支付系統。本應用程式及服務的營運中，Keychain 須收集、分析並轉發付款人與業主之間支付相關之資訊。閣下授權 Keychain 將該等資訊披露予閣下之銀行或閣下指定之其他實體，以便付款銀行促成業主與付款人之間之交易。</p>
      <p>對業主而言，Keychain 僅代表閣下，透過付款銀行（在適用情況下亦透過信用卡或 Apple Pay 或 Google Pay）向閣下之租戶收取款項。Keychain 不保證閣下之租戶會按時或全額支付到期款項。Keychain 將在合理切實可行之情況下儘快（一般為收款後七至十個日曆日內）將實際收到之款項（扣除服務費後之餘額）支付至閣下指定之帳戶。Keychain 之所有付款均具追索權，如有其他人士提出合法索賠，可作追索。</p>
      <p>對租戶而言，Keychain 僅在透過本應用程式及服務，閣下之付款已在付款銀行、Keychain 及業主之銀行之間生效後，方能將付款金額支付至業主指定之銀行帳戶。Keychain 不參與閣下與付款銀行之交易，亦不參與付款銀行與閣下之間之資金結算。</p>

      <h3>3.2 服務費</h3>
      <p>Keychain 於收到付款後將收取不可退還之服務費（通常為 2.9%），相關金額將由 Keychain 於每次依本服務向業主付款前或當時扣除及挪用。服務費於付款金額之外（並緊隨其後）支付，將自付款金額中扣除或調整後再行匯出。服務費將存入 Keychain 不時指定之銀行帳戶。</p>

      <h3>3.3 結算日期</h3>
      <p>付款人透過本應用程式或服務向 Keychain 付款後，Keychain 將立即根據租戶與業主之間就租金及交易費（如適用）所達成之協議，向付款人之卡片收取不可退還之金額。交易費根據雙方所選之條件由租戶及業主支付。如屬信用卡付款，付款人通常僅於發卡銀行根據付款人與發卡銀行之協議所訂之結算日（並按信用卡月結單顯示）要求其結算時，方需結算租金付款。</p>

      <h3>3.4 稅項</h3>
      <p>就 Keychain 代閣下收取或向閣下支付之款項，閣下須全權自行確定可能徵收或應由閣下繳納之稅項，並全權負責收取、申報、提交報稅表並向相關當局繳納適用稅項。Keychain 不負責查詢或判斷閣下之付款交易是否須繳稅，亦不負責收取、申報或繳納因閣下付款交易而產生之任何稅項。</p>

      <h3>3.5 信用卡延誤及未完成交易</h3>
      <p>閣下承認並接受信用卡付款處理時間取決於 Keychain 無法控制之行政因素及機構積壓。對業主而言，由付款人發起之信用卡付款可能至少需要七（7）個日曆日，或 Keychain 通知之較長期間。對租戶而言，閣下接受智能合約後將立即進行信用卡付款，或會在應用程式中所載每月租賃生效日期前約十四（14）個日曆日自動處理。經常性付款之扣卡日期視乎閣下之付款歷史及信用卡狀態而定。Keychain 可能會通知並提醒閣下跟進及完成。此外，信用卡付款的完成取決於信用卡付款的授權及接受。如信用卡付款無法完成，Keychain 將盡合理切實可行之努力，透過本應用程式或閣下用戶資料中之聯絡資料儘快通知閣下。所有延誤或未完成情況及由此產生之一切索賠及責任，均應完全屬於業主與租戶之間之事務。任何因遲交付款而適用之罰款、滯納金及利息費用均由付款人獨自承擔。</p>

      <h3>3.6 不設退回</h3>
      <p>於付款存入業主銀行帳戶後，Keychain 之服務即視作完成該交易，閣下接受並同意本應用程式及服務不提供任何付款或服務費或其任何部分之退款、取消或退單。閣下接受並同意，在任何情況下，Keychain 均不就租戶與業主之間可避免或可取消之任何已作付款（包括所有相關銀行、交易及服務費用）負責。</p>

      <h3>3.7 信用卡安全</h3>
      <p>信用卡付款涉及處理、傳輸或儲存信用卡資料，為保障閣下安全，將透過傳輸層安全（TLS）使用 HTTPS 處理，以遵守支付卡行業資料安全標準（PCI DSS）。Keychain 不會在我們的伺服器中保留閣下完整之信用卡號碼，僅保留（i）Apple Pay 或 Google Pay 之授權代幣，或（ii）發卡銀行及閣下信用卡號碼之最後 4 位數字。閣下輸入之持卡人姓名將用於合規檢查。完整信用卡資訊將於符合 PCI 規定之支付網關中處理、檢查及保存。</p>

      <h3>3.8 付款限額</h3>
      <p>Keychain 可自行酌情，不時對閣下透過本應用程式或服務可收取之每筆或累計付款金額施加並調整限制，並考慮應付租金金額而認為合理。</p>

      <h3>3.9 在途資金</h3>
      <p>所有從付款人收取之在途資金將存放於 Keychain 之專用客戶存款銀行帳戶，並依 Keychain 不時認為合理適當及切實可行而採用之規則及政策，與 Keychain 任何其他營運資金妥為分隔。應用戶要求並依 Keychain 接受之條款，可協議採取額外之措施及安排。</p>

      <h3>3.10 資金或信貸不足</h3>
      <div className="legal-emphasis">Keychain 對付款人向業主（或其代理）支付之租金或費用概不負責。Keychain 僅便利該等付款之處理。任何付款失誤或無法支付，均屬該付款人之獨自責任。對於付款人未能或無法向業主付款，Keychain 概不承擔任何責任，包括但不限於因 Keychain 就使用服務收取適用之服務費而導致付款人沒有足夠資金或信貸向業主付款之情況。</div>

      <h3>3.11 違約及欺詐性交易</h3>
      <p>如 Keychain 合理懷疑或相信，或獲任何主管當局告知，與用戶有關之任何交易或付款屬虛假、欺詐、非法或用以促成違法或不道德之目的及活動，Keychain 可暫停或終止用戶之帳戶。Keychain 亦可隨意向主管當局報告該案件，並披露所有相關資料及記錄。</p>

      <h3>3.12 收款</h3>
      <p>閣下僅可從已同意一般／付款人使用條款（網址 www.KeyChainPay.com）及其服務供應商（如適用）之付款人處收取付款。透過服務向閣下付款時，付款金額將轉入閣下及／或付款人指定之銀行帳戶，並受本協議或閣下可能須與 Keychain 訂立之其他協議之條款規限。</p>

      <h3>3.13 額外費用及支出</h3>
      <p>租戶承認並同意，除月租外，租戶可能須負擔業主或物業管理人指定之額外費用，包括但不限於清潔費、維修費及其他相關費用。該等費用將被視為支出，並依租賃協議所訂條款或業主或物業管理人之通知，透過 Keychain 平台處理。</p>

      <h2>4. 暫停及終止</h2>
      <h3>4.1 提前通知</h3>
      <p>當業主與租戶之間之相關協議將被終止或提早終止時，閣下須向 Keychain 發出提前通知以終止付款安排。通知須透過應用程式發出，並至少提前 1 個日曆月。</p>

      <h3>4.2 由租戶或業主終止</h3>
      <p>於租戶或業主向 Keychain 發出終止付款安排之通知後，付款安排亦將終止。</p>

      <h3>4.3 電郵通知</h3>
      <p>在合理切實可行之情況下，Keychain 將透過電郵通知用戶，已收到終止通知，以及付款安排何時停止運作。</p>

      <div className="legal-callout">如對本用戶條款有任何疑問，請聯絡 <a href="mailto:enquiry@keychainpay.com">enquiry@keychainpay.com</a>。</div>
    </LegalLayout>;
}

function TermsPage({ onNavigate }) {
  return currentLang === 'tc' ? <TermsPageTC onNavigate={onNavigate} /> : <TermsPageEN onNavigate={onNavigate} />;
}
function PrivacyPage({ onNavigate }) {
  return currentLang === 'tc' ? <PrivacyPageTC onNavigate={onNavigate} /> : <PrivacyPageEN onNavigate={onNavigate} />;
}
function UserTermsPage({ onNavigate }) {
  return currentLang === 'tc' ? <UserTermsPageTC onNavigate={onNavigate} /> : <UserTermsPageEN onNavigate={onNavigate} />;
}

function CookiePolicyPage({ onNavigate }) {
  return <LegalLayout title="Cookie Policy" subtitle="How Keychain uses cookies on our website and web app." lastUpdated="April 2023" onNavigate={onNavigate}>
      <h2>Cookie Policy (Applicable to registered users)</h2>
      <p>This website (keychainpay.com / webapp) uses cookies to improve your browsing experience and to analyze site traffic. By using our website and agreeing to this policy, you consent to our use of cookies in accordance with the terms of this policy.</p>

      <h2>What are cookies?</h2>
      <p>Cookies are small text files that are stored on your computer or mobile device when you visit our website. They are widely used to make our website work more efficiently and to provide information to us on how our users interact with our website. Cookies do not harm your computer or contain any personally identifiable information such as your name or credit card details.</p>

      <h2>What cookies do we use?</h2>
      <p>We use both session cookies and persistent cookies on our website. Session cookies are deleted from your computer or device when you close your web browser. Persistent cookies remain stored on your computer or device until they expire or you delete them.</p>
      <p>We use the following types of cookies on our website:</p>
      <ol>
        <li><strong>Essential cookies</strong>: necessary for the website to function properly and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information.</li>
        <li><strong>Performance cookies</strong>: allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.</li>
        <li><strong>Functionality cookies</strong>: enable the website to provide enhanced functionality and personalization. They may be set by us or by third-party providers whose services we have added to our pages. If you do not allow these cookies then some or all of these services may not function properly.</li>
        <li><strong>Targeting cookies</strong>: may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites. They do not store directly personal information, but are based on uniquely identifying your browser and internet device. If you do not allow these cookies, you will experience less targeted advertising.</li>
      </ol>

      <h2>Cookie List</h2>
      <h3>Essential Cookies</h3>
      <table>
        <thead><tr><th>Cookie Name</th><th>Purpose</th><th>Expiration</th></tr></thead>
        <tbody>
          <tr><td>__stripe_mid</td><td>Used to assist on fraud detection.</td><td>1 year</td></tr>
          <tr><td>__stripe_sid</td><td>Used to assist on fraud detection.</td><td>30 minutes</td></tr>
          <tr><td>private_machine_identifier</td><td>Used to assist on fraud detection.</td><td>1 year</td></tr>
          <tr><td>stripe.csrf</td><td>Used to assist on fraud detection.</td><td>1 year</td></tr>
        </tbody>
      </table>

      <h3>Performance Cookies</h3>
      <table>
        <thead><tr><th>Cookie Name</th><th>Purpose</th><th>Expiration</th></tr></thead>
        <tbody>
          <tr><td>_ga</td><td>Used to distinguish users.</td><td>2 years</td></tr>
          <tr><td>_gid</td><td>Used to distinguish users.</td><td>24 hours</td></tr>
          <tr><td>_gat</td><td>Used to throttle request rate. If Google Analytics is deployed via Google Tag Manager, this cookie will be named dc_gtm_&lt;property-id&gt;.</td><td>1 minute</td></tr>
          <tr><td>_gat_&lt;container-id&gt;</td><td>Used to provide technical monitoring.</td><td>Session</td></tr>
          <tr><td>_ga_&lt;container-id&gt;</td><td>Used to persist session state.</td><td>2 years</td></tr>
          <tr><td>_gac_gb_&lt;container-id&gt;</td><td>Contains campaign related information.</td><td>90 days</td></tr>
          <tr><td>AMP_TOKEN</td><td>Used to retrieve a Client ID from AMP Client ID service.</td><td>30 seconds to 1 year</td></tr>
          <tr><td>_gac_&lt;property-id&gt;</td><td>Used to store campaign related information for the user.</td><td>90 days</td></tr>
        </tbody>
      </table>

      <h3>Functional Cookies</h3>
      <table>
        <thead><tr><th>Cookie Name</th><th>Purpose</th><th>Expiration</th></tr></thead>
        <tbody>
          <tr><td>SOCS</td><td>Used to store a user's state regarding their cookies choices.</td><td>13 months</td></tr>
          <tr><td>CONSENT</td><td>Used to store a user's state regarding their cookies choices.</td><td>2 years</td></tr>
        </tbody>
      </table>

      <h3>Targeting Cookies</h3>
      <table>
        <thead><tr><th>Cookie Name</th><th>Purpose</th><th>Expiration</th></tr></thead>
        <tbody>
          <tr><td>__Secure-3PAPISID</td><td>Used for targeting purposes to build a profile of the website visitor's interests in order to show relevant & personalised Google advertising.</td><td>2 years</td></tr>
          <tr><td>__Secure-3PSID</td><td>Used for targeting purposes to build a profile of the website visitor's interests in order to show relevant & personalised Google advertising.</td><td>2 years</td></tr>
          <tr><td>__Secure-3PSIDCC</td><td>Used for targeting purposes to build a profile of the website visitor's interests in order to show relevant & personalised Google advertising.</td><td>2 years</td></tr>
          <tr><td>__Secure-ENID</td><td>Used to remember information that changes the way the site behaves or looks.</td><td>13 months</td></tr>
          <tr><td>AEC</td><td>Used to ensure that requests within a browsing session are made by the user, and not by other sites.</td><td>6 months</td></tr>
          <tr><td>NID</td><td>Used to remember information that changes the way the site behaves or looks.</td><td>1 month</td></tr>
          <tr><td>DEVICE_INFO</td><td>Used to store device information.</td><td>179 days</td></tr>
          <tr><td>PREF</td><td>Used for storing information such as your preferred page configuration and playback preferences like explicit autoplay choices, shuffle content, and player size.</td><td>1 year</td></tr>
          <tr><td>SIDCC</td><td>Used for protecting a user's data from unauthorized access.</td><td>1 year</td></tr>
          <tr><td>YSC</td><td>Used to ensure that requests within a browsing session are made by the user, and not by other sites.</td><td>Session</td></tr>
          <tr><td>VISITOR_INFO1_LIVE</td><td>Used to detect and resolve problems with the service.</td><td>6 months</td></tr>
        </tbody>
      </table>

      <h2>How can I change my preferences?</h2>
      <p>When you first visit our website you will be presented with our cookie management tool which enables you to set your preferences. You can also manage your cookies preferences by visiting the cookie-preferences page.</p>
      <p>You can also manage cookies through your web browser's setting. Most web browsers allow you to control cookies through their settings preferences. However, disabling cookies may affect the functionality of our website.</p>

      <h2>Changes to this policy</h2>
      <p>If we change the cookies we use, we will update this Cookies Policy. You always can find the latest version of this Policy on our website.</p>

      <h2>Contact us</h2>
      <div className="legal-callout">
        If you have any questions about our Cookie policy, please contact us at <a href="mailto:enquiry@keychainpay.com">enquiry@keychainpay.com</a>.
      </div>
    </LegalLayout>;
}

function NotFoundPage({ onNavigate }) {
  return <div style={{ minHeight: '100vh', background: '#FAFAFA', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 24px' }}>
    <SEO title="404 - Page Not Found" description="The page you are looking for does not exist." urlPath="" />
    <div style={{ textAlign: 'center', maxWidth: 480 }}>
      <div style={{ fontSize: 96, fontWeight: 800, color: '#E57500', lineHeight: 1, marginBottom: 8 }}>{t("k_918")}</div>
      <div style={{ fontSize: 28, fontWeight: 700, color: '#1A1A1A', marginBottom: 16 }}>{t("k_919")}</div>
      <div style={{ fontSize: 16, color: '#6B7280', marginBottom: 40, lineHeight: 1.6 }}>{t("k_920")}</div>
      <button onClick={() => onNavigate('home')} style={{ background: '#E57500', color: 'white', border: 'none', borderRadius: 10, padding: '14px 32px', fontSize: 16, fontWeight: 600, cursor: 'pointer' }}
        onMouseEnter={e => e.currentTarget.style.background = '#B55B00'}
        onMouseLeave={e => e.currentTarget.style.background = '#E57500'}>
        {t("k_921")}
      </button>
    </div>
  </div>;
}

function CreditCardRentPillarPage({ onNavigate }) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ background: "white", color: "#1A1A1A", fontFamily: "'Inter', -apple-system, sans-serif" }}>
      <SEO 
        title="信用卡交租 ‧ 網上交租 ‧ 上網交租賺回贈指南 | Keychain 智能租務代理" 
        description="比較 2026 最新各大銀行信用卡交租（網上交租/上網交租）手續費、積分、里數與現金回贈（含滙豐最優 3.6% 回贈與 0.8% 手續費）。詳解公屋信用卡交租、交租app推薦及安全合規資訊。教您利用交租 信用卡靈活理財，輕鬆過數！" 
        urlPath="/tc/信用卡交租/" 
      />
      
      <section style={{
        background: 'linear-gradient(135deg, #FFF6F0 0%, #FFFDFB 100%)',
        padding: '100px 24px 60px',
        textAlign: 'center',
        borderBottom: '1px solid rgba(229, 117, 0, 0.1)'
      }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <span style={{
            background: 'rgba(229, 117, 0, 0.1)',
            color: '#E57500',
            padding: '6px 16px',
            borderRadius: 20,
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: '0.1em',
            textTransform: 'uppercase'
          }}>2026 全港最齊指南</span>
          <h1 style={{
            fontSize: 'clamp(28px, 4vw, 42px)',
            fontWeight: 800,
            marginTop: 16,
            marginBottom: 16,
            fontFamily: "'Space Grotesk', sans-serif",
            lineHeight: 1.2
          }}>信用卡交租、網上交租與上網交租全攻略</h1>
          <p style={{ fontSize: 'clamp(15px, 1.8vw, 18px)', opacity: 0.9, maxWidth: 640, margin: '0 auto', lineHeight: 1.6 }}>
            比較 2026 各大銀行信用卡交租回贈與手續費，教您用交租app靈活理財並穩賺高達 3.6% 獎賞回贈！
          </p>
          <div style={{ fontSize: 13, color: '#6B7280', marginTop: 16, display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap', opacity: 0.8 }}>
            <span><strong>作者：</strong>Keychain 租務金融研究團隊</span>
            <span>|</span>
            <span><strong>專業審查：</strong>合規與支付安全委員會</span>
            <span>|</span>
            <span><strong>發佈日期：</strong>2026-07-19</span>
            <span>|</span>
            <span><strong>最後更新：</strong>2026-07-19</span>
          </div>
        </div>
      </section>

      <section style={{ padding: '60px 24px' }}>
        <div style={{ maxWidth: 800, margin: '0 auto', fontSize: 16, lineHeight: 1.8, color: '#374151' }}>
          
          <div style={{ background: '#FFFDF9', border: '1px solid rgba(229, 117, 0, 0.2)', borderRadius: 16, padding: '24px', marginBottom: 40 }}>
            <h3 style={{ fontSize: 18, fontWeight: 700, margin: '0 0 12px 0', color: '#B55B00' }}>快速導覽：信用卡 網上交租 優勢</h3>
            <p style={{ margin: 0, fontSize: 14, color: '#4B5563' }}>
              透過 Keychain 交租app，您可以將大額的住宅或商務租金轉化為信用卡消費，輕鬆累積飛行里數、積分與現金回贈。系統將於每月指定扣款日自動扣款，並直接以 FPS 過數予業主。業主無需下載任何 App，收款體驗完全無縫！
            </p>
          </div>

          <h2 style={{ fontSize: 24, fontWeight: 800, color: '#111827', borderBottom: '2px solid #E57500', paddingBottom: 8, marginTop: 40, marginBottom: 16 }}>
            1. 什麼是信用卡交租或網上交租？
          </h2>
          <p style={{ marginBottom: 20 }}>
            每月租金是絕大多數家庭或商戶的最大開支，但傳統的銀行自動轉賬、支票或轉數快（FPS）付款方式，都無法為您帶來任何增值回報。
          </p>
          <p style={{ marginBottom: 20 }}>
            <strong>信用卡交租</strong>（或稱 <strong>網上交租</strong> / <strong>上網交租</strong>）是指利用 Keychain 智能租務代理平台，將信用卡綁定到您的租約。系統會自動在每月交租日前扣除信用卡款項，並在約定時間安全過數給業主，讓您的租金支出轉化為大筆的信用卡消費積分、飛行里數（如 Asia Miles）與迎新現金回贈！
          </p>
          <p style={{ marginBottom: 20 }}>
            如果您想了解更多關於此平台針對租客提供的各項服務，歡迎瀏覽我們的 <a href="/tc/tenants/" onClick={(e) => { e.preventDefault(); onNavigate('tenants'); }} style={{ color: '#2563EB', fontWeight: 600, textDecoration: 'underline' }}>租戶交租服務</a> 頁面，隨時開始您的賺回贈之旅！
          </p>

          <h2 style={{ fontSize: 24, fontWeight: 800, color: '#111827', borderBottom: '2px solid #E57500', paddingBottom: 8, marginTop: 40, marginBottom: 16 }}>
            2. 網上交租手續費與回贈回本計算
          </h2>
          <p style={{ marginBottom: 20 }}>
            許多人會擔心：信用卡交租需要支付平台手續費（Transaction Fee），那真的能實現「回本」並穩賺利潤嗎？這完全取決於<strong>您信用卡的回贈率是否高於平台手續費</strong>。
          </p>
          <p style={{ marginBottom: 16 }}>
            例如，搭配 Keychain 與特定銀行（如滙豐銀行）的特低推廣手續費 <strong>0.8%</strong>，而您的信用卡交租回贈率最高可達 <strong>3.6% 獎賞錢</strong>：
          </p>
          <div style={{ background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: 12, padding: 20, marginBottom: 24 }}>
            <h4 style={{ fontSize: 16, fontWeight: 700, marginTop: 0, marginBottom: 12, color: '#111827' }}>範例 A：中高額住宅租金（每月 $20,000）</h4>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li><strong>假設每月租金：</strong>$20,000</li>
              <li><strong>Keychain 特低推廣手續費 (0.8%)：</strong>$160</li>
              <li><strong>滙豐信用卡交租回贈 (最高 3.6% 獎賞錢)：</strong>$720 獎賞錢 (等同於 $720 現金)</li>
              <li><strong>每月淨收益：</strong>$720 - $160 = <strong>$560</strong></li>
              <li><strong>每年淨賺收益：</strong>$560 × 12 = <strong>$6,720</strong> 收益（足夠免費換取一趟亞洲來回機票！）</li>
            </ul>
          </div>
          <div style={{ background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: 12, padding: 20, marginBottom: 24 }}>
            <h4 style={{ fontSize: 16, fontWeight: 700, marginTop: 0, marginBottom: 12, color: '#111827' }}>範例 B：中小型住宅或車位租金（每月 $10,000）</h4>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li><strong>假設每月租金：</strong>$10,000</li>
              <li><strong>Keychain 特低推廣手續費 (0.8%)：</strong>$80</li>
              <li><strong>滙豐信用卡交租回贈 (最高 3.6% 獎賞錢)：</strong>$360 獎賞錢 (等同於 $360 現金)</li>
              <li><strong>每月淨收益：</strong>$360 - $80 = <strong>$280</strong></li>
              <li><strong>每年淨賺收益：</strong>$280 × 12 = <strong>$3,360</strong> 現金回贈收益！</li>
            </ul>
          </div>

          <h2 style={{ fontSize: 24, fontWeight: 800, color: '#111827', borderBottom: '2px solid #E57500', paddingBottom: 8, marginTop: 40, marginBottom: 16 }}>
            3. 2026 各大銀行交租 信用卡 積分/里數/回贈比較表
          </h2>
          <p style={{ marginBottom: 20 }}>
            以下是最新各大銀行信用卡在 Keychain 平台的交租回贈、推廣手續費及到期日詳細比較：
          </p>
          
          <div style={{ overflowX: 'auto', marginBottom: 32 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
              <thead>
                <tr style={{ backgroundColor: '#F3F4F6', borderBottom: '2px solid #E5E7EB' }}>
                  <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: 600, color: '#1F2937' }}>銀行 / 信用卡</th>
                  <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: 600, color: '#1F2937' }}>Keychain 手續費</th>
                  <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: 600, color: '#1F2937' }}>回贈 / 里數率</th>
                  <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: 600, color: '#1F2937' }}>推廣到期日</th>
                  <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: 600, color: '#1F2937' }}>特點</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: '1px solid #E5E7EB', backgroundColor: '#FFFDF9' }}>
                  <td style={{ padding: '12px 8px', fontWeight: 'bold' }}>
                    <a href="/tc/promotions/hsbc/" onClick={(e) => { e.preventDefault(); onNavigate('promotions/hsbc'); }} style={{ color: '#E57500', textDecoration: 'underline' }}>滙豐信用卡交租優惠</a> (HSBC)
                  </td>
                  <td style={{ padding: '12px 8px' }}><strong>0.8%</strong></td>
                  <td style={{ padding: '12px 8px', color: '#10B981', fontWeight: 'bold' }}>最高 3.6% 獎賞錢</td>
                  <td style={{ padding: '12px 8px' }}>2027-03-31</td>
                  <td style={{ padding: '12px 8px', fontSize: 12 }}>特低手續費推廣，回贈極高，全港性價比之冠！</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #E5E7EB' }}>
                  <td style={{ padding: '12px 8px', fontWeight: 'bold' }}>渣打銀行 (SC)</td>
                  <td style={{ padding: '12px 8px' }}>1.98%</td>
                  <td style={{ padding: '12px 8px' }}>1.5% 現金回贈 / 1.5里/港元</td>
                  <td style={{ padding: '12px 8px' }}>長期有效</td>
                  <td style={{ padding: '12px 8px', fontSize: 12 }}>適合賺取 Asia Miles 飛行里數，儲里數必備。</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #E5E7EB' }}>
                  <td style={{ padding: '12px 8px', fontWeight: 'bold' }}>星展銀行 (DBS)</td>
                  <td style={{ padding: '12px 8px' }}>1.98%</td>
                  <td style={{ padding: '12px 8px' }}>$5 = 1 里 (約 1.6% 回贈)</td>
                  <td style={{ padding: '12px 8px' }}>長期有效</td>
                  <td style={{ padding: '12px 8px', fontSize: 12 }}>積分永久有效，兌換里數無上限。</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #E5E7EB' }}>
                  <td style={{ padding: '12px 8px', fontWeight: 'bold' }}>恒生銀行 (Hang Seng)</td>
                  <td style={{ padding: '12px 8px' }}>1.98%</td>
                  <td style={{ padding: '12px 8px' }}>1.2% +Fun Dollars 回贈</td>
                  <td style={{ padding: '12px 8px' }}>長期有效</td>
                  <td style={{ padding: '12px 8px', fontSize: 12 }}>靈活扣減合作商戶消費，賺取 +Fun Dollars 極為實用。</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #E5E7EB' }}>
                  <td style={{ padding: '12px 8px', fontWeight: 'bold' }}>花旗銀行 (Citibank)</td>
                  <td style={{ padding: '12px 8px' }}>1.98%</td>
                  <td style={{ padding: '12px 8px' }}>1.2% 積分回贈</td>
                  <td style={{ padding: '12px 8px' }}>長期有效</td>
                  <td style={{ padding: '12px 8px', fontSize: 12 }}>積分可靈活兌換電子禮券，彈性十足。</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 style={{ fontSize: 24, fontWeight: 800, color: '#111827', borderBottom: '2px solid #E57500', paddingBottom: 8, marginTop: 40, marginBottom: 16 }}>
            4. 公屋信用卡交租全攻略
          </h2>
          <p style={{ marginBottom: 16 }}>
            目前房屋署公屋交租並不直接提供信用卡支付渠道。但作為香港最全面的交租平台，<strong>Keychain 全面支持公屋住戶進行信用卡網上交租</strong>！
          </p>
          <p style={{ marginBottom: 20 }}>
            公屋租戶只需在 Keychain 交租app中設定繳款計劃時，提供您的<strong>電子繳費租戶號碼</strong>以及拍照上傳最新的<strong>房屋署繳費通知書 (Housing Department payment notice)</strong> 作為合約憑證。系統會自動在每月扣除您的信用卡款項，並在約定時間安全過數，讓公屋租戶也能同樣享受高達 3.6% 信用卡交贈回贈與里數，實現生活支出最大化增值！
          </p>

          <h2 style={{ fontSize: 24, fontWeight: 800, color: '#111827', borderBottom: '2px solid #E57500', paddingBottom: 8, marginTop: 40, marginBottom: 16 }}>
            5. 安全與合規保障 (FCA Licence)
          </h2>
          <p style={{ marginBottom: 20 }}>
            大額租金安全至關重要。作為值得信任的 <strong>交租app</strong>，Keychain 背後母公司 <strong>KeyChain FinTech (UK) Limited</strong> 是獲得<strong>英國金融行為監管局 (FCA)</strong> 授權及監管的持牌付款機構，持有正式的 <strong>payment-institution licence</strong> (Reference number: 967989)。
          </p>
          <p style={{ marginBottom: 32 }}>
            所有客戶資金均實行嚴格隔離託管於合規隔離賬戶中，交易流程受最高級別網絡及支付卡代碼安全認證 (PCI-DSS)，確保整個轉賬過程絕對安全無虞。
          </p>

          <h2 style={{ fontSize: 24, fontWeight: 800, color: '#111827', borderBottom: '2px solid #E57500', paddingBottom: 8, marginTop: 40, marginBottom: 16 }}>
            6. 常見問題解答 (Q&A)
          </h2>
          
          <div style={{ marginTop: 20 }}>
            {[
              { q: "上網交租有咩方法？", a: "上網交租最簡單、安全的方法是下載並使用 Keychain 交租app。只需設定您的智能租約，綁定您的信用卡（如滙豐、渣打、DBS），系統即會每月自動扣款並直接 FPS 過數給業主，無痛又方便。" },
              { q: "網上交租安全嗎？會儲存我的卡號嗎？", a: "絕對安全！Keychain 是受到英國金融行為監管局 (FCA) 監管的授權付款機構 (Licence: 967989)。系統採用 100% 信用卡代碼化技術 (Tokenisation)，絕不儲存您的完整卡號，安全性高達銀行級標準。" },
              { q: "分拆付款 (SPLIT) 功能是什麼？", a: "分拆付款是 Keychain 首創功能。租客可以將一筆租金分拆到最多 3 張不同的信用卡或與同居室友、配偶分拆支付。這能讓您靈活分配信用卡額度，更可同時賺取多張信用卡的迎新推廣回贈！" },
              { q: "公屋交租方法信用卡可行嗎？", a: "目前房屋署公屋交租並不直接提供信用卡支付渠道。但您可以利用特定銀行的理財配合通道，或留意房委會與第三方支付平台最新配合的「公屋交租方法信用卡」指定配合推廣或銀行理財迎新。" },
              { q: "使用信用卡交租會影響我的信貸評級嗎？", a: "不會。信用卡交租屬於標準的信用卡網上商戶消費，只要您每月按時向信用卡發卡銀行償還信用卡賬單，這與普通刷卡消費無異，還能幫助您建立良好的信貸記錄。" },
              { q: "業主也需要下載 app 嗎？", a: "完全不需要。業主不需要下載任何 App。當 Keychain 從租客端扣款後，會自動以 FPS 轉數快將租金存入業主指定的香港本地任何銀行賬戶中，對業主而言收款體驗完全與常規過數一致。" },
              { q: "商舖、寫字樓等商業租約，也可以用信用卡交租嗎？", a: "可以。Keychain 全面支持商用物業、寫字樓、車位及各類商業合同的租金支付。商業租金一般金額較大，使用信用卡網上交租能讓公司現金流更為靈活，並極速累積飛行里數與現金回贈。" },
              { q: "滙豐信用卡的 0.8% 手續費和 3.6% 回贈有期限嗎？", a: "是的。該 0.8% 特低手續費搭配最高 3.6% 獎賞錢回贈為推廣合約優惠，有效期至 2027-03-31。建議廣大租戶儘早綁定合約，鎖定這段推廣期內極高性價比的交租回贈！" }
            ].map((faq, i) => (
              <details key={i} style={{ marginBottom: 16, border: '1px solid #E5E7EB', borderRadius: 8, padding: '12px 16px', backgroundColor: '#F9FAFB' }}>
                <summary style={{ fontWeight: 600, cursor: 'pointer', color: '#1F2937' }}>Q{i+1}: {faq.q}</summary>
                <p style={{ marginTop: 8, fontSize: 14, color: '#4B5563', margin: '8px 0 0 0' }}>{faq.a}</p>
              </details>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: 40 }}>
            <button onClick={() => onNavigate('home')} style={{ display: 'inline-block', backgroundColor: '#E57500', color: 'white', padding: '12px 32px', fontWeight: 'bold', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 16 }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#B55B00'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = '#E57500'}>
              立即體驗信用卡網上交租
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

// ── PROMOTIONS ───────────────────────────────────────────────────────────────
// /promotions (index) and /promotions/referral. Ported from the Claude Design
// project `Promotions.dc.html`. Copy is kept in this page-local PROMO_CONTENT
// object rather than atomised into DICT_* — same treatment as
// HSBC_PROMO_CONTENT above, since the nesting (tiles, steps, T&C groups with
// sub-items) is closer to the CARDS / REWARDS data objects than to dict keys.

const TILE = [{
  bg: '#ffffff',
  border: '#EEE7DC',
  labelColor: '#6B7280',
  amtColor: '#1F3540',
  noteColor: '#6B7280'
}, {
  bg: '#ffffff',
  border: '#EEE7DC',
  labelColor: '#6B7280',
  amtColor: '#1F3540',
  noteColor: '#6B7280'
}, {
  bg: '#1F3540',
  border: '#1F3540',
  labelColor: 'rgba(255,255,255,0.6)',
  amtColor: '#FFA567',
  noteColor: 'rgba(255,255,255,0.6)'
}];

const APP_STORE = 'https://apps.apple.com/hk/app/keychain-pay-smart-rental/id1190238170';
const PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.keychainpay';

const PROMO_CONTENT = {
  en: {
    allPromotions: 'All promotions',
    p: {
      seoTitle: 'Promotions | Keychain',
      seoDesc: 'Rent smarter, earn more. Refer a friend for up to HK$150 rebate, or pay rent with your HSBC credit card for fees from 0.8%.',
      eyebrow: 'Promotions',
      title: 'Rent smarter, earn more',
      sub: 'Make the most of your rent payments with two exclusive offers on Keychain: Refer a friend and both of you earn a rebate, or pay rent with your HSBC credit card for the lowest transaction fee and the most RewardCash.',
      refBadge: 'New · Referral programme',
      refTitle: 'Refer Your Friend, Get Rebate',
      refSub: 'From now to 31 Dec 2026, refer a friend to register and set up a Smart Contract with Keychain — you and your friend both earn a rebate.',
      refPerReferral: 'in total, per successful referral',
      refCta: 'Learn more',
      hsbcBadge: 'HSBC CREDIT CARDS × KEYCHAIN',
      hsbcTitle: 'Earn RewardCash on your rent',
      hsbcSub: 'Pay rent with your HSBC credit card via Keychain — transaction fee as low as 0.8%, and earn up to 3.6% RewardCash.',
      hsbcCta: 'See HSBC offers'
    },
    r: {
      seoTitle: 'Refer Your Friend Get Rebate | Keychain',
      seoDesc: 'Refer a friend to Keychain and you both earn a rebate — HK$100 for you, HK$50 for them, per successful referral. Offer ends 31 Dec 2026.',
      eyebrow: 'Referral programme',
      title: 'Refer Your Friend Get Rebate',
      sub: 'From now to 31 Dec 2026, refer a friend to register and set up Smart Contract with Keychain, both earn up to HK$150 rebate per referral.',
      rebateTitle: 'How much you both earn',
      rebateCondition: 'Referee New Registration and Set Up 6 Months or above Smart Contract',
      tiles: [{
        label: 'Referrer',
        amt: '$100',
        note: 'Rebate on your next transaction fee, or paid with your rent receivable.'
      }, {
        label: 'Referee',
        amt: '$50',
        note: 'Rebate once your first Smart Contract is approved.'
      }, {
        label: 'Total for both',
        amt: '$150',
        note: 'Per successful referral, in HKD.'
      }],
      moreTagline: 'Refer more, Earn more!',
      notes: ['* Referrer must be an existing user and must have paid or received at least one rental payment of HK$10,000 or above (excluding transaction fee) through Keychain in the past 6 months. Smart Contract must be set at HK$10,000 or above in the rent when the Referrer is a tenant.', '** Terms and conditions apply.'],
      stepsEyebrow: 'Mechanism',
      stepsTitle: 'How it works',
      steps: [{
        n: '01',
        title: 'Open your referral link',
        desc: 'Log in to the Keychain app, Tap Profile > Referral.'
      }, {
        n: '02',
        title: 'Share the referral link',
        desc: 'Send it to the friend you want to refer.'
      }, {
        n: '03',
        title: 'Friend opens the link',
        desc: 'Referee download and open Keychain app with the referral link. The referrer email is auto-filled.'
      }, {
        n: '04',
        title: 'Register and verify',
        desc: 'Complete the registration and email verification.'
      }, {
        n: '05',
        title: 'Set up a Smart Contract',
        desc: 'Referee set up Smart Contract for at least 6 months.'
      }, {
        n: '06',
        title: 'Approved',
        desc: 'Referrer gets $100, Referee gets $50.'
      }],
      stepsNote: '* Referee can input the Referrer’s registered email address or phone number directly in the “Referrer” field upon registration.',
      ctaTitle: 'Refer Your Friends Now!',
      ctaSub: 'Start Experiencing the Smart and Rewarding Rental Payment!',
      ctaLinks: [{
        label: 'App Store',
        href: APP_STORE,
        bg: '#E57500',
        color: '#ffffff',
        border: 'none'
      }, {
        label: 'Google Play',
        href: PLAY_STORE,
        bg: '#E57500',
        color: '#ffffff',
        border: 'none'
      }, {
        label: 'Web Portal',
        href: APP_URL,
        bg: 'transparent',
        color: '#ffffff',
        border: '2px solid rgba(255,255,255,0.5)'
      }],
      tncTitle: 'Terms and conditions',
      tncGroups: [{
        title: 'Eligibility',
        items: [{
          n: 1,
          text: 'The “Refer Your Friend Get Rebate” promotion (the “Promotion”) period is from 28 November 2025 to 31 December 2026, both dates inclusive (“Promotion Period”).'
        }, {
          n: 2,
          text: 'Referrers in the Promotion (“Eligible Referrer”) are only applicable to current Keychain users who have paid or received at least one rental payment of HK$10,000 or above (excluding transaction fee) through Keychain in the past 6 months. Rent on the Smart Contract must be set at HK$10,000 or above if he or she is a tenant.'
        }, {
          n: 3,
          text: 'Referees in the Promotion (“Eligible Referee”) are only applicable to first-time users who are newly registered with Keychain. New registration requires using an email address and a contact number which have not been used in Keychain and completes with email verification.'
        }, {
          n: 4,
          text: 'Eligible Referee must provide the registered contact number and email address of Eligible Referrer. If no such information is found, the account will not be recognised as Eligible Referee or eligible to enjoy the rebate offers (the “Rebate”) in the Promotion.'
        }, {
          n: 5,
          text: 'Eligible Referee must set up a new Smart Contract for 6 months or longer. The Rebate is only applicable when the Smart Contract is approved and in good standing during the Promotion Period. For the avoidance of doubt, a new Smart Contract refers to a legitimate and stamped tenancy agreement that has not been used in Keychain.'
        }, {
          n: 6,
          text: 'The Rebate is not applicable to corporate clients. Individual users who pay commercial rent are not limited.'
        }]
      }, {
        title: 'How to join',
        items: [{
          n: 1,
          text: 'If Eligible Referrer is a tenant,',
          hasSubs: true,
          subs: ['1.1 He or she is a current Keychain user who has paid at least one rental payment of HK$10,000 or above (excluding transaction fee) through Keychain in the past 6 months. Smart Contract must be set at HK$10,000 or above in the rent.', '1.2 After Eligible Referee successfully registers a new account with Keychain and sets up a new Smart Contract for 6 months or longer, Eligible Referrer can receive a rebate of HK$100, which will be used to deduct transaction fee in his/her next payment with Keychain.']
        }, {
          n: 2,
          text: 'If Eligible Referrer is a landlord,',
          hasSubs: true,
          subs: ['2.1 After Eligible Referee successfully registers a new account with Keychain and sets up a new Smart Contract for 6 months or longer, Eligible Referrer can receive a rebate of HK$100, which will be deposited into his/her registered bank account together with rent receivable.']
        }, {
          n: 3,
          text: 'Eligible Referrer can be entitled once to the rebates of HK$100 per each Eligible Referee.'
        }, {
          n: 4,
          text: 'If Eligible Referee is a tenant, he/she can receive a rebate of HK$50 after successfully setting up a Smart Contract of 6 months or longer. The rebate of HK$50 will be used to deduct transaction fee in his/her next payment with Keychain.'
        }, {
          n: 5,
          text: 'If the referee is a landlord, he/she can receive a rebate of HK$50 after successfully setting up a Smart Contract of 6 months or longer. The rebate of HK$50 will be deposited into his/her registered bank account together with rent receivable.'
        }, {
          n: 6,
          text: 'The Rebate can only be used to deduct transaction fee when the rent on the Smart Contract is set at HK$10,000 or above and when the transaction fee is higher or equal to the total amount of the offers. Only a rebate of HK$50 shall be used per rental period payment. A cash rebate equivalent to HKD 50 will be deducted from the transaction fee. Customers will pay for the outstanding transaction fee to complete the transaction. Any outstanding cash rebate amount can be used in the next eligible transaction.'
        }, {
          n: 7,
          text: 'Example: Taking the rebate of HK$50 and transaction fee of HK$127 in the example. The transaction fee is higher than the total amount of the rebates. So, the payable amount of the transaction fee will be reduced to HK$77 (HK$127 - HK$50 = HK$77) after deducting from the rebate.'
        }, {
          n: 8,
          text: 'The Rebate is not transferable or exchanged for cash/other products or used in conjunction with other promotions unless specified.'
        }, {
          n: 9,
          text: 'If Eligible Referrer or Referee terminate his/her running Smart Contract or fail to settle any monthly payment, including deposits and disbursements if applicable, at the time after the Rebate is offered, Keychain reserves the right to charge back the given Rebate at any time reasonable.'
        }, {
          n: 10,
          text: 'In case of any fraud or abuse, Keychain reserves the right at any time of the forfeiture of his/her eligibility for the Rebate as well as cancellation of the Smart Contract(s). Keychain further reserves the right to deduct any relevant value of the Rebate redeemed inappropriately directly from any of the payment cards in his/her name without prior notice.'
        }, {
          n: 11,
          text: 'Terms and conditions from Keychain shall apply. Please visit ',
          hasLink: true,
          linkLabel: 'HERE',
          linkId: 'terms',
          post: ' for details.'
        }, {
          n: 12,
          text: 'These terms and conditions are applicable on or before 31 December 2026. Keychain reserves the right to terminate or change these terms and conditions without prior notice. In the event of disputes arising out of the Promotion, the decision by Keychain shall be final and conclusive.'
        }, {
          n: 13,
          text: 'In the case of any discrepancy or inconsistency between the English version and the Chinese version, the English version shall apply.'
        }]
      }],
      tncHide: 'Hide',
      tncShow: 'Show'
    }
  },
  tc: {
    allPromotions: '所有優惠',
    p: {
      seoTitle: '推廣優惠 | Keychain',
      seoDesc: 'Keychain 現正推出兩項優惠：推薦親友，雙方同享回贈；或以滙豐信用卡交租，享最低交易費及最多「獎賞錢」。',
      eyebrow: '推廣優惠',
      title: '交租更精明，\n回贈更豐富',
      sub: 'Keychain 精選兩大優惠：推薦親友，雙方同享回贈；以滙豐信用卡交租，享最低交易費及最多「獎賞錢」。',
      refBadge: '全新 · 推薦計劃',
      refTitle: '推薦親友‧享回贈',
      refSub: '即日起至 2026 年 12 月 31 日，推薦親友於 Keychain 註冊和設置智能合約，你與親友均可獲得回贈。',
      refPerReferral: '每成功推薦一位親友，雙方合共獲得',
      refCta: '了解更多',
      hsbcBadge: '滙豐信用卡 × KEYCHAIN',
      hsbcTitle: '交租，都可以賺「獎賞錢」',
      hsbcSub: '以滙豐信用卡透過 Keychain 繳付租金，交易費低至 0.8%，更可賺取高達 3.6%「獎賞錢」。',
      hsbcCta: '查看滙豐優惠'
    },
    r: {
      seoTitle: '推薦親友‧享回贈 | Keychain',
      seoDesc: '即日起至2026年12月31日，推薦親友於Keychain 註冊和設置6個月或以上的智能合約，每推薦一個親友，合共最高可獲得港幣150元交易費回贈。',
      eyebrow: '推薦計劃',
      title: '推薦親友‧享回贈',
      sub: '即日起至2026年12月31日，推薦親友於Keychain 註冊和設置6個月或以上的智能合約，每推薦一個親友，合共最高可獲得港幣150元交易費回贈。',
      rebateTitle: '雙方可獲得的回贈',
      rebateCondition: '被推薦親友成功註冊和設置6個月或以上的全新智能合約',
      tiles: [{
        label: '推薦人',
        amt: '$100',
        note: '用於抵銷下一次交易費，或連同租金款項存入銀行戶口。'
      }, {
        label: '被推薦人',
        amt: '$50',
        note: '首份智能合約獲批核後即可獲得。'
      }, {
        label: '合共獲得',
        amt: '$150',
        note: '每成功推薦一位親友（港幣）。'
      }],
      moreTagline: '推薦越多，回贈越多！',
      notes: ['* 推薦人必須為現有Keychain客戶，並於過去6個月內曾透過Keychain繳付或收取至少一筆港幣10,000元或以上的租金（不包括交易費）。若推薦人為租客，其有效智能合約之租金金額需達每月港幣10,000元或以上。', '** 優惠受條款及細則約束。'],
      stepsEyebrow: '推薦機制',
      stepsTitle: '推薦程序',
      steps: [{
        n: '01',
        title: '開啟推薦連結',
        desc: '登入Keychain app，點選帳戶資料 > 推薦計劃。'
      }, {
        n: '02',
        title: '分享推薦連結',
        desc: '把連結傳送給您想推薦的親友。'
      }, {
        n: '03',
        title: '親友點選連結',
        desc: '被推薦親友點選連結，下載並啟動Keychain app。推薦人的電郵已自動填上。'
      }, {
        n: '04',
        title: '完成註冊及驗證',
        desc: '完成註冊及電郵驗證。'
      }, {
        n: '05',
        title: '設置智能合約',
        desc: '被推薦親友設置6個月或以上的智能合約。'
      }, {
        n: '06',
        title: '成功審核',
        desc: '推薦人可獲$100回贈，被推薦親友亦可獲$50回贈。'
      }],
      stepsNote: '* 被推薦親友亦可直接於註冊時，填上推薦人的已註冊電郵地址或電話號碼。',
      ctaTitle: '立即推薦親友！',
      ctaSub: '立即推薦親友，體驗最嶄新方便的租務平台。',
      ctaLinks: [{
        label: 'App Store',
        href: APP_STORE,
        bg: '#E57500',
        color: '#ffffff',
        border: 'none'
      }, {
        label: 'Google Play',
        href: PLAY_STORE,
        bg: '#E57500',
        color: '#ffffff',
        border: 'none'
      }, {
        label: '網頁版',
        href: APP_URL,
        bg: 'transparent',
        color: '#ffffff',
        border: '2px solid rgba(255,255,255,0.5)'
      }],
      tncTitle: '條款及細則',
      tncGroups: [{
        title: '參加資格',
        items: [{
          n: 1,
          text: '「推薦親友‧享回贈」計劃（「本推廣」）由2025年11月28日至2026年12月31日（包括首尾兩日）為止（「推廣期」）。'
        }, {
          n: 2,
          text: '參加本推廣之推薦人（「推薦人」）必須為Keychain現有客戶，並於過去6個月內曾透過Keychain繳付或收取至少一筆港幣10,000元或以上的租金（不包括交易費）。若推薦人為租客，其有效智能合約之租金金額需達每月港幣10,000元或以上。'
        }, {
          n: 3,
          text: '參加本推廣之被推薦人（「被推薦人」）必須為Keychain全新用戶，即其電郵地址和電話號碼均未曾於Keychain註冊，並完成電郵驗證。'
        }, {
          n: 4,
          text: '被推薦人必須填妥推薦人電話號碼及已註冊電郵地址，方可合資格獲得本推廣之交易費回贈（「回贈」）。推薦人資料一經提交，將不能修改，請確保推薦人資料正確無誤。如確認登記時未能找到相關推薦人之資料，登記會自動修改為非推薦之登記而恕不另行通知。'
        }, {
          n: 5,
          text: '被推薦人必須主動設置6個月或以上的全新智能合約，一經批核，方可合資格獲得回贈。為免生疑問，「全新智能合約」指該份已蓋章合法租務協議從未於Keychain設置上使用。'
        }, {
          n: 6,
          text: '此優惠不適用於商業用戶，個人用戶繳付工商業單位租金則不在此限。'
        }]
      }, {
        title: '參加方式',
        items: [{
          n: 1,
          text: '若推薦人為租客，',
          hasSubs: true,
          subs: ['1.1 參加本推廣之推薦人（「推薦人」）必須為Keychain現有客戶，並於過去6個月內曾透過Keychain繳付至少一筆港幣10,000元或以上的租金（不包括交易費），其有效智能合約之租金金額需達每月港幣10,000元或以上。', '1.2 當被推薦人成功註冊成為Keychain用戶及設置6個月或以上的智能合約並獲成功批核後，推薦人會獲得價值港幣100元之交易費回贈，作抵銷交易費之用。']
        }, {
          n: 2,
          text: '若推薦人為業主，',
          hasSubs: true,
          subs: ['2.1 當被推薦人成功註冊成為Keychain用戶及設置6個月或以上的智能合約並獲成功批核後，推薦人會獲得價值港幣100元之回贈，該回贈會連同租金款項存入所登記之銀行戶口。']
        }, {
          n: 3,
          text: '推薦人就每位被推薦人享有一次價值港幣100元之回贈。'
        }, {
          n: 4,
          text: '若被推薦人為租客，當成功設置6個月或以上的智能合約並獲成功批核後，會獲得價值港幣50元之交易費回贈，作抵銷交易費之用。'
        }, {
          n: 5,
          text: '若被推薦人為業主，當成功設置6個月或以上的智能合約並成功批核後，會獲得價值港幣50元之現金回贈，該回贈會連同租金款項存入所登記之銀行戶口。'
        }, {
          n: 6,
          text: '每次使用交易費回贈時，租金金額需達港幣10,000元或以上（不包括交易費），應付之交易費必須等同或高於港幣50元，每個租期的租金付款最多只可以使用港幣50元之交易費回贈。系統會從應付之交易中扣減回贈之等額。未使用之交易費回贈適用於下次合資格的交易。'
        }, {
          n: 7,
          text: '例子：當應付之交易費高於回贈總額時，如交易費回贈價值為港幣50元，應付之交易費為港幣127元，即是次應付之交易費減至港幣77元（HK$127 - HK$50 = HK$77）。'
        }, {
          n: 8,
          text: '此回贈不得轉讓。除非另有說明，此回贈不能兌換現金或其他產品，亦不可與其他推廣優惠一併使用。'
        }, {
          n: 9,
          text: '當享用此回贈後，若推薦人或被推薦人提早終止智能合約或於智能合約生效期間未能以合資格銀行卡以港幣支付全額租金，包括按金或費用（如適用），Keychain就已發放之回贈保留在任何時候合理收回或扣取的權利。'
        }, {
          n: 10,
          text: '如有任何欺詐或濫用行為，Keychain保留於任何時候取消參加本推廣的資格以及智能合約的權利。Keychain保留權利從相關銀行卡直接扣除於本推廣獲享的回贈金額，恕不另行通知。'
        }, {
          n: 11,
          text: 'Keychain的一般條款適用。詳情請參閱',
          hasLink: true,
          linkLabel: '此處',
          linkId: 'terms',
          post: '。'
        }, {
          n: 12,
          text: '本推廣之回贈安排及準則只適用於2026年12月31日或之前，Keychain有權隨時終止本推廣及更改有關條款及細則而不作另行通知。就本推廣如有任何爭議，Keychain保留最終決定權。'
        }, {
          n: 13,
          text: '如中、英文兩個版本之條款細則有任何抵觸或不相符之處，應以英文版本為準。'
        }]
      }],
      tncHide: '收合',
      tncShow: '展開'
    }
  },
  sc: {
    allPromotions: '所有优惠',
    p: {
      seoTitle: '推广优惠 | Keychain',
      seoDesc: 'Keychain 现正推出两项优惠：推荐亲友，双方同享回赠；或以汇丰信用卡缴付租金，享最低交易费及最多「奖赏钱」。',
      eyebrow: '推广优惠',
      title: '交租更精明，\n回赠更丰富',
      sub: 'Keychain 精选两大优惠：推荐亲友，双方同享回赠；以汇丰信用卡缴付租金，享最低交易费及最多「奖赏钱」。',
      refBadge: '全新 · 推荐计划',
      refTitle: '推荐亲友‧享回赠',
      refSub: '即日起至 2026 年 12 月 31 日，推荐亲友于 Keychain 注册和设置智能合约，你与亲友均可获得回赠。',
      refPerReferral: '每成功推荐一位亲友，双方合共获得',
      refCta: '了解更多',
      hsbcBadge: '汇丰信用卡 × KEYCHAIN',
      hsbcTitle: '缴付租金，也可以赚「奖赏钱」',
      hsbcSub: '以汇丰信用卡通过 Keychain 缴付租金，交易费低至 0.8%，更可赚取高达 3.6%「奖赏钱」。',
      hsbcCta: '查看汇丰优惠'
    },
    r: {
      seoTitle: '推荐亲友‧享回赠 | Keychain',
      seoDesc: '即日起至2026年12月31日，推荐亲友于Keychain 注册和设置6个月或以上的智能合约，每推荐一个亲友，合共最高可获得港币150元交易费回赠。',
      eyebrow: '推荐计划',
      title: '推荐亲友‧享回赠',
      sub: '即日起至2026年12月31日，推荐亲友于Keychain 注册和设置6个月或以上的智能合约，每推荐一个亲友，合共最高可获得港币150元交易费回赠。',
      rebateTitle: '双方可获得的回赠',
      rebateCondition: '被推荐亲友成功注册和设置6个月或以上的全新智能合约',
      tiles: [{
        label: '推荐人',
        amt: '$100',
        note: '用于抵销下一次交易费，或连同租金款项存入银行账户。'
      }, {
        label: '被推荐人',
        amt: '$50',
        note: '首份智能合约获批核后即可获得。'
      }, {
        label: '合共获得',
        amt: '$150',
        note: '每成功推荐一位亲友（港币）。'
      }],
      moreTagline: '推荐越多，回赠越多！',
      notes: ['* 推荐人必须为现有Keychain客户，并于过去6个月内曾通过Keychain缴付或收取至少一笔港币10,000元或以上的租金（不包括交易费）。若推荐人为租客，其有效智能合约之租金金额需达每月港币10,000元或以上。', '** 优惠受条款及细则约束。'],
      stepsEyebrow: '推荐机制',
      stepsTitle: '推荐程序',
      steps: [{
        n: '01',
        title: '开启推荐链接',
        desc: '登录Keychain app，点选账户资料 > 推荐计划。'
      }, {
        n: '02',
        title: '分享推荐链接',
        desc: '把链接发送给您想推荐的亲友。'
      }, {
        n: '03',
        title: '亲友点选链接',
        desc: '被推荐亲友点选链接，下载并启动Keychain app。推荐人的电邮已自动填上。'
      }, {
        n: '04',
        title: '完成注册及验证',
        desc: '完成注册及电邮验证。'
      }, {
        n: '05',
        title: '设置智能合约',
        desc: '被推荐亲友设置6个月或以上的智能合约。'
      }, {
        n: '06',
        title: '成功审核',
        desc: '推荐人可获$100回赠，被推荐亲友亦可获$50回赠。'
      }],
      stepsNote: '* 被推荐亲友亦可直接于注册时，填上推荐人的已注册电邮地址或电话号码。',
      ctaTitle: '立即推荐亲友！',
      ctaSub: '立即推荐亲友，体验最崭新方便的租务平台。',
      ctaLinks: [{
        label: 'App Store',
        href: APP_STORE,
        bg: '#E57500',
        color: '#ffffff',
        border: 'none'
      }, {
        label: 'Google Play',
        href: PLAY_STORE,
        bg: '#E57500',
        color: '#ffffff',
        border: 'none'
      }, {
        label: '网页版',
        href: APP_URL,
        bg: 'transparent',
        color: '#ffffff',
        border: '2px solid rgba(255,255,255,0.5)'
      }],
      tncTitle: '条款及细则',
      tncGroups: [{
        title: '参加资格',
        items: [{
          n: 1,
          text: '「推荐亲友‧享回赠」计划（「本推广」）由2025年11月28日至2026年12月31日（包括首尾两日）为止（「推广期」）。'
        }, {
          n: 2,
          text: '参加本推广之推荐人（「推荐人」）必须为Keychain现有客户，并于过去6个月内曾通过Keychain缴付或收取至少一笔港币10,000元或以上的租金（不包括交易费）。若推荐人为租客，其有效智能合约之租金金额需达每月港币10,000元或以上。'
        }, {
          n: 3,
          text: '参加本推广之被推荐人（「被推荐人」）必须为Keychain全新用户，即其电邮地址和电话号码均未曾于Keychain注册，并完成电邮验证。'
        }, {
          n: 4,
          text: '被推荐人必须填妥推荐人电话号码及已注册电邮地址，方可合资格获得本推广之交易费回赠（「回赠」）。推荐人资料一经提交，将不能修改，请确保推荐人资料正确无误。如确认登记时未能找到相关推荐人之资料，登记会自动修改为非推荐之登记而恕不另行通知。'
        }, {
          n: 5,
          text: '被推荐人必须主动设置6个月或以上的全新智能合约，一经批核，方可合资格获得回赠。为免生疑问，「全新智能合约」指该份已盖章合法租务协议从未于Keychain设置上使用。'
        }, {
          n: 6,
          text: '此优惠不适用于商业用户，个人用户缴付工商业单位租金则不在此限。'
        }]
      }, {
        title: '参加方式',
        items: [{
          n: 1,
          text: '若推荐人为租客，',
          hasSubs: true,
          subs: ['1.1 参加本推广之推荐人（「推荐人」）必须为Keychain现有客户，并于过去6个月内曾通过Keychain缴付至少一笔港币10,000元或以上的租金（不包括交易费），其有效智能合约之租金金额需达每月港币10,000元或以上。', '1.2 当被推荐人成功注册成为Keychain用户及设置6个月或以上的智能合约并获成功批核后，推荐人会获得价值港币100元之交易费回赠，作抵销交易费之用。']
        }, {
          n: 2,
          text: '若推荐人为业主，',
          hasSubs: true,
          subs: ['2.1 当被推荐人成功注册成为Keychain用户及设置6个月或以上的智能合约并获成功批核后，推荐人会获得价值港币100元之回赠，该回赠会连同租金款项存入所登记之银行账户。']
        }, {
          n: 3,
          text: '推荐人就每位被推荐人享有一次价值港币100元之回赠。'
        }, {
          n: 4,
          text: '若被推荐人为租客，当成功设置6个月或以上的智能合约并获成功批核后，会获得价值港币50元之交易费回赠，作抵销交易费之用。'
        }, {
          n: 5,
          text: '若被推荐人为业主，当成功设置6个月或以上的智能合约并成功批核后，会获得价值港币50元之现金回赠，该回赠会连同租金款项存入所登记之银行账户。'
        }, {
          n: 6,
          text: '每次使用交易费回赠时，租金金额需达港币10,000元或以上（不包括交易费），应付之交易费必须等同或高于港币50元，每个租期的租金付款最多只可以使用港币50元之交易费回赠。系统会从应付之交易中扣减回赠之等额。未使用之交易费回赠适用于下次合资格的交易。'
        }, {
          n: 7,
          text: '例子：当应付之交易费高于回赠总额时，如交易费回赠价值为港币50元，应付之交易费为港币127元，即是次应付之交易费减至港币77元（HK$127 - HK$50 = HK$77）。'
        }, {
          n: 8,
          text: '此回赠不得转让。除非另有说明，此回赠不能兑换现金或其他产品，亦不可与其他推广优惠一并使用。'
        }, {
          n: 9,
          text: '当享用此回赠后，若推荐人或被推荐人提早终止智能合约或于智能合约生效期间未能以合资格银行卡以港币支付全额租金，包括按金或费用（如适用），Keychain就已发放之回赠保留在任何时候合理收回或扣取的权利。'
        }, {
          n: 10,
          text: '如有任何欺诈或滥用行为，Keychain保留于任何时候取消参加本推广的资格以及智能合约的权利。Keychain保留权利从相关银行卡直接扣除于本推广获享的回赠金额，恕不另行通知。'
        }, {
          n: 11,
          text: 'Keychain的一般条款适用。详情请参阅',
          hasLink: true,
          linkLabel: '此处',
          linkId: 'terms',
          post: '。'
        }, {
          n: 12,
          text: '本推广之回赠安排及准则只适用于2026年12月31日或之前，Keychain有权随时终止本推广及更改有关条款及细则而不作另行通知。就本推广如有任何争议，Keychain保留最终决定权。'
        }, {
          n: 13,
          text: '如中、英文两个版本之条款细则有任何抵触或不相符之处，应以英文版本为准。'
        }]
      }],
      tncHide: '收合',
      tncShow: '展开'
    }
  }
};

function promoContent() {
  const lang = PROMO_CONTENT[currentLang] ? currentLang : 'en';
  return {
    c: PROMO_CONTENT[lang],
    base: '/' + lang + '/'
  };
}

// /promotions — index listing the live offers
function PromotionsPage({ onNavigate }) {
  const {
    c,
    base
  } = promoContent();
  const p = c.p;
  const go = path => e => {
    if (onNavigate) {
      e.preventDefault();
      onNavigate(path);
      window.scrollTo(0, 0);
    }
  };
  return <div>
      <SEO title={p.seoTitle} description={p.seoDesc} urlPath={`/${currentLang}/promotions/`} />

      <section style={{
      background: 'linear-gradient(135deg, #B55B00 0%, #E57500 28%, #67919F 70%, #2D4E5C 88%, #1F3540 100%)',
      padding: '96px 24px 84px',
      position: 'relative',
      overflow: 'hidden'
    }}>
        <div style={{
        position: 'absolute',
        top: '6%',
        right: '12%',
        width: 400,
        height: 400,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(230,160,137,0.25) 0%, transparent 70%)',
        pointerEvents: 'none'
      }} />
        <div style={{
        position: 'relative',
        maxWidth: 1200,
        margin: '0 auto'
      }}>
          <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          background: 'rgba(255,255,255,0.16)',
          color: '#FFE3CF',
          border: '1px solid rgba(255,255,255,0.35)',
          borderRadius: 20,
          padding: '4px 12px',
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: '0.05em',
          textTransform: 'uppercase'
        }}>{p.eyebrow}</span>
          <h1 style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: 'clamp(34px, 5.6vw, 60px)',
          fontWeight: 800,
          color: 'white',
          lineHeight: 1.06,
          letterSpacing: '-0.03em',
          margin: '18px 0',
          maxWidth: '15ch',
          whiteSpace: 'pre-line'
        }}>{p.title}</h1>
          <p style={{
          fontSize: 'clamp(16px,2vw,19px)',
          color: 'rgba(255,255,255,0.78)',
          lineHeight: 1.65,
          maxWidth: '60ch',
          margin: 0
        }}>{p.sub}</p>
        </div>
      </section>

      {/* Referral banner */}
      <section style={{
      position: 'relative',
      overflow: 'hidden',
      background: '#1F3540',
      minHeight: 'clamp(420px, 32vw, 620px)',
      display: 'flex',
      alignItems: 'center',
      padding: '64px 24px'
    }}>
        <img src="/uploads/referral-hero.webp" alt="" style={{
        position: 'absolute',
        top: 0,
        left: '16%',
        width: '84%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: '62% 35%'
      }} />
        <div style={{
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(90deg, rgba(31,53,64,1) 0%, rgba(31,53,64,1) 17%, rgba(31,53,64,0.82) 38%, rgba(31,53,64,0.18) 76%, rgba(31,53,64,0) 100%)'
      }} />
        <div style={{
        position: 'relative',
        width: '100%',
        maxWidth: 1200,
        margin: '0 auto'
      }}>
          <div style={{
          maxWidth: 660
        }}>
          <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          background: '#E57500',
          color: '#fff',
          borderRadius: 20,
          padding: '4px 12px',
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: '0.05em',
          textTransform: 'uppercase'
        }}>{p.refBadge}</span>
          <h2 style={{
          fontFamily: "'Space Grotesk', sans-serif",
          color: 'white',
          fontSize: 'clamp(28px, 4vw, 42px)',
          fontWeight: 900,
          lineHeight: 1.2,
          margin: '20px 0 14px'
        }}>{p.refTitle}</h2>
          <p style={{
          color: 'rgba(255,255,255,0.88)',
          fontSize: 17,
          lineHeight: 1.7,
          marginBottom: 10,
          maxWidth: 500
        }}>{p.refSub}</p>
          <div style={{
          display: 'flex',
          alignItems: 'baseline',
          gap: 10,
          marginBottom: 26
        }}>
            <span style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontSize: 44,
            fontWeight: 900,
            color: '#FFA567',
            lineHeight: 1
          }}>HK$150</span>
            <span style={{
            fontSize: 14,
            color: 'rgba(255,255,255,0.72)'
          }}>{p.refPerReferral}</span>
          </div>
          <a href={base + 'promotions/referral/'} onClick={go('promotions/referral')} style={{
          background: '#E57500',
          color: 'white',
          borderRadius: 10,
          padding: '13px 26px',
          fontSize: 15,
          fontWeight: 600,
          textDecoration: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8
        }}>{p.refCta}</a>
          </div>
        </div>
      </section>

      {/* HSBC banner */}
      <section style={{
      position: 'relative',
      overflow: 'hidden',
      background: '#14263B',
      minHeight: 'clamp(420px, 32vw, 620px)',
      display: 'flex',
      alignItems: 'center',
      padding: '64px 24px'
    }}>
        <img src="/uploads/hsbc-promo-hero.webp" alt="" style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: '55% 30%'
      }} />
        <div style={{
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(90deg, rgba(20,38,59,0.92) 0%, rgba(20,38,59,0.78) 38%, rgba(20,38,59,0.15) 75%, rgba(20,38,59,0) 100%)'
      }} />
        <div style={{
        position: 'relative',
        width: '100%',
        maxWidth: 1200,
        margin: '0 auto'
      }}>
          <div style={{
          maxWidth: 640
        }}>
          <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          background: 'rgba(219,0,17,0.92)',
          color: '#fff',
          borderRadius: 20,
          padding: '4px 12px',
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: '0.05em',
          textTransform: 'uppercase'
        }}>{p.hsbcBadge}</span>
          <h2 style={{
          fontFamily: "'Space Grotesk', sans-serif",
          color: 'white',
          fontSize: 'clamp(28px, 4vw, 42px)',
          fontWeight: 900,
          lineHeight: 1.2,
          margin: '20px 0 14px'
        }}>{p.hsbcTitle}</h2>
          <p style={{
          color: 'rgba(255,255,255,0.85)',
          fontSize: 17,
          lineHeight: 1.7,
          marginBottom: 28,
          maxWidth: 480
        }}>{p.hsbcSub}</p>
          <a href={base + 'promotions/hsbc/'} onClick={go('promotions/hsbc')} style={{
          background: '#E57500',
          color: 'white',
          borderRadius: 10,
          padding: '13px 26px',
          fontSize: 15,
          fontWeight: 600,
          textDecoration: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8
        }}>{p.hsbcCta}</a>
          </div>
        </div>
      </section>
    </div>;
}

// /promotions/referral — the referral programme
function ReferralPage({ onNavigate }) {
  const {
    c,
    base
  } = promoContent();
  const r = c.r;
  const [tncOpen, setTncOpen] = React.useState(true);
  const goPromotions = e => {
    if (onNavigate) {
      e.preventDefault();
      onNavigate('promotions');
      window.scrollTo(0, 0);
    }
  };
  return <div>
      <SEO title={r.seoTitle} description={r.seoDesc} urlPath={`/${currentLang}/promotions/referral/`} />

      <section style={{
      position: 'relative',
      overflow: 'hidden',
      background: '#1F3540',
      minHeight: 520,
      display: 'flex',
      alignItems: 'center',
      padding: '96px 24px 60px'
    }}>
        <img src="/uploads/referral-hero.webp" alt="" style={{
        position: 'absolute',
        top: 0,
        left: '16%',
        width: '84%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: '62% 8%'
      }} />
        <div style={{
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(90deg, rgba(31,53,64,1) 0%, rgba(31,53,64,1) 17%, rgba(31,53,64,0.84) 40%, rgba(31,53,64,0.2) 78%, rgba(31,53,64,0) 100%)'
      }} />
        <div style={{
        position: 'relative',
        width: '100%',
        maxWidth: 1200,
        margin: '0 auto'
      }}>
          <div style={{
          maxWidth: 560
        }}>
          <a href={base + 'promotions/'} onClick={goPromotions} style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          color: 'rgba(255,255,255,0.7)',
          fontSize: 13,
          fontWeight: 600,
          textDecoration: 'none',
          marginBottom: 20
        }}>&larr; {c.allPromotions}</a>
          <div>
            <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            background: '#E57500',
            color: '#fff',
            borderRadius: 20,
            padding: '4px 12px',
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: '0.05em',
            textTransform: 'uppercase'
          }}>{r.eyebrow}</span>
          </div>
          <h1 style={{
          fontFamily: "'Space Grotesk', sans-serif",
          color: 'white',
          fontSize: 'clamp(32px, 5vw, 54px)',
          fontWeight: 900,
          lineHeight: 1.15,
          margin: '20px 0 16px'
        }}>{r.title}</h1>
          <p style={{
          color: 'rgba(255,255,255,0.9)',
          fontSize: 18,
          lineHeight: 1.7,
          maxWidth: 560
        }}>{r.sub}</p>
          </div>
        </div>
      </section>

      {/* Rebate breakdown */}
      <section style={{
      background: '#FBF8F4',
      padding: '96px 24px'
    }}>
        <div style={{
        maxWidth: 1200,
        margin: '0 auto'
      }}>
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          marginBottom: 8
        }}>
            <div style={{
            width: 34,
            height: 4,
            background: '#E57500'
          }} />
            <div style={{
            fontSize: 14,
            fontWeight: 700,
            color: '#E57500',
            letterSpacing: 2
          }}>KEYCHAIN</div>
          </div>
          <h2 style={{
          fontSize: 'clamp(26px,3.4vw,34px)',
          fontWeight: 900,
          margin: '0 0 10px',
          color: '#1F3540'
        }}>{r.rebateTitle}</h2>
          <p style={{
          fontSize: 16,
          color: '#45566B',
          lineHeight: 1.7,
          margin: '0 0 36px',
          maxWidth: '66ch'
        }}>{r.rebateCondition}</p>

          <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(230px,100%), 1fr))',
          gap: 20,
          alignItems: 'stretch'
        }}>
            {r.tiles.map((tile, i) => {
            const tl = Object.assign({}, tile, TILE[i]);
            return <Reveal key={i} delay={i * 80}>
                <div style={{
                background: tl.bg,
                border: '1px solid ' + tl.border,
                borderRadius: 16,
                padding: '34px 30px',
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
                height: '100%',
                boxShadow: '0 2px 14px rgba(27,59,95,0.06)'
              }}>
                  <div style={{
                  fontSize: 14,
                  fontWeight: 700,
                  letterSpacing: '0.04em',
                  textTransform: 'uppercase',
                  color: tl.labelColor
                }}>{tl.label}</div>
                  <div style={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontSize: 'clamp(48px,6vw,68px)',
                  fontWeight: 900,
                  lineHeight: 1,
                  color: tl.amtColor
                }}>{tl.amt}</div>
                  <div style={{
                  fontSize: 14,
                  color: tl.noteColor,
                  lineHeight: 1.6
                }}>{tl.note}</div>
                </div>
              </Reveal>;
          })}
          </div>

          <div style={{
          marginTop: 28,
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: 'clamp(20px,2.6vw,26px)',
          fontWeight: 800,
          color: '#E57500'
        }}>{r.moreTagline}</div>

          <div style={{
          marginTop: 24,
          borderTop: '1px solid #E8E2D9',
          paddingTop: 20,
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
          maxWidth: '90ch'
        }}>
            {r.notes.map((note, i) => <p key={i} style={{
            fontSize: 13,
            lineHeight: 1.75,
            color: '#6B7280',
            margin: 0
          }}>{note}</p>)}
          </div>
        </div>
      </section>

      {/* How it works */}
      <section style={{
      background: '#fff',
      padding: '96px 24px'
    }}>
        <div style={{
        maxWidth: 1200,
        margin: '0 auto'
      }}>
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          marginBottom: 8
        }}>
            <div style={{
            width: 34,
            height: 4,
            background: '#B55B00'
          }} />
            <div style={{
            fontSize: 14,
            fontWeight: 700,
            color: '#B55B00',
            letterSpacing: 2
          }}>{r.stepsEyebrow}</div>
          </div>
          <h2 style={{
          fontSize: 'clamp(26px,3.4vw,34px)',
          fontWeight: 900,
          margin: '0 0 40px',
          color: '#1F3540'
        }}>{r.stepsTitle}</h2>
          <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(280px,100%), 1fr))',
          gap: 22
        }}>
            {r.steps.map((step, i) => <Reveal key={i} delay={i * 60}>
                <div style={{
              background: '#FBF8F4',
              border: '1px solid #EEE7DC',
              borderRadius: 18,
              padding: '28px 26px',
              display: 'flex',
              flexDirection: 'column',
              gap: 12,
              height: '100%'
            }}>
                  <div style={{
                width: 44,
                height: 44,
                borderRadius: '50%',
                background: 'rgba(229,117,0,0.12)',
                border: '2px solid rgba(229,117,0,0.28)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: 15,
                fontWeight: 800,
                color: '#E57500'
              }}>{step.n}</div>
                  <h3 style={{
                fontSize: 17,
                fontWeight: 700,
                color: '#1F3540',
                margin: 0,
                lineHeight: 1.4
              }}>{step.title}</h3>
                  <p style={{
                fontSize: 14,
                color: '#6B7280',
                lineHeight: 1.7,
                margin: 0
              }}>{step.desc}</p>
                </div>
              </Reveal>)}
          </div>
          <p style={{
          fontSize: 13,
          lineHeight: 1.75,
          color: '#6B7280',
          margin: '22px 0 0',
          maxWidth: '90ch'
        }}>{r.stepsNote}</p>
        </div>
      </section>

      {/* CTA */}
      <section style={{
      background: '#1F3540',
      padding: '88px 24px'
    }}>
        <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(320px,100%), 1fr))',
        gap: 40,
        alignItems: 'center'
      }}>
          <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16
        }}>
            <h2 style={{
            color: '#fff',
            fontSize: 'clamp(26px,3.4vw,36px)',
            fontWeight: 900,
            margin: 0,
            lineHeight: 1.3
          }}>{r.ctaTitle}</h2>
            <p style={{
            color: 'rgba(255,255,255,0.82)',
            fontSize: 17,
            lineHeight: 1.8,
            margin: 0,
            maxWidth: '46ch'
          }}>{r.ctaSub}</p>
          </div>
          <div style={{
          display: 'flex',
          gap: 12,
          flexWrap: 'wrap'
        }}>
            {r.ctaLinks.map((cta, i) => <a key={i} href={cta.href} target="_blank" rel="noopener noreferrer" style={{
            background: cta.bg,
            color: cta.color,
            border: cta.border === 'none' ? 'none' : cta.border,
            borderRadius: 10,
            padding: '14px 24px',
            fontSize: 15,
            fontWeight: 700,
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8
          }}>{cta.label}</a>)}
          </div>
        </div>
      </section>

      {/* Terms and conditions */}
      <section style={{
      background: '#F9FAFB',
      padding: '88px 24px'
    }}>
        <div style={{
        maxWidth: 960,
        margin: '0 auto'
      }}>
          <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 20,
          flexWrap: 'wrap',
          borderBottom: '1px solid rgba(0,0,0,0.08)',
          paddingBottom: 20
        }}>
            <h2 style={{
            fontSize: 'clamp(22px,2.8vw,28px)',
            fontWeight: 800,
            color: '#1F3540',
            margin: 0
          }}>{r.tncTitle}</h2>
            <button type="button" onClick={() => setTncOpen(!tncOpen)} style={{
            background: 'none',
            border: '1px solid rgba(0,0,0,0.12)',
            borderRadius: 999,
            padding: '8px 16px',
            fontSize: 13,
            fontWeight: 600,
            color: '#B55B00',
            cursor: 'pointer'
          }}>{tncOpen ? r.tncHide : r.tncShow}</button>
          </div>

          {tncOpen && <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 38,
          paddingTop: 30
        }}>
              {r.tncGroups.map((grp, gi) => <div key={gi}>
                  <h3 style={{
              fontSize: 17,
              fontWeight: 800,
              color: '#1F3540',
              margin: '0 0 16px',
              letterSpacing: '0.01em'
            }}>{grp.title}</h3>
                  <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 14
            }}>
                    {grp.items.map((it, ii) => <div key={ii} style={{
                display: 'flex',
                gap: 14,
                alignItems: 'flex-start'
              }}>
                        <div style={{
                  flex: '0 0 26px',
                  fontSize: 13,
                  fontWeight: 700,
                  color: '#E57500',
                  lineHeight: 1.8,
                  textAlign: 'right'
                }}>{it.n}.</div>
                        <div style={{
                  flex: 1,
                  minWidth: 0
                }}>
                          <p style={{
                    fontSize: 14.5,
                    lineHeight: 1.8,
                    color: '#45566B',
                    margin: 0
                  }}>
                            {it.text}
                            {it.hasLink && <a href={base + it.linkId + '/'} style={{
                      color: '#E57500',
                      fontWeight: 600
                    }}>{it.linkLabel}</a>}
                            {it.post}
                          </p>
                          {it.hasSubs && <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                    marginTop: 10,
                    paddingLeft: 16,
                    borderLeft: '2px solid #EEE7DC'
                  }}>
                              {it.subs.map((sub, si) => <p key={si} style={{
                      fontSize: 14,
                      lineHeight: 1.8,
                      color: '#6B7280',
                      margin: 0
                    }}>{sub}</p>)}
                            </div>}
                        </div>
                      </div>)}
                  </div>
                </div>)}
            </div>}
        </div>
      </section>
    </div>;
}

function App() {
  const [page, setPage] = React.useState(() => {
    // 1. Try reading from the pathname (Clean Paths, e.g. /en/tenants)
    const path = window.location.pathname;
    if (path && path !== '/') {
      const parts = path.split('/').filter(Boolean); // ["en", "tenants"] or ["en", "promotions", "hsbc"]
      if (parts[0] === 'tc' || parts[0] === 'en' || parts[0] === 'sc') {
        currentLang = parts[0];
        const rawPage = parts.slice(1).join('/') || 'home';
        try {
          return decodeURIComponent(rawPage);
        } catch (_) {
          return rawPage;
        }
      }
    }

    // 2. Fall back to hash routing if present
    const hash = window.location.hash.replace('#/', '');
    const parts = hash.split('/');
    if (parts[0] === 'tc' || parts[0] === 'en' || parts[0] === 'sc') {
      currentLang = parts[0];
      const rawPage = parts.slice(1).join('/') || 'home';
      try {
        return decodeURIComponent(rawPage);
      } catch (_) {
        return rawPage;
      }
    }

    // No hash + non-root pathname = arrived via CloudFront 404 redirect
    if (!hash && window.location.pathname !== '/' && !path.startsWith('/en/') && !path.startsWith('/tc/') && !path.startsWith('/sc/')) {
      return '__notfound__';
    }
    return hash || 'home';
  });
  const [tweaks, setTweaks] = React.useState(TWEAK_DEFAULTS);
  const [chatbotOpen, setChatbotOpen] = React.useState(false);
  const openChatbot = React.useCallback(() => setChatbotOpen(true), []);
  const closeChatbot = React.useCallback(() => setChatbotOpen(false), []);
  const [tweakOpen, setTweakOpen] = React.useState(false);

  // Global Pageview Tracking attached to the routing state
  React.useEffect(() => {
    if (process.env.PUBLIC_GA_ID) {
      ReactGA.send({
        hitType: "pageview",
        page: "/" + page,
        title: page
      });
    }
  }, [page]);
  const [, forceRender] = React.useState(0);
  window.setLanguage = l => {
    currentLang = l;
    window.location.href = '/' + l + '/' + page + '/';
  };
  React.useEffect(() => {
    const onHash = () => {
      const hash = window.location.hash.replace('#/', '');
      const parts = hash.split('/');
      if (parts[0] === 'tc' || parts[0] === 'en' || parts[0] === 'sc') {
        if (currentLang !== parts[0]) {
          currentLang = parts[0];
          forceRender(x => x + 1);
        }
        setPage(parts.slice(1).join('/') || 'home');
      } else {
        setPage(hash || 'home');
      }
      window.scrollTo(0, 0);
    };
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, [page]);
  const navigate = p => {
    window.location.href = '/' + currentLang + '/' + p + '/';
  };

  // Edit-mode integration with parent host.
  // Only honour messages that come from a real parent frame (not the page itself)
  // and whose source is window.parent. The host origin is configured at build time
  // via window.__KEYCHAIN_HOST_ORIGIN; if absent we still require a parent frame.
  const isEmbedded = typeof window !== t("k_708") && window.parent && window.parent !== window;
  React.useEffect(() => {
    if (!isEmbedded) return;
    const allowedOrigin = typeof window !== t("k_708") && window.__KEYCHAIN_HOST_ORIGIN || null;
    const handler = e => {
      if (e.source !== window.parent) return;
      if (allowedOrigin && e.origin !== allowedOrigin) return;
      if (!e.data || typeof e.data !== t("k_913")) return;
      if (e.data.type === '__activate_edit_mode') setTweakOpen(true);
      if (e.data.type === '__deactivate_edit_mode') setTweakOpen(false);
    };
    window.addEventListener('message', handler);
    try {
      window.parent.postMessage({
        type: '__edit_mode_available'
      }, allowedOrigin || '*');
    } catch (_) {/* sandboxed */}
    return () => window.removeEventListener('message', handler);
  }, [isEmbedded]);
  const updateTweak = (key, val) => {
    setTweaks(t => ({
      ...t,
      [key]: val
    }));
    if (!isEmbedded) return;
    const allowedOrigin = typeof window !== t("k_708") && window.__KEYCHAIN_HOST_ORIGIN || '*';
    try {
      window.parent.postMessage({
        type: '__edit_mode_set_keys',
        edits: {
          [key]: val
        }
      }, allowedOrigin);
    } catch (_) {}
  };
  const pages = {
    home: <HomePage onNavigate={navigate} tweaks={tweaks} />,
    landlords: <LandlordDeveloperPage onNavigate={navigate} tweaks={tweaks} />,
    tenants: <TenantsPage onNavigate={navigate} tweaks={tweaks} onOpenChatbot={openChatbot} />,
    promotions: <PromotionsPage onNavigate={navigate} />,
    'promotions/referral': <ReferralPage onNavigate={navigate} />,
    'promotions/hsbc': <HsbcPromoPage onNavigate={navigate} />,
    faq: <GlobalFAQPage onNavigate={navigate} />,
    investors: <InvestorsPage onNavigate={navigate} tweaks={tweaks} />,
    terms: <TermsPage onNavigate={navigate} />,
    privacy: <PrivacyPage onNavigate={navigate} />,
    'user-terms': <UserTermsPage onNavigate={navigate} />,
    'cookie-policy': <CookiePolicyPage onNavigate={navigate} />,
    '信用卡交租': <CreditCardRentPillarPage onNavigate={navigate} tweaks={tweaks} onOpenChatbot={openChatbot} />,
    '%E4%BF%A1%E7%94%A8%E5%8D%A1%E4%BA%A4%E7%A7%9F': <CreditCardRentPillarPage onNavigate={navigate} tweaks={tweaks} onOpenChatbot={openChatbot} />
  };
  return <div>
      <Nav currentPage={page} onNavigate={navigate} />
      <main>{pages[page] !== undefined ? pages[page] : <NotFoundPage onNavigate={navigate} />}</main>
      <Footer onNavigate={navigate} onOpenChatbot={openChatbot} />
      <ChatbotPopup open={chatbotOpen} onClose={closeChatbot} onNavigate={navigate} />
      {tweakOpen && <div style={{
      position: 'fixed',
      bottom: 24,
      right: 24,
      zIndex: 9999,
      background: 'white',
      border: '1px solid rgba(0,0,0,0.1)',
      borderRadius: 16,
      padding: 24,
      width: 280,
      boxShadow: t("k_914")
    }}>
          <div style={{
        fontSize: 13,
        fontWeight: 800,
        color: '#1A1A1A',
        textTransform: t("k_262"),
        letterSpacing: '0.08em',
        marginBottom: 20
      }}>{t("k_221")}</div>
          <div style={{
        marginBottom: 16
      }}>
            <label style={{
          fontSize: 12,
          fontWeight: 600,
          color: '#6B7280',
          display: 'block',
          marginBottom: 6
        }}>{t("k_222")}</label>
            <div style={{
          display: 'flex',
          gap: 8
        }}>
              {['#FFA567', '#E57500', '#B55B00', '#67919F', '#ACB5B3'].map(c => <div key={c} onClick={() => updateTweak('accentColor', c)} style={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            background: c,
            cursor: t("k_251"),
            border: tweaks.accentColor === c ? '3px solid #1A1A1A' : '2px solid transparent',
            transition: t("k_915")
          }} />)}
            </div>
          </div>
          <div style={{
        marginBottom: 16
      }}>
            <label style={{
          fontSize: 12,
          fontWeight: 600,
          color: '#6B7280',
          display: 'block',
          marginBottom: 8
        }}>{t("k_223")}</label>
            <div style={{
          display: 'flex',
          flexDirection: t("k_283"),
          gap: 6
        }}>
              {['home', 'landlords', 'tenants', 'corporate', 'investors'].map(p => <button key={p} onClick={() => navigate(p)} style={{
            background: page === p ? '#E57500' : '#F9FAFB',
            color: page === p ? 'white' : '#374151',
            border: '1px solid rgba(0,0,0,0.07)',
            borderRadius: 8,
            padding: t("k_916"),
            fontSize: 13,
            fontWeight: 500,
            cursor: t("k_251"),
            textAlign: t("k_263"),
            textTransform: t("k_917")
          }}>{p}</button>)}
            </div>
          </div>
        </div>}
    </div>;
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<HelmetProvider><App /></HelmetProvider>);